
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire37dc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire37dc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});

parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("Rhhhq", function(module, exports) {
module.exports = import.meta.resolve("l3RDe");

});

parcelRegister("bumMD", function(module, exports) {
module.exports = import.meta.resolve("ilAxk");

});

parcelRegister("e8HRd", function(module, exports) {
module.exports = import.meta.resolve("i6rWm");

});

parcelRegister("1JThx", function(module, exports) {
module.exports = import.meta.resolve("ajXQu");

});

parcelRegister("h0KsI", function(module, exports) {
module.exports = import.meta.resolve("jbv7s");

});

parcelRegister("9BwyB", function(module, exports) {
module.exports = import.meta.resolve("hJbNU");

});

parcelRegister("fiMxY", function(module, exports) {
module.exports = import.meta.resolve("4UAFc");

});

parcelRegister("i1bf1", function(module, exports) {
module.exports = import.meta.resolve("dFu8v");

});

parcelRegister("gjmuW", function(module, exports) {
module.exports = import.meta.resolve("5Ef6v");

});

parcelRegister("6TuRg", function(module, exports) {
module.exports = import.meta.resolve("g7YtJ");

});

parcelRegister("brrWC", function(module, exports) {
module.exports = import.meta.resolve("7oRzi");

});

parcelRegister("7zyFN", function(module, exports) {
module.exports = import.meta.resolve("hGz4s");

});

parcelRegister("lylCC", function(module, exports) {
module.exports = import.meta.resolve("2zepK");

});

parcelRegister("kdavB", function(module, exports) {
module.exports = import.meta.resolve("a64Qj");

});

parcelRegister("dbE0R", function(module, exports) {
module.exports = import.meta.resolve("hsCvL");

});

parcelRegister("iCYgV", function(module, exports) {
module.exports = import.meta.resolve("5t0LD");

});

parcelRegister("kkaRu", function(module, exports) {
module.exports = import.meta.resolve("dfRu8");

});

parcelRegister("jReRO", function(module, exports) {
module.exports = import.meta.resolve("lNNpx");

});

parcelRegister("2mx64", function(module, exports) {
module.exports = import.meta.resolve("lbxkF");

});

parcelRegister("8Jl4d", function(module, exports) {
module.exports = import.meta.resolve("jQqsU");

});

parcelRegister("9L3aU", function(module, exports) {
module.exports = import.meta.resolve("1BUqk");

});

parcelRegister("16DSZ", function(module, exports) {
module.exports = import.meta.resolve("dLvRV");

});

parcelRegister("jdh2q", function(module, exports) {
module.exports = import.meta.resolve("bMgEn");

});

parcelRegister("iZEw8", function(module, exports) {
module.exports = import.meta.resolve("rd6pN");

});


var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $acw62 = parcelRequire("acw62");

var $587b054e52e3ab52$exports = {};

$587b054e52e3ab52$exports = $587b054e52e3ab52$exports;


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$err(message) {
    const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty
    return error;
}
var $7ef244517b504261$var$err_1 = $7ef244517b504261$var$err;
// @oss-only
var $7ef244517b504261$var$Recoil_err = $7ef244517b504261$var$err_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function $7ef244517b504261$var$isPromise(p) {
    return !!p && typeof p.then === 'function';
}
var $7ef244517b504261$var$Recoil_isPromise = $7ef244517b504261$var$isPromise;
function $7ef244517b504261$var$nullthrows(x, message) {
    if (x != null) return x;
    throw $7ef244517b504261$var$Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}
var $7ef244517b504261$var$Recoil_nullthrows = $7ef244517b504261$var$nullthrows;
function $7ef244517b504261$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $7ef244517b504261$var$BaseLoadable {
    getValue() {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
    toPromise() {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
    valueMaybe() {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
    valueOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected value, but in "${this.state}" state`);
    }
    promiseMaybe() {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
    promiseOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
    }
    errorMaybe() {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
    errorOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $7ef244517b504261$var$Recoil_err(`Loadable expected error, but in "${this.state}" state`);
    }
    is(other) {
        // $FlowFixMe[prop-missing]
        return other.state === this.state && other.contents === this.contents;
    }
    map(_map) {
        throw $7ef244517b504261$var$Recoil_err('BaseLoadable');
    }
}
class $7ef244517b504261$var$ValueLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(value){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", 'hasValue');
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = value;
    }
    getValue() {
        return this.contents;
    }
    toPromise() {
        return Promise.resolve(this.contents);
    }
    valueMaybe() {
        return this.contents;
    }
    valueOrThrow() {
        return this.contents;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        try {
            const next = map(this.contents);
            return $7ef244517b504261$var$Recoil_isPromise(next) ? $7ef244517b504261$var$loadableWithPromise(next) : $7ef244517b504261$var$isLoadable(next) ? next : $7ef244517b504261$var$loadableWithValue(next);
        } catch (e) {
            return $7ef244517b504261$var$Recoil_isPromise(e) ? // errors and subsequent retries will be handled in 'loading' case
            // $FlowFixMe[prop-missing]
            $7ef244517b504261$var$loadableWithPromise(e.next(()=>this.map(map))) : $7ef244517b504261$var$loadableWithError(e);
        }
    }
}
class $7ef244517b504261$var$ErrorLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(error){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", 'hasError');
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = error;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return Promise.reject(this.contents);
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return this.contents;
    }
    errorOrThrow() {
        return this.contents;
    }
    map(_map) {
        // $FlowIssue[incompatible-return]
        return this;
    }
}
class $7ef244517b504261$var$LoadingLoadable extends $7ef244517b504261$var$BaseLoadable {
    constructor(promise){
        super();
        $7ef244517b504261$var$_defineProperty(this, "state", 'loading');
        $7ef244517b504261$var$_defineProperty(this, "contents", void 0);
        this.contents = promise;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return this.contents;
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return this.contents;
    }
    promiseOrThrow() {
        return this.contents;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        return $7ef244517b504261$var$loadableWithPromise(this.contents.then((value)=>{
            const next = map(value);
            if ($7ef244517b504261$var$isLoadable(next)) {
                const nextLoadable = next;
                switch(nextLoadable.state){
                    case 'hasValue':
                        return nextLoadable.contents;
                    case 'hasError':
                        throw nextLoadable.contents;
                    case 'loading':
                        return nextLoadable.contents;
                }
            } // $FlowIssue[incompatible-return]
            return next;
        }) // $FlowFixMe[incompatible-call]
        .catch((e)=>{
            if ($7ef244517b504261$var$Recoil_isPromise(e)) // we were "suspended," try again
            return e.then(()=>this.map(map).contents);
            throw e;
        }));
    }
}
function $7ef244517b504261$var$loadableWithValue(value) {
    return Object.freeze(new $7ef244517b504261$var$ValueLoadable(value));
}
function $7ef244517b504261$var$loadableWithError(error) {
    return Object.freeze(new $7ef244517b504261$var$ErrorLoadable(error));
}
function $7ef244517b504261$var$loadableWithPromise(promise) {
    return Object.freeze(new $7ef244517b504261$var$LoadingLoadable(promise));
}
function $7ef244517b504261$var$loadableLoading() {
    return Object.freeze(new $7ef244517b504261$var$LoadingLoadable(new Promise(()=>{})));
}
function $7ef244517b504261$var$loadableAllArray(inputs) {
    return inputs.every((i)=>i.state === 'hasValue') ? $7ef244517b504261$var$loadableWithValue(inputs.map((i)=>i.contents)) : inputs.some((i)=>i.state === 'hasError') ? $7ef244517b504261$var$loadableWithError($7ef244517b504261$var$Recoil_nullthrows(inputs.find((i)=>i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : $7ef244517b504261$var$loadableWithPromise(Promise.all(inputs.map((i)=>i.contents)));
}
function $7ef244517b504261$var$loadableAll(inputs) {
    const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map((key)=>inputs[key]);
    const normalizedInputs = unwrapedInputs.map((x)=>$7ef244517b504261$var$isLoadable(x) ? x : $7ef244517b504261$var$Recoil_isPromise(x) ? $7ef244517b504261$var$loadableWithPromise(x) : $7ef244517b504261$var$loadableWithValue(x));
    const output = $7ef244517b504261$var$loadableAllArray(normalizedInputs);
    return Array.isArray(inputs) ? output : // $FlowIssue[incompatible-call]
    output.map((outputs)=>Object.getOwnPropertyNames(inputs).reduce((out, key, idx)=>({
                ...out,
                [key]: outputs[idx]
            }), {}));
}
function $7ef244517b504261$var$isLoadable(x) {
    return x instanceof $7ef244517b504261$var$BaseLoadable;
}
const $7ef244517b504261$var$LoadableStaticInterface = {
    of: (value)=>$7ef244517b504261$var$Recoil_isPromise(value) ? $7ef244517b504261$var$loadableWithPromise(value) : $7ef244517b504261$var$isLoadable(value) ? value : $7ef244517b504261$var$loadableWithValue(value),
    error: (error)=>$7ef244517b504261$var$loadableWithError(error),
    // $FlowIssue[incompatible-return]
    loading: ()=>$7ef244517b504261$var$loadableLoading(),
    // $FlowIssue[unclear-type]
    all: $7ef244517b504261$var$loadableAll,
    isLoadable: $7ef244517b504261$var$isLoadable
};
var $7ef244517b504261$var$Recoil_Loadable = {
    loadableWithValue: $7ef244517b504261$var$loadableWithValue,
    loadableWithError: $7ef244517b504261$var$loadableWithError,
    loadableWithPromise: $7ef244517b504261$var$loadableWithPromise,
    loadableLoading: $7ef244517b504261$var$loadableLoading,
    loadableAll: $7ef244517b504261$var$loadableAll,
    isLoadable: $7ef244517b504261$var$isLoadable,
    RecoilLoadable: $7ef244517b504261$var$LoadableStaticInterface
};
var $7ef244517b504261$var$Recoil_Loadable_1 = $7ef244517b504261$var$Recoil_Loadable.loadableWithValue;
var $7ef244517b504261$var$Recoil_Loadable_2 = $7ef244517b504261$var$Recoil_Loadable.loadableWithError;
var $7ef244517b504261$var$Recoil_Loadable_3 = $7ef244517b504261$var$Recoil_Loadable.loadableWithPromise;
var $7ef244517b504261$var$Recoil_Loadable_4 = $7ef244517b504261$var$Recoil_Loadable.loadableLoading;
var $7ef244517b504261$var$Recoil_Loadable_5 = $7ef244517b504261$var$Recoil_Loadable.loadableAll;
var $7ef244517b504261$var$Recoil_Loadable_6 = $7ef244517b504261$var$Recoil_Loadable.isLoadable;
var $7ef244517b504261$var$Recoil_Loadable_7 = $7ef244517b504261$var$Recoil_Loadable.RecoilLoadable;
var $7ef244517b504261$var$Recoil_Loadable$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    loadableWithValue: $7ef244517b504261$var$Recoil_Loadable_1,
    loadableWithError: $7ef244517b504261$var$Recoil_Loadable_2,
    loadableWithPromise: $7ef244517b504261$var$Recoil_Loadable_3,
    loadableLoading: $7ef244517b504261$var$Recoil_Loadable_4,
    loadableAll: $7ef244517b504261$var$Recoil_Loadable_5,
    isLoadable: $7ef244517b504261$var$Recoil_Loadable_6,
    RecoilLoadable: $7ef244517b504261$var$Recoil_Loadable_7
});
const $7ef244517b504261$var$env = {
    RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
    // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
    RECOIL_GKS_ENABLED: new Set([
        'recoil_hamt_2020',
        'recoil_sync_external_store',
        'recoil_suppress_rerender_in_callback',
        'recoil_memory_managament_2020'
    ])
};
function $7ef244517b504261$var$readProcessEnvBooleanFlag(name, set) {
    var _process$env$name, _process$env$name$toL;
    const sanitizedValue = (_process$env$name = $587b054e52e3ab52$exports.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
    if (sanitizedValue == null || sanitizedValue === '') return;
    const allowedValues = [
        'true',
        'false'
    ];
    if (!allowedValues.includes(sanitizedValue)) throw $7ef244517b504261$var$Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
    set(sanitizedValue === 'true');
}
function $7ef244517b504261$var$readProcessEnvStringArrayFlag(name, set) {
    var _process$env$name2;
    const sanitizedValue = (_process$env$name2 = $587b054e52e3ab52$exports.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
    if (sanitizedValue == null || sanitizedValue === '') return;
    set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */ function $7ef244517b504261$var$applyProcessEnvFlagOverrides() {
    var _process;
    var value, value1, gk;
    return;
}
$7ef244517b504261$var$applyProcessEnvFlagOverrides();
var $7ef244517b504261$var$Recoil_RecoilEnv = $7ef244517b504261$var$env;
function $7ef244517b504261$var$Recoil_gkx_OSS(gk) {
    return $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
$7ef244517b504261$var$Recoil_gkx_OSS.setPass = (gk)=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
$7ef244517b504261$var$Recoil_gkx_OSS.setFail = (gk)=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};
$7ef244517b504261$var$Recoil_gkx_OSS.clear = ()=>{
    $7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var $7ef244517b504261$var$Recoil_gkx = $7ef244517b504261$var$Recoil_gkx_OSS; // @oss-only
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$recoverableViolation(message, _projectName, { error: error } = {}) {
    return null;
}
var $7ef244517b504261$var$recoverableViolation_1 = $7ef244517b504261$var$recoverableViolation;
// @oss-only
var $7ef244517b504261$var$Recoil_recoverableViolation = $7ef244517b504261$var$recoverableViolation_1;
var $7ef244517b504261$var$_createMutableSource, $7ef244517b504261$var$_useMutableSource, $7ef244517b504261$var$_useSyncExternalStore;
const $7ef244517b504261$var$createMutableSource = ($7ef244517b504261$var$_createMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createMutableSource) !== null && $7ef244517b504261$var$_createMutableSource !== void 0 ? $7ef244517b504261$var$_createMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_createMutableSource;
const $7ef244517b504261$var$useMutableSource = ($7ef244517b504261$var$_useMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMutableSource) !== null && $7ef244517b504261$var$_useMutableSource !== void 0 ? $7ef244517b504261$var$_useMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86
const $7ef244517b504261$var$useSyncExternalStore = ($7ef244517b504261$var$_useSyncExternalStore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore) !== null && $7ef244517b504261$var$_useSyncExternalStore !== void 0 ? $7ef244517b504261$var$_useSyncExternalStore : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).unstable_useSyncExternalStore;
let $7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.
function $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore() {
    var _ReactCurrentDispatch;
    // $FlowFixMe[incompatible-use]
    const { ReactCurrentDispatcher: ReactCurrentDispatcher, ReactCurrentOwner: ReactCurrentOwner } = /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
    const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
    if ($7ef244517b504261$var$useSyncExternalStore && !isUseSyncExternalStoreSupported && !$7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce) {
        $7ef244517b504261$var$ReactRendererVersionMismatchWarnOnce = true;
        $7ef244517b504261$var$Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
    }
    return isUseSyncExternalStoreSupported;
}
/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */ function $7ef244517b504261$var$reactMode() {
    // NOTE: This mode is currently broken with some Suspense cases
    // see Recoil_selector-test.js
    if ($7ef244517b504261$var$Recoil_gkx('recoil_transition_support')) return {
        mode: 'TRANSITION_SUPPORT',
        early: true,
        concurrent: true
    };
    if ($7ef244517b504261$var$Recoil_gkx('recoil_sync_external_store') && $7ef244517b504261$var$useSyncExternalStore != null) return {
        mode: 'SYNC_EXTERNAL_STORE',
        early: true,
        concurrent: false
    };
    if ($7ef244517b504261$var$Recoil_gkx('recoil_mutable_source') && $7ef244517b504261$var$useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) return $7ef244517b504261$var$Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
        mode: 'MUTABLE_SOURCE',
        early: true,
        concurrent: true
    } : {
        mode: 'MUTABLE_SOURCE',
        early: false,
        concurrent: false
    };
    return $7ef244517b504261$var$Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
        mode: 'LEGACY',
        early: true,
        concurrent: false
    } : {
        mode: 'LEGACY',
        early: false,
        concurrent: false
    };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:
function $7ef244517b504261$var$isFastRefreshEnabled() {
    // @fb-only: const {isAcceptingUpdate} = require('__debug');
    // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
    return false; // @oss-only
}
var $7ef244517b504261$var$Recoil_ReactMode = {
    createMutableSource: $7ef244517b504261$var$createMutableSource,
    useMutableSource: $7ef244517b504261$var$useMutableSource,
    useSyncExternalStore: $7ef244517b504261$var$useSyncExternalStore,
    currentRendererSupportsUseSyncExternalStore: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore,
    reactMode: $7ef244517b504261$var$reactMode,
    isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // eslint-disable-next-line no-unused-vars
class $7ef244517b504261$var$AbstractRecoilValue {
    constructor(newKey){
        $7ef244517b504261$var$_defineProperty(this, "key", void 0);
        this.key = newKey;
    }
    toJSON() {
        return {
            key: this.key
        };
    }
}
class $7ef244517b504261$var$RecoilState extends $7ef244517b504261$var$AbstractRecoilValue {
}
class $7ef244517b504261$var$RecoilValueReadOnly extends $7ef244517b504261$var$AbstractRecoilValue {
}
function $7ef244517b504261$var$isRecoilValue(x) {
    return x instanceof $7ef244517b504261$var$RecoilState || x instanceof $7ef244517b504261$var$RecoilValueReadOnly;
}
var $7ef244517b504261$var$Recoil_RecoilValue = {
    AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue,
    RecoilState: $7ef244517b504261$var$RecoilState,
    RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue
};
var $7ef244517b504261$var$Recoil_RecoilValue_1 = $7ef244517b504261$var$Recoil_RecoilValue.AbstractRecoilValue;
var $7ef244517b504261$var$Recoil_RecoilValue_2 = $7ef244517b504261$var$Recoil_RecoilValue.RecoilState;
var $7ef244517b504261$var$Recoil_RecoilValue_3 = $7ef244517b504261$var$Recoil_RecoilValue.RecoilValueReadOnly;
var $7ef244517b504261$var$Recoil_RecoilValue_4 = $7ef244517b504261$var$Recoil_RecoilValue.isRecoilValue;
var $7ef244517b504261$var$Recoil_RecoilValue$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractRecoilValue: $7ef244517b504261$var$Recoil_RecoilValue_1,
    RecoilState: $7ef244517b504261$var$Recoil_RecoilValue_2,
    RecoilValueReadOnly: $7ef244517b504261$var$Recoil_RecoilValue_3,
    isRecoilValue: $7ef244517b504261$var$Recoil_RecoilValue_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$sprintf(format, ...args) {
    let index = 0;
    return format.replace(/%s/g, ()=>String(args[index++]));
}
var $7ef244517b504261$var$sprintf_1 = $7ef244517b504261$var$sprintf;
function $7ef244517b504261$var$expectationViolation(format, ...args) {}
var $7ef244517b504261$var$expectationViolation_1 = $7ef244517b504261$var$expectationViolation;
// @oss-only
var $7ef244517b504261$var$Recoil_expectationViolation = $7ef244517b504261$var$expectationViolation_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */ function $7ef244517b504261$var$mapIterable(iterable, callback) {
    // Use generator to create iterable/iterator
    return function*() {
        let index = 0;
        for (const value of iterable)yield callback(value, index++);
    }();
}
var $7ef244517b504261$var$Recoil_mapIterable = $7ef244517b504261$var$mapIterable;
const { isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled$1 } = $7ef244517b504261$var$Recoil_ReactMode;
class $7ef244517b504261$var$DefaultValue {
}
const $7ef244517b504261$var$DEFAULT_VALUE = new $7ef244517b504261$var$DefaultValue();
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$nodes = new Map(); // flowlint-next-line unclear-type:off
const $7ef244517b504261$var$recoilValues = new Map();
/* eslint-disable no-redeclare */ function $7ef244517b504261$var$recoilValuesForKeys(keys) {
    return $7ef244517b504261$var$Recoil_mapIterable(keys, (key)=>$7ef244517b504261$var$Recoil_nullthrows($7ef244517b504261$var$recoilValues.get(key)));
}
function $7ef244517b504261$var$checkForDuplicateAtomKey(key) {
    if ($7ef244517b504261$var$nodes.has(key)) {
        const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
        // @fb-only: recoverableViolation(message, 'recoil');
        console.warn(message); // @oss-only
    }
}
function $7ef244517b504261$var$registerNode(node) {
    if ($7ef244517b504261$var$Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) $7ef244517b504261$var$checkForDuplicateAtomKey(node.key);
    $7ef244517b504261$var$nodes.set(node.key, node);
    const recoilValue = node.set == null ? new $7ef244517b504261$var$Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new $7ef244517b504261$var$Recoil_RecoilValue$1.RecoilState(node.key);
    $7ef244517b504261$var$recoilValues.set(node.key, recoilValue);
    return recoilValue;
}
/* eslint-enable no-redeclare */ class $7ef244517b504261$var$NodeMissingError extends Error {
} // flowlint-next-line unclear-type:off
function $7ef244517b504261$var$getNode(key) {
    const node = $7ef244517b504261$var$nodes.get(key);
    if (node == null) throw new $7ef244517b504261$var$NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
    return node;
} // flowlint-next-line unclear-type:off
function $7ef244517b504261$var$getNodeMaybe(key) {
    return $7ef244517b504261$var$nodes.get(key);
}
const $7ef244517b504261$var$configDeletionHandlers = new Map();
function $7ef244517b504261$var$deleteNodeConfigIfPossible(key) {
    var _node$shouldDeleteCon;
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    const node = $7ef244517b504261$var$nodes.get(key);
    if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
        var _getConfigDeletionHan;
        $7ef244517b504261$var$nodes.delete(key);
        (_getConfigDeletionHan = $7ef244517b504261$var$getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 || _getConfigDeletionHan();
        $7ef244517b504261$var$configDeletionHandlers.delete(key);
    }
}
function $7ef244517b504261$var$setConfigDeletionHandler(key, fn) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    if (fn === undefined) $7ef244517b504261$var$configDeletionHandlers.delete(key);
    else $7ef244517b504261$var$configDeletionHandlers.set(key, fn);
}
function $7ef244517b504261$var$getConfigDeletionHandler(key) {
    return $7ef244517b504261$var$configDeletionHandlers.get(key);
}
var $7ef244517b504261$var$Recoil_Node = {
    nodes: $7ef244517b504261$var$nodes,
    recoilValues: $7ef244517b504261$var$recoilValues,
    registerNode: $7ef244517b504261$var$registerNode,
    getNode: $7ef244517b504261$var$getNode,
    getNodeMaybe: $7ef244517b504261$var$getNodeMaybe,
    deleteNodeConfigIfPossible: $7ef244517b504261$var$deleteNodeConfigIfPossible,
    setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler,
    getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler,
    recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys,
    NodeMissingError: $7ef244517b504261$var$NodeMissingError,
    DefaultValue: $7ef244517b504261$var$DefaultValue,
    DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$enqueueExecution(s, f) {
    f();
}
var $7ef244517b504261$var$Recoil_Queue = {
    enqueueExecution: $7ef244517b504261$var$enqueueExecution
};
function $7ef244517b504261$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $7ef244517b504261$var$hamt_1 = $7ef244517b504261$var$createCommonjsModule(function(module) {
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/ var hamt = {}; // export
    /* Configuration
 ******************************************************************************/ var SIZE = 5;
    var BUCKET_SIZE = Math.pow(2, SIZE);
    var MASK = BUCKET_SIZE - 1;
    var MAX_INDEX_NODE = BUCKET_SIZE / 2;
    var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
    /*
 ******************************************************************************/ var nothing = {};
    var constant = function constant(x) {
        return function() {
            return x;
        };
    };
    /**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/ var hash = hamt.hash = function(str) {
        var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
        if (type === 'number') return str;
        if (type !== 'string') str += '';
        var hash = 0;
        for(var i = 0, len = str.length; i < len; ++i){
            var c = str.charCodeAt(i);
            hash = (hash << 5) - hash + c | 0;
        }
        return hash;
    };
    /* Bit Ops
 ******************************************************************************/ /**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/ var popcount = function popcount(x) {
        x -= x >> 1 & 0x55555555;
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x += x >> 8;
        x += x >> 16;
        return x & 0x7f;
    };
    var hashFragment = function hashFragment(shift, h) {
        return h >>> shift & MASK;
    };
    var toBitmap = function toBitmap(x) {
        return 1 << x;
    };
    var fromBitmap = function fromBitmap(bitmap, bit) {
        return popcount(bitmap & bit - 1);
    };
    /* Array Ops
 ******************************************************************************/ /**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/ var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
        var out = arr;
        if (!mutate) {
            var len = arr.length;
            out = new Array(len);
            for(var i = 0; i < len; ++i)out[i] = arr[i];
        }
        out[at] = v;
        return out;
    };
    /**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/ var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
        var newLen = arr.length - 1;
        var i = 0;
        var g = 0;
        var out = arr;
        if (mutate) i = g = at;
        else {
            out = new Array(newLen);
            while(i < at)out[g++] = arr[i++];
        }
        ++i;
        while(i <= newLen)out[g++] = arr[i++];
        if (mutate) out.length = newLen;
        return out;
    };
    /**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/ var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
        var len = arr.length;
        if (mutate) {
            var _i = len;
            while(_i >= at)arr[_i--] = arr[_i];
            arr[at] = v;
            return arr;
        }
        var i = 0, g = 0;
        var out = new Array(len + 1);
        while(i < at)out[g++] = arr[i++];
        out[at] = v;
        while(i < len)out[++g] = arr[i++];
        return out;
    };
    /* Node Structures
 ******************************************************************************/ var LEAF = 1;
    var COLLISION = 2;
    var INDEX = 3;
    var ARRAY = 4;
    /**
    Empty node.
*/ var empty = {
        __hamt_isEmpty: true
    };
    var isEmptyNode = function isEmptyNode(x) {
        return x === empty || x && x.__hamt_isEmpty;
    };
    /**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/ var Leaf = function Leaf(edit, hash, key, value) {
        return {
            type: LEAF,
            edit: edit,
            hash: hash,
            key: key,
            value: value,
            _modify: Leaf__modify
        };
    };
    /**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/ var Collision = function Collision(edit, hash, children) {
        return {
            type: COLLISION,
            edit: edit,
            hash: hash,
            children: children,
            _modify: Collision__modify
        };
    };
    /**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/ var IndexedNode = function IndexedNode(edit, mask, children) {
        return {
            type: INDEX,
            edit: edit,
            mask: mask,
            children: children,
            _modify: IndexedNode__modify
        };
    };
    /**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/ var ArrayNode = function ArrayNode(edit, size, children) {
        return {
            type: ARRAY,
            edit: edit,
            size: size,
            children: children,
            _modify: ArrayNode__modify
        };
    };
    /**
    Is `node` a leaf node?
*/ var isLeaf = function isLeaf(node) {
        return node === empty || node.type === LEAF || node.type === COLLISION;
    };
    /* Internal node operations.
 ******************************************************************************/ /**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/ var expand = function expand(edit, frag, child, bitmap, subNodes) {
        var arr = [];
        var bit = bitmap;
        var count = 0;
        for(var i = 0; bit; ++i){
            if (bit & 1) arr[i] = subNodes[count++];
            bit >>>= 1;
        }
        arr[frag] = child;
        return ArrayNode(edit, count + 1, arr);
    };
    /**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/ var pack = function pack(edit, count, removed, elements) {
        var children = new Array(count - 1);
        var g = 0;
        var bitmap = 0;
        for(var i = 0, len = elements.length; i < len; ++i)if (i !== removed) {
            var elem = elements[i];
            if (elem && !isEmptyNode(elem)) {
                children[g++] = elem;
                bitmap |= 1 << i;
            }
        }
        return IndexedNode(edit, bitmap, children);
    };
    /**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/ var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
        if (h1 === h2) return Collision(edit, h1, [
            n2,
            n1
        ]);
        var subH1 = hashFragment(shift, h1);
        var subH2 = hashFragment(shift, h2);
        return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [
            mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)
        ] : subH1 < subH2 ? [
            n1,
            n2
        ] : [
            n2,
            n1
        ]);
    };
    /**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/ var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
        var len = list.length;
        for(var i = 0; i < len; ++i){
            var child = list[i];
            if (keyEq(k, child.key)) {
                var value = child.value;
                var _newValue = f(value);
                if (_newValue === value) return list;
                if (_newValue === nothing) {
                    --size.value;
                    return arraySpliceOut(mutate, i, list);
                }
                return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
            }
        }
        var newValue = f();
        if (newValue === nothing) return list;
        ++size.value;
        return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
    };
    var canEditNode = function canEditNode(edit, node) {
        return edit === node.edit;
    };
    /* Editing
 ******************************************************************************/ var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
        if (keyEq(k, this.key)) {
            var _v = f(this.value);
            if (_v === this.value) return this;
            else if (_v === nothing) {
                --size.value;
                return empty;
            }
            if (canEditNode(edit, this)) {
                this.value = _v;
                return this;
            }
            return Leaf(edit, h, k, _v);
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
        if (h === this.hash) {
            var canEdit = canEditNode(edit, this);
            var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
            if (list === this.children) return this;
            return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
        var mask = this.mask;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var bit = toBitmap(frag);
        var indx = fromBitmap(mask, bit);
        var exists = mask & bit;
        var current = exists ? children[indx] : empty;
        var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (current === child) return this;
        var canEdit = canEditNode(edit, this);
        var bitmap = mask;
        var newChildren = void 0;
        if (exists && isEmptyNode(child)) {
            // remove
            bitmap &= ~bit;
            if (!bitmap) return empty;
            if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse
            newChildren = arraySpliceOut(canEdit, indx, children);
        } else if (!exists && !isEmptyNode(child)) {
            // add
            if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
            bitmap |= bit;
            newChildren = arraySpliceIn(canEdit, indx, child, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, indx, child, children);
        if (canEdit) {
            this.mask = bitmap;
            this.children = newChildren;
            return this;
        }
        return IndexedNode(edit, bitmap, newChildren);
    };
    var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
        var count = this.size;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var child = children[frag];
        var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (child === newChild) return this;
        var canEdit = canEditNode(edit, this);
        var newChildren = void 0;
        if (isEmptyNode(child) && !isEmptyNode(newChild)) {
            // add
            ++count;
            newChildren = arrayUpdate(canEdit, frag, newChild, children);
        } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
            // remove
            --count;
            if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
            newChildren = arrayUpdate(canEdit, frag, empty, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, frag, newChild, children);
        if (canEdit) {
            this.size = count;
            this.children = newChildren;
            return this;
        }
        return ArrayNode(edit, count, newChildren);
    };
    empty._modify = function(edit, keyEq, shift, f, h, k, size) {
        var v = f();
        if (v === nothing) return empty;
        ++size.value;
        return Leaf(edit, h, k, v);
    };
    /*
 ******************************************************************************/ function Map1(editable, edit, config, root, size) {
        this._editable = editable;
        this._edit = edit;
        this._config = config;
        this._root = root;
        this._size = size;
    }
    Map1.prototype.setTree = function(newRoot, newSize) {
        if (this._editable) {
            this._root = newRoot;
            this._size = newSize;
            return this;
        }
        return newRoot === this._root ? this : new Map1(this._editable, this._edit, this._config, newRoot, newSize);
    };
    /* Queries
 ******************************************************************************/ /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/ var tryGetHash = hamt.tryGetHash = function(alt, hash, key, map) {
        var node = map._root;
        var shift = 0;
        var keyEq = map._config.keyEq;
        while(true)switch(node.type){
            case LEAF:
                return keyEq(key, node.key) ? node.value : alt;
            case COLLISION:
                if (hash === node.hash) {
                    var children = node.children;
                    for(var i = 0, len = children.length; i < len; ++i){
                        var child = children[i];
                        if (keyEq(key, child.key)) return child.value;
                    }
                }
                return alt;
            case INDEX:
                var frag = hashFragment(shift, hash);
                var bit = toBitmap(frag);
                if (node.mask & bit) {
                    node = node.children[fromBitmap(node.mask, bit)];
                    shift += SIZE;
                    break;
                }
                return alt;
            case ARRAY:
                node = node.children[hashFragment(shift, hash)];
                if (node) {
                    shift += SIZE;
                    break;
                }
                return alt;
            default:
                return alt;
        }
    };
    Map1.prototype.tryGetHash = function(alt, hash, key) {
        return tryGetHash(alt, hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/ var tryGet = hamt.tryGet = function(alt, key, map) {
        return tryGetHash(alt, map._config.hash(key), key, map);
    };
    Map1.prototype.tryGet = function(alt, key) {
        return tryGet(alt, key, this);
    };
    /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/ var getHash = hamt.getHash = function(hash, key, map) {
        return tryGetHash(undefined, hash, key, map);
    };
    Map1.prototype.getHash = function(hash, key) {
        return getHash(hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/ var get = hamt.get = function(key, map) {
        return tryGetHash(undefined, map._config.hash(key), key, map);
    };
    Map1.prototype.get = function(key, alt) {
        return tryGet(alt, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/ var hasHash = hamt.has = function(hash, key, map) {
        return tryGetHash(nothing, hash, key, map) !== nothing;
    };
    Map1.prototype.hasHash = function(hash, key) {
        return hasHash(hash, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/ var has = hamt.has = function(key, map) {
        return hasHash(map._config.hash(key), key, map);
    };
    Map1.prototype.has = function(key) {
        return has(key, this);
    };
    var defKeyCompare = function defKeyCompare(x, y) {
        return x === y;
    };
    /**
    Create an empty map.

    @param config Configuration.
*/ hamt.make = function(config) {
        return new Map1(0, 0, {
            keyEq: config && config.keyEq || defKeyCompare,
            hash: config && config.hash || hash
        }, empty, 0);
    };
    /**
    Empty map.
*/ hamt.empty = hamt.make();
    /**
    Does `map` contain any elements?
*/ var isEmpty = hamt.isEmpty = function(map) {
        return map && !!isEmptyNode(map._root);
    };
    Map1.prototype.isEmpty = function() {
        return isEmpty(this);
    };
    /* Updates
 ******************************************************************************/ /**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/ var modifyHash = hamt.modifyHash = function(f, hash, key, map) {
        var size = {
            value: map._size
        };
        var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);
        return map.setTree(newRoot, size.value);
    };
    Map1.prototype.modifyHash = function(hash, key, f) {
        return modifyHash(f, hash, key, this);
    };
    /**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/ var modify = hamt.modify = function(f, key, map) {
        return modifyHash(f, map._config.hash(key), key, map);
    };
    Map1.prototype.modify = function(key, f) {
        return modify(f, key, this);
    };
    /**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/ var setHash = hamt.setHash = function(hash, key, value, map) {
        return modifyHash(constant(value), hash, key, map);
    };
    Map1.prototype.setHash = function(hash, key, value) {
        return setHash(hash, key, value, this);
    };
    /**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/ var set = hamt.set = function(key, value, map) {
        return setHash(map._config.hash(key), key, value, map);
    };
    Map1.prototype.set = function(key, value) {
        return set(key, value, this);
    };
    /**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/ var del = constant(nothing);
    var removeHash = hamt.removeHash = function(hash, key, map) {
        return modifyHash(del, hash, key, map);
    };
    Map1.prototype.removeHash = Map1.prototype.deleteHash = function(hash, key) {
        return removeHash(hash, key, this);
    };
    /**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/ var remove = hamt.remove = function(key, map) {
        return removeHash(map._config.hash(key), key, map);
    };
    Map1.prototype.remove = Map1.prototype.delete = function(key) {
        return remove(key, this);
    };
    /* Mutation
 ******************************************************************************/ /**
    Mark `map` as mutable.
 */ var beginMutation = hamt.beginMutation = function(map) {
        return new Map1(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
    };
    Map1.prototype.beginMutation = function() {
        return beginMutation(this);
    };
    /**
    Mark `map` as immutable.
 */ var endMutation = hamt.endMutation = function(map) {
        map._editable = map._editable && map._editable - 1;
        return map;
    };
    Map1.prototype.endMutation = function() {
        return endMutation(this);
    };
    /**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/ var mutate = hamt.mutate = function(f, map) {
        var transient = beginMutation(map);
        f(transient);
        return endMutation(transient);
    };
    Map1.prototype.mutate = function(f) {
        return mutate(f, this);
    };
    /* Traversal
 ******************************************************************************/ /**
    Apply a continuation.
*/ var appk = function appk(k) {
        return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
    };
    /**
    Recursively visit all values stored in an array of nodes lazily.
*/ var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
        while(i < len){
            var child = children[i++];
            if (child && !isEmptyNode(child)) return lazyVisit(child, f, [
                len,
                children,
                i,
                f,
                k
            ]);
        }
        return appk(k);
    };
    /**
    Recursively visit all values stored in `node` lazily.
*/ var lazyVisit = function lazyVisit(node, f, k) {
        switch(node.type){
            case LEAF:
                return {
                    value: f(node),
                    rest: k
                };
            case COLLISION:
            case ARRAY:
            case INDEX:
                var children = node.children;
                return lazyVisitChildren(children.length, children, 0, f, k);
            default:
                return appk(k);
        }
    };
    var DONE = {
        done: true
    };
    /**
    Javascript iterator over a map.
*/ function MapIterator(v) {
        this.v = v;
    }
    MapIterator.prototype.next = function() {
        if (!this.v) return DONE;
        var v0 = this.v;
        this.v = appk(v0.rest);
        return v0;
    };
    MapIterator.prototype[Symbol.iterator] = function() {
        return this;
    };
    /**
    Lazily visit each value in map with function `f`.
*/ var visit = function visit(map, f) {
        return new MapIterator(lazyVisit(map._root, f));
    };
    /**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/ var buildPairs = function buildPairs(x) {
        return [
            x.key,
            x.value
        ];
    };
    var entries = hamt.entries = function(map) {
        return visit(map, buildPairs);
    };
    Map1.prototype.entries = Map1.prototype[Symbol.iterator] = function() {
        return entries(this);
    };
    /**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/ var buildKeys = function buildKeys(x) {
        return x.key;
    };
    var keys = hamt.keys = function(map) {
        return visit(map, buildKeys);
    };
    Map1.prototype.keys = function() {
        return keys(this);
    };
    /**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/ var buildValues = function buildValues(x) {
        return x.value;
    };
    var values = hamt.values = Map1.prototype.values = function(map) {
        return visit(map, buildValues);
    };
    Map1.prototype.values = function() {
        return values(this);
    };
    /* Fold
 ******************************************************************************/ /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/ var fold = hamt.fold = function(f, z, m) {
        var root = m._root;
        if (root.type === LEAF) return f(z, root.value, root.key);
        var toVisit = [
            root.children
        ];
        var children = void 0;
        while(children = toVisit.pop())for(var i = 0, len = children.length; i < len;){
            var child = children[i++];
            if (child && child.type) {
                if (child.type === LEAF) z = f(z, child.value, child.key);
                else toVisit.push(child.children);
            }
        }
        return z;
    };
    Map1.prototype.fold = function(f, z) {
        return fold(f, z, this);
    };
    /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/ var forEach = hamt.forEach = function(f, map) {
        return fold(function(_, value, key) {
            return f(value, key, map);
        }, null, map);
    };
    Map1.prototype.forEach = function(f) {
        return forEach(f, this);
    };
    /* Aggregate
 ******************************************************************************/ /**
    Get the number of entries in `map`.
*/ var count = hamt.count = function(map) {
        return map._size;
    };
    Map1.prototype.count = function() {
        return count(this);
    };
    Object.defineProperty(Map1.prototype, 'size', {
        get: Map1.prototype.count
    });
    /* Export
 ******************************************************************************/ if (module.exports) module.exports = hamt;
    else undefined.hamt = hamt;
});
class $7ef244517b504261$var$BuiltInMap {
    constructor(existing){
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
    }
    keys() {
        return this._map.keys();
    }
    entries() {
        return this._map.entries();
    }
    get(k) {
        return this._map.get(k);
    }
    has(k) {
        return this._map.has(k);
    }
    set(k, v) {
        this._map.set(k, v);
        return this;
    }
    delete(k) {
        this._map.delete(k);
        return this;
    }
    clone() {
        return $7ef244517b504261$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._map);
    }
}
class $7ef244517b504261$var$HashArrayMappedTrieMap {
    // Because hamt.empty is not a function there is no way to introduce type
    // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
    // $FlowIssue
    constructor(existing){
        $7ef244517b504261$var$_defineProperty(this, "_hamt", $7ef244517b504261$var$hamt_1.empty.beginMutation());
        if (existing instanceof $7ef244517b504261$var$HashArrayMappedTrieMap) {
            const h = existing._hamt.endMutation();
            existing._hamt = h.beginMutation();
            this._hamt = h.beginMutation();
        } else if (existing) for (const [k, v] of existing.entries())this._hamt.set(k, v);
    }
    keys() {
        return this._hamt.keys();
    }
    entries() {
        return this._hamt.entries();
    }
    get(k) {
        return this._hamt.get(k);
    }
    has(k) {
        return this._hamt.has(k);
    }
    set(k, v) {
        this._hamt.set(k, v);
        return this;
    }
    delete(k) {
        this._hamt.delete(k);
        return this;
    }
    clone() {
        return $7ef244517b504261$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._hamt);
    }
}
function $7ef244517b504261$var$persistentMap(existing) {
    if ($7ef244517b504261$var$Recoil_gkx('recoil_hamt_2020')) return new $7ef244517b504261$var$HashArrayMappedTrieMap(existing);
    else return new $7ef244517b504261$var$BuiltInMap(existing);
}
var $7ef244517b504261$var$Recoil_PersistentMap = {
    persistentMap: $7ef244517b504261$var$persistentMap
};
var $7ef244517b504261$var$Recoil_PersistentMap_1 = $7ef244517b504261$var$Recoil_PersistentMap.persistentMap;
var $7ef244517b504261$var$Recoil_PersistentMap$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    persistentMap: $7ef244517b504261$var$Recoil_PersistentMap_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */ function $7ef244517b504261$var$differenceSets(set, ...setsWithValuesToRemove) {
    const ret = new Set();
    FIRST: for (const value of set){
        for (const otherSet of setsWithValuesToRemove){
            if (otherSet.has(value)) continue FIRST;
        }
        ret.add(value);
    }
    return ret;
}
var $7ef244517b504261$var$Recoil_differenceSets = $7ef244517b504261$var$differenceSets;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */ function $7ef244517b504261$var$mapMap(map, callback) {
    const result = new Map();
    map.forEach((value, key)=>{
        result.set(key, callback(value, key));
    });
    return result;
}
var $7ef244517b504261$var$Recoil_mapMap = $7ef244517b504261$var$mapMap;
function $7ef244517b504261$var$makeGraph() {
    return {
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map()
    };
}
function $7ef244517b504261$var$cloneGraph(graph) {
    return {
        nodeDeps: $7ef244517b504261$var$Recoil_mapMap(graph.nodeDeps, (s)=>new Set(s)),
        nodeToNodeSubscriptions: $7ef244517b504261$var$Recoil_mapMap(graph.nodeToNodeSubscriptions, (s)=>new Set(s))
    };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.
function $7ef244517b504261$var$mergeDepsIntoGraph(key, newDeps, graph, // graph compared with olderGraph:
olderGraph) {
    const { nodeDeps: nodeDeps, nodeToNodeSubscriptions: nodeToNodeSubscriptions } = graph;
    const oldDeps = nodeDeps.get(key);
    if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) return;
     // Update nodeDeps:
    nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:
    const addedDeps = oldDeps == null ? newDeps : $7ef244517b504261$var$Recoil_differenceSets(newDeps, oldDeps);
    for (const dep of addedDeps){
        if (!nodeToNodeSubscriptions.has(dep)) nodeToNodeSubscriptions.set(dep, new Set());
        const existing = $7ef244517b504261$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
        existing.add(key);
    } // Remove removed deps from nodeToNodeSubscriptions:
    if (oldDeps) {
        const removedDeps = $7ef244517b504261$var$Recoil_differenceSets(oldDeps, newDeps);
        for (const dep of removedDeps){
            if (!nodeToNodeSubscriptions.has(dep)) return;
            const existing = $7ef244517b504261$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
            existing.delete(key);
            if (existing.size === 0) nodeToNodeSubscriptions.delete(dep);
        }
    }
}
function $7ef244517b504261$var$saveDepsToStore(key, deps, store, version) {
    var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
    const storeState = store.getState();
    if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $7ef244517b504261$var$Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
     // Merge the dependencies discovered into the store's dependency map
    // for the version that was read:
    const graph = store.getGraph(version);
    $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
    // into later versions if they don't already have their own:
    if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
        const currentGraph = store.getGraph(storeState.currentTree.version);
        $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, currentGraph, graph);
    }
    if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
        var _storeState$nextTree2;
        const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
        if (nextVersion !== undefined) {
            const nextGraph = store.getGraph(nextVersion);
            $7ef244517b504261$var$mergeDepsIntoGraph(key, deps, nextGraph, graph);
        }
    }
}
var $7ef244517b504261$var$Recoil_Graph = {
    cloneGraph: $7ef244517b504261$var$cloneGraph,
    graph: $7ef244517b504261$var$makeGraph,
    saveDepsToStore: $7ef244517b504261$var$saveDepsToStore
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $7ef244517b504261$var$nextTreeStateVersion = 0;
const $7ef244517b504261$var$getNextTreeStateVersion = ()=>$7ef244517b504261$var$nextTreeStateVersion++;
let $7ef244517b504261$var$nextStoreID = 0;
const $7ef244517b504261$var$getNextStoreID = ()=>$7ef244517b504261$var$nextStoreID++;
let $7ef244517b504261$var$nextComponentID = 0;
const $7ef244517b504261$var$getNextComponentID = ()=>$7ef244517b504261$var$nextComponentID++;
var $7ef244517b504261$var$Recoil_Keys = {
    getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion,
    getNextStoreID: $7ef244517b504261$var$getNextStoreID,
    getNextComponentID: $7ef244517b504261$var$getNextComponentID
};
const { persistentMap: $7ef244517b504261$var$persistentMap$1 } = $7ef244517b504261$var$Recoil_PersistentMap$1;
const { graph: $7ef244517b504261$var$graph } = $7ef244517b504261$var$Recoil_Graph;
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$1 } = $7ef244517b504261$var$Recoil_Keys;
function $7ef244517b504261$var$makeEmptyTreeState() {
    const version = $7ef244517b504261$var$getNextTreeStateVersion$1();
    return {
        version: version,
        stateID: version,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: $7ef244517b504261$var$persistentMap$1(),
        nonvalidatedAtoms: $7ef244517b504261$var$persistentMap$1()
    };
}
function $7ef244517b504261$var$makeEmptyStoreState() {
    const currentTree = $7ef244517b504261$var$makeEmptyTreeState();
    return {
        currentTree: currentTree,
        nextTree: null,
        previousTree: null,
        commitDepth: 0,
        knownAtoms: new Set(),
        knownSelectors: new Set(),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(currentTree.version, $7ef244517b504261$var$graph()),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        nodeCleanupFunctions: new Map()
    };
}
var $7ef244517b504261$var$Recoil_State = {
    makeEmptyTreeState: $7ef244517b504261$var$makeEmptyTreeState,
    makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState,
    getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$RetentionZone {
}
function $7ef244517b504261$var$retentionZone() {
    return new $7ef244517b504261$var$RetentionZone();
}
var $7ef244517b504261$var$Recoil_RetentionZone = {
    RetentionZone: $7ef244517b504261$var$RetentionZone,
    retentionZone: $7ef244517b504261$var$retentionZone
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$setByAddingToSet(set, v) {
    const next = new Set(set);
    next.add(v);
    return next;
}
function $7ef244517b504261$var$setByDeletingFromSet(set, v) {
    const next = new Set(set);
    next.delete(v);
    return next;
}
function $7ef244517b504261$var$mapBySettingInMap(map, k, v) {
    const next = new Map(map);
    next.set(k, v);
    return next;
}
function $7ef244517b504261$var$mapByUpdatingInMap(map, k, updater) {
    const next = new Map(map);
    next.set(k, updater(next.get(k)));
    return next;
}
function $7ef244517b504261$var$mapByDeletingFromMap(map, k) {
    const next = new Map(map);
    next.delete(k);
    return next;
}
function $7ef244517b504261$var$mapByDeletingMultipleFromMap(map, ks) {
    const next = new Map(map);
    ks.forEach((k)=>next.delete(k));
    return next;
}
var $7ef244517b504261$var$Recoil_CopyOnWrite = {
    setByAddingToSet: $7ef244517b504261$var$setByAddingToSet,
    setByDeletingFromSet: $7ef244517b504261$var$setByDeletingFromSet,
    mapBySettingInMap: $7ef244517b504261$var$mapBySettingInMap,
    mapByUpdatingInMap: $7ef244517b504261$var$mapByUpdatingInMap,
    mapByDeletingFromMap: $7ef244517b504261$var$mapByDeletingFromMap,
    mapByDeletingMultipleFromMap: $7ef244517b504261$var$mapByDeletingMultipleFromMap
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */ function* $7ef244517b504261$var$filterIterable(iterable, predicate) {
    // Use generator to create iterable/iterator
    let index = 0;
    for (const value of iterable)if (predicate(value, index++)) yield value;
}
var $7ef244517b504261$var$Recoil_filterIterable = $7ef244517b504261$var$filterIterable;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */ // $FlowIssue[unclear-type]
function $7ef244517b504261$var$lazyProxy(base, factories) {
    const proxy = new Proxy(base, {
        // Compute and cache lazy property if not already done.
        get: (target, prop)=>{
            if (!(prop in target) && prop in factories) target[prop] = factories[prop]();
            return target[prop];
        },
        // This method allows user to iterate keys as normal
        ownKeys: (target)=>{
            return Object.keys(target);
        }
    }); // $FlowIssue[incompatible-return]
    return proxy;
}
var $7ef244517b504261$var$Recoil_lazyProxy = $7ef244517b504261$var$lazyProxy;
const { getNode: $7ef244517b504261$var$getNode$1, getNodeMaybe: $7ef244517b504261$var$getNodeMaybe$1, recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys$1 } = $7ef244517b504261$var$Recoil_Node;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$1 } = $7ef244517b504261$var$Recoil_RetentionZone;
const { setByAddingToSet: $7ef244517b504261$var$setByAddingToSet$1 } = $7ef244517b504261$var$Recoil_CopyOnWrite;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$emptySet = Object.freeze(new Set());
class $7ef244517b504261$var$ReadOnlyRecoilValueError extends Error {
}
function $7ef244517b504261$var$initializeRetentionForNode(store, nodeKey, retainedBy) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return ()=>undefined;
    const { nodesRetainedByZone: nodesRetainedByZone } = store.getState().retention;
    function addToZone(zone) {
        let set = nodesRetainedByZone.get(zone);
        if (!set) nodesRetainedByZone.set(zone, set = new Set());
        set.add(nodeKey);
    }
    if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$1) addToZone(retainedBy);
    else if (Array.isArray(retainedBy)) for (const zone of retainedBy)addToZone(zone);
    return ()=>{
        if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
        const { retention: retention } = store.getState();
        function deleteFromZone(zone) {
            const set = retention.nodesRetainedByZone.get(zone);
            set === null || set === void 0 || set.delete(nodeKey);
            if (set && set.size === 0) retention.nodesRetainedByZone.delete(zone);
        }
        if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$1) deleteFromZone(retainedBy);
        else if (Array.isArray(retainedBy)) for (const zone of retainedBy)deleteFromZone(zone);
    };
}
function $7ef244517b504261$var$initializeNodeIfNewToStore(store, treeState, key, trigger) {
    const storeState = store.getState();
    if (storeState.nodeCleanupFunctions.has(key)) return;
    const node = $7ef244517b504261$var$getNode$1(key);
    const retentionCleanup = $7ef244517b504261$var$initializeRetentionForNode(store, key, node.retainedBy);
    const nodeCleanup = node.init(store, treeState, trigger);
    storeState.nodeCleanupFunctions.set(key, ()=>{
        nodeCleanup();
        retentionCleanup();
    });
}
function $7ef244517b504261$var$initializeNode(store, key, trigger) {
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function $7ef244517b504261$var$cleanUpNode(store, key) {
    var _state$nodeCleanupFun;
    const state = store.getState();
    (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 || _state$nodeCleanupFun();
    state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.
function $7ef244517b504261$var$getNodeLoadable(store, state, key) {
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, state, key, 'get');
    return $7ef244517b504261$var$getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change
function $7ef244517b504261$var$peekNodeLoadable(store, state, key) {
    return $7ef244517b504261$var$getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.
function $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
    var _node$invalidate;
    const node = $7ef244517b504261$var$getNodeMaybe$1(key);
    node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
    return {
        ...state,
        atomValues: state.atomValues.clone().delete(key),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
        dirtyAtoms: $7ef244517b504261$var$setByAddingToSet$1(state.dirtyAtoms, key)
    };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)
function $7ef244517b504261$var$setNodeValue(store, state, key, newValue) {
    const node = $7ef244517b504261$var$getNode$1(key);
    if (node.set == null) throw new $7ef244517b504261$var$ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
    const set = node.set; // so flow doesn't lose the above refinement.
    $7ef244517b504261$var$initializeNodeIfNewToStore(store, state, key, 'set');
    return set(store, state, newValue);
}
function $7ef244517b504261$var$peekNodeInfo(store, state, key) {
    const storeState = store.getState();
    const graph = store.getGraph(state.version);
    const type = $7ef244517b504261$var$getNode$1(key).nodeType;
    return $7ef244517b504261$var$Recoil_lazyProxy({
        type: type
    }, {
        // $FlowFixMe[underconstrained-implicit-instantiation]
        loadable: ()=>$7ef244517b504261$var$peekNodeLoadable(store, state, key),
        isActive: ()=>storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
        isSet: ()=>type === 'selector' ? false : state.atomValues.has(key),
        isModified: ()=>state.dirtyAtoms.has(key),
        // Report current dependencies.  If the node hasn't been evaluated, then
        // dependencies may be missing based on the current state.
        deps: ()=>{
            var _graph$nodeDeps$get;
            return $7ef244517b504261$var$recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
        },
        // Reports all "current" subscribers.  Evaluating other nodes or
        // previous in-progress async evaluations may introduce new subscribers.
        subscribers: ()=>{
            var _storeState$nodeToCom, _storeState$nodeToCom2;
            return {
                nodes: $7ef244517b504261$var$recoilValuesForKeys$1($7ef244517b504261$var$Recoil_filterIterable($7ef244517b504261$var$getDownstreamNodes(store, state, new Set([
                    key
                ])), (nodeKey)=>nodeKey !== key)),
                components: $7ef244517b504261$var$Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name])=>({
                        name: name
                    }))
            };
        }
    });
} // Find all of the recursively dependent nodes
function $7ef244517b504261$var$getDownstreamNodes(store, state, keys) {
    const visitedNodes = new Set();
    const visitingNodes = Array.from(keys);
    const graph = store.getGraph(state.version);
    for(let key = visitingNodes.pop(); key; key = visitingNodes.pop()){
        var _graph$nodeToNodeSubs;
        visitedNodes.add(key);
        const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : $7ef244517b504261$var$emptySet;
        for (const downstreamNode of subscribedNodes)if (!visitedNodes.has(downstreamNode)) visitingNodes.push(downstreamNode);
    }
    return visitedNodes;
}
var $7ef244517b504261$var$Recoil_FunctionalCore = {
    getNodeLoadable: $7ef244517b504261$var$getNodeLoadable,
    peekNodeLoadable: $7ef244517b504261$var$peekNodeLoadable,
    setNodeValue: $7ef244517b504261$var$setNodeValue,
    initializeNode: $7ef244517b504261$var$initializeNode,
    cleanUpNode: $7ef244517b504261$var$cleanUpNode,
    setUnvalidatedAtomValue_DEPRECATED: $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED,
    peekNodeInfo: $7ef244517b504261$var$peekNodeInfo,
    getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $7ef244517b504261$var$_invalidateMemoizedSnapshot = null;
function $7ef244517b504261$var$setInvalidateMemoizedSnapshot(invalidate) {
    $7ef244517b504261$var$_invalidateMemoizedSnapshot = invalidate;
}
function $7ef244517b504261$var$invalidateMemoizedSnapshot() {
    var _invalidateMemoizedSn;
    (_invalidateMemoizedSn = $7ef244517b504261$var$_invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 || _invalidateMemoizedSn();
}
var $7ef244517b504261$var$Recoil_SnapshotCache = {
    setInvalidateMemoizedSnapshot: $7ef244517b504261$var$setInvalidateMemoizedSnapshot,
    invalidateMemoizedSnapshot: $7ef244517b504261$var$invalidateMemoizedSnapshot
};
const { getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes$1, getNodeLoadable: $7ef244517b504261$var$getNodeLoadable$1, setNodeValue: $7ef244517b504261$var$setNodeValue$1 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { getNextComponentID: $7ef244517b504261$var$getNextComponentID$1 } = $7ef244517b504261$var$Recoil_Keys;
const { getNode: $7ef244517b504261$var$getNode$2, getNodeMaybe: $7ef244517b504261$var$getNodeMaybe$2 } = $7ef244517b504261$var$Recoil_Node;
const { DefaultValue: $7ef244517b504261$var$DefaultValue$1 } = $7ef244517b504261$var$Recoil_Node;
const { reactMode: $7ef244517b504261$var$reactMode$1 } = $7ef244517b504261$var$Recoil_ReactMode;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$1, RecoilState: $7ef244517b504261$var$RecoilState$1, RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly$1, isRecoilValue: $7ef244517b504261$var$isRecoilValue$1 } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { invalidateMemoizedSnapshot: $7ef244517b504261$var$invalidateMemoizedSnapshot$1 } = $7ef244517b504261$var$Recoil_SnapshotCache;
function $7ef244517b504261$var$getRecoilValueAsLoadable(store, { key: key }, treeState = store.getState().currentTree) {
    var _storeState$nextTree, _storeState$previousT;
    // Reading from an older tree can cause bugs because the dependencies that we
    // discover during the read are lost.
    const storeState = store.getState();
    if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $7ef244517b504261$var$Recoil_recoverableViolation('Tried to read from a discarded tree');
    const loadable = $7ef244517b504261$var$getNodeLoadable$1(store, treeState, key);
    if (loadable.state === 'loading') loadable.contents.catch(()=>{
        /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */ return;
    });
    return loadable;
}
function $7ef244517b504261$var$applyAtomValueWrites(atomValues, writes) {
    const result = atomValues.clone();
    writes.forEach((v, k)=>{
        if (v.state === 'hasValue' && v.contents instanceof $7ef244517b504261$var$DefaultValue$1) result.delete(k);
        else result.set(k, v);
    });
    return result;
}
function $7ef244517b504261$var$valueFromValueOrUpdater(store, state, { key: key }, valueOrUpdater) {
    if (typeof valueOrUpdater === 'function') {
        // Updater form: pass in the current value. Throw if the current value
        // is unavailable (namely when updating an async selector that's
        // pending or errored):
        const current = $7ef244517b504261$var$getNodeLoadable$1(store, state, key);
        if (current.state === 'loading') {
            const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
            $7ef244517b504261$var$Recoil_recoverableViolation(msg);
            throw $7ef244517b504261$var$Recoil_err(msg);
        } else if (current.state === 'hasError') throw current.contents;
         // T itself may be a function, so our refinement is not sufficient:
        return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
    } else return valueOrUpdater;
}
function $7ef244517b504261$var$applyAction(store, state, action) {
    if (action.type === 'set') {
        const { recoilValue: recoilValue, valueOrUpdater: valueOrUpdater } = action;
        const newValue = $7ef244517b504261$var$valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
        const writes = $7ef244517b504261$var$setNodeValue$1(store, state, recoilValue.key, newValue);
        for (const [key, loadable] of writes.entries())$7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === 'setLoadable') {
        const { recoilValue: { key: key }, loadable: loadable } = action;
        $7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === 'markModified') {
        const { recoilValue: { key: key } } = action;
        state.dirtyAtoms.add(key);
    } else if (action.type === 'setUnvalidated') {
        var _node$invalidate;
        // Write value directly to state bypassing the Node interface as the node
        // definitions may not have been loaded yet when processing the initial snapshot.
        const { recoilValue: { key: key }, unvalidatedValue: unvalidatedValue } = action;
        const node = $7ef244517b504261$var$getNodeMaybe$2(key);
        node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
        state.atomValues.delete(key);
        state.nonvalidatedAtoms.set(key, unvalidatedValue);
        state.dirtyAtoms.add(key);
    } else $7ef244517b504261$var$Recoil_recoverableViolation(`Unknown action ${action.type}`);
}
function $7ef244517b504261$var$writeLoadableToTreeState(state, key, loadable) {
    if (loadable.state === 'hasValue' && loadable.contents instanceof $7ef244517b504261$var$DefaultValue$1) state.atomValues.delete(key);
    else state.atomValues.set(key, loadable);
    state.dirtyAtoms.add(key);
    state.nonvalidatedAtoms.delete(key);
}
function $7ef244517b504261$var$applyActionsToStore(store, actions) {
    store.replaceState((state)=>{
        const newState = $7ef244517b504261$var$copyTreeState(state);
        for (const action of actions)$7ef244517b504261$var$applyAction(store, newState, action);
        $7ef244517b504261$var$invalidateDownstreams(store, newState);
        $7ef244517b504261$var$invalidateMemoizedSnapshot$1();
        return newState;
    });
}
function $7ef244517b504261$var$queueOrPerformStateUpdate(store, action) {
    if ($7ef244517b504261$var$batchStack.length) {
        const actionsByStore = $7ef244517b504261$var$batchStack[$7ef244517b504261$var$batchStack.length - 1];
        let actions = actionsByStore.get(store);
        if (!actions) actionsByStore.set(store, actions = []);
        actions.push(action);
    } else $7ef244517b504261$var$applyActionsToStore(store, [
        action
    ]);
}
const $7ef244517b504261$var$batchStack = [];
function $7ef244517b504261$var$batchStart() {
    const actionsByStore = new Map();
    $7ef244517b504261$var$batchStack.push(actionsByStore);
    return ()=>{
        for (const [store, actions] of actionsByStore)$7ef244517b504261$var$applyActionsToStore(store, actions);
        const popped = $7ef244517b504261$var$batchStack.pop();
        if (popped !== actionsByStore) $7ef244517b504261$var$Recoil_recoverableViolation('Incorrect order of batch popping');
    };
}
function $7ef244517b504261$var$copyTreeState(state) {
    return {
        ...state,
        atomValues: state.atomValues.clone(),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
        dirtyAtoms: new Set(state.dirtyAtoms)
    };
}
function $7ef244517b504261$var$invalidateDownstreams(store, state) {
    // Inform any nodes that were changed or downstream of changes so that they
    // can clear out any caches as needed due to the update:
    const downstreams = $7ef244517b504261$var$getDownstreamNodes$1(store, state, state.dirtyAtoms);
    for (const key of downstreams){
        var _getNodeMaybe, _getNodeMaybe$invalid;
        (_getNodeMaybe = $7ef244517b504261$var$getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 || (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 || _getNodeMaybe$invalid.call(_getNodeMaybe, state);
    }
}
function $7ef244517b504261$var$setRecoilValue(store, recoilValue, valueOrUpdater) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: 'set',
        recoilValue: recoilValue,
        valueOrUpdater: valueOrUpdater
    });
}
function $7ef244517b504261$var$setRecoilValueLoadable(store, recoilValue, loadable) {
    if (loadable instanceof $7ef244517b504261$var$DefaultValue$1) return $7ef244517b504261$var$setRecoilValue(store, recoilValue, loadable);
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: 'setLoadable',
        recoilValue: recoilValue,
        loadable: loadable
    });
}
function $7ef244517b504261$var$markRecoilValueModified(store, recoilValue) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: 'markModified',
        recoilValue: recoilValue
    });
}
function $7ef244517b504261$var$setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
    $7ef244517b504261$var$queueOrPerformStateUpdate(store, {
        type: 'setUnvalidated',
        recoilValue: recoilValue,
        unvalidatedValue: unvalidatedValue
    });
}
function $7ef244517b504261$var$subscribeToRecoilValue(store, { key: key }, callback, componentDebugName = null) {
    const subID = $7ef244517b504261$var$getNextComponentID$1();
    const storeState = store.getState();
    if (!storeState.nodeToComponentSubscriptions.has(key)) storeState.nodeToComponentSubscriptions.set(key, new Map());
    $7ef244517b504261$var$Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [
        componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>',
        callback
    ]); // Handle the case that, during the same tick that we are subscribing, an atom
    // has been updated by some effect handler. Otherwise we will miss the update.
    const mode = $7ef244517b504261$var$reactMode$1();
    if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
        const nextTree = store.getState().nextTree;
        if (nextTree && nextTree.dirtyAtoms.has(key)) callback(nextTree);
    }
    return {
        release: ()=>{
            const releaseStoreState = store.getState();
            const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
            if (subs === undefined || !subs.has(subID)) {
                $7ef244517b504261$var$Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
                return;
            }
            subs.delete(subID);
            if (subs.size === 0) releaseStoreState.nodeToComponentSubscriptions.delete(key);
        }
    };
}
function $7ef244517b504261$var$refreshRecoilValue(store, recoilValue) {
    var _node$clearCache;
    const { currentTree: currentTree } = store.getState();
    const node = $7ef244517b504261$var$getNode$2(recoilValue.key);
    (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, currentTree);
}
var $7ef244517b504261$var$Recoil_RecoilValueInterface = {
    RecoilValueReadOnly: $7ef244517b504261$var$RecoilValueReadOnly$1,
    AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$1,
    RecoilState: $7ef244517b504261$var$RecoilState$1,
    getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable,
    setRecoilValue: $7ef244517b504261$var$setRecoilValue,
    setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable,
    markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified,
    setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue,
    subscribeToRecoilValue: $7ef244517b504261$var$subscribeToRecoilValue,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue$1,
    applyAtomValueWrites: $7ef244517b504261$var$applyAtomValueWrites,
    batchStart: // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
    $7ef244517b504261$var$batchStart,
    writeLoadableToTreeState: $7ef244517b504261$var$writeLoadableToTreeState,
    invalidateDownstreams: $7ef244517b504261$var$invalidateDownstreams,
    copyTreeState: $7ef244517b504261$var$copyTreeState,
    refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */ function $7ef244517b504261$var$someSet(set, callback, context) {
    const iterator = set.entries();
    let current = iterator.next();
    while(!current.done){
        const entry = current.value;
        if (callback.call(context, entry[1], entry[0], set)) return true;
        current = iterator.next();
    }
    return false;
}
var $7ef244517b504261$var$Recoil_someSet = $7ef244517b504261$var$someSet;
const { cleanUpNode: $7ef244517b504261$var$cleanUpNode$1 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { deleteNodeConfigIfPossible: $7ef244517b504261$var$deleteNodeConfigIfPossible$1, getNode: $7ef244517b504261$var$getNode$3 } = $7ef244517b504261$var$Recoil_Node;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$2 } = $7ef244517b504261$var$Recoil_RetentionZone;
// Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.
const $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS = 120000;
const $7ef244517b504261$var$emptySet$1 = new Set();
function $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, retainables) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    if (storeState.nextTree) {
        $7ef244517b504261$var$Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
        return; // leak memory rather than erase something that's about to be used.
    }
    const nodes = new Set();
    for (const r of retainables){
        if (r instanceof $7ef244517b504261$var$RetentionZone$2) for (const n of $7ef244517b504261$var$nodesRetainedByZone(storeState, r))nodes.add(n);
        else nodes.add(r);
    }
    const releasableNodes = $7ef244517b504261$var$findReleasableNodes(store, nodes);
    for (const node of releasableNodes)$7ef244517b504261$var$releaseNode(store, treeState, node);
}
function $7ef244517b504261$var$findReleasableNodes(store, searchFromNodes) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    const graph = store.getGraph(treeState.version);
    const releasableNodes = new Set(); // mutated to collect answer
    const nonReleasableNodes = new Set();
    findReleasableNodesInner(searchFromNodes);
    return releasableNodes;
    function findReleasableNodesInner(searchFromNodes) {
        const releasableNodesFoundThisIteration = new Set();
        const downstreams = $7ef244517b504261$var$getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, nonReleasableNodes // don't descend into these
        ); // Find which of the downstream nodes are releasable and which are not:
        for (const node of downstreams){
            var _storeState$retention;
            // Not releasable if configured to be retained forever:
            if ($7ef244517b504261$var$getNode$3(node).retainedBy === 'recoilRoot') {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained directly by a component:
            if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained by a zone:
            if ($7ef244517b504261$var$zonesThatCouldRetainNode(node).some((z)=>storeState.retention.referenceCounts.get(z))) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if it has a non-releasable child (which will already be in
            // nonReleasableNodes because we are going in topological order):
            const nodeChildren = graph.nodeToNodeSubscriptions.get(node);
            if (nodeChildren && $7ef244517b504261$var$Recoil_someSet(nodeChildren, (child)=>nonReleasableNodes.has(child))) {
                nonReleasableNodes.add(node);
                continue;
            }
            releasableNodes.add(node);
            releasableNodesFoundThisIteration.add(node);
        } // If we found any releasable nodes, we need to walk UP from those nodes to
        // find whether their parents can now be released as well:
        const parents = new Set();
        for (const node of releasableNodesFoundThisIteration)for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : $7ef244517b504261$var$emptySet$1){
            var _graph$nodeDeps$get;
            if (!releasableNodes.has(parent)) parents.add(parent);
        }
        if (parents.size) findReleasableNodesInner(parents);
    }
} // Children before parents
function $7ef244517b504261$var$getDownstreamNodesInTopologicalOrder(store, treeState, nodes, doNotDescendInto1, doNotDescendInto2) {
    const graph = store.getGraph(treeState.version);
    const answer = [];
    const visited = new Set();
    while(nodes.size > 0)visit($7ef244517b504261$var$Recoil_nullthrows(nodes.values().next().value));
    return answer;
    function visit(node) {
        if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
            nodes.delete(node);
            return;
        }
        if (visited.has(node)) return;
        const children = graph.nodeToNodeSubscriptions.get(node);
        if (children) for (const child of children)visit(child);
        visited.add(node);
        nodes.delete(node);
        answer.push(node);
    }
}
function $7ef244517b504261$var$releaseNode(store, treeState, node) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
     // Atom effects, in-closure caches, etc.:
    $7ef244517b504261$var$cleanUpNode$1(store, node); // Delete from store state:
    const storeState = store.getState();
    storeState.knownAtoms.delete(node);
    storeState.knownSelectors.delete(node);
    storeState.nodeTransactionSubscriptions.delete(node);
    storeState.retention.referenceCounts.delete(node);
    const zones = $7ef244517b504261$var$zonesThatCouldRetainNode(node);
    for (const zone of zones){
        var _storeState$retention2;
        (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 || _storeState$retention2.delete(node);
    } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
    // already happens when the last component that was retaining the node unmounts,
    // and this could happen either before or after that.
    // Delete from TreeState and dep graph:
    treeState.atomValues.delete(node);
    treeState.dirtyAtoms.delete(node);
    treeState.nonvalidatedAtoms.delete(node);
    const graph = storeState.graphsByVersion.get(treeState.version);
    if (graph) {
        const deps = graph.nodeDeps.get(node);
        if (deps !== undefined) {
            graph.nodeDeps.delete(node);
            for (const dep of deps){
                var _graph$nodeToNodeSubs;
                (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 || _graph$nodeToNodeSubs.delete(node);
            }
        } // No need to delete sub's deps as there should be no subs at this point.
        // But an invariant would require deleting nodes in topological order.
        graph.nodeToNodeSubscriptions.delete(node);
    } // Node config (for family members only as their configs can be recreated, and
    // only if they are not retained within any other Stores):
    $7ef244517b504261$var$deleteNodeConfigIfPossible$1(node);
}
function $7ef244517b504261$var$nodesRetainedByZone(storeState, zone) {
    var _storeState$retention3;
    return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : $7ef244517b504261$var$emptySet$1;
}
function $7ef244517b504261$var$zonesThatCouldRetainNode(node) {
    const retainedBy = $7ef244517b504261$var$getNode$3(node).retainedBy;
    if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') return [];
    else if (retainedBy instanceof $7ef244517b504261$var$RetentionZone$2) return [
        retainedBy
    ];
    else return retainedBy; // it's an array of zones
}
function $7ef244517b504261$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
    const state = store.getState();
    if (state.nextTree) state.retention.retainablesToCheckForRelease.add(retainable);
    else $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, new Set([
        retainable
    ]));
}
function $7ef244517b504261$var$updateRetainCount(store, retainable, delta) {
    var _map$get;
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    const map = store.getState().retention.referenceCounts;
    const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
    if (newCount === 0) $7ef244517b504261$var$updateRetainCountToZero(store, retainable);
    else map.set(retainable, newCount);
}
function $7ef244517b504261$var$updateRetainCountToZero(store, retainable) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    const map = store.getState().retention.referenceCounts;
    map.delete(retainable);
    $7ef244517b504261$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function $7ef244517b504261$var$releaseScheduledRetainablesNow(store) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
    const state = store.getState();
    $7ef244517b504261$var$releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
    state.retention.retainablesToCheckForRelease.clear();
}
function $7ef244517b504261$var$retainedByOptionWithDefault(r) {
    // The default will change from 'recoilRoot' to 'components' in the future.
    return r === undefined ? 'recoilRoot' : r;
}
var $7ef244517b504261$var$Recoil_Retention = {
    SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS,
    updateRetainCount: $7ef244517b504261$var$updateRetainCount,
    updateRetainCountToZero: $7ef244517b504261$var$updateRetainCountToZero,
    releaseScheduledRetainablesNow: $7ef244517b504261$var$releaseScheduledRetainablesNow,
    retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates } = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports)));
var $7ef244517b504261$var$ReactBatchedUpdates = {
    unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ // @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$1 } = $7ef244517b504261$var$ReactBatchedUpdates; // @oss-only
var $7ef244517b504261$var$Recoil_ReactBatchedUpdates = {
    unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ const { batchStart: $7ef244517b504261$var$batchStart$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { unstable_batchedUpdates: $7ef244517b504261$var$unstable_batchedUpdates$2 } = $7ef244517b504261$var$Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off
/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */ let $7ef244517b504261$var$batcher = $7ef244517b504261$var$unstable_batchedUpdates$2 || ((batchFn)=>batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */ const $7ef244517b504261$var$setBatcher = (newBatcher)=>{
    $7ef244517b504261$var$batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */ const $7ef244517b504261$var$getBatcher = ()=>$7ef244517b504261$var$batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */ const $7ef244517b504261$var$batchUpdates = (callback)=>{
    $7ef244517b504261$var$batcher(()=>{
        let batchEnd = ()=>undefined;
        try {
            batchEnd = $7ef244517b504261$var$batchStart$1();
            callback();
        } finally{
            batchEnd();
        }
    });
};
var $7ef244517b504261$var$Recoil_Batching = {
    getBatcher: $7ef244517b504261$var$getBatcher,
    setBatcher: $7ef244517b504261$var$setBatcher,
    batchUpdates: $7ef244517b504261$var$batchUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */ function* $7ef244517b504261$var$concatIterables(iters) {
    for (const iter of iters)for (const val of iter)yield val;
}
var $7ef244517b504261$var$Recoil_concatIterables = $7ef244517b504261$var$concatIterables;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /* eslint-disable fb-www/typeof-undefined */ const $7ef244517b504261$var$isSSR = typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */ const $7ef244517b504261$var$isWindow = (value)=>!$7ef244517b504261$var$isSSR && (value === window || value instanceof Window);
const $7ef244517b504261$var$isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined
var $7ef244517b504261$var$Recoil_Environment = {
    isSSR: $7ef244517b504261$var$isSSR,
    isReactNative: $7ef244517b504261$var$isReactNative,
    isWindow: $7ef244517b504261$var$isWindow
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */ function $7ef244517b504261$var$memoizeWithArgsHash(fn, hashFunction) {
    let cache;
    return (...args)=>{
        if (!cache) cache = {};
        const key = hashFunction(...args);
        if (!Object.hasOwnProperty.call(cache, key)) cache[key] = fn(...args);
        return cache[key];
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $7ef244517b504261$var$memoizeOneWithArgsHash(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    return (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    const memoizedFn = (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
    const invalidate = ()=>{
        lastKey = null;
    };
    return [
        memoizedFn,
        invalidate
    ];
}
var $7ef244517b504261$var$Recoil_Memoize = {
    memoizeWithArgsHash: $7ef244517b504261$var$memoizeWithArgsHash,
    memoizeOneWithArgsHash: $7ef244517b504261$var$memoizeOneWithArgsHash,
    memoizeOneWithArgsHashAndInvalidation: $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation
};
const { batchUpdates: $7ef244517b504261$var$batchUpdates$1 } = $7ef244517b504261$var$Recoil_Batching;
const { initializeNode: $7ef244517b504261$var$initializeNode$1, peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$1 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { graph: $7ef244517b504261$var$graph$1 } = $7ef244517b504261$var$Recoil_Graph;
const { getNextStoreID: $7ef244517b504261$var$getNextStoreID$1 } = $7ef244517b504261$var$Recoil_Keys;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$1, recoilValues: $7ef244517b504261$var$recoilValues$1, recoilValuesForKeys: $7ef244517b504261$var$recoilValuesForKeys$2 } = $7ef244517b504261$var$Recoil_Node;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$2, getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$1, setRecoilValue: $7ef244517b504261$var$setRecoilValue$1, setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { updateRetainCount: $7ef244517b504261$var$updateRetainCount$1 } = $7ef244517b504261$var$Recoil_Retention;
const { setInvalidateMemoizedSnapshot: $7ef244517b504261$var$setInvalidateMemoizedSnapshot$1 } = $7ef244517b504261$var$Recoil_SnapshotCache;
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$2, makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState$1 } = $7ef244517b504261$var$Recoil_State;
const { isSSR: $7ef244517b504261$var$isSSR$1 } = $7ef244517b504261$var$Recoil_Environment;
const { memoizeOneWithArgsHashAndInvalidation: $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation$1 } = $7ef244517b504261$var$Recoil_Memoize;
// Opaque at this surface because it's part of the public API from here.
const $7ef244517b504261$var$retainWarning = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`; // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.
class $7ef244517b504261$var$Snapshot {
    // eslint-disable-next-line fb-www/no-uninitialized-properties
    constructor(storeState, parentStoreID){
        $7ef244517b504261$var$_defineProperty(this, "_store", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_refCount", 1);
        $7ef244517b504261$var$_defineProperty(this, "getLoadable", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return $7ef244517b504261$var$getRecoilValueAsLoadable$1(this._store, recoilValue);
        });
        $7ef244517b504261$var$_defineProperty(this, "getPromise", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return this.getLoadable(recoilValue).toPromise();
        });
        $7ef244517b504261$var$_defineProperty(this, "getNodes_UNSTABLE", (opt)=>{
            this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors
            if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
                if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) return [];
                const state = this._store.getState().currentTree;
                return $7ef244517b504261$var$recoilValuesForKeys$2(state.dirtyAtoms);
            }
            const knownAtoms = this._store.getState().knownAtoms;
            const knownSelectors = this._store.getState().knownSelectors;
            return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? $7ef244517b504261$var$recoilValues$1.values() : opt.isInitialized === true ? $7ef244517b504261$var$recoilValuesForKeys$2($7ef244517b504261$var$Recoil_concatIterables([
                knownAtoms,
                knownSelectors
            ])) : $7ef244517b504261$var$Recoil_filterIterable($7ef244517b504261$var$recoilValues$1.values(), ({ key: key })=>!knownAtoms.has(key) && !knownSelectors.has(key));
        });
        $7ef244517b504261$var$_defineProperty(this, "getInfo_UNSTABLE", ({ key: key })=>{
            this.checkRefCount_INTERNAL();
            return $7ef244517b504261$var$peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
        });
        $7ef244517b504261$var$_defineProperty(this, "map", (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $7ef244517b504261$var$MutableSnapshot(this, $7ef244517b504261$var$batchUpdates$1);
            mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here
            return mutableSnapshot;
        });
        $7ef244517b504261$var$_defineProperty(this, "asyncMap", async (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $7ef244517b504261$var$MutableSnapshot(this, $7ef244517b504261$var$batchUpdates$1);
            mutableSnapshot.retain(); // Retain new snapshot during async mapper
            await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
            // after the next tick, the same as a new synchronous snapshot.
            mutableSnapshot.autoRelease_INTERNAL();
            return mutableSnapshot;
        });
        this._store = {
            storeID: $7ef244517b504261$var$getNextStoreID$1(),
            parentStoreID: parentStoreID,
            getState: ()=>storeState,
            replaceState: (replacer)=>{
                // no batching, so nextTree is never active
                storeState.currentTree = replacer(storeState.currentTree);
            },
            getGraph: (version)=>{
                const graphs = storeState.graphsByVersion;
                if (graphs.has(version)) return $7ef244517b504261$var$Recoil_nullthrows(graphs.get(version));
                const newGraph = $7ef244517b504261$var$graph$1();
                graphs.set(version, newGraph);
                return newGraph;
            },
            subscribeToTransactions: ()=>({
                    release: ()=>{}
                }),
            addTransactionMetadata: ()=>{
                throw $7ef244517b504261$var$Recoil_err('Cannot subscribe to Snapshots');
            }
        }; // Initialize any nodes that are live in the parent store (primarily so that
        // this snapshot gets counted towards the node's live stores count).
        // TODO Optimize this when cloning snapshots for callbacks
        for (const nodeKey of this._store.getState().knownAtoms){
            $7ef244517b504261$var$initializeNode$1(this._store, nodeKey, 'get');
            $7ef244517b504261$var$updateRetainCount$1(this._store, nodeKey, 1);
        }
        this.autoRelease_INTERNAL();
    }
    retain() {
        if (this._refCount <= 0) $7ef244517b504261$var$Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
        this._refCount++;
        let released = false;
        return ()=>{
            if (!released) {
                released = true;
                this._release();
            }
        };
    }
    /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */ autoRelease_INTERNAL() {
        if (!$7ef244517b504261$var$isSSR$1) // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
        window.setTimeout(()=>this._release(), 10);
    }
    _release() {
        this._refCount--;
        if (this._refCount === 0) {
            this._store.getState().nodeCleanupFunctions.forEach((cleanup)=>cleanup());
            this._store.getState().nodeCleanupFunctions.clear();
            if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
             // Temporarily nerfing this to allow us to find broken call sites without
        // actually breaking anybody yet.
        // for (const k of this._store.getState().knownAtoms) {
        //   updateRetainCountToZero(this._store, k);
        // }
        } else this._refCount;
    }
    isRetained() {
        return this._refCount > 0;
    }
    checkRefCount_INTERNAL() {
        $7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020') && this._refCount;
    }
    getStore_INTERNAL() {
        this.checkRefCount_INTERNAL();
        return this._store;
    }
    getID() {
        this.checkRefCount_INTERNAL();
        return this._store.getState().currentTree.stateID;
    }
    getStoreID() {
        this.checkRefCount_INTERNAL();
        return this._store.storeID;
    }
}
function $7ef244517b504261$var$cloneStoreState(store, treeState, bumpVersion = false) {
    const storeState = store.getState();
    const version = bumpVersion ? $7ef244517b504261$var$getNextTreeStateVersion$2() : treeState.version;
    return {
        // Always clone the TreeState to isolate stores from accidental mutations.
        // For example, reading a selector from a cloned snapshot shouldn't cache
        // in the original treestate which may cause the original to skip
        // initialization of upstream atoms.
        currentTree: {
            // TODO snapshots shouldn't really have versions because a new version number
            // is always assigned when the snapshot is gone to.
            version: bumpVersion ? version : treeState.version,
            stateID: bumpVersion ? version : treeState.stateID,
            transactionMetadata: {
                ...treeState.transactionMetadata
            },
            dirtyAtoms: new Set(treeState.dirtyAtoms),
            atomValues: treeState.atomValues.clone(),
            nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
        },
        commitDepth: 0,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(storeState.knownAtoms),
        // FIXME here's a copy
        knownSelectors: new Set(storeState.knownSelectors),
        // FIXME here's a copy
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        // FIXME here's a copy
        // Create blank cleanup handlers for atoms so snapshots don't re-run
        // atom effects.
        nodeCleanupFunctions: new Map($7ef244517b504261$var$Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key])=>[
                key,
                ()=>{}
            ]))
    };
} // Factory to build a fresh snapshot
function $7ef244517b504261$var$freshSnapshot(initializeState) {
    const snapshot = new $7ef244517b504261$var$Snapshot($7ef244517b504261$var$makeEmptyStoreState$1());
    return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state
const [$7ef244517b504261$var$memoizedCloneSnapshot, $7ef244517b504261$var$invalidateMemoizedSnapshot$2] = $7ef244517b504261$var$memoizeOneWithArgsHashAndInvalidation$1((store, version)=>{
    var _storeState$nextTree;
    const storeState = store.getState();
    const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : $7ef244517b504261$var$Recoil_nullthrows(storeState.previousTree);
    return new $7ef244517b504261$var$Snapshot($7ef244517b504261$var$cloneStoreState(store, treeState), store.storeID);
}, (store, version)=>{
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies
$7ef244517b504261$var$setInvalidateMemoizedSnapshot$1($7ef244517b504261$var$invalidateMemoizedSnapshot$2);
function $7ef244517b504261$var$cloneSnapshot(store, version = 'latest') {
    const snapshot = $7ef244517b504261$var$memoizedCloneSnapshot(store, version);
    if (!snapshot.isRetained()) {
        $7ef244517b504261$var$invalidateMemoizedSnapshot$2();
        return $7ef244517b504261$var$memoizedCloneSnapshot(store, version);
    }
    return snapshot;
}
class $7ef244517b504261$var$MutableSnapshot extends $7ef244517b504261$var$Snapshot {
    constructor(snapshot, batch){
        super($7ef244517b504261$var$cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());
        $7ef244517b504261$var$_defineProperty(this, "_batch", void 0);
        $7ef244517b504261$var$_defineProperty(this, "set", (recoilState, newValueOrUpdater)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
            // read the written value after calling `set`. I would like to remove this
            // behavior and only batch in `Snapshot.map`, but this would be a breaking
            // change potentially.
            this._batch(()=>{
                $7ef244517b504261$var$updateRetainCount$1(store, recoilState.key, 1);
                $7ef244517b504261$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
            });
        });
        $7ef244517b504261$var$_defineProperty(this, "reset", (recoilState)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            this._batch(()=>{
                $7ef244517b504261$var$updateRetainCount$1(store, recoilState.key, 1);
                $7ef244517b504261$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, $7ef244517b504261$var$DEFAULT_VALUE$1);
            });
        });
        $7ef244517b504261$var$_defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", (values)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            $7ef244517b504261$var$batchUpdates$1(()=>{
                for (const [k, v] of values.entries()){
                    $7ef244517b504261$var$updateRetainCount$1(store, k, 1);
                    $7ef244517b504261$var$setUnvalidatedRecoilValue$1(store, new $7ef244517b504261$var$AbstractRecoilValue$2(k), v);
                }
            });
        });
        this._batch = batch;
    }
}
var $7ef244517b504261$var$Recoil_Snapshot = {
    Snapshot: $7ef244517b504261$var$Snapshot,
    MutableSnapshot: $7ef244517b504261$var$MutableSnapshot,
    freshSnapshot: $7ef244517b504261$var$freshSnapshot,
    cloneSnapshot: $7ef244517b504261$var$cloneSnapshot
};
var $7ef244517b504261$var$Recoil_Snapshot_1 = $7ef244517b504261$var$Recoil_Snapshot.Snapshot;
var $7ef244517b504261$var$Recoil_Snapshot_2 = $7ef244517b504261$var$Recoil_Snapshot.MutableSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot_3 = $7ef244517b504261$var$Recoil_Snapshot.freshSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot_4 = $7ef244517b504261$var$Recoil_Snapshot.cloneSnapshot;
var $7ef244517b504261$var$Recoil_Snapshot$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Snapshot: $7ef244517b504261$var$Recoil_Snapshot_1,
    MutableSnapshot: $7ef244517b504261$var$Recoil_Snapshot_2,
    freshSnapshot: $7ef244517b504261$var$Recoil_Snapshot_3,
    cloneSnapshot: $7ef244517b504261$var$Recoil_Snapshot_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$unionSets(...sets) {
    const result = new Set();
    for (const set of sets)for (const value of set)result.add(value);
    return result;
}
var $7ef244517b504261$var$Recoil_unionSets = $7ef244517b504261$var$unionSets;
const { useRef: $7ef244517b504261$var$useRef } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */ function $7ef244517b504261$var$useRefInitOnce(initialValue) {
    // $FlowExpectedError[incompatible-call]
    const ref = $7ef244517b504261$var$useRef(initialValue);
    if (ref.current === initialValue && typeof initialValue === 'function') // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
    return ref;
}
var $7ef244517b504261$var$Recoil_useRefInitOnce = $7ef244517b504261$var$useRefInitOnce;
// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');
const { getNextTreeStateVersion: $7ef244517b504261$var$getNextTreeStateVersion$3, makeEmptyStoreState: $7ef244517b504261$var$makeEmptyStoreState$2 } = $7ef244517b504261$var$Recoil_State;
const { cleanUpNode: $7ef244517b504261$var$cleanUpNode$2, getDownstreamNodes: $7ef244517b504261$var$getDownstreamNodes$2, initializeNode: $7ef244517b504261$var$initializeNode$2, setNodeValue: $7ef244517b504261$var$setNodeValue$2, setUnvalidatedAtomValue_DEPRECATED: $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED$1 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { graph: $7ef244517b504261$var$graph$2 } = $7ef244517b504261$var$Recoil_Graph;
const { cloneGraph: $7ef244517b504261$var$cloneGraph$1 } = $7ef244517b504261$var$Recoil_Graph;
const { getNextStoreID: $7ef244517b504261$var$getNextStoreID$2 } = $7ef244517b504261$var$Recoil_Keys;
const { createMutableSource: $7ef244517b504261$var$createMutableSource$1, reactMode: $7ef244517b504261$var$reactMode$2 } = $7ef244517b504261$var$Recoil_ReactMode;
const { applyAtomValueWrites: $7ef244517b504261$var$applyAtomValueWrites$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { releaseScheduledRetainablesNow: $7ef244517b504261$var$releaseScheduledRetainablesNow$1 } = $7ef244517b504261$var$Recoil_Retention;
const { freshSnapshot: $7ef244517b504261$var$freshSnapshot$1 } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useCallback: $7ef244517b504261$var$useCallback, useContext: $7ef244517b504261$var$useContext, useEffect: $7ef244517b504261$var$useEffect, useMemo: $7ef244517b504261$var$useMemo, useRef: $7ef244517b504261$var$useRef$1, useState: $7ef244517b504261$var$useState } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$notInAContext() {
    throw $7ef244517b504261$var$Recoil_err('This component must be used inside a <RecoilRoot> component.');
}
const $7ef244517b504261$var$defaultStore = Object.freeze({
    storeID: $7ef244517b504261$var$getNextStoreID$2(),
    getState: $7ef244517b504261$var$notInAContext,
    replaceState: $7ef244517b504261$var$notInAContext,
    getGraph: $7ef244517b504261$var$notInAContext,
    subscribeToTransactions: $7ef244517b504261$var$notInAContext,
    addTransactionMetadata: $7ef244517b504261$var$notInAContext
});
let $7ef244517b504261$var$stateReplacerIsBeingExecuted = false;
function $7ef244517b504261$var$startNextTreeIfNeeded(store) {
    if ($7ef244517b504261$var$stateReplacerIsBeingExecuted) throw $7ef244517b504261$var$Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
    const storeState = store.getState();
    if (storeState.nextTree === null) {
        if ($7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020') && $7ef244517b504261$var$Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) // If this is a cascading update (that is, rendering due to one state change
        // invokes a second state change), we won't have cleaned up retainables yet
        // because this normally happens after notifying components. Do it before
        // proceeding with the cascading update so that it remains predictable:
        {
            if (storeState.commitDepth > 0) $7ef244517b504261$var$releaseScheduledRetainablesNow$1(store);
        }
        const version = storeState.currentTree.version;
        const nextVersion = $7ef244517b504261$var$getNextTreeStateVersion$3();
        storeState.nextTree = {
            ...storeState.currentTree,
            version: nextVersion,
            stateID: nextVersion,
            dirtyAtoms: new Set(),
            transactionMetadata: {}
        };
        storeState.graphsByVersion.set(nextVersion, $7ef244517b504261$var$cloneGraph$1($7ef244517b504261$var$Recoil_nullthrows(storeState.graphsByVersion.get(version))));
    }
}
const $7ef244517b504261$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    current: $7ef244517b504261$var$defaultStore
});
const $7ef244517b504261$var$useStoreRef = ()=>$7ef244517b504261$var$useContext($7ef244517b504261$var$AppContext); // $FlowExpectedError[incompatible-call]
const $7ef244517b504261$var$MutableSourceContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $7ef244517b504261$var$useRecoilMutableSource() {
    const mutableSource = $7ef244517b504261$var$useContext($7ef244517b504261$var$MutableSourceContext);
    if (mutableSource == null) $7ef244517b504261$var$Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
    return mutableSource;
}
function $7ef244517b504261$var$notifyComponents(store, storeState, treeState) {
    const dependentNodes = $7ef244517b504261$var$getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
    for (const key of dependentNodes){
        const comps = storeState.nodeToComponentSubscriptions.get(key);
        if (comps) for (const [_subID, [_debugName, callback]] of comps)callback(treeState);
    }
}
function $7ef244517b504261$var$sendEndOfBatchNotifications(store) {
    const storeState = store.getState();
    const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:
    const dirtyAtoms = treeState.dirtyAtoms;
    if (dirtyAtoms.size) {
        // Execute Node-specific subscribers before global subscribers
        for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions){
            if (dirtyAtoms.has(key)) for (const [_, subscription] of subscriptions)subscription(store);
        }
        for (const [_, subscription] of storeState.transactionSubscriptions)subscription(store);
        if (!$7ef244517b504261$var$reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
            // Notifying components is needed to wake from suspense, even when using
            // early rendering.
            $7ef244517b504261$var$notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
            // We need to wake up components not just when some asynchronous selector
            // resolved, but also when changing synchronous values because this may cause
            // a selector to change from asynchronous to synchronous, in which case there
            // would be no follow-up asynchronous resolution to wake us up.
            // TODO OPTIMIZATION Only wake up related downstream components
            storeState.suspendedComponentResolvers.forEach((cb)=>cb());
            storeState.suspendedComponentResolvers.clear();
        }
    } // Special behavior ONLY invoked by useInterface.
    // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
    storeState.queuedComponentCallbacks_DEPRECATED.forEach((cb)=>cb(treeState));
    storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function $7ef244517b504261$var$endBatch(store) {
    const storeState = store.getState();
    storeState.commitDepth++;
    try {
        const { nextTree: nextTree } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
        // because something above RecoilRoot re-rendered:
        if (nextTree == null) return;
         // nextTree is now committed -- note that copying and reset occurs when
        // a transaction begins, in startNextTreeIfNeeded:
        storeState.previousTree = storeState.currentTree;
        storeState.currentTree = nextTree;
        storeState.nextTree = null;
        $7ef244517b504261$var$sendEndOfBatchNotifications(store);
        if (storeState.previousTree != null) storeState.graphsByVersion.delete(storeState.previousTree.version);
        else $7ef244517b504261$var$Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
        storeState.previousTree = null;
        if ($7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) // Only release retainables if there were no writes during the end of the
        // batch.  This avoids releasing something we might be about to use.
        {
            if (nextTree == null) $7ef244517b504261$var$releaseScheduledRetainablesNow$1(store);
        }
    } finally{
        storeState.commitDepth--;
    }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */ function $7ef244517b504261$var$Batcher({ setNotifyBatcherOfChange: setNotifyBatcherOfChange }) {
    const storeRef = $7ef244517b504261$var$useStoreRef();
    const [, setState] = $7ef244517b504261$var$useState([]); // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(()=>setState({}));
    $7ef244517b504261$var$useEffect(()=>{
        // $FlowFixMe[incompatible-call]
        setNotifyBatcherOfChange(()=>setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
        // notifyBatcherOfChange will still be called. An error gets thrown whenever
        // setState is called after a component is already unmounted, so this sets
        // notifyBatcherOfChange to be a no-op.
        return ()=>{
            setNotifyBatcherOfChange(()=>{});
        };
    }, [
        setNotifyBatcherOfChange
    ]);
    $7ef244517b504261$var$useEffect(()=>{
        // enqueueExecution runs this function immediately; it is only used to
        // manipulate the order of useEffects during tests, since React seems to
        // call useEffect in an unpredictable order sometimes.
        $7ef244517b504261$var$Recoil_Queue.enqueueExecution('Batcher', ()=>{
            $7ef244517b504261$var$endBatch(storeRef.current);
        });
    });
    return null;
}
// which will no longer be needed.
function $7ef244517b504261$var$initialStoreState_DEPRECATED(store, initializeState) {
    const initial = $7ef244517b504261$var$makeEmptyStoreState$2();
    initializeState({
        set: (atom, value)=>{
            const state = initial.currentTree;
            const writes = $7ef244517b504261$var$setNodeValue$2(store, state, atom.key, value);
            const writtenNodes = new Set(writes.keys());
            const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
            for (const n of writtenNodes)nonvalidatedAtoms.delete(n);
            initial.currentTree = {
                ...state,
                dirtyAtoms: $7ef244517b504261$var$Recoil_unionSets(state.dirtyAtoms, writtenNodes),
                atomValues: $7ef244517b504261$var$applyAtomValueWrites$1(state.atomValues, writes),
                nonvalidatedAtoms: // NB: PLEASE un-export applyAtomValueWrites when deleting this code
                nonvalidatedAtoms
            };
        },
        setUnvalidatedAtomValues: (atomValues)=>{
            // FIXME replace this with a mutative loop
            atomValues.forEach((v, k)=>{
                initial.currentTree = $7ef244517b504261$var$setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
            });
        }
    });
    return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.
function $7ef244517b504261$var$initialStoreState(initializeState) {
    // Initialize a snapshot and get its store
    const snapshot = $7ef244517b504261$var$freshSnapshot$1(initializeState);
    const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release
    snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
    // they will re-initialize if used during rendering.  This allows atom effect
    // initialization to take precedence over initializeState and be compatible
    // with StrictMode semantics.
    storeState.nodeCleanupFunctions.forEach((cleanup)=>cleanup());
    storeState.nodeCleanupFunctions.clear();
    return storeState;
}
let $7ef244517b504261$var$nextID = 0;
function $7ef244517b504261$var$RecoilRoot_INTERNAL({ initializeState_DEPRECATED: initializeState_DEPRECATED, initializeState: initializeState, store_INTERNAL: storeProp, children: // For use with React "context bridging"
children }) {
    // prettier-ignore
    // @fb-only: useEffect(() => {
    // @fb-only: if (gkx('recoil_usage_logging')) {
    // @fb-only: try {
    // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
    // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
    // @fb-only: path: URI.getRequestURI().getPath(),
    // @fb-only: }));
    // @fb-only: } catch {
    // @fb-only: recoverableViolation(
    // @fb-only: 'Error when logging Recoil Usage event',
    // @fb-only: 'recoil',
    // @fb-only: );
    // @fb-only: }
    // @fb-only: }
    // @fb-only: }, []);
    let storeStateRef; // eslint-disable-line prefer-const
    const getGraph = (version)=>{
        const graphs = storeStateRef.current.graphsByVersion;
        if (graphs.has(version)) return $7ef244517b504261$var$Recoil_nullthrows(graphs.get(version));
        const newGraph = $7ef244517b504261$var$graph$2();
        graphs.set(version, newGraph);
        return newGraph;
    };
    const subscribeToTransactions = (callback, key)=>{
        if (key == null) {
            // Global transaction subscriptions
            const { transactionSubscriptions: transactionSubscriptions } = storeRef.current.getState();
            const id = $7ef244517b504261$var$nextID++;
            transactionSubscriptions.set(id, callback);
            return {
                release: ()=>{
                    transactionSubscriptions.delete(id);
                }
            };
        } else {
            // Node-specific transaction subscriptions:
            const { nodeTransactionSubscriptions: nodeTransactionSubscriptions } = storeRef.current.getState();
            if (!nodeTransactionSubscriptions.has(key)) nodeTransactionSubscriptions.set(key, new Map());
            const id = $7ef244517b504261$var$nextID++;
            $7ef244517b504261$var$Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
            return {
                release: ()=>{
                    const subs = nodeTransactionSubscriptions.get(key);
                    if (subs) {
                        subs.delete(id);
                        if (subs.size === 0) nodeTransactionSubscriptions.delete(key);
                    }
                }
            };
        }
    };
    const addTransactionMetadata = (metadata)=>{
        $7ef244517b504261$var$startNextTreeIfNeeded(storeRef.current);
        for (const k of Object.keys(metadata))$7ef244517b504261$var$Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    };
    const replaceState = (replacer)=>{
        $7ef244517b504261$var$startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:
        const nextTree = $7ef244517b504261$var$Recoil_nullthrows(storeStateRef.current.nextTree);
        let replaced;
        try {
            $7ef244517b504261$var$stateReplacerIsBeingExecuted = true;
            replaced = replacer(nextTree);
        } finally{
            $7ef244517b504261$var$stateReplacerIsBeingExecuted = false;
        }
        if (replaced === nextTree) return;
        storeStateRef.current.nextTree = replaced;
        if ($7ef244517b504261$var$reactMode$2().early) $7ef244517b504261$var$notifyComponents(storeRef.current, storeStateRef.current, replaced);
        $7ef244517b504261$var$Recoil_nullthrows(notifyBatcherOfChange.current)();
    };
    const notifyBatcherOfChange = $7ef244517b504261$var$useRef$1(null);
    const setNotifyBatcherOfChange = $7ef244517b504261$var$useCallback((x)=>{
        notifyBatcherOfChange.current = x;
    }, [
        notifyBatcherOfChange
    ]);
    const storeRef = $7ef244517b504261$var$Recoil_useRefInitOnce(()=>storeProp !== null && storeProp !== void 0 ? storeProp : {
            storeID: $7ef244517b504261$var$getNextStoreID$2(),
            getState: ()=>storeStateRef.current,
            replaceState: replaceState,
            getGraph: getGraph,
            subscribeToTransactions: subscribeToTransactions,
            addTransactionMetadata: addTransactionMetadata
        });
    if (storeProp != null) storeRef.current = storeProp;
    storeStateRef = $7ef244517b504261$var$Recoil_useRefInitOnce(()=>initializeState_DEPRECATED != null ? $7ef244517b504261$var$initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? $7ef244517b504261$var$initialStoreState(initializeState) : $7ef244517b504261$var$makeEmptyStoreState$2());
    const mutableSource = $7ef244517b504261$var$useMemo(()=>$7ef244517b504261$var$createMutableSource$1 === null || $7ef244517b504261$var$createMutableSource$1 === void 0 ? void 0 : $7ef244517b504261$var$createMutableSource$1(storeStateRef, ()=>storeStateRef.current.currentTree.version), [
        storeStateRef
    ]); // Cleanup when the <RecoilRoot> is unmounted
    $7ef244517b504261$var$useEffect(()=>{
        // React is free to call effect cleanup handlers and effects at will, the
        // deps array is only an optimization.  For example, React strict mode
        // will execute each effect twice for testing.  Therefore, we need symmetry
        // to re-initialize all known atoms after they were cleaned up.
        const store = storeRef.current;
        for (const atomKey of new Set(store.getState().knownAtoms))$7ef244517b504261$var$initializeNode$2(store, atomKey, 'get');
        return ()=>{
            for (const atomKey of store.getState().knownAtoms)$7ef244517b504261$var$cleanUpNode$2(store, atomKey);
        };
    }, [
        storeRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$AppContext.Provider, {
        value: storeRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$MutableSourceContext.Provider, {
        value: mutableSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$Batcher, {
        setNotifyBatcherOfChange: setNotifyBatcherOfChange
    }), children));
}
function $7ef244517b504261$var$RecoilRoot(props) {
    const { override: override, ...propsExceptOverride } = props;
    const ancestorStoreRef = $7ef244517b504261$var$useStoreRef();
    if (override === false && ancestorStoreRef.current !== $7ef244517b504261$var$defaultStore) // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$RecoilRoot_INTERNAL, propsExceptOverride);
}
function $7ef244517b504261$var$useRecoilStoreID() {
    return $7ef244517b504261$var$useStoreRef().current.storeID;
}
var $7ef244517b504261$var$Recoil_RecoilRoot = {
    RecoilRoot: $7ef244517b504261$var$RecoilRoot,
    useStoreRef: $7ef244517b504261$var$useStoreRef,
    useRecoilMutableSource: $7ef244517b504261$var$useRecoilMutableSource,
    useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID,
    notifyComponents_FOR_TESTING: $7ef244517b504261$var$notifyComponents,
    sendEndOfBatchNotifications_FOR_TESTING: $7ef244517b504261$var$sendEndOfBatchNotifications
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$shallowArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var $7ef244517b504261$var$Recoil_shallowArrayEqual = $7ef244517b504261$var$shallowArrayEqual;
const { useEffect: $7ef244517b504261$var$useEffect$1, useRef: $7ef244517b504261$var$useRef$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$usePrevious(value) {
    const ref = $7ef244517b504261$var$useRef$2();
    $7ef244517b504261$var$useEffect$1(()=>{
        // $FlowFixMe[incompatible-type]
        ref.current = value;
    });
    return ref.current;
}
var $7ef244517b504261$var$Recoil_usePrevious = $7ef244517b504261$var$usePrevious;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$1 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$1 } = $7ef244517b504261$var$Recoil_Retention;
const { updateRetainCount: $7ef244517b504261$var$updateRetainCount$2 } = $7ef244517b504261$var$Recoil_Retention;
const { RetentionZone: $7ef244517b504261$var$RetentionZone$3 } = $7ef244517b504261$var$Recoil_RetentionZone;
const { useEffect: $7ef244517b504261$var$useEffect$2, useRef: $7ef244517b504261$var$useRef$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { isSSR: $7ef244517b504261$var$isSSR$2 } = $7ef244517b504261$var$Recoil_Environment;
// I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.
// flowlint-line unclear-type:off
function $7ef244517b504261$var$useRetain(toRetain) {
    if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
     // eslint-disable-next-line fb-www/react-hooks
    return $7ef244517b504261$var$useRetain_ACTUAL(toRetain);
}
function $7ef244517b504261$var$useRetain_ACTUAL(toRetain) {
    const array = Array.isArray(toRetain) ? toRetain : [
        toRetain
    ];
    const retainables = array.map((a)=>a instanceof $7ef244517b504261$var$RetentionZone$3 ? a : a.key);
    const storeRef = $7ef244517b504261$var$useStoreRef$1();
    $7ef244517b504261$var$useEffect$2(()=>{
        if (!$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) return;
        const store = storeRef.current;
        if (timeoutID.current && !$7ef244517b504261$var$isSSR$2) {
            // Already performed a temporary retain on render, simply cancel the release
            // of that temporary retain.
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
        } else for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, 1);
        return ()=>{
            for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        }; // eslint-disable-next-line fb-www/react-hooks-deps
    }, [
        storeRef,
        ...retainables
    ]); // We want to retain if the component suspends. This is terrible but the Suspense
    // API affords us no better option. If we suspend and never commit after some
    // seconds, then release. The 'actual' retain/release in the effect above
    // cancels this.
    const timeoutID = $7ef244517b504261$var$useRef$3();
    const previousRetainables = $7ef244517b504261$var$Recoil_usePrevious(retainables);
    if (!$7ef244517b504261$var$isSSR$2 && (previousRetainables === undefined || !$7ef244517b504261$var$Recoil_shallowArrayEqual(previousRetainables, retainables))) {
        const store = storeRef.current;
        for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, 1);
        if (previousRetainables) for (const r of previousRetainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        if (timeoutID.current) window.clearTimeout(timeoutID.current);
        timeoutID.current = window.setTimeout(()=>{
            timeoutID.current = null;
            for (const r of retainables)$7ef244517b504261$var$updateRetainCount$2(store, r, -1);
        }, $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$1);
    }
}
var $7ef244517b504261$var$Recoil_useRetain = $7ef244517b504261$var$useRetain;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */ // const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');
function $7ef244517b504261$var$useComponentName() {
    // const nameRef = useRef();
    // if (__DEV__) {
    //   if (gkx('recoil_infer_component_names')) {
    //     if (nameRef.current === undefined) {
    //       // There is no blessed way to determine the calling React component from
    //       // within a hook. This hack uses the fact that hooks must start with 'use'
    //       // and that hooks are either called by React Components or other hooks. It
    //       // follows therefore, that to find the calling component, you simply need
    //       // to look down the stack and find the first function which doesn't start
    //       // with 'use'. We are only enabling this in dev for now, since once the
    //       // codebase is minified, the naming assumptions no longer hold true.
    //       // eslint-disable-next-line fb-www/no-new-error
    //       const frames = stackTraceParser(new Error().stack);
    //       for (const {methodName} of frames) {
    //         // I observed cases where the frame was of the form 'Object.useXXX'
    //         // hence why I'm searching for hooks following a word boundary
    //         if (!methodName.match(/\buse[^\b]+$/)) {
    //           return (nameRef.current = methodName);
    //         }
    //       }
    //       nameRef.current = null;
    //     }
    //     return nameRef.current ?? '<unable to determine component name>';
    //   }
    // }
    // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
    return '<component name not available>'; // @oss-only
}
var $7ef244517b504261$var$Recoil_useComponentName = $7ef244517b504261$var$useComponentName;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$2 } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$2 } = $7ef244517b504261$var$Recoil_Node;
const { currentRendererSupportsUseSyncExternalStore: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore$1, reactMode: $7ef244517b504261$var$reactMode$3, useMutableSource: $7ef244517b504261$var$useMutableSource$1, useSyncExternalStore: $7ef244517b504261$var$useSyncExternalStore$1 } = $7ef244517b504261$var$Recoil_ReactMode;
const { useRecoilMutableSource: $7ef244517b504261$var$useRecoilMutableSource$1, useStoreRef: $7ef244517b504261$var$useStoreRef$2 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$2 } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$3, getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$2, setRecoilValue: $7ef244517b504261$var$setRecoilValue$2, setUnvalidatedRecoilValue: $7ef244517b504261$var$setUnvalidatedRecoilValue$2, subscribeToRecoilValue: $7ef244517b504261$var$subscribeToRecoilValue$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { useCallback: $7ef244517b504261$var$useCallback$1, useEffect: $7ef244517b504261$var$useEffect$3, useMemo: $7ef244517b504261$var$useMemo$1, useRef: $7ef244517b504261$var$useRef$4, useState: $7ef244517b504261$var$useState$1 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { setByAddingToSet: $7ef244517b504261$var$setByAddingToSet$2 } = $7ef244517b504261$var$Recoil_CopyOnWrite;
const { isSSR: $7ef244517b504261$var$isSSR$3 } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef) {
    // We can't just throw the promise we are waiting on to Suspense.  If the
    // upstream dependencies change it may produce a state in which the component
    // can render, but it would still be suspended on a Promise that may never resolve.
    if (loadable.state === 'hasValue') return loadable.contents;
    else if (loadable.state === 'loading') {
        const promise = new Promise((resolve)=>{
            const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
            suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
            // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)
            if ($7ef244517b504261$var$isSSR$3 && $7ef244517b504261$var$Recoil_isPromise(loadable.contents)) loadable.contents.finally(()=>{
                suspendedComponentResolvers.delete(resolve);
            });
        }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
        // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;
        throw promise;
    } else if (loadable.state === 'hasError') throw loadable.contents;
    else throw $7ef244517b504261$var$Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
}
function $7ef244517b504261$var$validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
    if (!$7ef244517b504261$var$isRecoilValue$2(recoilValue)) throw $7ef244517b504261$var$Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
}
/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */ function $7ef244517b504261$var$useRecoilInterface_DEPRECATED() {
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const storeRef = $7ef244517b504261$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $7ef244517b504261$var$useState$1([]);
    const recoilValuesUsed = $7ef244517b504261$var$useRef$4(new Set());
    recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render
    const previousSubscriptions = $7ef244517b504261$var$useRef$4(new Set());
    const subscriptions = $7ef244517b504261$var$useRef$4(new Map());
    const unsubscribeFrom = $7ef244517b504261$var$useCallback$1((key)=>{
        const sub = subscriptions.current.get(key);
        if (sub) {
            sub.release();
            subscriptions.current.delete(key);
        }
    }, [
        subscriptions
    ]);
    const updateState = $7ef244517b504261$var$useCallback$1((_state, key)=>{
        if (subscriptions.current.has(key)) forceUpdate([]);
    }, []); // Effect to add/remove subscriptions as nodes are used
    $7ef244517b504261$var$useEffect$3(()=>{
        const store = storeRef.current;
        $7ef244517b504261$var$Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach((key)=>{
            if (subscriptions.current.has(key)) {
                $7ef244517b504261$var$Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
                return;
            }
            const sub = $7ef244517b504261$var$subscribeToRecoilValue$1(store, new $7ef244517b504261$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            subscriptions.current.set(key, sub);
            /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */ // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
            const state = store.getState();
            if (state.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
                updateState(store.getState(), key);
            });
            else updateState(store.getState(), key);
        });
        $7ef244517b504261$var$Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach((key)=>{
            unsubscribeFrom(key);
        });
        previousSubscriptions.current = recoilValuesUsed.current;
    }); // Effect to unsubscribe from all when unmounting
    $7ef244517b504261$var$useEffect$3(()=>{
        const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice
        $7ef244517b504261$var$Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach((key)=>{
            const sub = $7ef244517b504261$var$subscribeToRecoilValue$1(storeRef.current, new $7ef244517b504261$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            currentSubscriptions.set(key, sub);
        });
        return ()=>currentSubscriptions.forEach((_, key)=>unsubscribeFrom(key));
    }, [
        componentName,
        storeRef,
        unsubscribeFrom,
        updateState
    ]);
    return $7ef244517b504261$var$useMemo$1(()=>{
        // eslint-disable-next-line no-shadow
        function useSetRecoilState(recoilState) {
            return (newValueOrUpdater)=>{
                $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
            };
        } // eslint-disable-next-line no-shadow
        function useResetRecoilState(recoilState) {
            return ()=>$7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, $7ef244517b504261$var$DEFAULT_VALUE$2);
        } // eslint-disable-next-line no-shadow
        function useRecoilValueLoadable(recoilValue) {
            var _storeState$nextTree;
            if (!recoilValuesUsed.current.has(recoilValue.key)) recoilValuesUsed.current = $7ef244517b504261$var$setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
             // TODO Restore optimization to memoize lookup
            const storeState = storeRef.current.getState();
            return $7ef244517b504261$var$getRecoilValueAsLoadable$2(storeRef.current, recoilValue, $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
        } // eslint-disable-next-line no-shadow
        function useRecoilValue(recoilValue) {
            const loadable = useRecoilValueLoadable(recoilValue);
            return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
        } // eslint-disable-next-line no-shadow
        function useRecoilState(recoilState) {
            return [
                useRecoilValue(recoilState),
                useSetRecoilState(recoilState)
            ];
        } // eslint-disable-next-line no-shadow
        function useRecoilStateLoadable(recoilState) {
            return [
                useRecoilValueLoadable(recoilState),
                useSetRecoilState(recoilState)
            ];
        }
        return {
            getRecoilValue: useRecoilValue,
            getRecoilValueLoadable: useRecoilValueLoadable,
            getRecoilState: useRecoilState,
            getRecoilStateLoadable: useRecoilStateLoadable,
            getSetRecoilState: useSetRecoilState,
            getResetRecoilState: useResetRecoilState
        };
    }, [
        recoilValuesUsed,
        storeRef
    ]);
}
const $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING = {
    current: 0
};
function $7ef244517b504261$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const getSnapshot = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree2;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
        const loadable = $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
        return {
            loadable: loadable,
            key: recoilValue.key
        };
    }, [
        storeRef,
        recoilValue
    ]); // Memoize the state to avoid unnecessary rerenders
    const memoizePreviousSnapshot = $7ef244517b504261$var$useCallback$1((getState)=>{
        let prevState;
        return ()=>{
            var _prevState, _prevState2;
            const nextState = getState();
            if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) return prevState;
            prevState = nextState;
            return nextState;
        };
    }, []);
    const getMemoizedSnapshot = $7ef244517b504261$var$useMemo$1(()=>memoizePreviousSnapshot(getSnapshot), [
        getSnapshot,
        memoizePreviousSnapshot
    ]);
    const subscribe = $7ef244517b504261$var$useCallback$1((notify)=>{
        const store = storeRef.current;
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName
    ]);
    return $7ef244517b504261$var$useSyncExternalStore$1(subscribe, getMemoizedSnapshot, getMemoizedSnapshot // getServerSnapshot() for SSR support
    ).loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree3;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getLoadableWithTesting = $7ef244517b504261$var$useCallback$1(()=>{
        return getLoadable();
    }, [
        getLoadable
    ]);
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const subscribe = $7ef244517b504261$var$useCallback$1((_storeState, notify)=>{
        const store = storeRef.current;
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, ()=>{
            if (!$7ef244517b504261$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return notify();
             // Only re-render if the value has changed.
            // This will evaluate the atom/selector now as well as when the
            // component renders, but that may help with prefetching.
            const newLoadable = getLoadable();
            if (!prevLoadableRef.current.is(newLoadable)) notify();
             // If the component is suspended then the effect setting prevLoadableRef
            // will not run.  So, set the previous value here when its subscription
            // is fired to wake it up.  We can't just rely on this, though, because
            // this only executes when an atom/selector is dirty and the atom/selector
            // passed to the hook can dynamically change.
            prevLoadableRef.current = newLoadable;
        }, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName,
        getLoadable
    ]);
    const source = $7ef244517b504261$var$useRecoilMutableSource$1();
    if (source == null) throw $7ef244517b504261$var$Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
    const loadable = $7ef244517b504261$var$useMutableSource$1(source, getLoadableWithTesting, subscribe);
    const prevLoadableRef = $7ef244517b504261$var$useRef$4(loadable);
    $7ef244517b504261$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    return loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const componentName = $7ef244517b504261$var$Recoil_useComponentName(); // Accessors to get the current state
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree4;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getState = $7ef244517b504261$var$useCallback$1(()=>({
            loadable: getLoadable(),
            key: recoilValue.key
        }), [
        getLoadable,
        recoilValue.key
    ]); // Memoize state snapshots
    const updateState = $7ef244517b504261$var$useCallback$1((prevState)=>{
        const nextState = getState();
        return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
    }, [
        getState
    ]); // Subscribe to Recoil state changes
    $7ef244517b504261$var$useEffect$3(()=>{
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(storeRef.current, recoilValue, (_state)=>{
            setState(updateState);
        }, componentName); // Update state in case we are using a different key
        setState(updateState);
        return subscription.release;
    }, [
        componentName,
        recoilValue,
        storeRef,
        updateState
    ]); // Get the current state
    const [state, setState] = $7ef244517b504261$var$useState$1(getState); // If we changed keys, then return the state for the new key.
    // This is important in case the old key would cause the component to suspend.
    // We don't have to set the new state here since the subscribing effect above
    // will do that.
    return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function $7ef244517b504261$var$useRecoilValueLoadable_LEGACY(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $7ef244517b504261$var$useState$1([]);
    const componentName = $7ef244517b504261$var$Recoil_useComponentName();
    const getLoadable = $7ef244517b504261$var$useCallback$1(()=>{
        var _storeState$nextTree5;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $7ef244517b504261$var$reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
        return $7ef244517b504261$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const loadable = getLoadable();
    const prevLoadableRef = $7ef244517b504261$var$useRef$4(loadable);
    $7ef244517b504261$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    $7ef244517b504261$var$useEffect$3(()=>{
        const store = storeRef.current;
        const storeState = store.getState();
        const subscription = $7ef244517b504261$var$subscribeToRecoilValue$1(store, recoilValue, (_state)=>{
            var _prevLoadableRef$curr;
            if (!$7ef244517b504261$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }, componentName);
        /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */ if (storeState.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
            // $FlowFixMe[incompatible-type]
            prevLoadableRef.current = null;
            forceUpdate([]);
        });
        else {
            var _prevLoadableRef$curr2;
            if (!$7ef244517b504261$var$Recoil_gkx('recoil_suppress_rerender_in_callback')) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }
        return subscription.release;
    }, [
        componentName,
        getLoadable,
        recoilValue,
        storeRef
    ]);
    return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/ function $7ef244517b504261$var$useRecoilValueLoadable(recoilValue) {
    if ($7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) // eslint-disable-next-line fb-www/react-hooks
    $7ef244517b504261$var$Recoil_useRetain(recoilValue);
    return ({
        TRANSITION_SUPPORT: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
        // `reactMode()` before calling it.  However, sometimes the host React
        // environment supports it but uses additional React renderers (such as with
        // `react-three-fiber`) which do not.  While this is technically a user issue
        // by using a renderer with React 18+ that doesn't fully support React 18 we
        // don't want to break users if it can be avoided. As the current renderer can
        // change at runtime, we need to dynamically check and fallback if necessary.
        SYNC_EXTERNAL_STORE: $7ef244517b504261$var$currentRendererSupportsUseSyncExternalStore$1() ? $7ef244517b504261$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE : $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        MUTABLE_SOURCE: $7ef244517b504261$var$useRecoilValueLoadable_MUTABLE_SOURCE,
        LEGACY: $7ef244517b504261$var$useRecoilValueLoadable_LEGACY
    })[$7ef244517b504261$var$reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */ function $7ef244517b504261$var$useRecoilValue(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const loadable = $7ef244517b504261$var$useRecoilValueLoadable(recoilValue);
    return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/ function $7ef244517b504261$var$useSetRecoilState(recoilState) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return $7ef244517b504261$var$useCallback$1((newValueOrUpdater)=>{
        $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/ function $7ef244517b504261$var$useResetRecoilState(recoilState) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return $7ef244517b504261$var$useCallback$1(()=>{
        $7ef244517b504261$var$setRecoilValue$2(storeRef.current, recoilState, $7ef244517b504261$var$DEFAULT_VALUE$2);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/ function $7ef244517b504261$var$useRecoilState(recoilState) {
    return [
        $7ef244517b504261$var$useRecoilValue(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/ function $7ef244517b504261$var$useRecoilStateLoadable(recoilState) {
    return [
        $7ef244517b504261$var$useRecoilValueLoadable(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
function $7ef244517b504261$var$useSetUnvalidatedAtomValues() {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    return (values, transactionMetadata = {})=>{
        $7ef244517b504261$var$batchUpdates$2(()=>{
            storeRef.current.addTransactionMetadata(transactionMetadata);
            values.forEach((value, key)=>$7ef244517b504261$var$setUnvalidatedRecoilValue$2(storeRef.current, new $7ef244517b504261$var$AbstractRecoilValue$3(key), value));
        });
    };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */ function $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    if ($7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020')) // eslint-disable-next-line fb-www/react-hooks
    $7ef244517b504261$var$Recoil_useRetain(recoilValue);
    return $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$2();
    const loadable = $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
    return $7ef244517b504261$var$handleLoadable(loadable, recoilValue, storeRef);
}
function $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
    return [
        $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState),
        $7ef244517b504261$var$useSetRecoilState(recoilState)
    ];
}
var $7ef244517b504261$var$Recoil_Hooks = {
    recoilComponentGetRecoilValueCount_FOR_TESTING: $7ef244517b504261$var$recoilComponentGetRecoilValueCount_FOR_TESTING,
    useRecoilInterface: $7ef244517b504261$var$useRecoilInterface_DEPRECATED,
    useRecoilState: $7ef244517b504261$var$useRecoilState,
    useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable,
    useRecoilValue: $7ef244517b504261$var$useRecoilValue,
    useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable,
    useResetRecoilState: $7ef244517b504261$var$useResetRecoilState,
    useSetRecoilState: $7ef244517b504261$var$useSetRecoilState,
    useSetUnvalidatedAtomValues: $7ef244517b504261$var$useSetUnvalidatedAtomValues,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */ function $7ef244517b504261$var$filterMap(map, callback) {
    const result = new Map();
    for (const [key, value] of map)if (callback(value, key)) result.set(key, value);
    return result;
}
var $7ef244517b504261$var$Recoil_filterMap = $7ef244517b504261$var$filterMap;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */ function $7ef244517b504261$var$filterSet(set, callback) {
    const result = new Set();
    for (const value of set)if (callback(value)) result.add(value);
    return result;
}
var $7ef244517b504261$var$Recoil_filterSet = $7ef244517b504261$var$filterSet;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$mergeMaps(...maps) {
    const result = new Map();
    for(let i = 0; i < maps.length; i++){
        const iterator = maps[i].keys();
        let nextKey;
        while(!(nextKey = iterator.next()).done)// $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
        result.set(nextKey.value, maps[i].get(nextKey.value));
    }
    return result;
}
var $7ef244517b504261$var$Recoil_mergeMaps = $7ef244517b504261$var$mergeMaps;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$3 } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$3, getNode: $7ef244517b504261$var$getNode$4, nodes: $7ef244517b504261$var$nodes$1 } = $7ef244517b504261$var$Recoil_Node;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$3 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { AbstractRecoilValue: $7ef244517b504261$var$AbstractRecoilValue$4, setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { SUSPENSE_TIMEOUT_MS: $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$2 } = $7ef244517b504261$var$Recoil_Retention;
const { cloneSnapshot: $7ef244517b504261$var$cloneSnapshot$1 } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useCallback: $7ef244517b504261$var$useCallback$2, useEffect: $7ef244517b504261$var$useEffect$4, useRef: $7ef244517b504261$var$useRef$5, useState: $7ef244517b504261$var$useState$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
const { isSSR: $7ef244517b504261$var$isSSR$4 } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$useTransactionSubscription(callback) {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    $7ef244517b504261$var$useEffect$4(()=>{
        const sub = storeRef.current.subscribeToTransactions(callback);
        return sub.release;
    }, [
        callback,
        storeRef
    ]);
}
function $7ef244517b504261$var$externallyVisibleAtomValuesInState(state) {
    const atomValues = state.atomValues.toMap();
    const persistedAtomContentsValues = $7ef244517b504261$var$Recoil_mapMap($7ef244517b504261$var$Recoil_filterMap(atomValues, (v, k)=>{
        const node = $7ef244517b504261$var$getNode$4(k);
        const persistence = node.persistence_UNSTABLE;
        return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
    }), (v)=>v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
    // all have persistence on or they wouldn't be there in the first place.
    return $7ef244517b504261$var$Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/ function $7ef244517b504261$var$useTransactionObservation_DEPRECATED(callback) {
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>{
        let previousTree = store.getState().previousTree;
        const currentTree = store.getState().currentTree;
        if (!previousTree) {
            $7ef244517b504261$var$Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
            previousTree = store.getState().currentTree; // attempt to trundle on
        }
        const atomValues = $7ef244517b504261$var$externallyVisibleAtomValuesInState(currentTree);
        const previousAtomValues = $7ef244517b504261$var$externallyVisibleAtomValuesInState(previousTree);
        const atomInfo = $7ef244517b504261$var$Recoil_mapMap($7ef244517b504261$var$nodes$1, (node)=>{
            var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
            return {
                persistence_UNSTABLE: {
                    type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
                    backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
                }
            };
        }); // Filter on existance in atomValues so that externally-visible rules
        // are also applied to modified atoms (specifically exclude selectors):
        const modifiedAtoms = $7ef244517b504261$var$Recoil_filterSet(currentTree.dirtyAtoms, (k)=>atomValues.has(k) || previousAtomValues.has(k));
        callback({
            atomValues: atomValues,
            previousAtomValues: previousAtomValues,
            atomInfo: atomInfo,
            modifiedAtoms: modifiedAtoms,
            transactionMetadata: {
                ...currentTree.transactionMetadata
            }
        });
    }, [
        callback
    ]));
}
function $7ef244517b504261$var$useRecoilTransactionObserver(callback) {
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>{
        const snapshot = $7ef244517b504261$var$cloneSnapshot$1(store, 'latest');
        const previousSnapshot = $7ef244517b504261$var$cloneSnapshot$1(store, 'previous');
        callback({
            snapshot: snapshot,
            previousSnapshot: previousSnapshot
        });
    }, [
        callback
    ]));
} // Return a snapshot of the current state and subscribe to all state changes
function $7ef244517b504261$var$useRecoilSnapshot() {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    const [snapshot, setSnapshot] = $7ef244517b504261$var$useState$2(()=>$7ef244517b504261$var$cloneSnapshot$1(storeRef.current));
    const previousSnapshot = $7ef244517b504261$var$Recoil_usePrevious(snapshot);
    const timeoutID = $7ef244517b504261$var$useRef$5();
    const releaseRef = $7ef244517b504261$var$useRef$5();
    $7ef244517b504261$var$useTransactionSubscription($7ef244517b504261$var$useCallback$2((store)=>setSnapshot($7ef244517b504261$var$cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted
    $7ef244517b504261$var$useEffect$4(()=>{
        const release = snapshot.retain(); // Release the retain from the rendering call
        if (timeoutID.current && !$7ef244517b504261$var$isSSR$4) {
            var _releaseRef$current;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 || _releaseRef$current.call(releaseRef);
            releaseRef.current = null;
        }
        return ()=>{
            // Defer the release.  If "Fast Refresh"" is used then the component may
            // re-render with the same state.  The previous cleanup will then run and
            // then the new effect will run. We don't want the snapshot to be released
            // by that cleanup before the new effect has a chance to retain it again.
            // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
            window.setTimeout(release, 10);
        };
    }, [
        snapshot
    ]); // Retain snapshot until above effect is run.
    // Release after a threshold in case component is suspended.
    if (previousSnapshot !== snapshot && !$7ef244517b504261$var$isSSR$4) {
        // Release the previous snapshot
        if (timeoutID.current) {
            var _releaseRef$current2;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 || _releaseRef$current2.call(releaseRef);
            releaseRef.current = null;
        }
        releaseRef.current = snapshot.retain();
        timeoutID.current = window.setTimeout(()=>{
            var _releaseRef$current3;
            timeoutID.current = null;
            (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 || _releaseRef$current3.call(releaseRef);
            releaseRef.current = null;
        }, $7ef244517b504261$var$SUSPENSE_TIMEOUT_MS$2);
    }
    return snapshot;
}
function $7ef244517b504261$var$gotoSnapshot(store, snapshot) {
    var _storeState$nextTree;
    const storeState = store.getState();
    const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
    const next = snapshot.getStore_INTERNAL().getState().currentTree;
    $7ef244517b504261$var$batchUpdates$3(()=>{
        const keysToUpdate = new Set();
        for (const keys of [
            prev.atomValues.keys(),
            next.atomValues.keys()
        ])for (const key of keys){
            var _prev$atomValues$get, _next$atomValues$get;
            if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && $7ef244517b504261$var$getNode$4(key).shouldRestoreFromSnapshots) keysToUpdate.add(key);
        }
        keysToUpdate.forEach((key)=>{
            $7ef244517b504261$var$setRecoilValueLoadable$1(store, new $7ef244517b504261$var$AbstractRecoilValue$4(key), next.atomValues.has(key) ? $7ef244517b504261$var$Recoil_nullthrows(next.atomValues.get(key)) : $7ef244517b504261$var$DEFAULT_VALUE$3);
        });
        store.replaceState((state)=>({
                ...state,
                stateID: snapshot.getID()
            }));
    });
}
function $7ef244517b504261$var$useGotoRecoilSnapshot() {
    const storeRef = $7ef244517b504261$var$useStoreRef$3();
    return $7ef244517b504261$var$useCallback$2((snapshot)=>$7ef244517b504261$var$gotoSnapshot(storeRef.current, snapshot), [
        storeRef
    ]);
}
var $7ef244517b504261$var$Recoil_SnapshotHooks = {
    useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot,
    gotoSnapshot: $7ef244517b504261$var$gotoSnapshot,
    useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot,
    useRecoilTransactionObserver: $7ef244517b504261$var$useRecoilTransactionObserver,
    useTransactionObservation_DEPRECATED: $7ef244517b504261$var$useTransactionObservation_DEPRECATED,
    useTransactionSubscription_DEPRECATED: $7ef244517b504261$var$useTransactionSubscription
};
const { peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$2 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$4 } = $7ef244517b504261$var$Recoil_RecoilRoot;
function $7ef244517b504261$var$useGetRecoilValueInfo() {
    const storeRef = $7ef244517b504261$var$useStoreRef$4(); // $FlowFixMe[incompatible-return]
    return ({ key: key })=>$7ef244517b504261$var$peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}
var $7ef244517b504261$var$Recoil_useGetRecoilValueInfo = $7ef244517b504261$var$useGetRecoilValueInfo;
const { reactMode: $7ef244517b504261$var$reactMode$4 } = $7ef244517b504261$var$Recoil_ReactMode;
const { RecoilRoot: $7ef244517b504261$var$RecoilRoot$1, useStoreRef: $7ef244517b504261$var$useStoreRef$5 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { useMemo: $7ef244517b504261$var$useMemo$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilBridgeAcrossReactRoots() {
    // The test fails when using useMutableSource(), but only if act() is used
    // for the nested root.  So, this may only be a testing environment issue.
    if ($7ef244517b504261$var$reactMode$4().mode === 'MUTABLE_SOURCE') // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
    const store = $7ef244517b504261$var$useStoreRef$5().current;
    return $7ef244517b504261$var$useMemo$2(()=>{
        // eslint-disable-next-line no-shadow
        function RecoilBridge({ children: children }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ef244517b504261$var$RecoilRoot$1, {
                store_INTERNAL: store
            }, children);
        }
        return RecoilBridge;
    }, [
        store
    ]);
}
var $7ef244517b504261$var$Recoil_useRecoilBridgeAcrossReactRoots = $7ef244517b504261$var$useRecoilBridgeAcrossReactRoots;
const { loadableWithValue: $7ef244517b504261$var$loadableWithValue$1 } = $7ef244517b504261$var$Recoil_Loadable$1;
const { initializeNode: $7ef244517b504261$var$initializeNode$3 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$4, getNode: $7ef244517b504261$var$getNode$5 } = $7ef244517b504261$var$Recoil_Node;
const { copyTreeState: $7ef244517b504261$var$copyTreeState$1, getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$3, invalidateDownstreams: $7ef244517b504261$var$invalidateDownstreams$1, writeLoadableToTreeState: $7ef244517b504261$var$writeLoadableToTreeState$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
function $7ef244517b504261$var$isAtom(recoilValue) {
    return $7ef244517b504261$var$getNode$5(recoilValue.key).nodeType === 'atom';
}
class $7ef244517b504261$var$TransactionInterfaceImpl {
    constructor(store, treeState){
        $7ef244517b504261$var$_defineProperty(this, "_store", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_treeState", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_changes", void 0);
        $7ef244517b504261$var$_defineProperty(this, "get", (recoilValue)=>{
            if (this._changes.has(recoilValue.key)) // $FlowIssue[incompatible-return]
            return this._changes.get(recoilValue.key);
            if (!$7ef244517b504261$var$isAtom(recoilValue)) throw $7ef244517b504261$var$Recoil_err('Reading selectors within atomicUpdate is not supported');
            const loadable = $7ef244517b504261$var$getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);
            if (loadable.state === 'hasValue') return loadable.contents;
            else if (loadable.state === 'hasError') throw loadable.contents;
            else throw $7ef244517b504261$var$Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
        });
        $7ef244517b504261$var$_defineProperty(this, "set", (recoilState, valueOrUpdater)=>{
            if (!$7ef244517b504261$var$isAtom(recoilState)) throw $7ef244517b504261$var$Recoil_err('Setting selectors within atomicUpdate is not supported');
            if (typeof valueOrUpdater === 'function') {
                const current = this.get(recoilState);
                this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off
            } else {
                // Initialize atom and run effects if not initialized yet
                $7ef244517b504261$var$initializeNode$3(this._store, recoilState.key, 'set');
                this._changes.set(recoilState.key, valueOrUpdater);
            }
        });
        $7ef244517b504261$var$_defineProperty(this, "reset", (recoilState)=>{
            this.set(recoilState, $7ef244517b504261$var$DEFAULT_VALUE$4);
        });
        this._store = store;
        this._treeState = treeState;
        this._changes = new Map();
    }
    // eslint-disable-next-line fb-www/extra-arrow-initializer
    newTreeState_INTERNAL() {
        if (this._changes.size === 0) return this._treeState;
        const newState = $7ef244517b504261$var$copyTreeState$1(this._treeState);
        for (const [k, v] of this._changes)$7ef244517b504261$var$writeLoadableToTreeState$1(newState, k, $7ef244517b504261$var$loadableWithValue$1(v));
        $7ef244517b504261$var$invalidateDownstreams$1(this._store, newState);
        return newState;
    }
}
function $7ef244517b504261$var$atomicUpdater(store) {
    return (fn)=>{
        store.replaceState((treeState)=>{
            const changeset = new $7ef244517b504261$var$TransactionInterfaceImpl(store, treeState);
            fn(changeset);
            return changeset.newTreeState_INTERNAL();
        });
    };
}
var $7ef244517b504261$var$Recoil_AtomicUpdates = {
    atomicUpdater: $7ef244517b504261$var$atomicUpdater
};
var $7ef244517b504261$var$Recoil_AtomicUpdates_1 = $7ef244517b504261$var$Recoil_AtomicUpdates.atomicUpdater;
var $7ef244517b504261$var$Recoil_AtomicUpdates$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    atomicUpdater: $7ef244517b504261$var$Recoil_AtomicUpdates_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$invariant(condition, message) {
    if (!condition) throw new Error(message);
}
var $7ef244517b504261$var$invariant_1 = $7ef244517b504261$var$invariant;
// @oss-only
var $7ef244517b504261$var$Recoil_invariant = $7ef244517b504261$var$invariant_1;
const { atomicUpdater: $7ef244517b504261$var$atomicUpdater$1 } = $7ef244517b504261$var$Recoil_AtomicUpdates$1;
const { batchUpdates: $7ef244517b504261$var$batchUpdates$4 } = $7ef244517b504261$var$Recoil_Batching;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$5 } = $7ef244517b504261$var$Recoil_Node;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$6 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue$1, setRecoilValue: $7ef244517b504261$var$setRecoilValue$3 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { cloneSnapshot: $7ef244517b504261$var$cloneSnapshot$2 } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { gotoSnapshot: $7ef244517b504261$var$gotoSnapshot$1 } = $7ef244517b504261$var$Recoil_SnapshotHooks;
const { useCallback: $7ef244517b504261$var$useCallback$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
class $7ef244517b504261$var$Sentinel {
}
const $7ef244517b504261$var$SENTINEL = new $7ef244517b504261$var$Sentinel();
function $7ef244517b504261$var$recoilCallback(store, fn, args, extraInterface) {
    let ret = $7ef244517b504261$var$SENTINEL;
    let releaseSnapshot;
    $7ef244517b504261$var$batchUpdates$4(()=>{
        const errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
        if (typeof fn !== 'function') throw $7ef244517b504261$var$Recoil_err(errMsg);
         // Clone the snapshot lazily to avoid overhead if the callback does not use it.
        // Note that this means the snapshot may represent later state from when
        // the callback was called if it first accesses the snapshot asynchronously.
        const callbackInterface = $7ef244517b504261$var$Recoil_lazyProxy({
            ...extraInterface !== null && extraInterface !== void 0 ? extraInterface : {},
            // flowlint-line unclear-type:off
            // $FlowFixMe[missing-local-annot]
            set: (node, newValue)=>$7ef244517b504261$var$setRecoilValue$3(store, node, newValue),
            // $FlowFixMe[missing-local-annot]
            reset: (node)=>$7ef244517b504261$var$setRecoilValue$3(store, node, $7ef244517b504261$var$DEFAULT_VALUE$5),
            // $FlowFixMe[missing-local-annot]
            refresh: (node)=>$7ef244517b504261$var$refreshRecoilValue$1(store, node),
            gotoSnapshot: (snapshot)=>$7ef244517b504261$var$gotoSnapshot$1(store, snapshot),
            transact_UNSTABLE: (transaction)=>$7ef244517b504261$var$atomicUpdater$1(store)(transaction)
        }, {
            snapshot: ()=>{
                const snapshot = $7ef244517b504261$var$cloneSnapshot$2(store);
                releaseSnapshot = snapshot.retain();
                return snapshot;
            }
        });
        const callback = fn(callbackInterface);
        if (typeof callback !== 'function') throw $7ef244517b504261$var$Recoil_err(errMsg);
        ret = callback(...args);
    });
    !!(ret instanceof $7ef244517b504261$var$Sentinel) && $7ef244517b504261$var$Recoil_invariant(false);
    if ($7ef244517b504261$var$Recoil_isPromise(ret)) ret = ret.finally(()=>{
        var _releaseSnapshot;
        (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 || _releaseSnapshot();
    });
    else {
        var _releaseSnapshot2;
        (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 || _releaseSnapshot2();
    }
    return ret;
}
function $7ef244517b504261$var$useRecoilCallback(fn, deps) {
    const storeRef = $7ef244517b504261$var$useStoreRef$6();
    return $7ef244517b504261$var$useCallback$3((...args)=>{
        return $7ef244517b504261$var$recoilCallback(storeRef.current, fn, args);
    }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $7ef244517b504261$var$Recoil_useRecoilCallback = {
    recoilCallback: $7ef244517b504261$var$recoilCallback,
    useRecoilCallback: $7ef244517b504261$var$useRecoilCallback
};
const { useStoreRef: $7ef244517b504261$var$useStoreRef$7 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $7ef244517b504261$var$refreshRecoilValue$2 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { useCallback: $7ef244517b504261$var$useCallback$4 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilRefresher(recoilValue) {
    const storeRef = $7ef244517b504261$var$useStoreRef$7();
    return $7ef244517b504261$var$useCallback$4(()=>{
        const store = storeRef.current;
        $7ef244517b504261$var$refreshRecoilValue$2(store, recoilValue);
    }, [
        recoilValue,
        storeRef
    ]);
}
var $7ef244517b504261$var$Recoil_useRecoilRefresher = $7ef244517b504261$var$useRecoilRefresher;
const { atomicUpdater: $7ef244517b504261$var$atomicUpdater$2 } = $7ef244517b504261$var$Recoil_AtomicUpdates$1;
const { useStoreRef: $7ef244517b504261$var$useStoreRef$8 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { useMemo: $7ef244517b504261$var$useMemo$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)));
function $7ef244517b504261$var$useRecoilTransaction(fn, deps) {
    const storeRef = $7ef244517b504261$var$useStoreRef$8();
    return $7ef244517b504261$var$useMemo$3(()=>(...args)=>{
            const atomicUpdate = $7ef244517b504261$var$atomicUpdater$2(storeRef.current);
            atomicUpdate((transactionInterface)=>{
                fn(transactionInterface)(...args);
            });
        }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $7ef244517b504261$var$Recoil_useRecoilTransaction = $7ef244517b504261$var$useRecoilTransaction;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$WrappedValue {
    constructor(value){
        $7ef244517b504261$var$_defineProperty(this, "value", void 0);
        this.value = value;
    }
}
var $7ef244517b504261$var$Recoil_Wrapper = {
    WrappedValue: $7ef244517b504261$var$WrappedValue
};
var $7ef244517b504261$var$Recoil_Wrapper_1 = $7ef244517b504261$var$Recoil_Wrapper.WrappedValue;
var $7ef244517b504261$var$Recoil_Wrapper$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WrappedValue: $7ef244517b504261$var$Recoil_Wrapper_1
});
const { isFastRefreshEnabled: $7ef244517b504261$var$isFastRefreshEnabled$2 } = $7ef244517b504261$var$Recoil_ReactMode;
class $7ef244517b504261$var$ChangedPathError extends Error {
}
class $7ef244517b504261$var$TreeCache {
    // $FlowIssue[unclear-type]
    constructor(options){
        var _options$onHit, _options$onSet, _options$mapNodeValue;
        $7ef244517b504261$var$_defineProperty(this, "_name", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_numLeafs", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_root", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_onHit", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_onSet", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_mapNodeValue", void 0);
        this._name = options === null || options === void 0 ? void 0 : options.name;
        this._numLeafs = 0;
        this._root = null;
        this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : ()=>{};
        this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : ()=>{};
        this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : (val)=>val;
    }
    size() {
        return this._numLeafs;
    }
    root() {
        return this._root;
    }
    get(getNodeValue, handlers) {
        var _this$getLeafNode;
        return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
    }
    getLeafNode(getNodeValue, handlers) {
        if (this._root == null) return undefined;
         // Iterate down the tree based on the current node values until we hit a leaf
        // $FlowIssue[unclear-type]
        let node = this._root;
        while(node){
            handlers === null || handlers === void 0 || handlers.onNodeVisit(node);
            if (node.type === 'leaf') {
                this._onHit(node);
                return node;
            }
            const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));
            node = node.branches.get(nodeValue);
        }
        return undefined;
    }
    set(route, value, handlers) {
        const addLeaf = ()=>{
            var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
            // First, setup the branch nodes for the route:
            // Iterate down the tree to find or add branch nodes following the route
            let node;
            let branchKey;
            for (const [nodeKey, nodeValue] of route){
                var _node, _handlers$onNodeVisit, _this$_root;
                // If the previous root was a leaf, while we not have a get(), it means
                // the selector has inconsistent values or implementation changed.
                const root = this._root;
                if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') throw this.invalidCacheError();
                 // node now refers to the next node down in the tree
                const parent = node; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = (_node = node) !== null && _node !== void 0 ? _node : {
                    type: 'branch',
                    nodeKey: nodeKey,
                    parent: parent,
                    branches: new Map(),
                    branchKey: branchKey
                }; // If we found an existing node, confirm it has a consistent value
                if (node.type !== 'branch' || node.nodeKey !== nodeKey) throw this.invalidCacheError();
                 // Add the branch node to the tree
                parent === null || parent === void 0 || parent.branches.set(branchKey, node);
                handlers === null || handlers === void 0 || (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 || _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.
                branchKey = this._mapNodeValue(nodeValue);
                this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
            } // Second, setup the leaf node:
            // If there is an existing leaf for this route confirm it is consistent
            const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;
            if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) throw this.invalidCacheError();
             // Create a new or replacement leaf.
            const leafNode = {
                type: 'leaf',
                value: value,
                parent: node,
                branchKey: branchKey
            }; // Install the leaf and call handlers
            (_node3 = node) === null || _node3 === void 0 || _node3.branches.set(branchKey, leafNode);
            this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
            this._numLeafs++;
            this._onSet(leafNode);
            handlers === null || handlers === void 0 || (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 || _handlers$onNodeVisit2.call(handlers, leafNode);
        };
        try {
            addLeaf();
        } catch (error) {
            // If the cache was stale or observed inconsistent values, such as with
            // Fast Refresh, then clear it and rebuild with the new values.
            if (error instanceof $7ef244517b504261$var$ChangedPathError) {
                this.clear();
                addLeaf();
            } else throw error;
        }
    }
    delete(leaf) {
        const root = this.root();
        if (!root) return false;
        if (leaf === root) {
            this._root = null;
            this._numLeafs = 0;
            return true;
        } // Iterate up from the leaf deleteing it from it's parent's branches.
        let node = leaf.parent;
        let branchKey = leaf.branchKey;
        while(node){
            var _node4;
            node.branches.delete(branchKey); // Stop iterating if we hit the root.
            if (node === root) {
                if (node.branches.size === 0) {
                    this._root = null;
                    this._numLeafs = 0;
                } else this._numLeafs--;
                return true;
            } // Stop iterating if there are other branches since we don't need to
            // remove any more nodes.
            if (node.branches.size > 0) break;
             // Iterate up to our parent
            branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
            node = node.parent;
        } // Confirm that the leaf we are deleting is actually attached to our tree
        for(; node !== root; node = node.parent){
            if (node == null) return false;
        }
        this._numLeafs--;
        return true;
    }
    clear() {
        this._numLeafs = 0;
        this._root = null;
    }
    invalidCacheError() {
        const CHANGED_PATH_ERROR_MESSAGE = $7ef244517b504261$var$isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
        $7ef244517b504261$var$Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
        throw new $7ef244517b504261$var$ChangedPathError();
    }
}
var $7ef244517b504261$var$Recoil_TreeCache = {
    TreeCache: $7ef244517b504261$var$TreeCache
};
var $7ef244517b504261$var$Recoil_TreeCache_1 = $7ef244517b504261$var$Recoil_TreeCache.TreeCache;
var $7ef244517b504261$var$Recoil_TreeCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TreeCache: $7ef244517b504261$var$Recoil_TreeCache_1
});
class $7ef244517b504261$var$LRUCache {
    constructor(options){
        var _options$mapKey;
        $7ef244517b504261$var$_defineProperty(this, "_maxSize", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_size", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_head", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_tail", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_keyMapper", void 0);
        this._maxSize = options.maxSize;
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    head() {
        return this._head;
    }
    tail() {
        return this._tail;
    }
    size() {
        return this._size;
    }
    maxSize() {
        return this._maxSize;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        const mappedKey = this._keyMapper(key);
        const node = this._map.get(mappedKey);
        if (!node) return undefined;
        this.set(key, node.value);
        return node.value;
    }
    set(key, val) {
        const mappedKey = this._keyMapper(key);
        const existingNode = this._map.get(mappedKey);
        if (existingNode) this.delete(key);
        const head = this.head();
        const node = {
            key: key,
            right: head,
            left: null,
            value: val
        };
        if (head) head.left = node;
        else this._tail = node;
        this._map.set(mappedKey, node);
        this._head = node;
        this._size++;
        this._maybeDeleteLRU();
    }
    _maybeDeleteLRU() {
        if (this.size() > this.maxSize()) this.deleteLru();
    }
    deleteLru() {
        const tail = this.tail();
        if (tail) this.delete(tail.key);
    }
    delete(key) {
        const mappedKey = this._keyMapper(key);
        if (!this._size || !this._map.has(mappedKey)) return;
        const node = $7ef244517b504261$var$Recoil_nullthrows(this._map.get(mappedKey));
        const right = node.right;
        const left = node.left;
        if (right) right.left = node.left;
        if (left) left.right = node.right;
        if (node === this.head()) this._head = right;
        if (node === this.tail()) this._tail = left;
        this._map.delete(mappedKey);
        this._size--;
    }
    clear() {
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
    }
}
var $7ef244517b504261$var$Recoil_LRUCache = {
    LRUCache: $7ef244517b504261$var$LRUCache
};
var $7ef244517b504261$var$Recoil_LRUCache_1 = $7ef244517b504261$var$Recoil_LRUCache.LRUCache;
var $7ef244517b504261$var$Recoil_LRUCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    LRUCache: $7ef244517b504261$var$Recoil_LRUCache_1
});
const { LRUCache: $7ef244517b504261$var$LRUCache$1 } = $7ef244517b504261$var$Recoil_LRUCache$1;
const { TreeCache: $7ef244517b504261$var$TreeCache$1 } = $7ef244517b504261$var$Recoil_TreeCache$1;
function $7ef244517b504261$var$treeCacheLRU({ name: name, maxSize: maxSize, mapNodeValue: mapNodeValue = (v)=>v }) {
    const lruCache = new $7ef244517b504261$var$LRUCache$1({
        maxSize: maxSize
    });
    const cache = new $7ef244517b504261$var$TreeCache$1({
        name: name,
        mapNodeValue: mapNodeValue,
        onHit: (node)=>{
            lruCache.set(node, true);
        },
        onSet: (node)=>{
            const lruNode = lruCache.tail();
            lruCache.set(node, true);
            if (lruNode && cache.size() > maxSize) // $FlowFixMe[incompatible-call]
            cache.delete(lruNode.key);
        }
    });
    return cache;
}
var $7ef244517b504261$var$Recoil_treeCacheLRU = $7ef244517b504261$var$treeCacheLRU;
const $7ef244517b504261$var$TIME_WARNING_THRESHOLD_MS = 15;
function $7ef244517b504261$var$stringify(x, opt, key) {
    // A optimization to avoid the more expensive JSON.stringify() for simple strings
    // This may lose protection for u2028 and u2029, though.
    if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) return `"${x}"`;
     // Handle primitive types
    switch(typeof x){
        case 'undefined':
            return '';
        // JSON.stringify(undefined) returns undefined, but we always want to return a string
        case 'boolean':
            return x ? 'true' : 'false';
        case 'number':
        case 'symbol':
            // case 'bigint': // BigInt is not supported in www
            return String(x);
        case 'string':
            // Add surrounding quotes and escape internal quotes
            return JSON.stringify(x);
        case 'function':
            if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) throw $7ef244517b504261$var$Recoil_err('Attempt to serialize function in a Recoil cache key');
            return `__FUNCTION(${x.name})__`;
    }
    if (x === null) return 'null';
     // Fallback case for unknown types
    if (typeof x !== 'object') {
        var _JSON$stringify;
        return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
    } // Deal with all promises as equivalent for now.
    if ($7ef244517b504261$var$Recoil_isPromise(x)) return '__PROMISE__';
     // Arrays handle recursive stringification
    if (Array.isArray(x)) // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i)=>$7ef244517b504261$var$stringify(v, opt, i.toString()))}]`;
     // If an object defines a toJSON() method, then use that to override the
    // serialization.  This matches the behavior of JSON.stringify().
    // Pass the key for compatibility.
    // Immutable.js collections define this method to allow us to serialize them.
    if (typeof x.toJSON === 'function') // flowlint-next-line unclear-type: off
    return $7ef244517b504261$var$stringify(x.toJSON(key), opt, key);
     // For built-in Maps, sort the keys in a stable order instead of the
    // default insertion order.  Support non-string keys.
    if (x instanceof Map) {
        const obj = {};
        for (const [k, v] of x)// Stringify will escape any nested quotes
        obj[typeof k === 'string' ? k : $7ef244517b504261$var$stringify(k, opt)] = v;
        return $7ef244517b504261$var$stringify(obj, opt, key);
    } // For built-in Sets, sort the keys in a stable order instead of the
    // default insertion order.
    if (x instanceof Set) return $7ef244517b504261$var$stringify(Array.from(x).sort((a, b)=>$7ef244517b504261$var$stringify(a, opt).localeCompare($7ef244517b504261$var$stringify(b, opt))), opt, key);
     // Anything else that is iterable serialize as an Array.
    if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') // flowlint-next-line unclear-type: off
    return $7ef244517b504261$var$stringify(Array.from(x), opt, key);
     // For all other Objects, sort the keys in a stable order.
    return `{${Object.keys(x).filter((k)=>x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
    .map((k)=>`${$7ef244517b504261$var$stringify(k, opt)}:${$7ef244517b504261$var$stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples
function $7ef244517b504261$var$stableStringify(x, opt = {
    allowFunctions: false
}) {
    return $7ef244517b504261$var$stringify(x, opt);
}
var $7ef244517b504261$var$Recoil_stableStringify = $7ef244517b504261$var$stableStringify;
const { TreeCache: $7ef244517b504261$var$TreeCache$2 } = $7ef244517b504261$var$Recoil_TreeCache$1;
const $7ef244517b504261$var$defaultPolicy = {
    equality: 'reference',
    eviction: 'keep-all',
    maxSize: Infinity
};
function $7ef244517b504261$var$treeCacheFromPolicy({ equality: equality = $7ef244517b504261$var$defaultPolicy.equality, eviction: eviction = $7ef244517b504261$var$defaultPolicy.eviction, maxSize: maxSize = $7ef244517b504261$var$defaultPolicy.maxSize } = $7ef244517b504261$var$defaultPolicy, name) {
    const valueMapper = $7ef244517b504261$var$getValueMapper(equality);
    return $7ef244517b504261$var$getTreeCache(eviction, maxSize, valueMapper, name);
}
function $7ef244517b504261$var$getValueMapper(equality) {
    switch(equality){
        case 'reference':
            return (val)=>val;
        case 'value':
            return (val)=>$7ef244517b504261$var$Recoil_stableStringify(val);
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $7ef244517b504261$var$getTreeCache(eviction, maxSize, mapNodeValue, name) {
    switch(eviction){
        case 'keep-all':
            return new $7ef244517b504261$var$TreeCache$2({
                name: name,
                mapNodeValue: mapNodeValue
            });
        case 'lru':
            return $7ef244517b504261$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: $7ef244517b504261$var$Recoil_nullthrows(maxSize),
                mapNodeValue: mapNodeValue
            });
        case 'most-recent':
            return $7ef244517b504261$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: 1,
                mapNodeValue: mapNodeValue
            });
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $7ef244517b504261$var$Recoil_treeCacheFromPolicy = $7ef244517b504261$var$treeCacheFromPolicy;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$isNode(object) {
    var _ownerDocument, _doc$defaultView;
    if (typeof window === 'undefined') return false;
    const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
    const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
    return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}
var $7ef244517b504261$var$Recoil_isNode = $7ef244517b504261$var$isNode;
const { isReactNative: $7ef244517b504261$var$isReactNative$1, isWindow: $7ef244517b504261$var$isWindow$1 } = $7ef244517b504261$var$Recoil_Environment;
function $7ef244517b504261$var$shouldNotBeFrozen(value) {
    // Primitives and functions:
    if (value === null || typeof value !== 'object') return true;
     // React elements:
    switch(typeof value.$$typeof){
        case 'symbol':
            return true;
        case 'number':
            return true;
    } // Immutable structures:
    if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) return true;
     // DOM nodes:
    if ($7ef244517b504261$var$Recoil_isNode(value)) return true;
    if ($7ef244517b504261$var$Recoil_isPromise(value)) return true;
    if (value instanceof Error) return true;
    if (ArrayBuffer.isView(value)) return true;
     // Some environments, just as Jest, don't work with the instanceof check
    if (!$7ef244517b504261$var$isReactNative$1 && $7ef244517b504261$var$isWindow$1(value)) return true;
    return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)
function $7ef244517b504261$var$deepFreezeValue(value) {
    if (typeof value !== 'object' || $7ef244517b504261$var$shouldNotBeFrozen(value)) return;
    Object.freeze(value); // Make all properties read-only
    for(const key in value)// $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
        const prop = value[key]; // Prevent infinite recurssion for circular references.
        if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) $7ef244517b504261$var$deepFreezeValue(prop);
    }
    Object.seal(value); // This also makes existing properties non-configurable.
}
var $7ef244517b504261$var$Recoil_deepFreezeValue = $7ef244517b504261$var$deepFreezeValue;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$startPerfBlock(_id) {
    return ()=>null;
}
var $7ef244517b504261$var$Recoil_PerformanceTimings = {
    startPerfBlock: $7ef244517b504261$var$startPerfBlock
};
const { isLoadable: $7ef244517b504261$var$isLoadable$1, loadableWithError: $7ef244517b504261$var$loadableWithError$1, loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$1, loadableWithValue: $7ef244517b504261$var$loadableWithValue$2 } = $7ef244517b504261$var$Recoil_Loadable$1;
const { WrappedValue: $7ef244517b504261$var$WrappedValue$1 } = $7ef244517b504261$var$Recoil_Wrapper$1;
const { getNodeLoadable: $7ef244517b504261$var$getNodeLoadable$2, peekNodeLoadable: $7ef244517b504261$var$peekNodeLoadable$1, setNodeValue: $7ef244517b504261$var$setNodeValue$3 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { saveDepsToStore: $7ef244517b504261$var$saveDepsToStore$1 } = $7ef244517b504261$var$Recoil_Graph;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$6, getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler$1, getNode: $7ef244517b504261$var$getNode$6, registerNode: $7ef244517b504261$var$registerNode$1 } = $7ef244517b504261$var$Recoil_Node;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$3 } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified$1 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault$1 } = $7ef244517b504261$var$Recoil_Retention;
const { recoilCallback: $7ef244517b504261$var$recoilCallback$1 } = $7ef244517b504261$var$Recoil_useRecoilCallback;
const { startPerfBlock: $7ef244517b504261$var$startPerfBlock$1 } = $7ef244517b504261$var$Recoil_PerformanceTimings;
class $7ef244517b504261$var$Canceled {
}
const $7ef244517b504261$var$CANCELED = new $7ef244517b504261$var$Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */ const $7ef244517b504261$var$dependencyStack = []; // for detecting circular dependencies.
const $7ef244517b504261$var$waitingStores = new Map();
const $7ef244517b504261$var$getNewExecutionID = (()=>{
    let executionID = 0;
    return ()=>executionID++;
})();
/* eslint-disable no-redeclare */ function $7ef244517b504261$var$selector(options) {
    let recoilValue = null;
    const { key: key, get: get, cachePolicy_UNSTABLE: cachePolicy } = options;
    const set = options.set != null ? options.set : undefined; // flow
    const discoveredDependencyNodeKeys = new Set();
    const cache = $7ef244517b504261$var$Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
        equality: 'reference',
        eviction: 'keep-all'
    }, key);
    const retainedBy = $7ef244517b504261$var$retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
    const executionInfoMap = new Map();
    let liveStoresCount = 0;
    function selectorIsLive() {
        return !$7ef244517b504261$var$Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
    }
    function selectorInit(store) {
        store.getState().knownSelectors.add(key);
        liveStoresCount++;
        return ()=>{
            liveStoresCount--;
        };
    }
    function selectorShouldDeleteConfigOnRelease() {
        return $7ef244517b504261$var$getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
    }
    function resolveAsync(store, state, executionID, loadable, depValues) {
        setCache(state, loadable, depValues);
        notifyStoresOfResolvedAsync(store, executionID);
    }
    function notifyStoresOfResolvedAsync(store, executionID) {
        if (isLatestExecution(store, executionID)) clearExecutionInfo(store);
        notifyWaitingStores(executionID, true);
    }
    /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */ function notifyStoresOfNewAsyncDep(store, executionID) {
        if (isLatestExecution(store, executionID)) {
            const executionInfo = $7ef244517b504261$var$Recoil_nullthrows(getExecutionInfo(store));
            executionInfo.stateVersions.clear();
            notifyWaitingStores(executionID, false);
        }
    }
    function notifyWaitingStores(executionID, clearWaitlist) {
        const stores = $7ef244517b504261$var$waitingStores.get(executionID);
        if (stores != null) {
            for (const waitingStore of stores)$7ef244517b504261$var$markRecoilValueModified$1(waitingStore, $7ef244517b504261$var$Recoil_nullthrows(recoilValue));
            if (clearWaitlist) $7ef244517b504261$var$waitingStores.delete(executionID);
        }
    }
    function markStoreWaitingForResolvedAsync(store, executionID) {
        let stores = $7ef244517b504261$var$waitingStores.get(executionID);
        if (stores == null) $7ef244517b504261$var$waitingStores.set(executionID, stores = new Set());
        stores.add(store);
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */ function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
        return promise.then((value)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            const loadable = $7ef244517b504261$var$loadableWithValue$2(value);
            resolveAsync(store, state, executionID, loadable, depValues);
            return value;
        }).catch((errorOrPromise)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            if ($7ef244517b504261$var$Recoil_isPromise(errorOrPromise)) return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
            const loadable = $7ef244517b504261$var$loadableWithError$1(errorOrPromise);
            resolveAsync(store, state, executionID, loadable, depValues);
            throw errorOrPromise;
        });
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */ function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
        return promise.then((resolvedDep)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            } // Check if we are handling a pending Recoil dependency or if the user
            // threw their own Promise to "suspend" a selector evaluation.  We need
            // to check that the loadingDepPromise actually matches the promise that
            // we caught in case the selector happened to catch the promise we threw
            // for a pending Recoil dependency from `getRecoilValue()` and threw
            // their own promise instead.
            if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */ state.atomValues.set(loadingDepsState.loadingDepKey, $7ef244517b504261$var$loadableWithValue$2(resolvedDep));
            else /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */ store.getState().knownSelectors.forEach((nodeKey)=>{
                state.atomValues.delete(nodeKey);
            });
            /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */ const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
            if (cachedLoadable && cachedLoadable.state !== 'loading') {
                /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */ if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) notifyStoresOfResolvedAsync(store, executionID);
                if (cachedLoadable.state === 'hasValue') return cachedLoadable.contents;
                else throw cachedLoadable.contents;
            }
            /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */ if (!isLatestExecution(store, executionID)) {
                const executionInfo = getInProgressExecutionInfo(store, state);
                if (executionInfo != null) /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */ return executionInfo.loadingLoadable.contents;
            } // Retry the selector evaluation now that the dependency has resolved
            const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);
            if (loadable.state !== 'loading') resolveAsync(store, state, executionID, loadable, depValues);
            if (loadable.state === 'hasError') throw loadable.contents;
            return loadable.contents;
        }).catch((error)=>{
            // The selector was released since the request began; ignore the response.
            if (error instanceof $7ef244517b504261$var$Canceled) throw $7ef244517b504261$var$CANCELED;
            if (!selectorIsLive()) {
                clearExecutionInfo(store);
                throw $7ef244517b504261$var$CANCELED;
            }
            const loadable = $7ef244517b504261$var$loadableWithError$1(error);
            resolveAsync(store, state, executionID, loadable, existingDeps);
            throw error;
        });
    }
    function updateDeps(store, state, deps, executionID) {
        var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
        if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
            var _store$getState$nextT, _store$getState3, _store$getState3$next;
            $7ef244517b504261$var$saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
        }
        for (const nodeKey of deps)discoveredDependencyNodeKeys.add(nodeKey);
    }
    function evaluateSelectorGetter(store, state, executionID) {
        const endPerfBlock = $7ef244517b504261$var$startPerfBlock$1(key); // TODO T63965866: use execution ID here
        let duringSynchronousExecution = true;
        let duringAsynchronousExecution = true;
        const finishEvaluation = ()=>{
            endPerfBlock();
            duringAsynchronousExecution = false;
        };
        let result;
        let resultIsError = false;
        let loadable;
        const loadingDepsState = {
            loadingDepKey: null,
            loadingDepPromise: null
        };
        /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */ const depValues = new Map();
        function getRecoilValue({ key: depKey }) {
            const depLoadable = $7ef244517b504261$var$getNodeLoadable$2(store, state, depKey);
            depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
            // knows if it has to restart evaluation if one of them is updated before
            // the asynchronous selector completely resolves.
            if (!duringSynchronousExecution) {
                updateDeps(store, state, new Set(depValues.keys()), executionID);
                notifyStoresOfNewAsyncDep(store, executionID);
            }
            switch(depLoadable.state){
                case 'hasValue':
                    return depLoadable.contents;
                case 'hasError':
                    throw depLoadable.contents;
                case 'loading':
                    loadingDepsState.loadingDepKey = depKey;
                    loadingDepsState.loadingDepPromise = depLoadable.contents;
                    throw depLoadable.contents;
            }
            throw $7ef244517b504261$var$Recoil_err('Invalid Loadable state');
        }
        const getCallback = (fn)=>{
            return (...args)=>{
                if (duringAsynchronousExecution) throw $7ef244517b504261$var$Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
                !(recoilValue != null) && $7ef244517b504261$var$Recoil_invariant(false);
                return $7ef244517b504261$var$recoilCallback$1(store, fn, args, {
                    node: recoilValue
                } // flowlint-line unclear-type:off
                );
            };
        };
        try {
            result = get({
                get: getRecoilValue,
                getCallback: getCallback
            });
            result = $7ef244517b504261$var$isRecoilValue$3(result) ? getRecoilValue(result) : result;
            if ($7ef244517b504261$var$isLoadable$1(result)) {
                if (result.state === 'hasError') resultIsError = true;
                result = result.contents;
            }
            if ($7ef244517b504261$var$Recoil_isPromise(result)) result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else finishEvaluation();
            result = result instanceof $7ef244517b504261$var$WrappedValue$1 ? result.value : result;
        } catch (errorOrDepPromise) {
            result = errorOrDepPromise;
            if ($7ef244517b504261$var$Recoil_isPromise(result)) result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else {
                resultIsError = true;
                finishEvaluation();
            }
        }
        if (resultIsError) loadable = $7ef244517b504261$var$loadableWithError$1(result);
        else if ($7ef244517b504261$var$Recoil_isPromise(result)) loadable = $7ef244517b504261$var$loadableWithPromise$1(result);
        else loadable = $7ef244517b504261$var$loadableWithValue$2(result);
        duringSynchronousExecution = false;
        updateExecutionInfoDepValues(store, executionID, depValues);
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        return [
            loadable,
            depValues
        ];
    }
    function getLoadableFromCacheAndUpdateDeps(store, state) {
        // First, look up in the state cache
        // If it's here, then the deps in the store should already be valid.
        let cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
         // Second, look up in the selector cache and update the deps in the store
        const depsAfterCacheLookup = new Set();
        try {
            cachedLoadable = cache.get((nodeKey)=>{
                !(typeof nodeKey === 'string') && $7ef244517b504261$var$Recoil_invariant(false);
                return $7ef244517b504261$var$getNodeLoadable$2(store, state, nodeKey).contents;
            }, {
                onNodeVisit: (node)=>{
                    if (node.type === 'branch' && node.nodeKey !== key) depsAfterCacheLookup.add(node.nodeKey);
                }
            });
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
        }
        if (cachedLoadable) {
            var _getExecutionInfo;
            // Cache the results in the state to allow for cheaper lookup than
            // iterating the tree cache of dependencies.
            state.atomValues.set(key, cachedLoadable);
            /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */ updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
        }
        return cachedLoadable;
    }
    /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */ function getSelectorLoadableAndUpdateDeps(store, state) {
        // First, see if our current state is cached
        const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
        if (cachedVal != null) {
            clearExecutionInfo(store);
            return cachedVal;
        } // Second, check if there is already an ongoing execution based on the current state
        const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
        if (inProgressExecutionInfo != null) {
            var _inProgressExecutionI;
            if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
             // FIXME: check after the fact to see if we made the right choice by waiting
            return inProgressExecutionInfo.loadingLoadable;
        } // Third, start a new evaluation of the selector
        const newExecutionID = $7ef244517b504261$var$getNewExecutionID();
        const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
        /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */ if (loadable.state === 'loading') {
            setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
            markStoreWaitingForResolvedAsync(store, newExecutionID);
        } else {
            clearExecutionInfo(store);
            setCache(state, loadable, newDepValues);
        }
        return loadable;
    }
    /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */ function getInProgressExecutionInfo(store, state) {
        // Sort the pending executions so that our current store is checked first.
        const pendingExecutions = $7ef244517b504261$var$Recoil_concatIterables([
            executionInfoMap.has(store) ? [
                $7ef244517b504261$var$Recoil_nullthrows(executionInfoMap.get(store))
            ] : [],
            $7ef244517b504261$var$Recoil_mapIterable($7ef244517b504261$var$Recoil_filterIterable(executionInfoMap, ([s])=>s !== store), ([, execInfo])=>execInfo)
        ]);
        function anyDepChanged(execDepValues) {
            for (const [depKey, execLoadable] of execDepValues){
                if (!$7ef244517b504261$var$getNodeLoadable$2(store, state, depKey).is(execLoadable)) return true;
            }
            return false;
        }
        for (const execInfo of pendingExecutions)if (// of state, then let's use it!
        execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
        !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
            execInfo.stateVersions.set(state.version, true);
            return execInfo;
        } else execInfo.stateVersions.set(state.version, false);
        return undefined;
    }
    function getExecutionInfo(store) {
        return executionInfoMap.get(store);
    }
    /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */ function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
        executionInfoMap.set(store, {
            depValuesDiscoveredSoFarDuringAsyncWork: depValues,
            executionID: newExecutionID,
            loadingLoadable: loadable,
            stateVersions: new Map([
                [
                    state.version,
                    true
                ]
            ])
        });
    }
    function updateExecutionInfoDepValues(store, executionID, depValues) {
        // We only need to bother updating the deps for the latest execution because
        // that's all getInProgressExecutionInfo() will be looking for.
        if (isLatestExecution(store, executionID)) {
            const executionInfo = getExecutionInfo(store);
            if (executionInfo != null) executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
        }
    }
    function clearExecutionInfo(store) {
        executionInfoMap.delete(store);
    }
    function isLatestExecution(store, executionID) {
        var _getExecutionInfo2;
        return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
    }
    /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */ function depValuesToDepRoute(depValues) {
        return Array.from(depValues.entries()).map(([depKey, valLoadable])=>[
                depKey,
                valLoadable.contents
            ]);
    }
    function setCache(state, loadable, depValues) {
        state.atomValues.set(key, loadable);
        try {
            cache.set(depValuesToDepRoute(depValues), loadable);
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
        }
    }
    function detectCircularDependencies(fn) {
        if ($7ef244517b504261$var$dependencyStack.includes(key)) {
            const message = `Recoil selector has circular dependencies: ${$7ef244517b504261$var$dependencyStack.slice($7ef244517b504261$var$dependencyStack.indexOf(key)).join(' \u2192 ')}`;
            return $7ef244517b504261$var$loadableWithError$1($7ef244517b504261$var$Recoil_err(message));
        }
        $7ef244517b504261$var$dependencyStack.push(key);
        try {
            return fn();
        } finally{
            $7ef244517b504261$var$dependencyStack.pop();
        }
    }
    function selectorPeek(store, state) {
        const cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
        return cache.get((nodeKey)=>{
            var _peekNodeLoadable;
            !(typeof nodeKey === 'string') && $7ef244517b504261$var$Recoil_invariant(false);
            return (_peekNodeLoadable = $7ef244517b504261$var$peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
        });
    }
    function selectorGet(store, state) {
        return detectCircularDependencies(()=>getSelectorLoadableAndUpdateDeps(store, state));
    }
    function invalidateSelector(state) {
        state.atomValues.delete(key);
    }
    function clearSelectorCache(store, treeState) {
        !(recoilValue != null) && $7ef244517b504261$var$Recoil_invariant(false);
        for (const nodeKey of discoveredDependencyNodeKeys){
            var _node$clearCache;
            const node = $7ef244517b504261$var$getNode$6(nodeKey);
            (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, treeState);
        }
        discoveredDependencyNodeKeys.clear();
        invalidateSelector(treeState);
        cache.clear();
        $7ef244517b504261$var$markRecoilValueModified$1(store, recoilValue);
    }
    if (set != null) {
        /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */ const selectorSet = (store, state, newValue)=>{
            let syncSelectorSetFinished = false;
            const writes = new Map();
            function getRecoilValue({ key: depKey }) {
                if (syncSelectorSetFinished) throw $7ef244517b504261$var$Recoil_err('Recoil: Async selector sets are not currently supported.');
                const loadable = $7ef244517b504261$var$getNodeLoadable$2(store, state, depKey);
                if (loadable.state === 'hasValue') return loadable.contents;
                else if (loadable.state === 'loading') {
                    const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
                    $7ef244517b504261$var$Recoil_recoverableViolation(msg);
                    throw $7ef244517b504261$var$Recoil_err(msg);
                } else throw loadable.contents;
            }
            function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
            ) {
                if (syncSelectorSetFinished) {
                    const msg = 'Recoil: Async selector sets are not currently supported.';
                    $7ef244517b504261$var$Recoil_recoverableViolation(msg);
                    throw $7ef244517b504261$var$Recoil_err(msg);
                }
                const setValue = typeof valueOrUpdater === 'function' ? // flowlint-next-line unclear-type:off
                valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
                const upstreamWrites = $7ef244517b504261$var$setNodeValue$3(store, state, recoilState.key, setValue);
                upstreamWrites.forEach((v, k)=>writes.set(k, v));
            }
            function resetRecoilState(recoilState) {
                setRecoilState(recoilState, $7ef244517b504261$var$DEFAULT_VALUE$6);
            }
            const ret = set({
                set: setRecoilState,
                get: getRecoilValue,
                reset: resetRecoilState
            }, newValue); // set should be a void method, but if the user makes it `async`, then it
            // will return a Promise, which we don't currently support.
            if (ret !== undefined) throw $7ef244517b504261$var$Recoil_isPromise(ret) ? $7ef244517b504261$var$Recoil_err('Recoil: Async selector sets are not currently supported.') : $7ef244517b504261$var$Recoil_err('Recoil: selector set should be a void function.');
            syncSelectorSetFinished = true;
            return writes;
        };
        return recoilValue = $7ef244517b504261$var$registerNode$1({
            key: key,
            nodeType: 'selector',
            peek: selectorPeek,
            get: selectorGet,
            set: selectorSet,
            init: selectorInit,
            invalidate: invalidateSelector,
            clearCache: clearSelectorCache,
            shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: false,
            retainedBy: retainedBy
        });
    } else return recoilValue = $7ef244517b504261$var$registerNode$1({
        key: key,
        nodeType: 'selector',
        peek: selectorPeek,
        get: selectorGet,
        init: selectorInit,
        invalidate: invalidateSelector,
        clearCache: clearSelectorCache,
        shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: false,
        retainedBy: retainedBy
    });
}
/* eslint-enable no-redeclare */ // $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]
$7ef244517b504261$var$selector.value = (value)=>new $7ef244517b504261$var$WrappedValue$1(value);
var $7ef244517b504261$var$Recoil_selector = $7ef244517b504261$var$selector;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const { isLoadable: $7ef244517b504261$var$isLoadable$2, loadableWithError: $7ef244517b504261$var$loadableWithError$2, loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$2, loadableWithValue: $7ef244517b504261$var$loadableWithValue$3 } = $7ef244517b504261$var$Recoil_Loadable$1;
const { WrappedValue: $7ef244517b504261$var$WrappedValue$2 } = $7ef244517b504261$var$Recoil_Wrapper$1;
const { peekNodeInfo: $7ef244517b504261$var$peekNodeInfo$3 } = $7ef244517b504261$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $7ef244517b504261$var$DEFAULT_VALUE$7, DefaultValue: $7ef244517b504261$var$DefaultValue$2, getConfigDeletionHandler: $7ef244517b504261$var$getConfigDeletionHandler$2, registerNode: $7ef244517b504261$var$registerNode$2, setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$1 } = $7ef244517b504261$var$Recoil_Node;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$4 } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { getRecoilValueAsLoadable: $7ef244517b504261$var$getRecoilValueAsLoadable$4, markRecoilValueModified: $7ef244517b504261$var$markRecoilValueModified$2, setRecoilValue: $7ef244517b504261$var$setRecoilValue$4, setRecoilValueLoadable: $7ef244517b504261$var$setRecoilValueLoadable$2 } = $7ef244517b504261$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $7ef244517b504261$var$retainedByOptionWithDefault$2 } = $7ef244517b504261$var$Recoil_Retention;
const $7ef244517b504261$var$unwrap = (x)=>x instanceof $7ef244517b504261$var$WrappedValue$2 ? x.value : x;
function $7ef244517b504261$var$baseAtom(options) {
    const { key: key, persistence_UNSTABLE: persistence } = options;
    const retainedBy = $7ef244517b504261$var$retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
    let liveStoresCount = 0;
    function unwrapPromise(promise) {
        return $7ef244517b504261$var$loadableWithPromise$2(promise.then((value)=>{
            defaultLoadable = $7ef244517b504261$var$loadableWithValue$3(value);
            return value;
        }).catch((error)=>{
            defaultLoadable = $7ef244517b504261$var$loadableWithError$2(error);
            throw error;
        }));
    }
    let defaultLoadable = $7ef244517b504261$var$Recoil_isPromise(options.default) ? unwrapPromise(options.default) : $7ef244517b504261$var$isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : $7ef244517b504261$var$loadableWithValue$3($7ef244517b504261$var$unwrap(options.default));
    maybeFreezeValueOrPromise(defaultLoadable.contents);
    let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
    // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>
    const cleanupEffectsByStore = new Map();
    function maybeFreezeValueOrPromise(valueOrPromise) {
        var value;
        return valueOrPromise;
    }
    function wrapPendingPromise(store, promise) {
        const wrappedPromise = promise.then((value)=>{
            var _store$getState$nextT, _state$atomValues$get;
            const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
            if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) $7ef244517b504261$var$setRecoilValue$4(store, node, value);
            return value;
        }).catch((error)=>{
            var _store$getState$nextT2, _state$atomValues$get2;
            const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
            if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) $7ef244517b504261$var$setRecoilValueLoadable$2(store, node, $7ef244517b504261$var$loadableWithError$2(error));
            throw error;
        });
        return wrappedPromise;
    }
    function initAtom(store, initState, trigger) {
        var _options$effects;
        liveStoresCount++;
        const cleanupAtom = ()=>{
            var _cleanupEffectsByStor;
            liveStoresCount--;
            (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 || _cleanupEffectsByStor.forEach((cleanup)=>cleanup());
            cleanupEffectsByStore.delete(store);
        };
        store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve
        if (defaultLoadable.state === 'loading') {
            const notifyDefaultSubscribers = ()=>{
                var _store$getState$nextT3;
                const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
                if (!state.atomValues.has(key)) $7ef244517b504261$var$markRecoilValueModified$2(store, node);
            };
            defaultLoadable.contents.finally(notifyDefaultSubscribers);
        } ///////////////////
        // Run Atom Effects
        ///////////////////
        const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
        if (effects != null) {
            // This state is scoped by Store, since this is in the initAtom() closure
            let initValue = $7ef244517b504261$var$DEFAULT_VALUE$7;
            let isDuringInit = true;
            let isInitError = false;
            let pendingSetSelf = null;
            function getLoadable(recoilValue) {
                // Normally we can just get the current value of another atom.
                // But for our own value we need to check if there is a pending
                // initialized value or get the fallback default value.
                if (isDuringInit && recoilValue.key === key) {
                    // Cast T to S
                    const retValue = initValue; // flowlint-line unclear-type:off
                    return retValue instanceof $7ef244517b504261$var$DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
                     : $7ef244517b504261$var$Recoil_isPromise(retValue) ? $7ef244517b504261$var$loadableWithPromise$2(retValue.then((v)=>v instanceof $7ef244517b504261$var$DefaultValue$2 ? defaultLoadable.toPromise() // flowlint-line unclear-type:off
                         : v)) : $7ef244517b504261$var$loadableWithValue$3(retValue);
                }
                return $7ef244517b504261$var$getRecoilValueAsLoadable$4(store, recoilValue);
            }
            function getPromise(recoilValue) {
                return getLoadable(recoilValue).toPromise();
            }
            function getInfo_UNSTABLE(recoilValue) {
                var _store$getState$nextT4;
                const info = $7ef244517b504261$var$peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
                return isDuringInit && recoilValue.key === key && !(initValue instanceof $7ef244517b504261$var$DefaultValue$2) ? {
                    ...info,
                    isSet: true,
                    loadable: getLoadable(recoilValue)
                } : info;
            }
            const setSelf = (effect)=>(valueOrUpdater)=>{
                    if (isDuringInit) {
                        const currentLoadable = getLoadable(node);
                        const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : $7ef244517b504261$var$DEFAULT_VALUE$7;
                        initValue = typeof valueOrUpdater === 'function' ? valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                         : valueOrUpdater;
                        if ($7ef244517b504261$var$Recoil_isPromise(initValue)) initValue = initValue.then((value)=>{
                            // Avoid calling onSet() when setSelf() initializes with a Promise
                            pendingSetSelf = {
                                effect: effect,
                                value: value
                            };
                            return value;
                        });
                    } else {
                        if ($7ef244517b504261$var$Recoil_isPromise(valueOrUpdater)) throw $7ef244517b504261$var$Recoil_err('Setting atoms to async values is not implemented.');
                        if (typeof valueOrUpdater !== 'function') pendingSetSelf = {
                            effect: effect,
                            value: $7ef244517b504261$var$unwrap(valueOrUpdater)
                        };
                        $7ef244517b504261$var$setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? (currentValue)=>{
                            const newValue = $7ef244517b504261$var$unwrap(valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                            ); // $FlowFixMe[incompatible-type]
                            pendingSetSelf = {
                                effect: effect,
                                value: newValue
                            };
                            return newValue;
                        } : $7ef244517b504261$var$unwrap(valueOrUpdater));
                    }
                };
            const resetSelf = (effect)=>()=>setSelf(effect)($7ef244517b504261$var$DEFAULT_VALUE$7);
            const onSet = (effect)=>(handler)=>{
                    var _cleanupEffectsByStor2;
                    const { release: release } = store.subscribeToTransactions((currentStore)=>{
                        var _currentTree$atomValu;
                        // eslint-disable-next-line prefer-const
                        let { currentTree: currentTree, previousTree: previousTree } = currentStore.getState();
                        if (!previousTree) {
                            $7ef244517b504261$var$Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
                            previousTree = currentTree; // attempt to trundle on
                        }
                        const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
                        if (newLoadable.state === 'hasValue') {
                            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
                            const newValue = newLoadable.contents;
                            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
                            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : $7ef244517b504261$var$DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
                            // Ignore atom value changes that were set via setSelf() in the same effect.
                            // We will still properly call the handler if there was a subsequent
                            // set from something other than an atom effect which was batched
                            // with the `setSelf()` call.  However, we may incorrectly ignore
                            // the handler if the subsequent batched call happens to set the
                            // atom to the exact same value as the `setSelf()`.   But, in that
                            // case, it was kind of a noop, so the semantics are debatable..
                            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) handler(newValue, oldValue, !currentTree.atomValues.has(key));
                            else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) pendingSetSelf = null;
                        }
                    }, key);
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : [],
                        release
                    ]);
                };
            for (const effect of effects)try {
                const cleanup = effect({
                    node: node,
                    storeID: store.storeID,
                    parentStoreID_UNSTABLE: store.parentStoreID,
                    trigger: trigger,
                    setSelf: setSelf(effect),
                    resetSelf: resetSelf(effect),
                    onSet: onSet(effect),
                    getPromise: getPromise,
                    getLoadable: getLoadable,
                    getInfo_UNSTABLE: getInfo_UNSTABLE
                });
                if (cleanup != null) {
                    var _cleanupEffectsByStor3;
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : [],
                        cleanup
                    ]);
                }
            } catch (error) {
                initValue = error;
                isInitError = true;
            }
            isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
            // since we are the ones initializing on first use.
            if (!(initValue instanceof $7ef244517b504261$var$DefaultValue$2)) {
                var _store$getState$nextT5;
                const initLoadable = isInitError ? $7ef244517b504261$var$loadableWithError$2(initValue) : $7ef244517b504261$var$Recoil_isPromise(initValue) ? $7ef244517b504261$var$loadableWithPromise$2(wrapPendingPromise(store, initValue)) : $7ef244517b504261$var$loadableWithValue$3($7ef244517b504261$var$unwrap(initValue));
                maybeFreezeValueOrPromise(initLoadable.contents);
                initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
                // This could happen if the atom was first initialized in an action that
                // also updated some other atom's state.
                (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 || _store$getState$nextT5.atomValues.set(key, initLoadable);
            }
        }
        return cleanupAtom;
    }
    function peekAtom(_store, state) {
        var _ref, _state$atomValues$get3;
        return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
    }
    function getAtom(_store, state) {
        if (state.atomValues.has(key)) // Atom value is stored in state:
        return $7ef244517b504261$var$Recoil_nullthrows(state.atomValues.get(key));
        else if (state.nonvalidatedAtoms.has(key)) {
            // Atom value is stored but needs validation before use.
            // We might have already validated it and have a cached validated value:
            if (cachedAnswerForUnvalidatedValue != null) return cachedAnswerForUnvalidatedValue;
            if (persistence == null) {
                $7ef244517b504261$var$Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
                return defaultLoadable;
            }
            const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
            const validatorResult = persistence.validator(nonvalidatedValue, $7ef244517b504261$var$DEFAULT_VALUE$7);
            const validatedValueLoadable = validatorResult instanceof $7ef244517b504261$var$DefaultValue$2 ? defaultLoadable : $7ef244517b504261$var$loadableWithValue$3(validatorResult);
            cachedAnswerForUnvalidatedValue = validatedValueLoadable;
            return cachedAnswerForUnvalidatedValue;
        } else return defaultLoadable;
    }
    function invalidateAtom() {
        cachedAnswerForUnvalidatedValue = undefined;
    }
    function setAtom(_store, state, newValue) {
        // Bail out if we're being set to the existing value, or if we're being
        // reset but have no stored value (validated or unvalidated) to reset from:
        if (state.atomValues.has(key)) {
            const existing = $7ef244517b504261$var$Recoil_nullthrows(state.atomValues.get(key));
            if (existing.state === 'hasValue' && newValue === existing.contents) return new Map();
        } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof $7ef244517b504261$var$DefaultValue$2) return new Map();
        maybeFreezeValueOrPromise(newValue);
        cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use
        return new Map().set(key, $7ef244517b504261$var$loadableWithValue$3(newValue));
    }
    function shouldDeleteConfigOnReleaseAtom() {
        return $7ef244517b504261$var$getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
    }
    const node = $7ef244517b504261$var$registerNode$2({
        key: key,
        nodeType: 'atom',
        peek: peekAtom,
        get: getAtom,
        set: setAtom,
        init: initAtom,
        invalidate: invalidateAtom,
        shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        persistence_UNSTABLE: options.persistence_UNSTABLE ? {
            type: options.persistence_UNSTABLE.type,
            backButton: options.persistence_UNSTABLE.backButton
        } : undefined,
        shouldRestoreFromSnapshots: true,
        retainedBy: retainedBy
    });
    return node;
} // prettier-ignore
function $7ef244517b504261$var$atom(options) {
    const { ...restOptions } = options;
    const optionsDefault = 'default' in options ? options.default : new Promise(()=>{});
    if ($7ef244517b504261$var$isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
    ) return $7ef244517b504261$var$atomWithFallback({
        ...restOptions,
        default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    else return $7ef244517b504261$var$baseAtom({
        ...restOptions,
        default: optionsDefault
    });
}
function $7ef244517b504261$var$atomWithFallback(options) {
    const base = $7ef244517b504261$var$atom({
        ...options,
        default: $7ef244517b504261$var$DEFAULT_VALUE$7,
        persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : {
            ...options.persistence_UNSTABLE,
            validator: (storedValue)=>storedValue instanceof $7ef244517b504261$var$DefaultValue$2 ? storedValue : $7ef244517b504261$var$Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, $7ef244517b504261$var$DEFAULT_VALUE$7)
        },
        // TODO Hack for now.
        effects: options.effects,
        // flowlint-line unclear-type: off
        effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off
    }); // $FlowFixMe[incompatible-call]
    const sel = $7ef244517b504261$var$Recoil_selector({
        key: `${options.key}__withFallback`,
        get: ({ get: get })=>{
            const baseValue = get(base);
            return baseValue instanceof $7ef244517b504261$var$DefaultValue$2 ? options.default : baseValue;
        },
        // $FlowFixMe[incompatible-call]
        set: ({ set: set }, newValue)=>set(base, newValue),
        // This selector does not need to cache as it is a wrapper selector
        // and the selector within the wrapper selector will have a cache
        // option by default
        cachePolicy_UNSTABLE: {
            eviction: 'most-recent'
        },
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    $7ef244517b504261$var$setConfigDeletionHandler$1(sel.key, $7ef244517b504261$var$getConfigDeletionHandler$2(options.key));
    return sel;
} // $FlowFixMe[missing-local-annot]
$7ef244517b504261$var$atom.value = (value)=>new $7ef244517b504261$var$WrappedValue$2(value);
var $7ef244517b504261$var$Recoil_atom = $7ef244517b504261$var$atom;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $7ef244517b504261$var$MapCache {
    constructor(options){
        var _options$mapKey;
        $7ef244517b504261$var$_defineProperty(this, "_map", void 0);
        $7ef244517b504261$var$_defineProperty(this, "_keyMapper", void 0);
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    size() {
        return this._map.size;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        return this._map.get(this._keyMapper(key));
    }
    set(key, val) {
        this._map.set(this._keyMapper(key), val);
    }
    delete(key) {
        this._map.delete(this._keyMapper(key));
    }
    clear() {
        this._map.clear();
    }
}
var $7ef244517b504261$var$Recoil_MapCache = {
    MapCache: $7ef244517b504261$var$MapCache
};
var $7ef244517b504261$var$Recoil_MapCache_1 = $7ef244517b504261$var$Recoil_MapCache.MapCache;
var $7ef244517b504261$var$Recoil_MapCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MapCache: $7ef244517b504261$var$Recoil_MapCache_1
});
const { LRUCache: $7ef244517b504261$var$LRUCache$2 } = $7ef244517b504261$var$Recoil_LRUCache$1;
const { MapCache: $7ef244517b504261$var$MapCache$1 } = $7ef244517b504261$var$Recoil_MapCache$1;
const $7ef244517b504261$var$defaultPolicy$1 = {
    equality: 'reference',
    eviction: 'none',
    maxSize: Infinity
};
function $7ef244517b504261$var$cacheFromPolicy({ equality: equality = $7ef244517b504261$var$defaultPolicy$1.equality, eviction: eviction = $7ef244517b504261$var$defaultPolicy$1.eviction, maxSize: maxSize = $7ef244517b504261$var$defaultPolicy$1.maxSize } = $7ef244517b504261$var$defaultPolicy$1) {
    const valueMapper = $7ef244517b504261$var$getValueMapper$1(equality);
    const cache = $7ef244517b504261$var$getCache(eviction, maxSize, valueMapper);
    return cache;
}
function $7ef244517b504261$var$getValueMapper$1(equality) {
    switch(equality){
        case 'reference':
            return (val)=>val;
        case 'value':
            return (val)=>$7ef244517b504261$var$Recoil_stableStringify(val);
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $7ef244517b504261$var$getCache(eviction, maxSize, mapKey) {
    switch(eviction){
        case 'keep-all':
            return new $7ef244517b504261$var$MapCache$1({
                mapKey: mapKey
            });
        case 'lru':
            return new $7ef244517b504261$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: $7ef244517b504261$var$Recoil_nullthrows(maxSize)
            });
        case 'most-recent':
            return new $7ef244517b504261$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: 1
            });
    }
    throw $7ef244517b504261$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $7ef244517b504261$var$Recoil_cacheFromPolicy = $7ef244517b504261$var$cacheFromPolicy;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
const { setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$2 } = $7ef244517b504261$var$Recoil_Node;
// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }
/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/ function $7ef244517b504261$var$atomFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const atomCache = $7ef244517b504261$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
        eviction: 'keep-all'
    }); // Simple atomFamily implementation to cache individual atoms based
    // on the parameter value equality.
    return (params)=>{
        var _stableStringify, _options$effects;
        const cachedAtom = atomCache.get(params);
        if (cachedAtom != null) return cachedAtom;
        const { cachePolicyForParams_UNSTABLE: cachePolicyForParams_UNSTABLE, ...atomOptions } = options;
        const optionsDefault = 'default' in options ? options.default : new Promise(()=>{});
        const newAtom = $7ef244517b504261$var$Recoil_atom({
            ...atomOptions,
            key: `${options.key}__${(_stableStringify = $7ef244517b504261$var$Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
            default: typeof optionsDefault === 'function' ? // Flow doesn't know that T isn't a function, so we need to case to any
            // $FlowIssue[incompatible-use]
            optionsDefault(params) : optionsDefault,
            retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
            effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
        });
        atomCache.set(params, newAtom);
        $7ef244517b504261$var$setConfigDeletionHandler$2(newAtom.key, ()=>{
            atomCache.delete(params);
        });
        return newAtom;
    };
}
var $7ef244517b504261$var$Recoil_atomFamily = $7ef244517b504261$var$atomFamily;
const { setConfigDeletionHandler: $7ef244517b504261$var$setConfigDeletionHandler$3 } = $7ef244517b504261$var$Recoil_Node;
// Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify
// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let $7ef244517b504261$var$nextIndex = 0;
/* eslint-disable no-redeclare */ // Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function $7ef244517b504261$var$selectorFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const selectorCache = $7ef244517b504261$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
        eviction: 'keep-all'
    });
    return (params)=>{
        var _stableStringify;
        // Throw an error with selector key so that it is clear which
        // selector is causing an error
        let cachedSelector;
        try {
            cachedSelector = selectorCache.get(params);
        } catch (error) {
            throw $7ef244517b504261$var$Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
        }
        if (cachedSelector != null) return cachedSelector;
        const myKey = `${options.key}__selectorFamily/${(_stableStringify = $7ef244517b504261$var$Recoil_stableStringify(params, {
            // It is possible to use functions in parameters if the user uses
            // a cache with reference equality thanks to the incrementing index.
            allowFunctions: true
        })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${$7ef244517b504261$var$nextIndex++}`; // Append index in case values serialize to the same key string
        const myGet = (callbacks)=>options.get(params)(callbacks);
        const myCachePolicy = options.cachePolicy_UNSTABLE;
        const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
        let newSelector;
        if (options.set != null) {
            const set = options.set;
            const mySet = (callbacks, newValue)=>set(params)(callbacks, newValue);
            newSelector = $7ef244517b504261$var$Recoil_selector({
                key: myKey,
                get: myGet,
                set: mySet,
                cachePolicy_UNSTABLE: myCachePolicy,
                dangerouslyAllowMutability: options.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: retainedBy
            });
        } else newSelector = $7ef244517b504261$var$Recoil_selector({
            key: myKey,
            get: myGet,
            cachePolicy_UNSTABLE: myCachePolicy,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            retainedBy_UNSTABLE: retainedBy
        });
        selectorCache.set(params, newSelector);
        $7ef244517b504261$var$setConfigDeletionHandler$3(newSelector.key, ()=>{
            selectorCache.delete(params);
        });
        return newSelector;
    };
}
/* eslint-enable no-redeclare */ var $7ef244517b504261$var$Recoil_selectorFamily = $7ef244517b504261$var$selectorFamily;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$constantSelector = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__constant',
    get: (constant)=>()=>constant,
    cachePolicyForParams_UNSTABLE: {
        equality: 'reference'
    }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.
function $7ef244517b504261$var$constSelector(constant) {
    return $7ef244517b504261$var$constantSelector(constant);
}
var $7ef244517b504261$var$Recoil_constSelector = $7ef244517b504261$var$constSelector;
// flowlint-next-line unclear-type:off
const $7ef244517b504261$var$throwingSelector = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__error',
    get: (message)=>()=>{
            throw $7ef244517b504261$var$Recoil_err(message);
        },
    // TODO Why?
    cachePolicyForParams_UNSTABLE: {
        equality: 'reference'
    }
}); // Function that returns a selector which always throws an error
// with the provided message.
function $7ef244517b504261$var$errorSelector(message) {
    return $7ef244517b504261$var$throwingSelector(message);
}
var $7ef244517b504261$var$Recoil_errorSelector = $7ef244517b504261$var$errorSelector;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */ function $7ef244517b504261$var$readOnlySelector(atom) {
    // flowlint-next-line unclear-type: off
    return atom;
}
var $7ef244517b504261$var$Recoil_readOnlySelector = $7ef244517b504261$var$readOnlySelector;
const { loadableWithError: $7ef244517b504261$var$loadableWithError$3, loadableWithPromise: $7ef244517b504261$var$loadableWithPromise$3, loadableWithValue: $7ef244517b504261$var$loadableWithValue$4 } = $7ef244517b504261$var$Recoil_Loadable$1;
/////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.
function $7ef244517b504261$var$concurrentRequests(getRecoilValue, deps) {
    const results = Array(deps.length).fill(undefined);
    const exceptions = Array(deps.length).fill(undefined);
    for (const [i, dep] of deps.entries())try {
        results[i] = getRecoilValue(dep);
    } catch (e) {
        // exceptions can either be Promises of pending results or real errors
        exceptions[i] = e;
    }
    return [
        results,
        exceptions
    ];
}
function $7ef244517b504261$var$isError(exp) {
    return exp != null && !$7ef244517b504261$var$Recoil_isPromise(exp);
}
function $7ef244517b504261$var$unwrapDependencies(dependencies) {
    return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map((key)=>dependencies[key]);
}
function $7ef244517b504261$var$wrapResults(dependencies, /* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */ results) {
    return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce((out, key, idx)=>({
            ...out,
            [key]: results[idx]
        }), {});
}
function $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions) {
    const output = exceptions.map((exception, idx)=>exception == null ? $7ef244517b504261$var$loadableWithValue$4(results[idx]) : $7ef244517b504261$var$Recoil_isPromise(exception) ? $7ef244517b504261$var$loadableWithPromise$3(exception) : $7ef244517b504261$var$loadableWithError$3(exception));
    return $7ef244517b504261$var$wrapResults(dependencies, output);
}
function $7ef244517b504261$var$combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
    return asyncResults.map((result, idx)=>/**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */ result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.
const $7ef244517b504261$var$waitForNone = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__waitForNone',
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // Always return the current status of the results; never block.
            return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.
const $7ef244517b504261$var$waitForAny = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__waitForAny',
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If any results are available, value or error, return the current status
            if (exceptions.some((exp)=>!$7ef244517b504261$var$Recoil_isPromise(exp))) return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
             // Otherwise, return a promise that will resolve when the next result is
            // available, whichever one happens to be next.  But, if all pending
            // dependencies end up with errors, then reject the promise.
            return new Promise((resolve)=>{
                for (const [i, exp] of exceptions.entries())if ($7ef244517b504261$var$Recoil_isPromise(exp)) exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                    resolve($7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
                }).catch((error)=>{
                    exceptions[i] = error;
                    resolve($7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
                });
            });
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.
const $7ef244517b504261$var$waitForAll = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__waitForAll',
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>exp == null)) return $7ef244517b504261$var$wrapResults(dependencies, results);
             // If we have any errors, throw the first error
            const error = exceptions.find($7ef244517b504261$var$isError);
            if (error != null) throw error;
             // Otherwise, return a promise that will resolve when all results are available
            return Promise.all(exceptions).then((exceptionResults)=>$7ef244517b504261$var$wrapResults(dependencies, $7ef244517b504261$var$combineAsyncResultsWithSyncResults(results, exceptionResults)));
        },
    dangerouslyAllowMutability: true
});
const $7ef244517b504261$var$waitForAllSettled = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__waitForAllSettled',
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $7ef244517b504261$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $7ef244517b504261$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>!$7ef244517b504261$var$Recoil_isPromise(exp))) return $7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions);
             // Wait for all results to settle
            return Promise.all(exceptions.map((exp, i)=>$7ef244517b504261$var$Recoil_isPromise(exp) ? exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                }).catch((error)=>{
                    results[i] = undefined;
                    exceptions[i] = error;
                }) : null)) // Then wrap them as loadables
            .then(()=>$7ef244517b504261$var$wrapLoadables(dependencies, results, exceptions));
        },
    dangerouslyAllowMutability: true
});
const $7ef244517b504261$var$noWait = $7ef244517b504261$var$Recoil_selectorFamily({
    key: '__noWait',
    get: (dependency)=>({ get: get })=>{
            try {
                return $7ef244517b504261$var$Recoil_selector.value($7ef244517b504261$var$loadableWithValue$4(get(dependency)));
            } catch (exception) {
                return $7ef244517b504261$var$Recoil_selector.value($7ef244517b504261$var$Recoil_isPromise(exception) ? $7ef244517b504261$var$loadableWithPromise$3(exception) : $7ef244517b504261$var$loadableWithError$3(exception));
            }
        },
    dangerouslyAllowMutability: true
});
var $7ef244517b504261$var$Recoil_WaitFor = {
    waitForNone: $7ef244517b504261$var$waitForNone,
    waitForAny: $7ef244517b504261$var$waitForAny,
    waitForAll: $7ef244517b504261$var$waitForAll,
    waitForAllSettled: $7ef244517b504261$var$waitForAllSettled,
    noWait: $7ef244517b504261$var$noWait
};
const { RecoilLoadable: $7ef244517b504261$var$RecoilLoadable } = $7ef244517b504261$var$Recoil_Loadable$1;
const { DefaultValue: $7ef244517b504261$var$DefaultValue$3 } = $7ef244517b504261$var$Recoil_Node;
const { RecoilRoot: $7ef244517b504261$var$RecoilRoot$2, useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID$1 } = $7ef244517b504261$var$Recoil_RecoilRoot;
const { isRecoilValue: $7ef244517b504261$var$isRecoilValue$5 } = $7ef244517b504261$var$Recoil_RecoilValue$1;
const { retentionZone: $7ef244517b504261$var$retentionZone$1 } = $7ef244517b504261$var$Recoil_RetentionZone;
const { freshSnapshot: $7ef244517b504261$var$freshSnapshot$2 } = $7ef244517b504261$var$Recoil_Snapshot$1;
const { useRecoilState: $7ef244517b504261$var$useRecoilState$1, useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable$1, useRecoilValue: $7ef244517b504261$var$useRecoilValue$1, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable$1, useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1, useResetRecoilState: $7ef244517b504261$var$useResetRecoilState$1, useSetRecoilState: $7ef244517b504261$var$useSetRecoilState$1 } = $7ef244517b504261$var$Recoil_Hooks;
const { useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot$1, useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot$1, useRecoilTransactionObserver: $7ef244517b504261$var$useRecoilTransactionObserver$1 } = $7ef244517b504261$var$Recoil_SnapshotHooks;
const { useRecoilCallback: $7ef244517b504261$var$useRecoilCallback$1 } = $7ef244517b504261$var$Recoil_useRecoilCallback;
const { noWait: $7ef244517b504261$var$noWait$1, waitForAll: $7ef244517b504261$var$waitForAll$1, waitForAllSettled: $7ef244517b504261$var$waitForAllSettled$1, waitForAny: $7ef244517b504261$var$waitForAny$1, waitForNone: $7ef244517b504261$var$waitForNone$1 } = $7ef244517b504261$var$Recoil_WaitFor;
var $7ef244517b504261$var$Recoil_index = {
    // Types
    DefaultValue: $7ef244517b504261$var$DefaultValue$3,
    isRecoilValue: $7ef244517b504261$var$isRecoilValue$5,
    RecoilLoadable: $7ef244517b504261$var$RecoilLoadable,
    // Global Recoil environment settiongs
    RecoilEnv: $7ef244517b504261$var$Recoil_RecoilEnv,
    // Recoil Root
    RecoilRoot: $7ef244517b504261$var$RecoilRoot$2,
    useRecoilStoreID: $7ef244517b504261$var$useRecoilStoreID$1,
    useRecoilBridgeAcrossReactRoots_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilBridgeAcrossReactRoots,
    // Atoms/Selectors
    atom: $7ef244517b504261$var$Recoil_atom,
    selector: $7ef244517b504261$var$Recoil_selector,
    // Convenience Atoms/Selectors
    atomFamily: $7ef244517b504261$var$Recoil_atomFamily,
    selectorFamily: $7ef244517b504261$var$Recoil_selectorFamily,
    constSelector: $7ef244517b504261$var$Recoil_constSelector,
    errorSelector: $7ef244517b504261$var$Recoil_errorSelector,
    readOnlySelector: $7ef244517b504261$var$Recoil_readOnlySelector,
    // Concurrency Helpers for Atoms/Selectors
    noWait: $7ef244517b504261$var$noWait$1,
    waitForNone: $7ef244517b504261$var$waitForNone$1,
    waitForAny: $7ef244517b504261$var$waitForAny$1,
    waitForAll: $7ef244517b504261$var$waitForAll$1,
    waitForAllSettled: $7ef244517b504261$var$waitForAllSettled$1,
    // Hooks for Atoms/Selectors
    useRecoilValue: $7ef244517b504261$var$useRecoilValue$1,
    useRecoilValueLoadable: $7ef244517b504261$var$useRecoilValueLoadable$1,
    useRecoilState: $7ef244517b504261$var$useRecoilState$1,
    useRecoilStateLoadable: $7ef244517b504261$var$useRecoilStateLoadable$1,
    useSetRecoilState: $7ef244517b504261$var$useSetRecoilState$1,
    useResetRecoilState: $7ef244517b504261$var$useResetRecoilState$1,
    useGetRecoilValueInfo_UNSTABLE: $7ef244517b504261$var$Recoil_useGetRecoilValueInfo,
    useRecoilRefresher_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilRefresher,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $7ef244517b504261$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
    // Hooks for complex operations
    useRecoilCallback: $7ef244517b504261$var$useRecoilCallback$1,
    useRecoilTransaction_UNSTABLE: $7ef244517b504261$var$Recoil_useRecoilTransaction,
    // Snapshots
    useGotoRecoilSnapshot: $7ef244517b504261$var$useGotoRecoilSnapshot$1,
    useRecoilSnapshot: $7ef244517b504261$var$useRecoilSnapshot$1,
    useRecoilTransactionObserver_UNSTABLE: $7ef244517b504261$var$useRecoilTransactionObserver$1,
    snapshot_UNSTABLE: $7ef244517b504261$var$freshSnapshot$2,
    // Memory Management
    useRetain: $7ef244517b504261$var$Recoil_useRetain,
    retentionZone: $7ef244517b504261$var$retentionZone$1
};
var $7ef244517b504261$export$a4e369a19907695d = $7ef244517b504261$var$Recoil_index.DefaultValue;
var $7ef244517b504261$export$8e2120adc095590f = $7ef244517b504261$var$Recoil_index.isRecoilValue;
var $7ef244517b504261$export$b04cb8d38132ba6e = $7ef244517b504261$var$Recoil_index.RecoilLoadable;
var $7ef244517b504261$export$b6bd5219181c222b = $7ef244517b504261$var$Recoil_index.RecoilEnv;
var $7ef244517b504261$export$f72b9f9819639629 = $7ef244517b504261$var$Recoil_index.RecoilRoot;
var $7ef244517b504261$export$cb8baa5ebbbeec81 = $7ef244517b504261$var$Recoil_index.useRecoilStoreID;
var $7ef244517b504261$export$a42d8cff2ac8d9e5 = $7ef244517b504261$var$Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var $7ef244517b504261$export$5fb5cc0d078610b = $7ef244517b504261$var$Recoil_index.atom;
var $7ef244517b504261$export$aea217a45095ce11 = $7ef244517b504261$var$Recoil_index.selector;
var $7ef244517b504261$export$98dc87c59e005bfc = $7ef244517b504261$var$Recoil_index.atomFamily;
var $7ef244517b504261$export$62317b671b80c71d = $7ef244517b504261$var$Recoil_index.selectorFamily;
var $7ef244517b504261$export$18e41ac5fdf5533e = $7ef244517b504261$var$Recoil_index.constSelector;
var $7ef244517b504261$export$47aec13333381be0 = $7ef244517b504261$var$Recoil_index.errorSelector;
var $7ef244517b504261$export$11880e5adc5def9 = $7ef244517b504261$var$Recoil_index.readOnlySelector;
var $7ef244517b504261$export$ab07e6aa23cd7e90 = $7ef244517b504261$var$Recoil_index.noWait;
var $7ef244517b504261$export$5c93b0ea2ae8f20b = $7ef244517b504261$var$Recoil_index.waitForNone;
var $7ef244517b504261$export$9ee161e2f87911b5 = $7ef244517b504261$var$Recoil_index.waitForAny;
var $7ef244517b504261$export$4dcf1964c6471cb6 = $7ef244517b504261$var$Recoil_index.waitForAll;
var $7ef244517b504261$export$a82851251af05082 = $7ef244517b504261$var$Recoil_index.waitForAllSettled;
var $7ef244517b504261$export$8b71bf98365f8042 = $7ef244517b504261$var$Recoil_index.useRecoilValue;
var $7ef244517b504261$export$23331814aa7f2650 = $7ef244517b504261$var$Recoil_index.useRecoilValueLoadable;
var $7ef244517b504261$export$12012bbeae92bfa2 = $7ef244517b504261$var$Recoil_index.useRecoilState;
var $7ef244517b504261$export$223ac8c28103fd98 = $7ef244517b504261$var$Recoil_index.useRecoilStateLoadable;
var $7ef244517b504261$export$4102102216e95cfa = $7ef244517b504261$var$Recoil_index.useSetRecoilState;
var $7ef244517b504261$export$75b418d01f19b2e = $7ef244517b504261$var$Recoil_index.useResetRecoilState;
var $7ef244517b504261$export$24dc7ee2767b2f1c = $7ef244517b504261$var$Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var $7ef244517b504261$export$3726f445fa0ad4a7 = $7ef244517b504261$var$Recoil_index.useRecoilRefresher_UNSTABLE;
var $7ef244517b504261$export$c6e9c47eec22eb86 = $7ef244517b504261$var$Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$435b1bf0f9f79a38 = $7ef244517b504261$var$Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$2df379f232d6fe77 = $7ef244517b504261$var$Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var $7ef244517b504261$export$6ef5088871c318c5 = $7ef244517b504261$var$Recoil_index.useRecoilCallback;
var $7ef244517b504261$export$4a76cc788f949bc4 = $7ef244517b504261$var$Recoil_index.useRecoilTransaction_UNSTABLE;
var $7ef244517b504261$export$a7cf2c8ce398f17a = $7ef244517b504261$var$Recoil_index.useGotoRecoilSnapshot;
var $7ef244517b504261$export$7cc4a4decba383e9 = $7ef244517b504261$var$Recoil_index.useRecoilSnapshot;
var $7ef244517b504261$export$924c13ee4d1c0013 = $7ef244517b504261$var$Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var $7ef244517b504261$export$fe4c07befea3edfb = $7ef244517b504261$var$Recoil_index.snapshot_UNSTABLE;
var $7ef244517b504261$export$f9d5dc8f5133b7e8 = $7ef244517b504261$var$Recoil_index.useRetain;
var $7ef244517b504261$export$33ebb0dc02dfd75d = $7ef244517b504261$var$Recoil_index.retentionZone;
var $7ef244517b504261$export$2e2bcd8739ae039 = $7ef244517b504261$var$Recoil_index;


var $71096008450a71c4$exports = {};
$71096008450a71c4$exports = JSON.parse("{\"name\":\"emukit\",\"version\":\"0.10.25\",\"description\":\"Emulation Web UI toolkit\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/joamag/emukit.git\"},\"license\":\"Apache-2.0\",\"scripts\":{\"lint\":\"eslint .\",\"pretty\":\"prettier --config .prettierrc \\\"./**/*.{js,ts,tsx,json}\\\" --write\",\"test\":\"npm run test:mocha\",\"test:mocha\":\"mocha --require tsx/cjs --recursive test\"},\"source\":\"index.ts\",\"peerDependencies\":{\"@types/react\":\"^18.3.18\",\"@types/react-dom\":\"^18.3.5\",\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\",\"recoil\":\"^0.7.7\"},\"devDependencies\":{\"@types/react\":\"^18.3.18\",\"@types/react-dom\":\"^18.3.5\",\"@typescript-eslint/eslint-plugin\":\"^8.26.1\",\"@typescript-eslint/parser\":\"^8.26.1\",\"eslint\":\"^8.57.0\",\"eslint-plugin-import\":\"^2.29.1\",\"eslint-plugin-react-hooks\":\"^5.2.0\",\"mocha\":\"^11.1.0\",\"prettier\":\"^3.5.3\",\"prettier-plugin-organize-imports\":\"^4.0.0\",\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\",\"recoil\":\"^0.7.7\",\"tsx\":\"^4.19.3\",\"typescript\":\"^5.8.2\"}}");


var $a1d49843ac1aef96$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})($a1d49843ac1aef96$export$243e62d78d3b544d || ($a1d49843ac1aef96$export$243e62d78d3b544d = {}));
class $a1d49843ac1aef96$export$efa9a398d6368992 {
    constructor(){
        this.logLevel = $a1d49843ac1aef96$export$243e62d78d3b544d.DEBUG;
    }
    debug(message, ...args) {
        if (this.level > $a1d49843ac1aef96$export$243e62d78d3b544d.DEBUG) return;
        console.debug(message, ...args);
    }
    info(message, ...args) {
        if (this.level > $a1d49843ac1aef96$export$243e62d78d3b544d.INFO) return;
        console.info(message, ...args);
    }
    warn(message, ...args) {
        if (this.level > $a1d49843ac1aef96$export$243e62d78d3b544d.WARN) return;
        console.warn(message, ...args);
    }
    error(message, ...args) {
        if (this.level > $a1d49843ac1aef96$export$243e62d78d3b544d.ERROR) return;
        console.error(message, ...args);
    }
    get level() {
        return this.logLevel;
    }
    set level(logLevel) {
        this.logLevel = logLevel;
    }
}
const $a1d49843ac1aef96$export$af88d00dbe7f521 = new $a1d49843ac1aef96$export$efa9a398d6368992();



/**
 * Encodes an array of bytes into a base64 string.
 *
 * @param buffer The array of bytes to encode.
 * @returns The resulting base64 string.
 */ const $a07119bee7a8f987$export$8ffe10d2aad3f2 = (buffer)=>{
    const data = Array(buffer.length).fill(null).map((_, i)=>String.fromCharCode(buffer[i])).join("");
    const base64 = btoa(data);
    return base64;
};
const $a07119bee7a8f987$export$243468195665a877 = (base64)=>{
    const data = atob(base64);
    const array = Array(data.length).fill(null).map((_, i)=>data.charCodeAt(i));
    const buffer = new Uint8Array(array);
    return buffer;
};
const $a07119bee7a8f987$export$a11b0059900ceec8 = ()=>{
    return navigator.userAgent.match(/Android/i);
};
const $a07119bee7a8f987$export$f0df9fc502b4499c = (rgb, width, height, format = "image/png")=>{
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Could not create canvas context");
    const imageData = ctx.createImageData(width, height);
    const rgba = new Uint8Array(width * height * 4);
    for(let i = 0; i < width * height; i++){
        rgba[i * 4] = rgb[i * 3];
        rgba[i * 4 + 1] = rgb[i * 3 + 1];
        rgba[i * 4 + 2] = rgb[i * 3 + 2];
        rgba[i * 4 + 3] = 255;
    }
    imageData.data.set(rgba);
    ctx.putImageData(imageData, 0, 0);
    const dataUrl = canvas.toDataURL(format);
    return dataUrl;
};
const $a07119bee7a8f987$export$93588aa942feafe7 = (buffer, filename, type = "application/octet-stream")=>{
    // copies the buffer so that it's backed by its own array buffer,
    // as a typed array backed by a shared one is not a valid blob part
    const blob = new Blob([
        buffer.slice()
    ], {
        type: type
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("download", filename);
    link.setAttribute("href", url);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
const $a07119bee7a8f987$export$66e1c0999abad646 = (first, second)=>{
    const parseVersion = (version)=>{
        return version.split(".").map(Number);
    };
    const [major1, minor1, patch1] = parseVersion(first);
    const [major2, minor2, patch2] = parseVersion(second);
    if (major1 > major2) return true;
    if (major1 < major2) return false;
    if (minor1 > minor2) return true;
    if (minor1 < minor2) return false;
    if (patch1 >= patch2) return true;
    return false;
};
const $a07119bee7a8f987$export$96812dd9af999b22 = (filename)=>{
    const lastDotIndex = filename.lastIndexOf(".");
    return lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : "";
};


var $21488f2abed026ea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $21488f2abed026ea$export$a4ca6f0b93d1bc79 = 100000;
const $21488f2abed026ea$export$c8c8884a02af7737 = 1;
/**
 * The frequency at which the emulator emulator should
 * run "normally". This is a simple placeholder and the
 * concrete value should be always overridden.
 */ const $21488f2abed026ea$var$LOGIC_HZ = 1000;
/**
 * The frequency at which the the visual loop is going to
 * run, increasing this value will have a consequence in
 * the visual frames per second (FPS) of emulation.
 */ const $21488f2abed026ea$var$VISUAL_HZ = 60;
/**
 * The frequency of the pause polling update operation,
 * increasing this value will make resume from emulation
 * paused state fasted.
 */ const $21488f2abed026ea$var$IDLE_HZ = 10;
/**
 * The sample rate that is going to be used for FPS calculus,
 * meaning that every N seconds we will calculate the number
 * of frames rendered divided by the N seconds.
 */ const $21488f2abed026ea$var$FPS_SAMPLE_RATE = 3;
/**
 * The maximum number of emulation ticks that can be executed
 * for a single animation frame, this value allows an animation
 * frame loop of 30 FPS to run an emulator that requires 90 Hz
 * of visual execution.
 */ const $21488f2abed026ea$var$MAX_TICKS_ANIMATION_FRAME = 3;
var $21488f2abed026ea$export$6e91cf7616333d5;
(function(Feature) {
    Feature[Feature["Help"] = 1] = "Help";
    Feature[Feature["Debug"] = 2] = "Debug";
    Feature[Feature["Themes"] = 3] = "Themes";
    Feature[Feature["Palettes"] = 4] = "Palettes";
    Feature[Feature["Benchmark"] = 5] = "Benchmark";
    Feature[Feature["LoopMode"] = 6] = "LoopMode";
    Feature[Feature["Keyboard"] = 7] = "Keyboard";
    Feature[Feature["KeyboardChip8"] = 8] = "KeyboardChip8";
    Feature[Feature["KeyboardGB"] = 9] = "KeyboardGB";
    Feature[Feature["DisplayFrequency"] = 10] = "DisplayFrequency";
    Feature[Feature["Framerate"] = 11] = "Framerate";
    Feature[Feature["Cyclerate"] = 12] = "Cyclerate";
    Feature[Feature["Animationrate"] = 13] = "Animationrate";
    Feature[Feature["SkippedTicks"] = 14] = "SkippedTicks";
    Feature[Feature["EmulationSpeed"] = 15] = "EmulationSpeed";
    Feature[Feature["BootRomInfo"] = 16] = "BootRomInfo";
    Feature[Feature["RomTypeInfo"] = 17] = "RomTypeInfo";
    Feature[Feature["SaveState"] = 18] = "SaveState";
})($21488f2abed026ea$export$6e91cf7616333d5 || ($21488f2abed026ea$export$6e91cf7616333d5 = {}));
var $21488f2abed026ea$export$44c95d3770756ed2;
(function(Frequency) {
    Frequency["Hz"] = "Hz";
    Frequency["Khz"] = "KHz";
    Frequency["MHz"] = "MHz";
})($21488f2abed026ea$export$44c95d3770756ed2 || ($21488f2abed026ea$export$44c95d3770756ed2 = {}));
var $21488f2abed026ea$export$abee86c20a5429d;
(function(PixelFormat) {
    PixelFormat[PixelFormat["RGB"] = 3] = "RGB";
    PixelFormat[PixelFormat["RGBA"] = 4] = "RGBA";
})($21488f2abed026ea$export$abee86c20a5429d || ($21488f2abed026ea$export$abee86c20a5429d = {}));
var $21488f2abed026ea$export$978b507482c55c4c;
(function(LoopMode) {
    LoopMode[LoopMode["Auto"] = 1] = "Auto";
    LoopMode[LoopMode["SetTimeout"] = 2] = "SetTimeout";
    LoopMode[LoopMode["AnimationFrame"] = 3] = "AnimationFrame";
    LoopMode[LoopMode["AnimationDesynced"] = 4] = "AnimationDesynced";
})($21488f2abed026ea$export$978b507482c55c4c || ($21488f2abed026ea$export$978b507482c55c4c = {}));
var $21488f2abed026ea$export$cf3b21a5f06c6de0;
(function(TickMode) {
    TickMode[TickMode["Synced"] = 1] = "Synced";
    TickMode[TickMode["Desynced"] = 2] = "Desynced";
})($21488f2abed026ea$export$cf3b21a5f06c6de0 || ($21488f2abed026ea$export$cf3b21a5f06c6de0 = {}));
const $21488f2abed026ea$export$145cd2705873a35b = {
    Hz: 1,
    KHz: 1000,
    MHz: 1000000
};
class $21488f2abed026ea$export$77cea355fa80b5f4 {
    constructor(){
        this.events = {};
    }
    bind(event, callback) {
        var _a;
        const callbacks = (_a = this.events[event]) !== null && _a !== void 0 ? _a : [];
        if (callbacks.includes(callback)) return;
        callbacks.push(callback);
        this.events[event] = callbacks;
    }
    unbind(event, callback) {
        var _a;
        const callbacks = (_a = this.events[event]) !== null && _a !== void 0 ? _a : [];
        if (!callbacks.includes(callback)) return;
        const index = callbacks.indexOf(callback);
        callbacks.splice(index, 1);
        this.events[event] = callbacks;
    }
    trigger(event, params) {
        var _a;
        const callbacks = (_a = this.events[event]) !== null && _a !== void 0 ? _a : [];
        callbacks.forEach((c)=>c(this, params));
    }
}
class $21488f2abed026ea$export$ac140ec8504792b9 extends $21488f2abed026ea$export$77cea355fa80b5f4 {
    constructor(){
        super(...arguments);
        this._handlers = {};
    }
    static now() {
        if (performance && performance.now) return performance.now();
        return Date.now();
    }
    get icon() {
        return undefined;
    }
    get version() {
        return undefined;
    }
    get repository() {
        return undefined;
    }
    get features() {
        return [];
    }
    get sections() {
        return [];
    }
    get help() {
        return [];
    }
    get debug() {
        return [];
    }
    get stateExts() {
        return [];
    }
    get displayFrequency() {
        return 0;
    }
    set displayFrequency(value) {}
    get frequencySpecs() {
        return {
            unit: $21488f2abed026ea$export$44c95d3770756ed2.MHz,
            delta: $21488f2abed026ea$export$a4ca6f0b93d1bc79,
            places: 2
        };
    }
    get audioSpecs() {
        return null;
    }
    get audioBuffer() {
        return [];
    }
    get romInfo() {
        return {};
    }
    get compiler() {
        return null;
    }
    get compilation() {
        return null;
    }
    get wasmEngine() {
        return null;
    }
    get framerate() {
        return 0;
    }
    get cyclerate() {
        return 0;
    }
    get animationrate() {
        return 0;
    }
    get skippedTicks() {
        return 0;
    }
    get emulationSpeed() {
        return 100.0;
    }
    get audioOutput() {
        return {};
    }
    get palette() {
        return undefined;
    }
    set palette(value) {}
    get compilerString() {
        if (!this.compiler) return null;
        const buffer = [];
        if (this.compiler.name) buffer.push(this.compiler.name);
        if (this.compiler.version) buffer.push(this.compiler.version);
        return buffer.join("/");
    }
    get compilationString() {
        if (!this.compilation) return null;
        const buffer = [];
        if (this.compilation.date) buffer.push(this.compilation.date);
        if (this.compilation.time) buffer.push(this.compilation.time);
        return buffer.join(" ");
    }
    get handlers() {
        return this._handlers;
    }
    set handlers(value) {
        this._handlers = value;
    }
    get logger() {
        return 0, $a1d49843ac1aef96$export$af88d00dbe7f521;
    }
    buildRomData(file) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            const arrayBuffer = yield file.arrayBuffer();
            const romData = new Uint8Array(arrayBuffer);
            return romData;
        });
    }
    serializeState() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error("Unable to serialize state");
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    unserializeState(_data) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error("Unable to unserialize state");
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    buildState(_index, _data) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error("Unable to build state");
        });
    }
    saveState(index_1, data_1) {
        return $21488f2abed026ea$var$__awaiter(this, arguments, void 0, function*(index, data, safe = true) {
            if (!window.localStorage) throw new Error("Unable to save state");
            if (data === undefined) data = yield this.serializeState();
            if (safe) yield this.validateState(data, {
                title: this.romInfo.name
            });
            const dataB64 = (0, $a07119bee7a8f987$export$8ffe10d2aad3f2)(data);
            localStorage.setItem(`${this.romInfo.name}-s${index}`, dataB64);
        });
    }
    loadState(index) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.getStateData(index);
            yield this.unserializeState(data);
        });
    }
    deleteState(index) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            if (!window.localStorage) throw new Error("Unable to delete state");
            localStorage.removeItem(`${this.romInfo.name}-s${index}`);
        });
    }
    getState(index) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            const data = yield this.getStateData(index);
            return yield this.buildState(index, data);
        });
    }
    getStateData(index) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            if (!window.localStorage) throw new Error("Unable to get state");
            const dataB64 = localStorage.getItem(`${this.romInfo.name}-s${index}`);
            if (!dataB64) throw new Error("Unable to get state");
            const data = (0, $a07119bee7a8f987$export$243468195665a877)(dataB64);
            return data;
        });
    }
    listStates() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            if (!window.localStorage) throw new Error("Unable to list states");
            const states = [];
            for(let index = 0; index < 10; index++){
                const dataB64 = localStorage.getItem(`${this.romInfo.name}-s${index}`);
                if (dataB64 !== null) states.push(index);
            }
            return states;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    validateState(data, validation) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
class $21488f2abed026ea$export$9965e7f257856636 extends $21488f2abed026ea$export$ac140ec8504792b9 {
    constructor(){
        super(...arguments);
        this.running = false;
        this.paused = false;
        this.nextTickTime = 0;
        this.previousTickTime = 0;
        this.logicFrequency = $21488f2abed026ea$var$LOGIC_HZ;
        this.visualFrequency = $21488f2abed026ea$var$VISUAL_HZ;
        this.idleFrequency = $21488f2abed026ea$var$IDLE_HZ;
        this.fps = 0;
        this.frameStart = $21488f2abed026ea$export$9965e7f257856636.now();
        this.frameCount = 0;
        this.cps = 0;
        this.cycleStart = $21488f2abed026ea$export$9965e7f257856636.now();
        this.cycleCount = 0;
        this.afps = 0;
        this.animationFrameStart = $21488f2abed026ea$export$9965e7f257856636.now();
        this.animationFrameCount = 0;
        this.skipped = 0;
        this.skippedTicksStart = $21488f2abed026ea$export$9965e7f257856636.now();
        this.skippedTicksCount = 0;
        /**
         * The handler for the visibility change event, this is
         * used to reset the time counters whenever the emulator
         * gets focus again, avoiding the FPS and CPS to be
         * incorrectly calculated.
         */ this.visibilityChangeHandler = null;
        /**
         * The identifier of the animation frame that is currently
         * scheduled, allowing its cancellation on the stop operation.
         */ this.animationFrameHandle = null;
        /**
         * The resolve function of the animation frame loop that is
         * currently running, allowing the loop to be settled without
         * having to wait for another frame to be scheduled.
         */ this.animationFrameResolve = null;
        this._loopMode = $21488f2abed026ea$export$978b507482c55c4c.Auto;
    }
    get framerate() {
        return this.fps;
    }
    get cyclerate() {
        return this.cps;
    }
    get animationrate() {
        return this.afps;
    }
    get skippedTicks() {
        return this.skipped;
    }
    get emulationSpeed() {
        if (this.logicFrequency === 0.0) return 0.0;
        return this.cps / this.logicFrequency * 100.0;
    }
    get loopMode() {
        return this._loopMode;
    }
    set loopMode(value) {
        // in case the loop mode is set to auto, tries to determine
        // the best loop mode for the current environment
        if (value === $21488f2abed026ea$export$978b507482c55c4c.Auto) value = window.requestAnimationFrame === undefined ? $21488f2abed026ea$export$978b507482c55c4c.SetTimeout : $21488f2abed026ea$export$978b507482c55c4c.AnimationDesynced;
        this._loopMode = value;
    }
    /**
     * Runs the initialization and main loop execution for the emulator.
     * The main execution of this function should be an infinite
     * loop running machine `tick` operations.
     *
     * Should be called only once per instance and serve as its main entry
     * point of execution.
     *
     * @param options The set of options that are going to be
     * used in he emulator initialization.
     */ start(_a) {
        return $21488f2abed026ea$var$__awaiter(this, arguments, void 0, function*({ romUrl: romUrl, loopMode: loopMode = $21488f2abed026ea$export$978b507482c55c4c.Auto }) {
            this.loopMode = loopMode;
            this.running = true;
            // boots the emulator subsystem with the initial
            // ROM retrieved from a remote data source, resetting the
            // running state in case the boot operation fails
            try {
                yield this.boot({
                    loadRom: true,
                    romPath: romUrl !== null && romUrl !== void 0 ? romUrl : undefined
                });
            } catch (err) {
                this.running = false;
                throw err;
            }
            // in case the emulator has been stopped while the boot
            // operation was still pending then returns the control flow
            // immediately, avoiding the registration of the listeners
            if (!this.running) return;
            // binds the frame event to the current instance of the
            // emulator logic, this event is going to be used to
            // calculate the number of frames per second (FPS)
            this.bind("frame", (_owner, params)=>{
                var _a;
                const frameInfo = params !== null && params !== void 0 ? params : {};
                // increments the current frame count (as new frame exists)
                // and in case the target number of frames for FPS control
                // has been reached calculates the number of FPS and
                // flushes the value to the screen
                this.frameCount += (_a = frameInfo.count) !== null && _a !== void 0 ? _a : 1;
                if (this.frameCount >= this.visualFrequency * $21488f2abed026ea$var$FPS_SAMPLE_RATE) {
                    const currentTime = $21488f2abed026ea$export$9965e7f257856636.now();
                    const deltaFps = (currentTime - this.frameStart) / 1000;
                    const deltaCps = (currentTime - this.cycleStart) / 1000;
                    const deltaAfps = (currentTime - this.animationFrameStart) / 1000;
                    const deltaSkipped = (currentTime - this.skippedTicksStart) / 1000;
                    this.fps = Math.round(this.frameCount / deltaFps);
                    this.cps = Math.round(this.cycleCount / deltaCps);
                    this.afps = Math.round(this.animationFrameCount / deltaAfps);
                    this.skipped = Math.round(this.skippedTicksCount / deltaSkipped * 100) / 100;
                    this.resetTimeCounters();
                }
            });
            this.bind("tick", (_owner, params)=>{
                var _a;
                const tickInfo = params !== null && params !== void 0 ? params : {};
                this.cycleCount += (_a = tickInfo.cycles) !== null && _a !== void 0 ? _a : 0;
            });
            this.bind("animation-frame", (_owner, params)=>{
                var _a;
                const animationFrameInfo = params !== null && params !== void 0 ? params : {};
                const ticks = (_a = animationFrameInfo.ticks) !== null && _a !== void 0 ? _a : 0;
                this.animationFrameCount++;
                this.skippedTicksCount += Math.max(ticks - 1, 0);
            });
            // registers for the visibility change event so that the
            // whenever we get focus on the emulator tab we reset
            // the counters so that the FPS and CPS are accurate
            this.bind("visible", ()=>{
                this.nextTickTime = $21488f2abed026ea$export$9965e7f257856636.now();
                this.previousTickTime = $21488f2abed026ea$export$9965e7f257856636.now();
                this.resetTimeCounters();
            });
            // pipes some of the native visibility change events
            // into the internal event system, keeping a reference to the
            // handler so that it can be released on the stop operation
            this.visibilityChangeHandler = ()=>{
                if (document.visibilityState === "visible") this.trigger("visible");
                if (document.visibilityState === "hidden") this.trigger("hidden");
            };
            document.addEventListener("visibilitychange", this.visibilityChangeHandler);
            yield this.loop();
        });
    }
    /**
     * Stops the main loop execution of the emulator, releasing the
     * event listeners that have been registered as part of the
     * `start()` operation.
     *
     * The set timeout loop is only effectively terminated on its next
     * scheduled iteration, while the animation frame ones are settled
     * immediately, as a hidden document would otherwise suspend the
     * scheduling of new frames indefinitely.
     */ stop() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            this.running = false;
            if (this.animationFrameHandle !== null) {
                window.cancelAnimationFrame(this.animationFrameHandle);
                this.animationFrameHandle = null;
            }
            if (this.animationFrameResolve) {
                this.animationFrameResolve();
                this.animationFrameResolve = null;
            }
            if (this.visibilityChangeHandler) {
                document.removeEventListener("visibilitychange", this.visibilityChangeHandler);
                this.visibilityChangeHandler = null;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    boot(options) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error("Not implemented");
        });
    }
    toggleRunning() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            if (this.paused) yield this.resume();
            else yield this.pause();
        });
    }
    pause() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            this.paused = true;
        });
    }
    resume() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            this.paused = false;
            this.nextTickTime = $21488f2abed026ea$export$9965e7f257856636.now();
            this.previousTickTime = $21488f2abed026ea$export$9965e7f257856636.now();
            this.resetTimeCounters();
        });
    }
    reset() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            yield this.boot({
                engine: null
            });
            this.resetTimeCounters();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    tick(params) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error("Not implemented");
        });
    }
    hardReset() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            // calls the (soft) reset as a fallback default implementation
            // of the hard reset operation, this should be enough for most
            // of the cases, but may be overridden by the concrete emulator
            // implementation if a more specific (hard) behavior is required
            yield this.reset();
        });
    }
    handleError(err) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            // sets the default error message to be displayed
            // to the user, this value may be overridden in case
            // a better and more explicit message can be determined
            let message = String(err);
            // verifies if the current issue is a panic one
            // and updates the message value if that's the case
            const messageNormalized = err.message.toLowerCase();
            const isPanic = messageNormalized.startsWith("unreachable") || messageNormalized.startsWith("recursive use of an object");
            if (isPanic) message = "Unrecoverable error, restarting emulator";
            // displays the error information to both the end-user
            // and the developer (for diagnostics)
            this.trigger("message", {
                text: message,
                error: true,
                timeout: 5000
            });
            console.error(err);
            // pauses the machine, allowing the end-user to act
            // on the error in a proper fashion
            this.pause();
            // if we're talking about a panic, proper action must be taken
            // which in this case means restarting both the WASM sub
            // system and the machine state (to be able to recover)
            if (isPanic) {
                yield this.hardReset();
                this.trigger("error");
            }
        });
    }
    loop() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            while(this.running)switch(this.loopMode){
                case $21488f2abed026ea$export$978b507482c55c4c.SetTimeout:
                    yield this.loopSetTimeout();
                    break;
                case $21488f2abed026ea$export$978b507482c55c4c.AnimationFrame:
                    yield this.loopAnimationFrame();
                    break;
                case $21488f2abed026ea$export$978b507482c55c4c.AnimationDesynced:
                    yield this.loopAnimationDesynced();
                    break;
                default:
                    throw new Error("Invalid loop mode");
            }
        });
    }
    loopSetTimeout() {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            // runs the sequence as an infinite loop, running
            // the associated CPU cycles accordingly
            while(this.running){
                // breaks the loop in case the loop mode has changed
                if (this.loopMode !== $21488f2abed026ea$export$978b507482c55c4c.SetTimeout) break;
                // in case the machine is paused we must delay the execution
                // a little bit until the paused state is recovered
                if (this.paused) {
                    this.trigger("animation-frame", {
                        ticks: 0
                    });
                    yield new Promise((resolve)=>{
                        setTimeout(resolve, 1000 / this.idleFrequency);
                    });
                    continue;
                }
                // runs the internal tick operation that is going to
                // update the state of the machine and handle possible errors
                yield this.internalTick();
                // calculates the amount of time until the next draw operation
                // this is the amount of time that is going to be pending
                const pendingTime = Math.max(this.nextTickTime - $21488f2abed026ea$export$9965e7f257856636.now(), 0);
                // triggers the animation frame event so that any listener "knows"
                // that a new frame render loop has been executed
                this.trigger("animation-frame", {
                    ticks: 1
                });
                // waits the required time until until the next tick operation
                // should be executed - this should control the flow of render
                yield new Promise((resolve)=>{
                    setTimeout(resolve, pendingTime);
                });
            }
        });
    }
    loopAnimationFrame() {
        return $21488f2abed026ea$var$__awaiter(this, arguments, void 0, function*(useTimeParam = true) {
            yield new Promise((resolve)=>{
                this.animationFrameResolve = resolve;
                const step = (time)=>$21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
                        let ticks = 0;
                        this.animationFrameHandle = null;
                        // returns the control flow to the main loop in case the
                        // emulator has been stopped or the loop mode has changed
                        if (!this.running || this.loopMode !== $21488f2abed026ea$export$978b507482c55c4c.AnimationFrame) {
                            this.settleAnimationFrame();
                            return;
                        }
                        this.animationFrameHandle = window.requestAnimationFrame(step);
                        if (!this.paused) {
                            let remainingTicks = $21488f2abed026ea$var$MAX_TICKS_ANIMATION_FRAME;
                            const now = useTimeParam ? time : $21488f2abed026ea$export$9965e7f257856636.now();
                            while(now >= this.nextTickTime){
                                if (remainingTicks === 0) {
                                    this.nextTickTime = now;
                                    break;
                                }
                                yield this.internalTick(now);
                                remainingTicks--;
                                ticks++;
                            }
                        }
                        this.trigger("animation-frame", {
                            ticks: ticks
                        });
                        // settles the loop in case the emulator has been stopped
                        // while the tick operations were being executed, so that
                        // the caller is only released once the work is complete
                        if (!this.running) this.settleAnimationFrame();
                    });
                this.animationFrameHandle = window.requestAnimationFrame(step);
            });
        });
    }
    loopAnimationDesynced() {
        return $21488f2abed026ea$var$__awaiter(this, arguments, void 0, function*(useTimeParam = true) {
            yield new Promise((resolve)=>{
                this.animationFrameResolve = resolve;
                const step = (time)=>$21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
                        this.animationFrameHandle = null;
                        // returns the control flow to the main loop in case the
                        // emulator has been stopped or the loop mode has changed
                        if (!this.running || this.loopMode !== $21488f2abed026ea$export$978b507482c55c4c.AnimationDesynced) {
                            this.settleAnimationFrame();
                            return;
                        }
                        this.animationFrameHandle = window.requestAnimationFrame(step);
                        if (!this.paused) {
                            const now = useTimeParam ? time : $21488f2abed026ea$export$9965e7f257856636.now();
                            yield this.internalTick(now, $21488f2abed026ea$export$cf3b21a5f06c6de0.Desynced);
                        }
                        this.trigger("animation-frame", {
                            ticks: 1
                        });
                        // settles the loop in case the emulator has been stopped
                        // while the tick operation was being executed, so that
                        // the caller is only released once the work is complete
                        if (!this.running) this.settleAnimationFrame();
                    });
                this.animationFrameHandle = window.requestAnimationFrame(step);
            });
        });
    }
    /**
     * Settles the animation frame loop that is currently running,
     * releasing the caller that is waiting on it.
     *
     * The resolve function is cleared in the process, so that the
     * loop is only ever settled once.
     */ settleAnimationFrame() {
        if (!this.animationFrameResolve) return;
        const resolve = this.animationFrameResolve;
        this.animationFrameResolve = null;
        resolve();
    }
    internalTick(time, mode) {
        return $21488f2abed026ea$var$__awaiter(this, void 0, void 0, function*() {
            mode = mode !== null && mode !== void 0 ? mode : $21488f2abed026ea$export$cf3b21a5f06c6de0.Synced;
            // obtains the current time, this value is going
            // to be used to compute the need for tick computation
            const beforeTime = time !== null && time !== void 0 ? time : $21488f2abed026ea$export$9965e7f257856636.now();
            // bootstraps the previous tick time in case it's the
            // first tick operation, and then uses it to calculate
            // the elapsed time useful for the desynced mode
            if (this.previousTickTime === 0) this.previousTickTime = beforeTime;
            const elapsedTime = beforeTime - this.previousTickTime;
            // calculates the visual ratio of the current tick operation
            // this value represents the ration between the expected visual
            // frequency elapsed time and the actual elapsed time, in case
            // the synced mode is set this value is considered to be 1.0 as
            // a "perfect" tick scheduling frequency is expected
            const visualRatio = mode === $21488f2abed026ea$export$cf3b21a5f06c6de0.Desynced ? elapsedTime / 1000 / (1 / this.visualFrequency) : 1.0;
            // calculates the number of cycles that are going to be
            // processed in the current tick operation, this value is
            // calculated using the logic and visual frequencies and
            // the elapsed time (in case desynced is set)
            let cycles = 0;
            switch(mode){
                case $21488f2abed026ea$export$cf3b21a5f06c6de0.Synced:
                    cycles = Math.round(this.logicFrequency / this.visualFrequency);
                    break;
                case $21488f2abed026ea$export$cf3b21a5f06c6de0.Desynced:
                    cycles = Math.round(this.logicFrequency * (elapsedTime / 1000));
                    break;
            }
            try {
                yield this.tick({
                    mode: mode,
                    cycles: cycles,
                    visualRatio: visualRatio,
                    elapsedTime: elapsedTime
                });
            } catch (err) {
                yield this.handleError(err);
            }
            // calculates the number of ticks that have elapsed since the
            // last draw operation, this is critical to be able to properly
            // operate the clock of the CPU in frame drop situations, meaning
            // a situation where the system resources are not able to emulate
            // the system on time and frames must be skipped (ticks > 1)
            //
            // NOTE: The ticks operations does not apply to the animation frame
            // loop mode due to the nature of the event loop, which does not
            // allow direct control of the internal tick timing (that's controller
            // by the browser), which means that a certain delay may always occur
            // and multiple emulator tick operations should be performed on a single
            // animate tick to compensate for this fact.
            if (this.nextTickTime === 0) this.nextTickTime = beforeTime;
            let ticks = Math.ceil((beforeTime - this.nextTickTime) / (1000 / this.visualFrequency));
            ticks = this.loopMode === $21488f2abed026ea$export$978b507482c55c4c.AnimationFrame ? 1 : Math.max(ticks, 1);
            // updates the next update time according to the number of ticks
            // that have elapsed since the last operation, this way this value
            // can better be used to control the game loop
            this.nextTickTime += 1000 / this.visualFrequency * ticks;
            // saves the time used before the tick operation as the previous
            // tick time, required to calculate the elapsed time in the next
            // tick operation
            this.previousTickTime = beforeTime;
        });
    }
    resetTimeCounters() {
        this.resetFpsCounters();
        this.resetCpsCounters();
        this.resetAfpsCounters();
        this.resetSkippedCounters();
    }
    resetFpsCounters() {
        this.frameCount = 0;
        this.frameStart = $21488f2abed026ea$export$9965e7f257856636.now();
    }
    resetCpsCounters() {
        this.cycleCount = 0;
        this.cycleStart = $21488f2abed026ea$export$9965e7f257856636.now();
    }
    resetAfpsCounters() {
        this.animationFrameCount = 0;
        this.animationFrameStart = $21488f2abed026ea$export$9965e7f257856636.now();
    }
    resetSkippedCounters() {
        this.skippedTicksCount = 0;
        this.skippedTicksStart = $21488f2abed026ea$export$9965e7f257856636.now();
    }
}
const $21488f2abed026ea$export$af62d366e1d34747 = {
    auto: $21488f2abed026ea$export$978b507482c55c4c.Auto,
    settimeout: $21488f2abed026ea$export$978b507482c55c4c.SetTimeout,
    animation: $21488f2abed026ea$export$978b507482c55c4c.AnimationFrame,
    animationframe: $21488f2abed026ea$export$978b507482c55c4c.AnimationFrame,
    desynced: $21488f2abed026ea$export$978b507482c55c4c.AnimationDesynced
};
const $21488f2abed026ea$export$f07b844fcedbc4af = [
    "auto",
    "settimeout",
    "animation",
    "desynced"
];
const $21488f2abed026ea$export$9b2ef54602e501d2 = ()=>{
    return $21488f2abed026ea$export$f07b844fcedbc4af;
};
const $21488f2abed026ea$export$894f5dc5e1b52f8d = (value)=>{
    var _a;
    return (_a = $21488f2abed026ea$export$af62d366e1d34747[value]) !== null && _a !== void 0 ? _a : $21488f2abed026ea$export$978b507482c55c4c.Auto;
};
const $21488f2abed026ea$export$805ddaeeece0413e = (emulator, feature)=>{
    return emulator.features.includes(feature);
};






const $94cf575fb2a61e3b$export$9d9b9548e3df4666 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "paused",
    default: false
});
const $94cf575fb2a61e3b$export$ca6e93bd6a473dc8 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "muted",
    default: false
});
const $94cf575fb2a61e3b$export$122d93c74d79e9b1 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "fast",
    default: false
});
const $94cf575fb2a61e3b$export$3bca10c1d2e608e9 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "fullscreen",
    default: false
});



const $0c78cea49e52d841$export$db71243a43768e82 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "keyboardVisible",
    default: false
});
const $0c78cea49e52d841$export$81d769b9f617c951 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "infoVisible",
    default: true
});
const $0c78cea49e52d841$export$196c69f150d1ebb1 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "debugVisible",
    default: false
});
const $0c78cea49e52d841$export$7c36d9956e98f511 = (0, $7ef244517b504261$export$5fb5cc0d078610b)({
    key: "visibleSections",
    default: []
});





var $acw62 = parcelRequire("acw62");

const $132489609fea9882$export$eddf54ea3db8d0f0 = ({ children: children, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "button-container",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, children);
};
var $132489609fea9882$export$2e2bcd8739ae039 = $132489609fea9882$export$eddf54ea3db8d0f0;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $f543aa1e6c3d6410$export$353f5b6fc5456de1 = ({ text: text, image: image, imageAlt: imageAlt, enabled: enabled = false, focusable: focusable = true, file: file = false, accept: accept = ".txt", size: size = "small", style: style = [
    "simple",
    "border"
], onClick: onClick, onFile: onFile })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "button",
            size,
            enabled ? "enabled" : "",
            file ? "file" : "",
            ...style
        ].join(" "), [
        size,
        enabled,
        file,
        style
    ]);
    const fileRef = (0, $acw62.useRef)(null);
    const onFileChange = (0, $acw62.useCallback)((event)=>{
        if (!event.target.files) return;
        if (event.target.files.length === 0) return;
        const file = event.target.files[0];
        onFile === null || onFile === void 0 || onFile(file);
        event.target.value = "";
    }, [
        onFile
    ]);
    const onMouseDown = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onMouseUp = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        var _a;
        if (event.key !== "Enter") return;
        if (file) (_a = fileRef.current) === null || _a === void 0 || _a.click();
        onClick === null || onClick === void 0 || onClick();
    }, [
        onClick,
        file
    ]);
    const renderSimple = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: classes,
            onClick: onClick,
            onKeyDown: onKeyDown,
            tabIndex: focusable ? 0 : undefined
        }, text);
    const renderComplex = ()=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: classes,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onKeyDown: onKeyDown,
            tabIndex: focusable ? 0 : undefined
        }, image && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: image,
            alt: (_a = imageAlt !== null && imageAlt !== void 0 ? imageAlt : text) !== null && _a !== void 0 ? _a : "button"
        }), file && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            ref: fileRef,
            type: "file",
            accept: accept,
            onChange: onFileChange
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, text));
    };
    return image ? renderComplex() : renderSimple();
};
var $f543aa1e6c3d6410$export$2e2bcd8739ae039 = $f543aa1e6c3d6410$export$353f5b6fc5456de1;



const $958b609a0ec418e9$export$8ab700b743774a9b = ({ value: value, delta: delta = 1, min: min, max: max, prefix: prefix, suffix: suffix, decimalPlaces: decimalPlaces, size: size = "medium", style: style = [
    "simple",
    "border"
], onClick: onClick, onBeforeChange: onBeforeChange, onChange: onChange, onReady: onReady })=>{
    const [valueState, setValue] = (0, $acw62.useState)(value);
    const classes = (0, $acw62.useMemo)(()=>[
            "button-increment",
            size,
            ...style
        ].join(" "), [
        size,
        style
    ]);
    (0, $acw62.useEffect)(()=>{
        onReady === null || onReady === void 0 || onReady((value)=>setValue(value));
    }, [
        onReady
    ]);
    const _onMinusClick = ()=>{
        let valueNew = valueState - delta;
        if (onBeforeChange) {
            if (!onBeforeChange(valueNew)) return;
        }
        if (min !== undefined) valueNew = Math.max(min, valueNew);
        if (valueNew === valueState) return;
        setValue(valueNew);
        if (onChange) onChange(valueNew);
    };
    const _onPlusClick = ()=>{
        let valueNew = valueState + delta;
        if (onBeforeChange) {
            if (!onBeforeChange(valueNew)) return;
        }
        if (max !== undefined) valueNew = Math.min(max, valueNew);
        if (valueNew === valueState) return;
        setValue(valueNew);
        if (onChange) onChange(valueNew);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes,
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: "-",
        size: size,
        style: [
            "simple"
        ],
        onClick: _onMinusClick
    }), prefix && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "prefix"
    }, prefix), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "value"
    }, decimalPlaces ? valueState.toFixed(decimalPlaces) : valueState), suffix && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "suffix"
    }, suffix), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: "+",
        size: size,
        style: [
            "simple"
        ],
        onClick: _onPlusClick
    }));
};
var $958b609a0ec418e9$export$2e2bcd8739ae039 = $958b609a0ec418e9$export$8ab700b743774a9b;



var $acw62 = parcelRequire("acw62");

const $f38955a851b5395c$export$822ecae9b15b07a4 = ({ options: options, value: value, uppercase: uppercase = false, size: size = "small", style: style = [
    "simple",
    "border"
], onClick: onClick, onChange: onChange })=>{
    const initial = value === undefined ? 0 : options.indexOf(value);
    const [index, setIndex] = (0, $acw62.useState)(initial);
    const text = ()=>uppercase ? options[index].toUpperCase() : options[index];
    const _onClick = ()=>{
        const indexNew = (index + 1) % options.length;
        const option = options[indexNew];
        setIndex(indexNew);
        if (onClick) onClick();
        if (onChange) onChange(option, indexNew);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: text(),
        size: size,
        style: style,
        onClick: _onClick
    });
};
var $f38955a851b5395c$export$2e2bcd8739ae039 = $f38955a851b5395c$export$822ecae9b15b07a4;




var $acw62 = parcelRequire("acw62");

const $a762831310e01428$export$8d01c972ee8b14a9 = ({ width: width, height: height, canvasRef: canvasRef, scaledWidth: scaledWidth, pixelRatio: pixelRatio = window.devicePixelRatio, scale: scale = 1, smoothing: smoothing = false, imageRendering: imageRendering = "pixelated", init: init = true, style: style = [], onCanvas: onCanvas })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "canvas",
            ...style
        ].join(" "), [
        style
    ]);
    (0, $acw62.useEffect)(()=>{
        if (canvasRef.current && init) {
            const structure = $a762831310e01428$var$initCanvas(width, height, scale * pixelRatio, canvasRef.current, smoothing);
            if (structure) onCanvas === null || onCanvas === void 0 || onCanvas(structure);
        }
    }, [
        onCanvas,
        canvasRef,
        width,
        height,
        init,
        pixelRatio,
        scale,
        smoothing
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
        ref: canvasRef,
        className: classes,
        style: {
            width: scaledWidth !== null && scaledWidth !== void 0 ? scaledWidth : width * scale,
            imageRendering: imageRendering
        },
        width: width * scale * pixelRatio,
        height: height * scale * pixelRatio
    });
};
const $a762831310e01428$var$initCanvas = (width, height, scale, canvas, smoothing = false)=>{
    const canvasOffScreen = document.createElement("canvas");
    canvasOffScreen.width = width;
    canvasOffScreen.height = height;
    const canvasOffScreenContext = canvasOffScreen.getContext("2d");
    if (!canvasOffScreenContext) throw new Error("Not possible to obtain 2D context");
    const canvasImage = canvasOffScreenContext.createImageData(width, height);
    const canvasBuffer = new DataView(canvasImage.data.buffer);
    const canvasContext = canvas.getContext("2d");
    if (!canvasContext) throw new Error("Not possible to obtain 2D context");
    canvasContext.setTransform(1, 0, 0, 1, 0, 0);
    canvasContext.scale(scale, scale);
    canvasContext.imageSmoothingEnabled = smoothing;
    return {
        canvas: canvas,
        canvasOffScreen: canvasOffScreen,
        canvasContext: canvasContext,
        canvasOffScreenContext: canvasOffScreenContext,
        canvasImage: canvasImage,
        canvasBuffer: canvasBuffer
    };
};
var $a762831310e01428$export$2e2bcd8739ae039 = $a762831310e01428$export$8d01c972ee8b14a9;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $a8c0c095862b1bbd$export$445d62b2c6943727 = ({ tabs: tabs, tabNames: tabNames, tabIndex: tabIndex = 0, selectors: selectors = true, flex: flex = false, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "panel-tab",
            flex ? "flex" : "",
            ...style
        ].join(" "), [
        flex,
        style
    ]);
    const [tabIndexState, setTabIndexState] = (0, $acw62.useState)(tabIndex);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, selectors && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "tab-selectors"
    }, tabNames.map((tabName, tabIndex)=>{
        const classes = [
            "tab-selector",
            tabIndex === tabIndexState ? "selected" : ""
        ].join(" ");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: tabIndex,
            className: classes,
            onClick: ()=>setTabIndexState(tabIndex)
        }, tabName);
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "tab-containers"
    }, tabs.map((tab, tabIndex)=>{
        const classes = [
            "tab-container",
            tabIndex === tabIndexState ? "selected" : ""
        ].join(" ");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: tabIndex,
            className: classes
        }, tabs[tabIndex]);
    })));
};
var $a8c0c095862b1bbd$export$2e2bcd8739ae039 = $a8c0c095862b1bbd$export$445d62b2c6943727;



const $6608e85548e82078$export$153e5dc2c098b35c = ({ panels: panels, names: names, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "debug",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$2e2bcd8739ae039), {
        tabs: panels,
        tabNames: names
    }));
};
var $6608e85548e82078$export$2e2bcd8739ae039 = $6608e85548e82078$export$153e5dc2c098b35c;



var $acw62 = parcelRequire("acw62");


var $c1b6b9ada899904f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c1b6b9ada899904f$var$PIXEL_UNSET_COLOR = 0x1b1a17ff;

const $c1b6b9ada899904f$export$76748c987176663a = ({ options: options = {
    width: 320,
    height: 288,
    logicWidth: 160,
    logicHeight: 144
}, size: size = "small", fullscreen: fullscreen = false, nativeFullscreen: nativeFullscreen = true, style: style = [], onDrawHandler: onDrawHandler, onClearHandler: onClearHandler, onMinimize: onMinimize })=>{
    options = Object.assign({
        width: 320,
        height: 288,
        logicWidth: 160,
        logicHeight: 144
    }, options);
    if (!options.scale) options.scale = window.devicePixelRatio ? window.devicePixelRatio : 1;
    const classes = (0, $acw62.useMemo)(()=>[
            "display",
            fullscreen ? "fullscreen" : null,
            size,
            ...style
        ].join(" "), [
        fullscreen,
        size,
        style
    ]);
    const [width, setWidth] = (0, $acw62.useState)();
    const [height, setHeight] = (0, $acw62.useState)();
    const canvasRef = (0, $acw62.useRef)(null);
    const canvasContentsRef = (0, $acw62.useRef)();
    const resizeRef = (0, $acw62.useRef)(()=>{
        const [fullWidth, fullHeight] = $c1b6b9ada899904f$var$crop(options.width / options.height);
        setWidth(fullWidth);
        setHeight(fullHeight);
    });
    (0, $acw62.useEffect)(()=>{
        if (canvasRef.current) canvasContentsRef.current = $c1b6b9ada899904f$var$initCanvas(options.logicWidth, options.logicHeight, canvasRef.current);
    }, [
        canvasRef,
        options.logicWidth,
        options.logicHeight
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const onResize = resizeRef.current;
        if (fullscreen) {
            (_a = canvasRef.current) === null || _a === void 0 || _a.focus();
            resizeRef.current();
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
            window.addEventListener("resize", onResize);
            // requests the browser to go fullscreen using the
            // body of the document as the entry HTML element
            if (nativeFullscreen && document.body.requestFullscreen) document.body.requestFullscreen().catch(()=>{});
            else if (nativeFullscreen && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.body.webkitRequestFullscreen) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.body.webkitRequestFullscreen();
        } else {
            setWidth(undefined);
            setHeight(undefined);
            document.getElementsByTagName("body")[0].style.removeProperty("overflow");
            window.removeEventListener("resize", onResize);
            // restores the window mode, returning from the
            // fullscreen browser
            if (nativeFullscreen && document.exitFullscreen) document.exitFullscreen().catch(()=>{});
            else if (nativeFullscreen && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.webkitExitFullscreen) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.webkitExitFullscreen();
        }
        return ()=>{
            window.removeEventListener("resize", onResize);
        };
    }, [
        fullscreen,
        nativeFullscreen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (onDrawHandler) onDrawHandler((pixels, format)=>{
            if (!canvasContentsRef.current) return;
            $c1b6b9ada899904f$var$updateCanvas(canvasContentsRef.current, pixels, format);
        });
    }, [
        onDrawHandler
    ]);
    (0, $acw62.useEffect)(()=>{
        if (onClearHandler) onClearHandler((color, image, imageScale)=>$c1b6b9ada899904f$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!canvasContentsRef.current) return;
                yield $c1b6b9ada899904f$var$clearCanvas(canvasContentsRef.current, color, {
                    image: image,
                    imageScale: imageScale
                });
            }));
    }, [
        onClearHandler
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "magnify-button display-minimize",
        onClick: onMinimize
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: "large",
        src: (parcelRequire("Rhhhq")),
        alt: "minimise"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "display-frame"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
        ref: canvasRef,
        tabIndex: -1,
        className: "display-canvas",
        width: options.width * options.scale,
        height: options.height * options.scale,
        style: {
            width: width !== null && width !== void 0 ? width : options.width,
            height: height
        }
    })));
};
const $c1b6b9ada899904f$var$initCanvas = (width, height, canvas)=>{
    // initializes the off-screen canvas that is going to be
    // used in the drawing process, this is used essentially for
    // performance reasons as it provides a way to draw pixels
    // in the original size instead of the target one
    const canvasBuffer = document.createElement("canvas");
    canvasBuffer.width = width;
    canvasBuffer.height = height;
    const canvasBufferCtx = canvasBuffer.getContext("2d");
    if (!canvasBufferCtx) throw new Error("Not possible to obtain 2D context");
    const imageData = canvasBufferCtx.createImageData(canvasBuffer.width, canvasBuffer.height);
    const videoBuffer = new DataView(imageData.data.buffer);
    // initializes the visual canvas (where data is going to be written)
    // with, resetting the transform vector to the identity and re-calculating
    // the scale of the drawing properly
    const canvasCtx = canvas.getContext("2d");
    if (!canvasCtx) throw new Error("Not possible to obtain 2D context");
    canvasCtx.setTransform(1, 0, 0, 1, 0, 0);
    canvasCtx.scale(canvas.width / canvasBuffer.width, canvas.height / canvasBuffer.height);
    canvasCtx.imageSmoothingEnabled = false;
    return {
        canvas: canvas,
        canvasCtx: canvasCtx,
        canvasBuffer: canvasBuffer,
        canvasBufferCtx: canvasBufferCtx,
        imageData: imageData,
        videoBuffer: videoBuffer
    };
};
const $c1b6b9ada899904f$var$updateCanvas = (canvasContents, pixels, format = (0, $21488f2abed026ea$export$abee86c20a5429d).RGB)=>{
    let offset = 0;
    for(let index = 0; index < pixels.length; index += format){
        const color = pixels[index] << 24 | pixels[index + 1] << 16 | pixels[index + 2] << 8 | (format == (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA ? pixels[index + 3] : 0xff);
        canvasContents.videoBuffer.setUint32(offset, color);
        offset += (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA;
    }
    canvasContents.canvasBufferCtx.putImageData(canvasContents.imageData, 0, 0);
    canvasContents.canvasCtx.drawImage(canvasContents.canvasBuffer, 0, 0);
};
const $c1b6b9ada899904f$var$clearCanvas = (canvasContents_1, ...args_1)=>$c1b6b9ada899904f$var$__awaiter(void 0, [
        canvasContents_1,
        ...args_1
    ], void 0, function*(canvasContents, color = $c1b6b9ada899904f$var$PIXEL_UNSET_COLOR, { image: image = null, imageScale: imageScale = 1 } = {}) {
        // uses the "clear" color to fill a rectangle with the complete
        // size of the canvas contents
        canvasContents.canvasCtx.fillStyle = `#${color.toString(16).toUpperCase()}`;
        canvasContents.canvasCtx.fillRect(0, 0, canvasContents.canvas.width, canvasContents.canvas.height);
        // in case an image was requested then uses that to load
        // an image at the center of the screen properly scaled
        if (image) yield $c1b6b9ada899904f$var$drawImageCanvas(canvasContents, image, imageScale);
    });
const $c1b6b9ada899904f$var$drawImageCanvas = (canvasContents_1, image_1, ...args_1)=>$c1b6b9ada899904f$var$__awaiter(void 0, [
        canvasContents_1,
        image_1,
        ...args_1
    ], void 0, function*(canvasContents, image, imageScale = 1.0) {
        const img = yield new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(img);
            };
            img.src = image;
        });
        const [imgWidth, imgHeight] = [
            img.width * imageScale * window.devicePixelRatio,
            img.height * imageScale * window.devicePixelRatio
        ];
        const [x0, y0] = [
            canvasContents.canvas.width / 2 - imgWidth / 2,
            canvasContents.canvas.height / 2 - imgHeight / 2
        ];
        canvasContents.canvasCtx.setTransform(1, 0, 0, 1, 0, 0);
        try {
            canvasContents.canvasCtx.drawImage(img, x0, y0, imgWidth, imgHeight);
        } finally{
            canvasContents.canvasCtx.scale(canvasContents.canvas.width / canvasContents.canvasBuffer.width, canvasContents.canvas.height / canvasContents.canvasBuffer.height);
        }
    });
const $c1b6b9ada899904f$var$crop = (ratio)=>{
    // calculates the window ratio as this is fundamental to
    // determine the proper way to crop the fullscreen
    const windowRatio = window.innerWidth / window.innerHeight;
    // in case the window is wider (more horizontal than the base ratio)
    // this means that we must crop horizontally
    if (windowRatio > ratio) return [
        window.innerWidth * (ratio / windowRatio),
        window.innerHeight
    ];
    else return [
        window.innerWidth,
        window.innerHeight * (windowRatio / ratio)
    ];
};
var $c1b6b9ada899904f$export$2e2bcd8739ae039 = $c1b6b9ada899904f$export$76748c987176663a;



var $acw62 = parcelRequire("acw62");

const $89f1204196cd6c76$export$a06f1c675e846f6f = ({ children: children, color: color = "ffffff", style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "footer",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "footer-background",
        style: {
            backgroundColor: `#${color}f2`
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "footer-contents"
    }, children));
};
var $89f1204196cd6c76$export$2e2bcd8739ae039 = $89f1204196cd6c76$export$a06f1c675e846f6f;



var $acw62 = parcelRequire("acw62");


const $faaea4057129900a$export$1be7516c0280bee8 = ({ panels: panels, names: names, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "help",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$2e2bcd8739ae039), {
        tabs: panels,
        tabNames: names,
        flex: true
    }));
};
var $faaea4057129900a$export$2e2bcd8739ae039 = $faaea4057129900a$export$1be7516c0280bee8;



var $acw62 = parcelRequire("acw62");

const $6731544d163a7061$export$c4868e4a24d48fad = ({ children: children, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "info",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dl", {
        className: classes
    }, children);
};
var $6731544d163a7061$export$2e2bcd8739ae039 = $6731544d163a7061$export$c4868e4a24d48fad;



var $acw62 = parcelRequire("acw62");

const $8732e049cf7ac6ef$var$KEYS = {
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    q: "Q",
    w: "W",
    e: "E",
    r: "R",
    a: "A",
    s: "S",
    d: "D",
    f: "F",
    z: "Z",
    x: "X",
    c: "C",
    v: "V",
    Q: "Q",
    W: "W",
    E: "E",
    R: "R",
    A: "A",
    S: "S",
    D: "D",
    F: "F",
    Z: "Z",
    X: "X",
    C: "C",
    V: "V"
};
const $8732e049cf7ac6ef$export$39e14a39e4981a75 = ({ focusable: focusable = true, physical: physical = true, vibrate: vibrate = 75, style: style = [], onKeyDown: onKeyDown, onKeyUp: onKeyUp })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "keyboard",
            "keyboard-chip8",
            ...style
        ].join(" "), [
        style
    ]);
    const [pressed, setPressed] = (0, $acw62.useState)({
        "1": false,
        "2": false,
        "3": false,
        "4": false,
        Q: false,
        W: false,
        E: false,
        R: false,
        A: false,
        S: false,
        D: false,
        F: false,
        Z: false,
        X: false,
        C: false,
        V: false
    });
    (0, $acw62.useEffect)(()=>{
        if (!physical) return;
        const _onKeyDown = (event)=>{
            const keyCode = $8732e049cf7ac6ef$var$KEYS[event.key];
            if (keyCode !== undefined) {
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyCode);
                return;
            }
        };
        const _onKeyUp = (event)=>{
            const keyCode = $8732e049cf7ac6ef$var$KEYS[event.key];
            if (keyCode !== undefined) {
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyCode);
                return;
            }
        };
        document.addEventListener("keydown", _onKeyDown);
        document.addEventListener("keyup", _onKeyUp);
        return ()=>{
            document.removeEventListener("keydown", _onKeyDown);
            document.removeEventListener("keyup", _onKeyUp);
        };
    }, [
        onKeyDown,
        onKeyUp,
        physical
    ]);
    const renderKey = (key, styles = [])=>{
        const classes = [
            "key",
            pressed[key] ? "pressed" : "",
            ...styles
        ].join(" ");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: classes,
            key: key,
            tabIndex: focusable ? 0 : undefined,
            onKeyDown: (event)=>{
                if (event.key !== "Enter") return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(key);
                event.preventDefault();
            },
            onKeyUp: (event)=>{
                if (event.key !== "Enter") return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
                event.preventDefault();
            },
            onBlur: ()=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
            },
            onMouseDown: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(key);
                event.preventDefault();
            },
            onMouseUp: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
                event.preventDefault();
            },
            onMouseLeave: (event)=>{
                if (!pressed[key]) return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
                event.preventDefault();
            },
            onTouchStart: (event)=>{
                var _a, _b;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: true
                    }));
                if (vibrate) (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.vibrate) === null || _b === void 0 || _b.call(_a, vibrate);
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(key);
                event.preventDefault();
            },
            onTouchEnd: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [key]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
                event.preventDefault();
            }
        }, key);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "keyboard-line"
    }, [
        "1",
        "2",
        "3",
        "4"
    ].map((k)=>renderKey(k))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "keyboard-line"
    }, [
        "Q",
        "W",
        "E",
        "R"
    ].map((k)=>renderKey(k))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "keyboard-line"
    }, [
        "A",
        "S",
        "D",
        "F"
    ].map((k)=>renderKey(k))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "keyboard-line"
    }, [
        "Z",
        "X",
        "C",
        "V"
    ].map((k)=>renderKey(k))));
};
var $8732e049cf7ac6ef$export$2e2bcd8739ae039 = $8732e049cf7ac6ef$export$39e14a39e4981a75;



var $acw62 = parcelRequire("acw62");


const $bba052522aedacf8$var$KEYS = {
    ArrowUp: "ArrowUp",
    ArrowDown: "ArrowDown",
    ArrowLeft: "ArrowLeft",
    ArrowRight: "ArrowRight",
    Enter: "Start",
    " ": "Select",
    a: "A",
    s: "B",
    A: "A",
    S: "B"
};
const $bba052522aedacf8$var$KEYS_STANDARD = {
    12: "ArrowUp",
    102: "ArrowUp",
    13: "ArrowDown",
    103: "ArrowDown",
    14: "ArrowLeft",
    100: "ArrowLeft",
    15: "ArrowRight",
    101: "ArrowRight",
    9: "Start",
    8: "Select",
    1: "A",
    0: "B"
};
const $bba052522aedacf8$var$PREVENT_KEYS = {
    ArrowUp: true,
    ArrowDown: true,
    ArrowLeft: true,
    ArrowRight: true,
    " ": true
};
var $bba052522aedacf8$export$6c7655ea3aaed579;
(function(GamepadType) {
    GamepadType[GamepadType["Unknown"] = 1] = "Unknown";
    GamepadType[GamepadType["Standard"] = 2] = "Standard";
    GamepadType[GamepadType["Xbox"] = 3] = "Xbox";
    GamepadType[GamepadType["Playstation"] = 4] = "Playstation";
    GamepadType[GamepadType["Switch"] = 5] = "Switch";
})($bba052522aedacf8$export$6c7655ea3aaed579 || ($bba052522aedacf8$export$6c7655ea3aaed579 = {}));
/**
 * The sequence of game pads that are considered
 * supported by the current implementation.
 */ const $bba052522aedacf8$var$SUPPORTED_PADS = [
    $bba052522aedacf8$export$6c7655ea3aaed579.Standard
];
const $bba052522aedacf8$export$1901b6ac81a8ee81 = ({ focusable: focusable = true, fullscreen: fullscreen = false, physical: physical = true, vibrate: vibrate = 75, style: style = [], onKeyDown: onKeyDown, onKeyUp: onKeyUp, onGamepad: onGamepad })=>{
    const containerClasses = (0, $acw62.useMemo)(()=>[
            "keyboard-container",
            fullscreen ? "fullscreen" : ""
        ].join(" "), [
        fullscreen
    ]);
    const [pressed, setPressed] = (0, $acw62.useState)({
        ArrowUp: false,
        ArrowDown: false,
        ArrowLeft: false,
        ArrowRight: false,
        Start: false,
        Select: false,
        A: false,
        B: false
    });
    const classes = (0, $acw62.useMemo)(()=>[
            "keyboard",
            "keyboard-gb",
            fullscreen ? "fullscreen" : "",
            ...style
        ].join(" "), [
        fullscreen,
        style
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!physical) return;
        const getGamepadType = (gamepad)=>{
            let gamepadType = $bba052522aedacf8$export$6c7655ea3aaed579.Unknown;
            const isStandard = gamepad.mapping === "standard";
            if (isStandard) gamepadType = $bba052522aedacf8$export$6c7655ea3aaed579.Standard;
            return gamepadType;
        };
        const _onKeyDown = (event)=>{
            var _a;
            const keyCode = $bba052522aedacf8$var$KEYS[event.key];
            const isPrevent = (_a = $bba052522aedacf8$var$PREVENT_KEYS[event.key]) !== null && _a !== void 0 ? _a : false;
            if (isPrevent) event.preventDefault();
            if (keyCode !== undefined) {
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyCode);
                return;
            }
        };
        const _onKeyUp = (event)=>{
            var _a;
            const keyCode = $bba052522aedacf8$var$KEYS[event.key];
            const isPrevent = (_a = $bba052522aedacf8$var$PREVENT_KEYS[event.key]) !== null && _a !== void 0 ? _a : false;
            if (isPrevent) event.preventDefault();
            if (keyCode !== undefined) {
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyCode);
                return;
            }
        };
        const onGamepadConnected = (event)=>{
            const gamepad = event.gamepad;
            const gamepadType = getGamepadType(gamepad);
            const isValid = $bba052522aedacf8$var$SUPPORTED_PADS.includes(gamepadType);
            if (onGamepad) onGamepad({
                index: gamepad.index,
                id: gamepad.id,
                type: gamepadType
            }, isValid);
            let keySolver = {};
            switch(gamepadType){
                case $bba052522aedacf8$export$6c7655ea3aaed579.Standard:
                    keySolver = $bba052522aedacf8$var$KEYS_STANDARD;
                    break;
            }
            const buttonStates = {};
            const updateStatus = ()=>{
                const _gamepad = navigator.getGamepads()[gamepad.index];
                if (!_gamepad) return;
                handleButton(100, _gamepad.axes[0] < -0.5);
                handleButton(101, _gamepad.axes[0] > 0.5);
                handleButton(102, _gamepad.axes[1] < -0.5);
                handleButton(103, _gamepad.axes[1] > 0.5);
                _gamepad.buttons.forEach((button, index)=>{
                    const pressed = button.pressed;
                    handleButton(index, pressed);
                });
                requestAnimationFrame(updateStatus);
            };
            const handleButton = (index, pressed)=>{
                var _a;
                const keyCode = keySolver[index];
                if (keyCode === undefined) return;
                const state = (_a = buttonStates[index]) !== null && _a !== void 0 ? _a : false;
                const keyDown = pressed && !state;
                const keyUp = !pressed && state;
                if (keyDown) {
                    setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                            [keyCode]: true
                        }));
                    onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyCode);
                }
                if (keyUp) {
                    setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                            [keyCode]: false
                        }));
                    onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyCode);
                }
                buttonStates[index] = pressed;
            };
            requestAnimationFrame(updateStatus);
        };
        const onGamepadDisconnected = (event)=>{
            const gamepad = event.gamepad;
            const gamepadType = getGamepadType(gamepad);
            const isValid = $bba052522aedacf8$var$SUPPORTED_PADS.includes(gamepadType);
            if (onGamepad) onGamepad({
                index: gamepad.index,
                id: gamepad.id,
                type: gamepadType
            }, isValid, false);
        };
        document.addEventListener("keydown", _onKeyDown);
        document.addEventListener("keyup", _onKeyUp);
        window.addEventListener("gamepadconnected", onGamepadConnected);
        window.addEventListener("gamepaddisconnected", onGamepadDisconnected);
        return ()=>{
            document.removeEventListener("keydown", _onKeyDown);
            document.removeEventListener("keyup", _onKeyUp);
            window.removeEventListener("gamepadconnected", onGamepadConnected);
            window.removeEventListener("gamepadconnected", onGamepadDisconnected);
        };
    }, [
        onGamepad,
        onKeyDown,
        onKeyUp,
        physical
    ]);
    const renderKey = (key, keyName, styles = [])=>{
        var _a, _b, _c;
        const keyCode = (_c = (_b = (_a = $bba052522aedacf8$var$KEYS[keyName !== null && keyName !== void 0 ? keyName : key]) !== null && _a !== void 0 ? _a : keyName) !== null && _b !== void 0 ? _b : key) !== null && _c !== void 0 ? _c : undefined;
        const classes = [
            "key",
            pressed[keyCode] ? "pressed" : "",
            ...styles
        ].join(" ");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: classes,
            key: keyName !== null && keyName !== void 0 ? keyName : key,
            tabIndex: focusable ? 0 : undefined,
            onKeyDown: (event)=>{
                if (event.key !== "Enter") return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onKeyUp: (event)=>{
                if (event.key !== "Enter") return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onBlur: ()=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(key);
            },
            onMouseDown: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: true
                    }));
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onMouseUp: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onMouseLeave: (event)=>{
                if (!pressed[keyCode]) return;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onTouchStart: (event)=>{
                var _a, _b;
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: true
                    }));
                if (vibrate) (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.vibrate) === null || _b === void 0 || _b.call(_a, vibrate);
                onKeyDown === null || onKeyDown === void 0 || onKeyDown(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            },
            onTouchEnd: (event)=>{
                setPressed((prev)=>Object.assign(Object.assign({}, prev), {
                        [keyCode]: false
                    }));
                onKeyUp === null || onKeyUp === void 0 || onKeyUp(keyName !== null && keyName !== void 0 ? keyName : key);
                event.preventDefault();
            }
        }, key);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: containerClasses
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        onTouchStart: (e)=>e.preventDefault(),
        onTouchEnd: (e)=>e.preventDefault()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dpad"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dpad-top"
    }, renderKey((0, $a07119bee7a8f987$export$a11b0059900ceec8)() ? "\u25B2" : "\u25B2", "ArrowUp", [
        "up"
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, renderKey((0, $a07119bee7a8f987$export$a11b0059900ceec8)() ? "\u25C0" : "\u25C4", "ArrowLeft", [
        "left"
    ]), renderKey((0, $a07119bee7a8f987$export$a11b0059900ceec8)() ? "\u25B6" : "\u25BA", "ArrowRight", [
        "right"
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dpad-bottom"
    }, renderKey((0, $a07119bee7a8f987$export$a11b0059900ceec8)() ? "\u25BC" : "\u25BC", "ArrowDown", [
        "down"
    ]))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "action"
    }, renderKey("B", "B", [
        "b"
    ]), renderKey("A", "A", [
        "a"
    ])), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "break"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "options"
    }, renderKey("SELECT", "Select", [
        "select"
    ]), renderKey("START", "Start", [
        "start"
    ]))));
};
var $bba052522aedacf8$export$2e2bcd8739ae039 = $bba052522aedacf8$export$1901b6ac81a8ee81;



var $acw62 = parcelRequire("acw62");

const $a1e6017981edfa31$export$a6c7ac8248d6e38a = ({ children: children, text: text, href: href, target: target, style: style = [], onClick: onClick })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "link",
            onClick ? "click" : "",
            ...style
        ].join(" "), [
        onClick,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        className: classes,
        href: href,
        target: target,
        onClick: onClick
    }, children !== null && children !== void 0 ? children : text);
};
var $a1e6017981edfa31$export$2e2bcd8739ae039 = $a1e6017981edfa31$export$a6c7ac8248d6e38a;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



const $779763a93d7c85f7$export$2b77a92f1a5ad772 = ({ title: title = "Alert", text: text, contents: contents, visible: visible = false, buttons: buttons, overlayClose: overlayClose = true, style: style = [], onConfirm: onConfirm, onCancel: onCancel })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "modal",
            visible ? "visible" : "",
            ...style
        ].join(" "), [
        visible,
        style
    ]);
    text = text !== null && text !== void 0 ? text : contents ? undefined : "Do you confirm the following operation?";
    buttons = buttons !== null && buttons !== void 0 ? buttons : contents ? false : true;
    const modalRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === "Escape") onCancel === null || onCancel === void 0 || onCancel();
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        onCancel
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (visible) (_a = modalRef.current) === null || _a === void 0 || _a.focus();
    }, [
        visible
    ]);
    const getTextHtml = (separator = /\n/g)=>text ? {
            __html: text.replace(separator, "<br/>")
        } : undefined;
    const onWindowClick = (0, $acw62.useCallback)((event)=>{
        if (!overlayClose) return;
        event.stopPropagation();
    }, [
        overlayClose
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        onClick: onCancel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: modalRef,
        className: "modal-window",
        onClick: onWindowClick,
        tabIndex: -1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "modal-top-buttons"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: "",
        size: "medium",
        style: [
            "simple",
            "rounded",
            "no-text"
        ],
        image: (parcelRequire("bumMD")),
        imageAlt: "close",
        onClick: onCancel
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h2", {
        className: "modal-title"
    }, title), contents ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "modal-contents"
    }, contents) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "modal-text",
        dangerouslySetInnerHTML: getTextHtml()
    }), buttons && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "modal-buttons"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: "Cancel",
        size: "medium",
        style: [
            "simple",
            "red",
            "border",
            "padded-large"
        ],
        onClick: onCancel
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$2e2bcd8739ae039), {
        text: "Confirm",
        size: "medium",
        style: [
            "simple",
            "border",
            "padded-large"
        ],
        onClick: onConfirm
    }))));
};
var $779763a93d7c85f7$export$2e2bcd8739ae039 = $779763a93d7c85f7$export$2b77a92f1a5ad772;


var $fc8c4b9396eb68a8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fc8c4b9396eb68a8$export$ce11c4ecd08cea67 = (0, $acw62.forwardRef)(({ style: style = [] }, ref)=>{
    const [modalTitle, setModalTitle] = (0, $acw62.useState)();
    const [modalText, setModalText] = (0, $acw62.useState)();
    const [modalContents, setModalContents] = (0, $acw62.useState)();
    const [modalVisible, setModalVisible] = (0, $acw62.useState)(false);
    const modalCallbackRef = (0, $acw62.useRef)();
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            showModal: (...args_1)=>$fc8c4b9396eb68a8$var$__awaiter(void 0, [
                    ...args_1
                ], void 0, function*(title = "Alert", text, contents) {
                    setModalTitle(title);
                    setModalText(text);
                    setModalContents(contents);
                    setModalVisible(true);
                    const result = yield new Promise((resolve)=>{
                        modalCallbackRef.current = resolve;
                    });
                    return result;
                })
        }));
    const onModalConfirm = (0, $acw62.useCallback)(()=>{
        if (modalCallbackRef.current) {
            modalCallbackRef.current(true);
            modalCallbackRef.current = undefined;
        }
        setModalVisible(false);
    }, []);
    const onModalCancel = (0, $acw62.useCallback)(()=>{
        if (modalCallbackRef.current) {
            modalCallbackRef.current(false);
            modalCallbackRef.current = undefined;
        }
        setModalVisible(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $779763a93d7c85f7$export$2e2bcd8739ae039), {
        title: modalTitle,
        text: modalText,
        contents: modalContents,
        visible: modalVisible,
        style: style,
        onConfirm: onModalConfirm,
        onCancel: onModalCancel
    });
});
var $fc8c4b9396eb68a8$export$2e2bcd8739ae039 = $fc8c4b9396eb68a8$export$ce11c4ecd08cea67;




var $acw62 = parcelRequire("acw62");


var $ca24016d70cb32f8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $ca24016d70cb32f8$export$c6fdb837b070b4ff = ({ text: text, accept: accept, style: style = [], onFile: onFile })=>{
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const classes = (0, $acw62.useMemo)(()=>[
            "overlay",
            visible ? "visible" : "",
            ...style
        ].join(" "), [
        visible,
        style
    ]);
    (0, $acw62.useEffect)(()=>{
        const isFile = (event)=>{
            // run a series of validations to determine if the event
            // refers to a valid data transfer operation
            if (!event.dataTransfer) return false;
            if (!event.dataTransfer.items) return false;
            if (!event.dataTransfer.types) return false;
            // in case the items section of the data transfer
            // is defined and no valid type is found, we assume
            // that the user is dragging a binary file
            if (event.dataTransfer.items.length > 0 && !event.dataTransfer.items[0].type) return true;
            // in case the types section of the data transfer
            // is defined and the first type is "Files", we assume
            // that the user is dragging a binary file
            if (event.dataTransfer.types.length > 0 && event.dataTransfer.types[0] === "Files") return true;
            return false;
        };
        const onDrop = (event)=>$ca24016d70cb32f8$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!isFile(event)) return;
                if (!event.dataTransfer) return;
                setVisible(false);
                const file = event.dataTransfer.files[0];
                const extension = (0, $a07119bee7a8f987$export$96812dd9af999b22)(file.name);
                if (accept === undefined || accept.includes(`.${extension}`)) onFile === null || onFile === void 0 || onFile(file);
                event.preventDefault();
                event.stopPropagation();
            });
        const onDragOver = (event)=>$ca24016d70cb32f8$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!isFile(event)) return;
                setVisible(true);
                event.preventDefault();
            });
        const onDragEnter = (event)=>$ca24016d70cb32f8$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!isFile(event)) return;
                setVisible(true);
            });
        const onDragLeave = (event)=>$ca24016d70cb32f8$var$__awaiter(void 0, void 0, void 0, function*() {
                if (!isFile(event)) return;
                setVisible(false);
            });
        document.addEventListener("drop", onDrop);
        document.addEventListener("dragover", onDragOver);
        document.addEventListener("dragenter", onDragEnter);
        document.addEventListener("dragleave", onDragLeave);
        return ()=>{
            document.removeEventListener("drop", onDrop);
            document.removeEventListener("dragover", onDragOver);
            document.removeEventListener("dragenter", onDragEnter);
            document.removeEventListener("dragleave", onDragLeave);
        };
    }, [
        onFile,
        accept
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "overlay-container"
    }, text && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "overlay-text"
    }, text), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "overlay-image"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        alt: "sunglasses",
        src: (parcelRequire("e8HRd"))
    }))));
};
var $ca24016d70cb32f8$export$2e2bcd8739ae039 = $ca24016d70cb32f8$export$c6fdb837b070b4ff;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $abb712638f5210c7$export$d63d7cff08fe4dc9 = ({ name: name, value: value, title: title, nameNode: nameNode, valueNode: valueNode, nameHref: nameHref, valueHref: valueHref, nameTarget: nameTarget, valueTarget: valueTarget, style: style = [], onNameClick: onNameClick, onValueClick: onValueClick })=>{
    var _a, _b, _c, _d;
    const classes = (0, $acw62.useMemo)(()=>[
            "pair",
            title ? "with-title" : "",
            onNameClick ? "name-click" : "",
            onValueClick ? "value-click" : "",
            ...style
        ].join(" "), [
        onNameClick,
        onValueClick,
        title,
        style
    ]);
    const _onNameClick = (0, $acw62.useCallback)(()=>onNameClick ? onNameClick() : undefined, [
        onNameClick
    ]);
    const _onValueClick = (0, $acw62.useCallback)(()=>onValueClick ? onValueClick() : undefined, [
        onValueClick
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dt", {
        className: classes,
        onClick: _onNameClick,
        title: title
    }, (_b = (_a = nameNode !== null && nameNode !== void 0 ? nameNode : nameHref && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
        href: nameHref,
        target: nameTarget !== null && nameTarget !== void 0 ? nameTarget : "_blank"
    }, name)) !== null && _a !== void 0 ? _a : name) !== null && _b !== void 0 ? _b : ""), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("dd", {
        className: classes,
        onClick: _onValueClick
    }, (_d = (_c = valueNode !== null && valueNode !== void 0 ? valueNode : valueHref && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
        href: valueHref,
        target: valueTarget !== null && valueTarget !== void 0 ? valueTarget : "_blank"
    }, value)) !== null && _c !== void 0 ? _c : value) !== null && _d !== void 0 ? _d : ""));
};
var $abb712638f5210c7$export$2e2bcd8739ae039 = $abb712638f5210c7$export$d63d7cff08fe4dc9;



const $9a683e10efe99492$export$d022ea1b4dcd550c = ({ index: index, thumbnail: thumbnail, thumbnailSize: thumbnailSize = [
    100,
    100
], saveState: saveState, style: style = [], onLoadClick: onLoadClick, onDownloadClick: onDownloadClick, onInfoClick: onInfoClick, onDeleteClick: onDeleteClick })=>{
    const pairStyle = (0, $acw62.useMemo)(()=>[
            "pair-state",
            ...style
        ], [
        style
    ]);
    const thumbnailUrl = (0, $acw62.useMemo)(()=>{
        var _a, _b;
        return thumbnail && (0, $a07119bee7a8f987$export$f0df9fc502b4499c)(thumbnail, (_a = thumbnailSize === null || thumbnailSize === void 0 ? void 0 : thumbnailSize[0]) !== null && _a !== void 0 ? _a : 0, (_b = thumbnailSize === null || thumbnailSize === void 0 ? void 0 : thumbnailSize[1]) !== null && _b !== void 0 ? _b : 0);
    }, [
        thumbnail,
        thumbnailSize
    ]);
    const _onLoadClick = (0, $acw62.useCallback)(()=>onLoadClick === null || onLoadClick === void 0 ? void 0 : onLoadClick(saveState), [
        onLoadClick,
        saveState
    ]);
    const _onDownloadClick = (0, $acw62.useCallback)(()=>onDownloadClick === null || onDownloadClick === void 0 ? void 0 : onDownloadClick(saveState), [
        onDownloadClick,
        saveState
    ]);
    const _onInfoClick = (0, $acw62.useCallback)(()=>onInfoClick === null || onInfoClick === void 0 ? void 0 : onInfoClick(saveState), [
        onInfoClick,
        saveState
    ]);
    const _onDeleteClick = (0, $acw62.useCallback)(()=>onDeleteClick === null || onDeleteClick === void 0 ? void 0 : onDeleteClick(saveState), [
        onDeleteClick,
        saveState
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: `#${index}`,
        name: `Save State #${index}`,
        nameNode: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, "Save State #", index), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "pair-state-description"
        }, saveState && saveState.timestamp !== undefined ? new Date(saveState.timestamp * 1000).toLocaleString(undefined, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }) : "", saveState && saveState.error !== undefined ? "Error - " + saveState.error : ""), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "pair-state-buttons"
        }, onLoadClick && (saveState === null || saveState === void 0 ? void 0 : saveState.error) === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "link-separator"
        }, "/"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
            text: "Load",
            onClick: _onLoadClick
        })), onDownloadClick && (saveState === null || saveState === void 0 ? void 0 : saveState.error) === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "link-separator"
        }, "/"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
            text: "Download",
            onClick: _onDownloadClick
        })), onInfoClick && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "link-separator"
        }, "/"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
            text: "Info",
            onClick: _onInfoClick
        })), onDeleteClick && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "link-separator"
        }, "/"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$2e2bcd8739ae039), {
            text: "Delete",
            onClick: _onDeleteClick
        })))),
        valueNode: thumbnailUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            className: "pair-state-thumbnail",
            src: thumbnailUrl
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null),
        style: pairStyle,
        onValueClick: _onLoadClick
    }));
};
var $9a683e10efe99492$export$2e2bcd8739ae039 = $9a683e10efe99492$export$d022ea1b4dcd550c;




var $acw62 = parcelRequire("acw62");

const $db1967ac167dad1f$export$ca38978b734fad5f = ({ children: children, left: left, right: right, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "panel-split",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "side-left"
    }, left), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "side-right"
    }, children !== null && children !== void 0 ? children : right));
};
var $db1967ac167dad1f$export$2e2bcd8739ae039 = $db1967ac167dad1f$export$ca38978b734fad5f;




var $acw62 = parcelRequire("acw62");

const $df815c6cfea7e2d2$export$358a232cca1ab2ac = ({ children: children, text: text, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "paragraph",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: classes
    }, children !== null && children !== void 0 ? children : text);
};
var $df815c6cfea7e2d2$export$2e2bcd8739ae039 = $df815c6cfea7e2d2$export$358a232cca1ab2ac;



var $acw62 = parcelRequire("acw62");





const $5973aea0c159fe09$export$6c6aedcd06940e1a = ({ saveState: saveState, emulator: emulator, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "save-info",
            ...style
        ].join(" "), [
        style
    ]);
    const tabs = [
        $5973aea0c159fe09$export$419ea812136cefe3({
            saveState: saveState,
            emulator: emulator
        })
    ];
    const tabNames = [
        "Main"
    ];
    if (saveState.thumbnail !== undefined) {
        tabs.push($5973aea0c159fe09$export$c8c6b2f51f76ef94({
            saveState: saveState,
            emulator: emulator
        }));
        tabNames.push("Thumbnail");
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$2e2bcd8739ae039), {
        tabs: tabs,
        tabNames: tabNames,
        flex: true
    }));
};
const $5973aea0c159fe09$export$419ea812136cefe3 = ({ saveState: saveState })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "save-info-main"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$2e2bcd8739ae039), null, saveState.model && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "model",
        name: "Model",
        value: saveState.model
    }), saveState.title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "title",
        name: "Title",
        value: saveState.title
    }), saveState.format && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "format",
        name: "Format",
        value: saveState.format
    }), saveState.agent && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "agent",
        name: "Agent",
        value: saveState.agent
    }), saveState.size && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "size",
        name: "Size",
        value: saveState.size ? `${new Intl.NumberFormat().format(saveState.size)} bytes` : "-"
    }), saveState.timestamp && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$2e2bcd8739ae039), {
        key: "date",
        name: "Date",
        value: new Date(saveState.timestamp * 1000).toLocaleString(undefined, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        })
    })));
const $5973aea0c159fe09$export$c8c6b2f51f76ef94 = ({ saveState: saveState, emulator: emulator })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "save-info-thumbnail"
    }, saveState.thumbnail && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: "pair-state-thumbnail",
        src: (0, $a07119bee7a8f987$export$f0df9fc502b4499c)(saveState.thumbnail, emulator.dimensions.width, emulator.dimensions.height)
    }));
var $5973aea0c159fe09$export$2e2bcd8739ae039 = $5973aea0c159fe09$export$6c6aedcd06940e1a;



var $acw62 = parcelRequire("acw62");

const $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce = ({ children: children, visible: visible = true, separator: separator = true, separatorBottom: separatorBottom = false, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "section",
            visible ? "visible" : "",
            ...style
        ].join(" "), [
        visible,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, separator && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "separator"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "section-contents"
    }, children), separatorBottom && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "separator"
    }));
};
var $6f514e8ee8fa1f0a$export$2e2bcd8739ae039 = $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce;



var $acw62 = parcelRequire("acw62");

const $8db713e26b576873$export$1ff3c3f08ae963c0 = ({ marginTop: marginTop = 20, marginBottom: marginBottom = 20, thickness: thickness = 1, color: color = "#ffffff", clear: clear = true, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "separator",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, clear && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "separator-clear"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        style: {
            marginTop: marginTop,
            marginBottom: marginBottom,
            height: thickness,
            backgroundColor: color
        }
    }));
};
var $8db713e26b576873$export$2e2bcd8739ae039 = $8db713e26b576873$export$1ff3c3f08ae963c0;



var $acw62 = parcelRequire("acw62");

const $e9838918c3372d19$export$c86715117507e8e5 = ({ type: type = "text", size: size = "large", value: value, placeholder: placeholder, style: style = [], onChange: onChange })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "text-input",
            size,
            ...style
        ].join(" "), [
        size,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        className: classes,
        type: type,
        value: value,
        placeholder: placeholder,
        onChange: (e)=>onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value)
    });
};
var $e9838918c3372d19$export$2e2bcd8739ae039 = $e9838918c3372d19$export$c86715117507e8e5;



var $acw62 = parcelRequire("acw62");


const $a8e4a5eb44e16b55$export$f99233281efd08a0 = ({ text: text, version: version, versionUrl: versionUrl, iconSrc: iconSrc, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "title",
            ...style
        ].join(" "), [
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        className: classes
    }, text, version && (versionUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        href: versionUrl,
        target: "_blank"
    }, version) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "label"
    }, version)), iconSrc && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: "icon",
        src: iconSrc,
        alt: "icon"
    }));
};
var $a8e4a5eb44e16b55$export$2e2bcd8739ae039 = $a8e4a5eb44e16b55$export$f99233281efd08a0;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $8d2cf589569407a6$export$8d8dc7d5f743331b = ({ text: text = "", error: error = false, visible: visible = false, style: style = [], onCancel: onCancel })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "toast",
            error ? "error" : "",
            visible ? "visible" : "",
            ...style
        ].join(" "), [
        error,
        visible,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "toast-text",
        onClick: onCancel
    }, text));
};
var $8d2cf589569407a6$export$2e2bcd8739ae039 = $8d2cf589569407a6$export$8d8dc7d5f743331b;


var $7b8a18762d707a5b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7b8a18762d707a5b$export$51d32fc2dfa9b88b = (0, $acw62.forwardRef)(({ style: style = [] }, ref)=>{
    const [toastText, setToastText] = (0, $acw62.useState)();
    const [toastError, setToastError] = (0, $acw62.useState)(false);
    const [toastVisible, setToastVisible] = (0, $acw62.useState)(false);
    const toastCounterRef = (0, $acw62.useRef)(0);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            showToast: (text_1, ...args_1)=>$7b8a18762d707a5b$var$__awaiter(void 0, [
                    text_1,
                    ...args_1
                ], void 0, function*(text, error = false, timeout = 3500) {
                    setToastText(text);
                    setToastError(error);
                    setToastVisible(true);
                    toastCounterRef.current++;
                    const counter = toastCounterRef.current;
                    yield new Promise((resolve)=>{
                        setTimeout(()=>{
                            if (counter !== toastCounterRef.current) return;
                            setToastVisible(false);
                            resolve(true);
                        }, timeout);
                    });
                })
        }));
    const onToastCancel = (0, $acw62.useCallback)(()=>{
        setToastVisible(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8d2cf589569407a6$export$2e2bcd8739ae039), {
        text: toastText,
        error: toastError,
        visible: toastVisible,
        style: style,
        onCancel: onToastCancel
    });
});
var $7b8a18762d707a5b$export$2e2bcd8739ae039 = $7b8a18762d707a5b$export$51d32fc2dfa9b88b;






var $a64f72727446b946$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a64f72727446b946$var$isTouchDevice = ()=>{
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};


















const $a64f72727446b946$export$82737577c2f239fd = ({ emulator: emulator, fullscreen: fullscreen = false, info: info = true, debug: debug = false, keyboard: keyboard = false, sections: sections = [], palette: palette, nativeFullscreen: nativeFullscreen = true, background: background, backgrounds: backgrounds = [
    "264653"
], onBackground: onBackground })=>{
    const [paused, setPaused] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $94cf575fb2a61e3b$export$9d9b9548e3df4666));
    const [muted, setMuted] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $94cf575fb2a61e3b$export$ca6e93bd6a473dc8));
    const [fast, setFast] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $94cf575fb2a61e3b$export$122d93c74d79e9b1));
    const [fullscreenState, setFullscreenState] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $94cf575fb2a61e3b$export$3bca10c1d2e608e9));
    const [backgroundIndex, setBackgroundIndex] = (0, $acw62.useState)(background ? Math.max(backgrounds.indexOf(background), 0) : 0);
    const [romInfo, setRomInfo] = (0, $acw62.useState)({});
    const [paletteName, setPaletteName] = (0, $acw62.useState)(palette !== null && palette !== void 0 ? palette : emulator.palette);
    const [saveStates, setSaveStates] = (0, $acw62.useState)({});
    const [gamepads, setGamepads] = (0, $acw62.useState)({});
    const [keyaction, setKeyaction] = (0, $acw62.useState)();
    const [keyboardVisible, setKeyboardVisible] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $0c78cea49e52d841$export$db71243a43768e82));
    const [infoVisible, setInfoVisible] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $0c78cea49e52d841$export$81d769b9f617c951));
    const [debugVisible, setDebugVisible] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $0c78cea49e52d841$export$196c69f150d1ebb1));
    const [visibleSections, setVisibleSections] = (0, $7ef244517b504261$export$12012bbeae92bfa2)((0, $0c78cea49e52d841$export$7c36d9956e98f511));
    const audioStateRef = (0, $acw62.useRef)({
        audioContext: null,
        audioChunks: [],
        nextPlayTime: 0.0
    });
    const modalManagerRef = (0, $acw62.useRef)(null);
    const toastManagerRef = (0, $acw62.useRef)(null);
    const frameRef = (0, $acw62.useRef)(false);
    const errorRef = (0, $acw62.useRef)(false);
    const titleRef = (0, $acw62.useRef)(document.title);
    const frequencyRatio = (0, $acw62.useMemo)(()=>{
        var _a;
        return (0, $21488f2abed026ea$export$145cd2705873a35b)[(_a = emulator.frequencySpecs.unit) !== null && _a !== void 0 ? _a : (0, $21488f2abed026ea$export$44c95d3770756ed2).Hz];
    }, [
        emulator
    ]);
    const displayFrequencyRatio = (0, $acw62.useMemo)(()=>{
        var _a;
        return (0, $21488f2abed026ea$export$145cd2705873a35b)[(_a = emulator.frequencySpecs.displayUnit) !== null && _a !== void 0 ? _a : (0, $21488f2abed026ea$export$44c95d3770756ed2).Hz];
    }, [
        emulator
    ]);
    const thumbnailSize = (0, $acw62.useMemo)(()=>[
            emulator.dimensions.width,
            emulator.dimensions.height
        ], [
        emulator
    ]);
    const saveStateEntries = (0, $acw62.useMemo)(()=>Object.entries(saveStates), [
        saveStates
    ]);
    const displayOptions = (0, $acw62.useMemo)(()=>{
        var _a, _b;
        return {
            width: emulator.dimensions.width * ((_a = emulator.dimensions.scale) !== null && _a !== void 0 ? _a : 2),
            height: emulator.dimensions.height * ((_b = emulator.dimensions.scale) !== null && _b !== void 0 ? _b : 2),
            logicWidth: emulator.dimensions.width,
            logicHeight: emulator.dimensions.height
        };
    }, [
        emulator
    ]);
    const romExts = (0, $acw62.useMemo)(()=>emulator.romExts.map((e)=>`.${e}`).join(","), [
        emulator.romExts
    ]);
    const stateExts = (0, $acw62.useMemo)(()=>emulator.stateExts.map((e)=>`.${e}`).join(","), [
        emulator.stateExts
    ]);
    (0, $acw62.useEffect)(()=>{
        setFullscreenState(fullscreen);
        setKeyboardVisible($a64f72727446b946$var$isTouchDevice() || keyboard);
        setDebugVisible(debug);
        setInfoVisible(info);
        if (sections.length > 0) setVisibleSections(sections);
    }, [
        setFullscreenState,
        setKeyboardVisible,
        setDebugVisible,
        setInfoVisible,
        setVisibleSections,
        fullscreen,
        keyboard,
        info,
        debug,
        sections
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const background = getBackground();
        document.body.style.backgroundColor = `#${background}`;
        onBackground === null || onBackground === void 0 || onBackground(background);
        (_a = emulator.onBackground) === null || _a === void 0 || _a.call(emulator, background);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        emulator,
        backgroundIndex
    ]);
    (0, $acw62.useEffect)(()=>{
        if (romInfo.name) document.title = `${titleRef.current} - ${romInfo.name}`;
        else document.title = titleRef.current;
    }, [
        romInfo
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b;
        switch(keyaction){
            case "Plus":
                emulator.frequency += (_a = emulator.frequencySpecs.delta) !== null && _a !== void 0 ? _a : (0, $21488f2abed026ea$export$a4ca6f0b93d1bc79);
                setKeyaction(undefined);
                break;
            case "Minus":
                emulator.frequency -= (_b = emulator.frequencySpecs.delta) !== null && _b !== void 0 ? _b : (0, $21488f2abed026ea$export$a4ca6f0b93d1bc79);
                setKeyaction(undefined);
                break;
            case "Escape":
                setFullscreenState(false);
                setKeyaction(undefined);
                break;
            case "Fullscreen":
                setFullscreenState((prev)=>!prev);
                setKeyaction(undefined);
                break;
            case "Keyboard":
                setKeyboardVisible((prev)=>!prev);
                setKeyaction(undefined);
                break;
            case "Palette":
                if (emulator.changePalette) setPaletteName(emulator.changePalette());
                setKeyaction(undefined);
                break;
            case "Accelerate":
                if (!fast) {
                    emulator.frequency *= 8;
                    setFast(true);
                }
                break;
            case "Slowdown":
                if (fast) {
                    emulator.frequency /= 8;
                    setFast(false);
                }
                break;
        }
    }, [
        setFullscreenState,
        setFast,
        setKeyboardVisible,
        emulator,
        keyaction,
        fast
    ]);
    (0, $acw62.useEffect)(()=>{
        if (palette) emulator.palette = palette;
        const onFullChange = ()=>{
            if (!document.fullscreenElement && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !document.webkitFullscreenElement) setFullscreenState(false);
        };
        const onKeyDown = (event)=>{
            switch(event.key){
                case "+":
                    setKeyaction("Plus");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "-":
                    setKeyaction("Minus");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "Escape":
                    setKeyaction("Escape");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
            }
            if (event.ctrlKey === true) switch(event.key){
                case "f":
                    setKeyaction("Fullscreen");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "k":
                    setKeyaction("Keyboard");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "d":
                    setKeyaction("Accelerate");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "p":
                    setKeyaction("Palette");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
            }
        };
        const onKeyUp = (event)=>{
            if (event.ctrlKey === true) switch(event.key){
                case "d":
                    setKeyaction("Slowdown");
                    event.stopPropagation();
                    event.preventDefault();
                    break;
            }
            else switch(event.key){
                case "Control":
                    setKeyaction("Slowdown");
                    break;
            }
        };
        const onBooted = ()=>{
            refreshRom();
            setPaused(false);
        };
        const onMessage = (emulator, _params = {})=>{
            const params = _params;
            showToast(params.text, params.error, params.timeout);
        };
        document.addEventListener("fullscreenchange", onFullChange);
        document.addEventListener("webkitfullscreenchange", onFullChange);
        document.addEventListener("keydown", onKeyDown);
        document.addEventListener("keyup", onKeyUp);
        emulator.bind("booted", onBooted);
        emulator.bind("message", onMessage);
        // updates the emulator with the handles that can be used to control
        // some of the UI functionality directly from the emulator instance
        emulator.handlers = {
            showModal: showModal,
            showHelp: showHelp,
            showToast: showToast
        };
        refreshRom();
        return ()=>{
            document.removeEventListener("fullscreenchange", onFullChange);
            document.removeEventListener("webkitfullscreenchange", onFullChange);
            document.removeEventListener("keydown", onKeyDown);
            document.removeEventListener("keyup", onKeyUp);
            emulator.unbind("booted", onBooted);
            emulator.unbind("message", onMessage);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        emulator,
        palette
    ]);
    /**
     * Refreshes the current ROM information by querying the emulator
     * about the multiple changes resulting from a new ROM loading.
     */ const refreshRom = ()=>{
        setRomInfo(emulator.romInfo);
        refreshSaveStates();
    };
    /**
     * Refreshes the current save states information by querying the emulator
     * for the current list of save states and then updating the state with
     * the new information.
     * It should trigger a visual refresh on React state change, that will
     * update the UI with the new save states.
     * This operation is considered expensive and should used with care.
     */ const refreshSaveStates = (0, $acw62.useCallback)(()=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            if (emulator.listStates === undefined) return [];
            const saveStates = Object.fromEntries((yield Promise.all((_a = (yield emulator.listStates()).map((index)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
                    return [
                        index,
                        (yield emulator.getState(index))
                    ];
                }))) !== null && _a !== void 0 ? _a : [])));
            setSaveStates(saveStates);
        }), [
        emulator
    ]);
    const getPauseText = ()=>paused ? "Resume" : "Pause";
    const getPauseIcon = ()=>paused ? (parcelRequire("1JThx")) : (parcelRequire("h0KsI"));
    const getSoundText = ()=>muted ? "Unmute Sound" : "Mute Sound";
    const getSoundIcon = ()=>muted ? (parcelRequire("9BwyB")) : (parcelRequire("fiMxY"));
    const getBackground = (0, $acw62.useCallback)(()=>backgrounds[backgroundIndex], [
        backgrounds,
        backgroundIndex
    ]);
    const hasFeature = (0, $acw62.useCallback)((feature)=>{
        return emulator.features.includes(feature);
    }, [
        emulator
    ]);
    const hasSaveStatesTab = (0, $acw62.useCallback)(()=>hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).SaveState), [
        hasFeature
    ]);
    const hasControllersTab = (0, $acw62.useCallback)(()=>Object.keys(gamepads).length > 0, [
        gamepads
    ]);
    const getTabs = ()=>{
        const tabs = [];
        tabs.push(generalTab);
        tabs.push(detailsTab);
        if (hasSaveStatesTab()) tabs.push(saveStatesTab);
        if (hasControllersTab()) tabs.push(renderControllersTab);
        return tabs;
    };
    const getTabNames = ()=>{
        const tabNames = [];
        tabNames.push("General");
        tabNames.push("Details");
        if (hasSaveStatesTab()) tabNames.push("Save States");
        if (hasControllersTab()) tabNames.push("Controllers");
        return tabNames;
    };
    const showModal = (0, $acw62.useCallback)((...args_1)=>$a64f72727446b946$var$__awaiter(void 0, [
            ...args_1
        ], void 0, function*(title = "Alert", text, contents) {
            var _a, _b;
            return (_b = yield (_a = modalManagerRef.current) === null || _a === void 0 ? void 0 : _a.showModal(title, text, contents)) !== null && _b !== void 0 ? _b : true;
        }), []);
    const showHelp = (0, $acw62.useCallback)((...args_1)=>$a64f72727446b946$var$__awaiter(void 0, [
            ...args_1
        ], void 0, function*(title = "Help") {
            yield showModal(title, undefined, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $faaea4057129900a$export$1be7516c0280bee8), {
                panels: emulator.help.map((h)=>h.node),
                names: emulator.help.map((h)=>h.name)
            }));
        }), [
        showModal,
        emulator
    ]);
    const showSaveInfo = (0, $acw62.useCallback)((saveState)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            yield showModal(`Save State #${saveState.index}`, undefined, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5973aea0c159fe09$export$6c6aedcd06940e1a), {
                saveState: saveState,
                emulator: emulator
            }));
        }), [
        showModal,
        emulator
    ]);
    const showToast = (0, $acw62.useCallback)((text_1, ...args_1)=>$a64f72727446b946$var$__awaiter(void 0, [
            text_1,
            ...args_1
        ], void 0, function*(text, error = false, timeout = 3500) {
            var _a;
            return yield (_a = toastManagerRef.current) === null || _a === void 0 ? void 0 : _a.showToast(text, error, timeout);
        }), []);
    const onFile = (0, $acw62.useCallback)((file)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const fileExtension = (_a = file.name.split(".").pop()) !== null && _a !== void 0 ? _a : "";
            if (!emulator.romExts.includes(fileExtension)) {
                showToast(`This is probably not a ${emulator.device.text} ROM file!`, true);
                return;
            }
            const romData = yield emulator.buildRomData(file);
            try {
                yield emulator.boot({
                    engine: null,
                    romName: file.name,
                    romData: romData
                });
                showToast(`Loaded ${file.name} ROM successfully!`);
                emulator.logger.info(`Loaded ${file.name} ROM successfully`);
            } catch (err) {
                showToast(`Failed to load ${file.name} ROM!`, true);
                emulator.logger.error(`Failed to load ${file.name} ROM (${err})`);
            }
        }), [
        showToast,
        emulator
    ]);
    const onPauseClick = (0, $acw62.useCallback)(()=>{
        emulator.toggleRunning();
        setPaused(!paused);
    }, [
        setPaused,
        emulator,
        paused
    ]);
    const onResetClick = (0, $acw62.useCallback)(()=>{
        emulator.reset();
        emulator.logger.info(`Finished reset operation`);
    }, [
        emulator
    ]);
    const onSoundClick = (0, $acw62.useCallback)(()=>{
        var _a, _b;
        if (!audioStateRef.current.audioContext) return;
        const audioContext = audioStateRef.current.audioContext;
        if (muted) {
            audioContext.resume();
            (_a = emulator.resumeAudio) === null || _a === void 0 || _a.call(emulator);
            setMuted(false);
        } else {
            audioContext.suspend();
            (_b = emulator.pauseAudio) === null || _b === void 0 || _b.call(emulator);
            setMuted(true);
        }
    }, [
        setMuted,
        emulator,
        muted
    ]);
    const onBenchmarkClick = (0, $acw62.useCallback)(()=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            if (!emulator.benchmark) return;
            const result = yield showModal("Confirm", "Are you sure you want to start a benchmark?\nThe benchmark is considered an expensive operation!");
            if (!result) return;
            const { delta: delta, count: count, frequency_mhz: frequency_mhz } = emulator.benchmark();
            yield showToast(`Took ${delta.toFixed(2)} seconds to run ${count} ticks (${frequency_mhz.toFixed(2)} Mhz)!`, undefined, 7500);
        }), [
        showModal,
        showToast,
        emulator
    ]);
    const onFullscreenClick = (0, $acw62.useCallback)(()=>{
        setFullscreenState(!fullscreenState);
    }, [
        setFullscreenState,
        fullscreenState
    ]);
    const onKeyboardClick = (0, $acw62.useCallback)(()=>{
        setKeyboardVisible(!keyboardVisible);
    }, [
        setKeyboardVisible,
        keyboardVisible
    ]);
    const onInformationClick = (0, $acw62.useCallback)(()=>{
        setInfoVisible(!infoVisible);
    }, [
        setInfoVisible,
        infoVisible
    ]);
    const onHelpClick = (0, $acw62.useCallback)(()=>{
        showHelp();
    }, [
        showHelp
    ]);
    const onDebugClick = (0, $acw62.useCallback)(()=>{
        setDebugVisible(!debugVisible);
    }, [
        setDebugVisible,
        debugVisible
    ]);
    const onThemeClick = (0, $acw62.useCallback)(()=>{
        setBackgroundIndex((backgroundIndex + 1) % backgrounds.length);
    }, [
        backgroundIndex,
        backgrounds.length
    ]);
    const onPaletteClick = (0, $acw62.useCallback)(()=>{
        if (!emulator.changePalette) return;
        const palette = emulator.changePalette();
        setPaletteName(palette);
    }, [
        emulator
    ]);
    const onSectionClick = (0, $acw62.useCallback)((name)=>{
        const isVisible = visibleSections.includes(name);
        if (isVisible) setVisibleSections(visibleSections.filter((s)=>s !== name));
        else setVisibleSections([
            ...visibleSections,
            name
        ]);
    }, [
        setVisibleSections,
        visibleSections
    ]);
    const onSaveStateClick = (0, $acw62.useCallback)(()=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            for(let index = 0; index < 10; index++)if (saveStates[index] === undefined) {
                yield (_a = emulator.saveState) === null || _a === void 0 ? void 0 : _a.call(emulator, index);
                refreshSaveStates();
                break;
            }
        }), [
        refreshSaveStates,
        emulator,
        saveStates
    ]);
    const onLoadStateClick = (0, $acw62.useCallback)((saveState)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            yield (_a = emulator.loadState) === null || _a === void 0 ? void 0 : _a.call(emulator, saveState.index);
            showToast(`Loaded save state #${saveState.index} successfully!`);
        }), [
        showToast,
        emulator
    ]);
    const onDownloadStateClick = (0, $acw62.useCallback)((saveState)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            const data = yield emulator.getStateData(saveState.index);
            (0, $a07119bee7a8f987$export$93588aa942feafe7)(data, `${emulator.romInfo.name}.s${saveState.index}`);
        }), [
        emulator
    ]);
    const onInfoStateClick = (0, $acw62.useCallback)((saveState)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            showSaveInfo(saveState);
        }), [
        showSaveInfo
    ]);
    const onDeleteStateClick = (0, $acw62.useCallback)((saveState)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const result = yield showModal("Confirm", `Are you sure you want to delete save state #${saveState.index}?\nThis operation is not reversible!`);
            if (!result) return;
            yield (_a = emulator.deleteState) === null || _a === void 0 ? void 0 : _a.call(emulator, saveState.index);
            yield refreshSaveStates();
            showToast(`Deleted save state #${saveState.index} successfully!`);
        }), [
        showModal,
        showToast,
        refreshSaveStates,
        emulator
    ]);
    const onUploadRom = (0, $acw62.useCallback)((file)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            const romData = yield emulator.buildRomData(file);
            try {
                yield emulator.boot({
                    engine: null,
                    romName: file.name,
                    romData: romData
                });
                showToast(`Loaded ${file.name} ROM successfully!`);
                emulator.logger.info(`Loaded ${file.name} ROM successfully`);
            } catch (err) {
                showToast(`Failed to load ${file.name} ROM!`, true);
                emulator.logger.error(`Failed to load ${file.name} ROM (${err})`);
            }
        }), [
        showToast,
        emulator
    ]);
    const onUploadState = (0, $acw62.useCallback)((file)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            try {
                const arrayBuffer = yield file.arrayBuffer();
                const data = new Uint8Array(arrayBuffer);
                for(let index = 0; index < 10; index++)if (saveStates[index] === undefined) {
                    yield (_a = emulator.saveState) === null || _a === void 0 ? void 0 : _a.call(emulator, index, data);
                    refreshSaveStates();
                    break;
                }
                showToast(`Loaded ${file.name} state successfully!`);
                emulator.logger.info(`Loaded ${file.name} state successfully`);
            } catch (err) {
                showToast(`Failed to load ${file.name} state!`, true);
                emulator.logger.error(`Failed to load ${file.name} state (${err})`);
            }
        }), [
        showToast,
        refreshSaveStates,
        saveStates,
        emulator
    ]);
    const onEngineChange = (0, $acw62.useCallback)((engine)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            yield emulator.boot({
                engine: engine
            });
            showToast(`${emulator.device.text} running on engine "${engine}" from now on!`);
        }), [
        showToast,
        emulator
    ]);
    const onLoopChange = (0, $acw62.useCallback)((loopMode)=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
            emulator.loopMode = (0, $21488f2abed026ea$export$894f5dc5e1b52f8d)(loopMode);
            showToast(`${emulator.device.text} running on loop mode "${loopMode}" from now on!`);
        }), [
        showToast,
        emulator
    ]);
    const onFrequencyChange = (0, $acw62.useCallback)((value)=>{
        emulator.frequency = value * frequencyRatio;
    }, [
        emulator,
        frequencyRatio
    ]);
    const onFrequencyReady = (0, $acw62.useCallback)((handler)=>{
        emulator.bind("frequency", (emulator, frequency)=>{
            handler(frequency / frequencyRatio);
        });
    }, [
        emulator,
        frequencyRatio
    ]);
    const onDisplayFrequencyChange = (0, $acw62.useCallback)((value)=>{
        emulator.displayFrequency = value * displayFrequencyRatio;
    }, [
        emulator,
        displayFrequencyRatio
    ]);
    const onMinimize = (0, $acw62.useCallback)(()=>{
        setFullscreenState(!fullscreenState);
    }, [
        setFullscreenState,
        fullscreenState
    ]);
    const onKeyDown = (0, $acw62.useCallback)((key)=>{
        emulator.keyPress(key);
    }, [
        emulator
    ]);
    const onKeyUp = (0, $acw62.useCallback)((key)=>{
        emulator.keyLift(key);
    }, [
        emulator
    ]);
    const onGamepad = (0, $acw62.useCallback)((gamepad, isValid, connected = true)=>{
        const { index: index, id: id } = gamepad;
        if (connected) {
            if (isValid) {
                gamepads[gamepad.index] = gamepad;
                setGamepads(Object.assign({}, gamepads));
                showToast(`\u{1F579}\u{FE0F} Gamepad #${index} connect ${id}`);
            } else showToast(`\u{1F625} Unsupported gamepad connect ${id}`, true);
        } else if (isValid) {
            delete gamepads[index];
            setGamepads(Object.assign({}, gamepads));
            showToast(`\u{1F579}\u{FE0F} Gamepad #${index} disconnected ${id}`, true);
        }
    }, [
        showToast,
        gamepads
    ]);
    const onDrawHandler = (0, $acw62.useCallback)((handler)=>{
        if (frameRef.current) return;
        frameRef.current = true;
        emulator.bind("frame", ()=>{
            handler(emulator.imageBuffer, (0, $21488f2abed026ea$export$abee86c20a5429d).RGB);
        });
    }, [
        emulator
    ]);
    const onClearHandler = (0, $acw62.useCallback)((handler)=>{
        if (errorRef.current) return;
        errorRef.current = true;
        emulator.bind("error", ()=>$a64f72727446b946$var$__awaiter(void 0, void 0, void 0, function*() {
                yield handler(undefined, (parcelRequire("i1bf1")), 0.2);
            }));
    }, [
        emulator
    ]);
    const onAudioReady = (0, $acw62.useCallback)(()=>{
        // in case the emulator does not provide proper audio specs
        // then the audio should not be enabled for it
        if (emulator.audioSpecs === null) return;
        // in case the audio context has already been build then
        // there's nothing pending to be done
        if (audioStateRef.current.audioContext !== null) return;
        // creates the audio context (should be created on a click
        // event for user interaction) and then immediately resumes
        // the audio for it so that it play the sound in buffer
        const audioContext = new AudioContext({
            sampleRate: emulator.audioSpecs.samplingRate
        });
        audioContext.resume();
        audioStateRef.current.audioContext = audioContext;
        emulator.bind("audio", ()=>{
            if (emulator.audioSpecs === null) return;
            const audioState = audioStateRef.current;
            if (audioState.audioContext === null) return;
            const internalAudioBuffer = emulator.audioBuffer;
            const { samplingRate: samplingRate, channels: channels } = emulator.audioSpecs;
            const bufferLength = internalAudioBuffer[0].length;
            if (bufferLength === 0) return;
            const audioBuffer = audioState.audioContext.createBuffer(channels, bufferLength, samplingRate);
            // for each of the channels copies the float 32 array from the
            // internal (emulator specific) buffers into the audio buffer
            // channel data buffers
            for(let channel = 0; channel < channels; channel++){
                const channelBuffer = audioBuffer.getChannelData(channel);
                const internalChannelBuffer = internalAudioBuffer[channel];
                channelBuffer.set(internalChannelBuffer);
            }
            const source = audioState.audioContext.createBufferSource();
            source.buffer = audioBuffer;
            source.connect(audioState.audioContext.destination);
            // makes sure that we're not too far away from the audio
            // and if that's the case drops some of the audio to regain
            // some sync, this is required because of time hogging
            const audioCurrentTime = audioState.audioContext.currentTime;
            if (audioState.nextPlayTime > audioCurrentTime + 0.25 || audioState.nextPlayTime < audioCurrentTime) {
                audioState.audioChunks.forEach((chunk)=>{
                    if (!(audioState === null || audioState === void 0 ? void 0 : audioState.audioContext)) return;
                    chunk.source.disconnect(audioState.audioContext.destination);
                    chunk.source.stop();
                });
                audioState.audioChunks = [];
                audioState.nextPlayTime = audioCurrentTime + 0.1;
            }
            audioState.nextPlayTime = audioState.nextPlayTime || audioCurrentTime;
            const chunk = {
                source: source,
                playTime: audioState.nextPlayTime,
                duration: audioBuffer.length / samplingRate
            };
            source.start(chunk.playTime);
            audioState.nextPlayTime += chunk.duration;
            audioState.audioChunks.push(chunk);
        });
    }, [
        emulator
    ]);
    const displayContainer = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "display-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c1b6b9ada899904f$export$76748c987176663a), {
            options: displayOptions,
            fullscreen: fullscreenState,
            nativeFullscreen: nativeFullscreen,
            onDrawHandler: onDrawHandler,
            onClearHandler: onClearHandler,
            onMinimize: onMinimize
        })), [
        onDrawHandler,
        onMinimize,
        onClearHandler,
        displayOptions,
        fullscreenState,
        nativeFullscreen
    ]);
    const header = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc8c4b9396eb68a8$export$ce11c4ecd08cea67), {
            ref: modalManagerRef
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7b8a18762d707a5b$export$51d32fc2dfa9b88b), {
            ref: toastManagerRef
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca24016d70cb32f8$export$c6fdb837b070b4ff), {
            text: "Drag to load ROM",
            accept: romExts,
            onFile: onFile
        })), [
        onFile,
        romExts
    ]);
    const footer = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89f1204196cd6c76$export$a06f1c675e846f6f), {
            color: getBackground()
        }, "Built with \u2764\uFE0F by", " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
            href: "https://joao.me",
            target: "_blank"
        }, "Jo\u00E3o Magalh\u00E3es")), [
        getBackground
    ]);
    const title = (0, $acw62.useMemo)(()=>{
        var _a, _b, _c;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8e4a5eb44e16b55$export$f99233281efd08a0), {
            text: emulator.name,
            version: (_a = emulator.version) === null || _a === void 0 ? void 0 : _a.text,
            versionUrl: (_b = emulator.version) === null || _b === void 0 ? void 0 : _b.url,
            iconSrc: (_c = emulator.icon) !== null && _c !== void 0 ? _c : (parcelRequire("gjmuW"))
        });
    }, [
        emulator
    ]);
    const descriptionSection = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df815c6cfea7e2d2$export$358a232cca1ab2ac), null, "This is a", " ", emulator.device.url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
            href: emulator.device.url,
            target: "_blank"
        }, emulator.device.text) : emulator.device.text, " ", "emulator built using the", " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
            href: "https://www.rust-lang.org",
            target: "_blank"
        }, "Rust Programming Language"), " ", "and is running inside this browser with the help of", " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
            href: "https://webassembly.org",
            target: "_blank"
        }, "WebAssembly"), "."), emulator.repository && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df815c6cfea7e2d2$export$358a232cca1ab2ac), null, "You can check the source code of it on", " ", emulator.repository.url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
            href: emulator.repository.url,
            target: "_blank"
        }, emulator.repository.text) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, emulator.repository.text), "."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df815c6cfea7e2d2$export$358a232cca1ab2ac), null, "TIP: Drag and Drop ROM files to the Browser to load the ROM.")), [
        emulator
    ]);
    const debugSection = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6608e85548e82078$export$153e5dc2c098b35c), {
            panels: emulator.debug.map((h)=>h.node),
            names: emulator.debug.map((h)=>h.name)
        })), [
        emulator
    ]);
    const keyboardSection = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), {
            visible: keyboardVisible,
            separatorBottom: true
        }, hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).KeyboardChip8) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8732e049cf7ac6ef$export$39e14a39e4981a75), {
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).KeyboardGB) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bba052522aedacf8$export$1901b6ac81a8ee81), {
            fullscreen: fullscreenState,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            onGamepad: onGamepad
        })), [
        hasFeature,
        onGamepad,
        onKeyDown,
        onKeyUp,
        fullscreenState,
        keyboardVisible
    ]);
    const generalTab = (0, $acw62.useMemo)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "button-engine",
            name: "Engine",
            valueNode: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
                options: emulator.engines,
                value: emulator.engine || emulator.engines[0],
                uppercase: true,
                size: "large",
                style: [
                    "simple"
                ],
                onChange: onEngineChange
            })
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "rom",
            name: "ROM",
            value: (_a = romInfo.name) !== null && _a !== void 0 ? _a : "-"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "rom-size",
            name: "ROM Size",
            value: romInfo.size ? `${new Intl.NumberFormat().format(romInfo.size)} bytes` : "-"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "button-frequency",
            name: "CPU Frequency",
            valueNode: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $958b609a0ec418e9$export$8ab700b743774a9b), {
                value: emulator.frequency / frequencyRatio,
                delta: ((_b = emulator.frequencySpecs.delta) !== null && _b !== void 0 ? _b : (0, $21488f2abed026ea$export$a4ca6f0b93d1bc79)) / frequencyRatio,
                min: 0,
                suffix: (_c = emulator.frequencySpecs.unit) !== null && _c !== void 0 ? _c : "Hz",
                decimalPlaces: (_d = emulator.frequencySpecs.places) !== null && _d !== void 0 ? _d : 0,
                onChange: onFrequencyChange,
                onReady: onFrequencyReady
            })
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).DisplayFrequency) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "button-display-frequency",
            name: "Display Frequency",
            valueNode: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $958b609a0ec418e9$export$8ab700b743774a9b), {
                value: emulator.displayFrequency / displayFrequencyRatio,
                delta: ((_e = emulator.frequencySpecs.displayDelta) !== null && _e !== void 0 ? _e : (0, $21488f2abed026ea$export$c8c8884a02af7737)) / displayFrequencyRatio,
                min: 0,
                suffix: (_f = emulator.frequencySpecs.displayUnit) !== null && _f !== void 0 ? _f : "Hz",
                decimalPlaces: (_g = emulator.frequencySpecs.displayPlaces) !== null && _g !== void 0 ? _g : 0,
                onChange: onDisplayFrequencyChange
            })
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).LoopMode) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "button-loop-mode",
            name: "Loop Mode",
            valueNode: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
                options: (0, $21488f2abed026ea$export$9b2ef54602e501d2)(),
                value: "auto",
                uppercase: true,
                size: "large",
                style: [
                    "simple"
                ],
                onChange: onLoopChange
            })
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).BootRomInfo) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "boot-rom",
            name: "Boot ROM",
            value: ((_h = romInfo.extra) === null || _h === void 0 ? void 0 : _h.bootRom) ? `${(_j = romInfo.extra) === null || _j === void 0 ? void 0 : _j.bootRom}` : "-"
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).RomTypeInfo) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "rom-type",
            name: "ROM Type",
            value: ((_k = romInfo.extra) === null || _k === void 0 ? void 0 : _k.romType) ? `${(_l = romInfo.extra) === null || _l === void 0 ? void 0 : _l.romType}` : "-"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a64f72727446b946$export$5766d5f446d60bb4, {
            emulator: emulator
        }));
    }, [
        hasFeature,
        onDisplayFrequencyChange,
        onEngineChange,
        onFrequencyChange,
        onFrequencyReady,
        onLoopChange,
        emulator,
        displayFrequencyRatio,
        frequencyRatio,
        romInfo
    ]);
    const detailsTab = (0, $acw62.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "emukit",
            name: "EmuKit",
            value: (0, (/*@__PURE__*/$parcel$interopDefault($71096008450a71c4$exports))).version,
            valueHref: "https://github.com/joamag/emukit/blob/master/CHANGELOG.md"
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Themes) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "theme",
            name: "Theme",
            value: `#${getBackground()}`
        }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Palettes) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "palette",
            name: "Palette",
            value: paletteName
        }), emulator.compilerString && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "compiler",
            name: "Compiler",
            value: emulator.compilerString
        }), emulator.compilationString && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "compilation",
            name: "Compilation",
            value: emulator.compilationString
        }), emulator.wasmEngine && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
            key: "wasm-engine",
            name: "WASM Engine",
            value: emulator.wasmEngine
        })), [
        hasFeature,
        getBackground,
        paletteName,
        emulator.compilerString,
        emulator.compilationString,
        emulator.wasmEngine
    ]);
    const saveStatesTab = (0, $acw62.useMemo)(()=>hasSaveStatesTab() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), null, saveStateEntries.length > 0 ? saveStateEntries.map(([index, saveSate])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
                key: `#${index}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9a683e10efe99492$export$d022ea1b4dcd550c), {
                index: saveSate.index,
                thumbnail: saveSate.thumbnail,
                thumbnailSize: thumbnailSize,
                saveState: saveSate,
                onLoadClick: onLoadStateClick,
                onDeleteClick: onDeleteStateClick,
                onInfoClick: onInfoStateClick,
                onDownloadClick: onDownloadStateClick
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8db713e26b576873$export$1ff3c3f08ae963c0), {
                marginTop: 12,
                marginBottom: 12,
                thickness: 1,
                color: "transparent"
            }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df815c6cfea7e2d2$export$358a232cca1ab2ac), {
            style: [
                "no-margin-top"
            ]
        }, "There're currently no save states for this ROM!", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("br", null), "Press Save State to capture the current machine state into local storage.")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $132489609fea9882$export$eddf54ea3db8d0f0), {
            style: [
                "simple"
            ]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
            text: "Save State",
            image: (parcelRequire("6TuRg")),
            imageAlt: "download",
            onClick: onSaveStateClick
        }), stateExts.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
            text: "Load State",
            image: (parcelRequire("brrWC")),
            imageAlt: "upload",
            file: true,
            accept: stateExts,
            style: [
                "simple",
                "border",
                "padded"
            ],
            onFile: onUploadState
        }))) : null, [
        hasSaveStatesTab,
        onDeleteStateClick,
        onDownloadStateClick,
        onInfoStateClick,
        onLoadStateClick,
        onSaveStateClick,
        onUploadState,
        saveStateEntries,
        thumbnailSize,
        stateExts
    ]);
    const renderControllersTab = (0, $acw62.useMemo)(()=>hasControllersTab() ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), {
            style: [
                "small"
            ]
        }, Object.entries(gamepads).map(([index, gamepad])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
                key: `#${index}`,
                name: `#${index}`,
                value: gamepad.id
            }))) : null, [
        hasControllersTab,
        gamepads
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "app",
        onClick: onAudioReady,
        onTouchStart: onAudioReady
    }, header, footer, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $db1967ac167dad1f$export$ca38978b734fad5f), {
        left: displayContainer
    }, keyboardSection, title, descriptionSection, debugVisible && debugSection, infoVisible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$445d62b2c6943727), {
        tabs: getTabs(),
        tabNames: getTabNames(),
        selectors: true
    })), emulator.sections.map((section)=>visibleSections.includes(section.name) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), {
            key: section.name
        }, section.node)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6f514e8ee8fa1f0a$export$6e2c8f0811a474ce), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $132489609fea9882$export$eddf54ea3db8d0f0), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: getPauseText(),
        image: getPauseIcon(),
        imageAlt: "pause",
        enabled: paused,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onPauseClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Reset",
        image: (parcelRequire("7zyFN")),
        imageAlt: "reset",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onResetClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: getSoundText(),
        image: getSoundIcon(),
        imageAlt: "sound",
        enabled: muted,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onSoundClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Benchmark) && emulator.benchmark && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Benchmark",
        image: (parcelRequire("lylCC")),
        imageAlt: "benchmark",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onBenchmarkClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Fullscreen",
        image: (parcelRequire("kdavB")),
        imageAlt: "maximise",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onFullscreenClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Keyboard) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Keyboard",
        image: (parcelRequire("dbE0R")),
        imageAlt: "keyboard",
        enabled: keyboardVisible,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onKeyboardClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Information",
        image: (parcelRequire("iCYgV")),
        imageAlt: "information",
        enabled: infoVisible,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onInformationClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Help) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Help",
        image: (parcelRequire("kkaRu")),
        imageAlt: "help",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onHelpClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Debug) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Debug",
        image: (parcelRequire("jReRO")),
        imageAlt: "debug",
        enabled: debugVisible,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onDebugClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Themes) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Themes",
        image: (parcelRequire("2mx64")),
        imageAlt: "theme",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onThemeClick
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Palettes) && emulator.changePalette && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Palette",
        image: (parcelRequire("8Jl4d")),
        imageAlt: "palette",
        style: [
            "simple",
            "border",
            "padded"
        ],
        onClick: onPaletteClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
        text: "Load ROM",
        image: (parcelRequire("brrWC")),
        imageAlt: "upload",
        file: true,
        accept: romExts,
        style: [
            "simple",
            "border",
            "padded"
        ],
        onFile: onUploadRom
    }), emulator.sections.map((section)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f543aa1e6c3d6410$export$353f5b6fc5456de1), {
            key: section.name,
            text: section.name,
            image: section.icon,
            enabled: visibleSections.includes(section.name),
            onClick: ()=>onSectionClick(section.name)
        }))))));
};
const $a64f72727446b946$export$e820db9e9e2fc09b = (element, { emulator: emulator, strictMode: strictMode = false, fullscreen: fullscreen = false, debug: debug = false, keyboard: keyboard = false, info: info = true, sections: sections = [], palette: palette, background: background, backgrounds: backgrounds })=>{
    const elementRef = document.getElementById(element);
    if (!elementRef) return;
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(elementRef);
    const app = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ef244517b504261$export$f72b9f9819639629), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a64f72727446b946$export$82737577c2f239fd, {
        emulator: emulator,
        fullscreen: fullscreen,
        debug: debug,
        keyboard: keyboard,
        info: info,
        sections: sections,
        palette: palette,
        background: background,
        backgrounds: backgrounds
    }));
    if (strictMode) root.render((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.StrictMode), null, app));
    else root.render(app);
};
const $a64f72727446b946$export$5766d5f446d60bb4 = ({ emulator: emulator })=>{
    const [framerate, setFramerate] = (0, $acw62.useState)(0);
    const [cyclerate, setCyclerate] = (0, $acw62.useState)(0);
    const [animationrate, setAnimationrate] = (0, $acw62.useState)(0);
    const [skippedTicks, setSkippedTicks] = (0, $acw62.useState)(0);
    const [emulationSpeed, setEmulationSpeed] = (0, $acw62.useState)(0);
    const hasFeature = (0, $acw62.useCallback)((feature)=>{
        return emulator.features.includes(feature);
    }, [
        emulator
    ]);
    (0, $acw62.useEffect)(()=>{
        emulator.bind("frame", ()=>{
            setFramerate(emulator.framerate);
            setCyclerate(emulator.cyclerate);
            setAnimationrate(emulator.animationrate);
            setSkippedTicks(emulator.skippedTicks);
            setEmulationSpeed(emulator.emulationSpeed);
        });
    }, [
        emulator
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Framerate) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "framerate",
        name: "Framerate",
        value: `${framerate} FPS`,
        title: `Number of frames generated by the emulator per second (logic frame rate)`
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Cyclerate) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "cyclerate",
        name: "Cyclerate",
        value: `${Intl.NumberFormat().format(cyclerate)} Hz`,
        title: `Number of CPU cycles executed per second`
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).Animationrate) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "animationrate",
        name: "Animationrate",
        value: `${Intl.NumberFormat().format(animationrate)} Hz`,
        title: `Rate at which the animation loop is being executed`
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).SkippedTicks) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "skipped-ticks",
        name: "Skipped Ticks",
        value: `${Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(skippedTicks)} TPS`,
        title: `Number of logic ticks skipped by the emulator per second`
    }), hasFeature((0, $21488f2abed026ea$export$6e91cf7616333d5).EmulationSpeed) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "emulation-speed",
        name: "Emulation Speed",
        value: `${Math.round(emulationSpeed)} %`,
        title: `Current emulation speed in relation to the target frequency`
    }));
};
var $a64f72727446b946$export$2e2bcd8739ae039 = $a64f72727446b946$export$82737577c2f239fd;








/* @ts-self-types="./boytacean.d.ts" */ class $796a66717a25f3ee$export$103f9e68d146c6c {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$103f9e68d146c6c.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$BessStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$BessStateFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_bessstate_free(ptr, 0);
    }
    /**
     * @returns {string}
     */ agent_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bessstate_agent_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */ has_image_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bessstate_has_image_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Uint8Array}
     */ image_eager_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bessstate_image_eager_wa(this.__wbg_ptr);
        if (ret[3]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {string}
     */ model_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bessstate_model_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */ timestamp_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bessstate_timestamp_wa(this.__wbg_ptr);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return BigInt.asUintN(64, ret[0]);
    }
    /**
     * @returns {string}
     */ title_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bessstate_title_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$103f9e68d146c6c.prototype[Symbol.dispose] = $796a66717a25f3ee$export$103f9e68d146c6c.prototype.free;
const $796a66717a25f3ee$export$44336435feae4ccf = Object.freeze({
    Dmg: 0,
    "0": "Dmg",
    Sgb: 1,
    "1": "Sgb",
    DmgBootix: 2,
    "2": "DmgBootix",
    MgbBootix: 3,
    "3": "MgbBootix",
    Cgb: 4,
    "4": "Cgb",
    CgbBoytacean: 5,
    "5": "CgbBoytacean",
    Other: 6,
    "6": "Other",
    None: 7,
    "7": "None"
});
class $796a66717a25f3ee$export$b7ac99645321b5f9 {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$b7ac99645321b5f9.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$BosStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$BosStateFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_bosstate_free(ptr, 0);
    }
    /**
     * @returns {string}
     */ agent_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bosstate_agent_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */ has_image_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bosstate_has_image_wa(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Uint8Array}
     */ image_eager_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bosstate_image_eager_wa(this.__wbg_ptr);
        if (ret[3]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {string}
     */ model_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bosstate_model_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * @returns {bigint}
     */ timestamp_wa() {
        const ret = $796a66717a25f3ee$var$wasm.bosstate_timestamp_wa(this.__wbg_ptr);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return BigInt.asUintN(64, ret[0]);
    }
    /**
     * @returns {string}
     */ title_wa() {
        let deferred2_0;
        let deferred2_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.bosstate_title_wa(this.__wbg_ptr);
            var ptr1 = ret[0];
            var len1 = ret[1];
            if (ret[3]) {
                ptr1 = 0;
                len1 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr1, len1);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$b7ac99645321b5f9.prototype[Symbol.dispose] = $796a66717a25f3ee$export$b7ac99645321b5f9.prototype.free;
class $796a66717a25f3ee$export$af807f7dbba0e4c5 {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$af807f7dbba0e4c5.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$BoscStateFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$BoscStateFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_boscstate_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$af807f7dbba0e4c5.prototype[Symbol.dispose] = $796a66717a25f3ee$export$af807f7dbba0e4c5.prototype.free;
class $796a66717a25f3ee$export$dbc25efda8448299 {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$dbc25efda8448299.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$CartridgeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$CartridgeFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_cartridge_free(ptr, 0);
    }
    /**
     * @returns {CgbMode}
     */ cgb_flag() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_cgb_flag(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ checksum() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_checksum(this.__wbg_ptr);
        return ret;
    }
    clear_ram_data() {
        $796a66717a25f3ee$var$wasm.cartridge_clear_ram_data(this.__wbg_ptr);
    }
    /**
     * @param {number} column_length
     * @returns {string}
     */ description(column_length) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.cartridge_description(this.__wbg_ptr, column_length);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {GameBoyMode}
     */ gb_mode() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_gb_mode(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */ has_battery() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_has_battery(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * A cartridge is considered legacy (DMG only) if it does
     * not have a CGB flag bit (bit 7 of 0x0143) set.
     *
     * These are the monochromatic only cartridges built
     * for the original DMG Game Boy.
     * @returns {boolean}
     */ is_legacy() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_is_legacy(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Licensee}
     */ licensee() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_licensee(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ ram_data_eager() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_ram_data_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {RamSize}
     */ ram_size() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_ram_size(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */ ram_size_s() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.cartridge_ram_size_s(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Region}
     */ region() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_region(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ rom_data_eager() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_rom_data_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {RomSize}
     */ rom_size() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_rom_size(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */ rom_size_s() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.cartridge_rom_size_s(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {RomType}
     */ rom_type() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_rom_type(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */ rom_type_s() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.cartridge_rom_type_s(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {Uint8Array} data
     */ set_ram_data(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        $796a66717a25f3ee$var$wasm.cartridge_set_ram_data(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {SgbMode}
     */ sgb_flag() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_sgb_flag(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */ title() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.cartridge_title(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {boolean}
     */ valid_checksum() {
        const ret = $796a66717a25f3ee$var$wasm.cartridge_valid_checksum(this.__wbg_ptr);
        return ret !== 0;
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$dbc25efda8448299.prototype[Symbol.dispose] = $796a66717a25f3ee$export$dbc25efda8448299.prototype.free;
const $796a66717a25f3ee$export$8be48dbdac986fe0 = Object.freeze({
    NoCgb: 0,
    "0": "NoCgb",
    CgbCompatible: 128,
    "128": "CgbCompatible",
    CgbOnly: 192,
    "192": "CgbOnly"
});
class $796a66717a25f3ee$export$a564195ba20f9a9e {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$a564195ba20f9a9e.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$ClockFrameFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$ClockFrameFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_clockframe_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array | undefined}
     */ frame_buffer_eager() {
        const ret = $796a66717a25f3ee$var$wasm.clockframe_frame_buffer_eager(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
            $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @returns {bigint}
     */ get cycles() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_clockframe_cycles(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
     * @returns {number}
     */ get frames() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_clockframe_frames(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {bigint} arg0
     */ set cycles(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_clockframe_cycles(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set frames(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_clockframe_frames(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$a564195ba20f9a9e.prototype[Symbol.dispose] = $796a66717a25f3ee$export$a564195ba20f9a9e.prototype.free;
class $796a66717a25f3ee$export$bbbb570a7e306505 {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$bbbb570a7e306505.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$FromGbOptionsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$FromGbOptionsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_fromgboptions_free(ptr, 0);
    }
    /**
     * @param {boolean} thumbnail
     * @param {StateFormat | null} [state_format]
     * @param {string | null} [agent]
     * @param {string | null} [agent_version]
     * @returns {FromGbOptions}
     */ static new(thumbnail, state_format, agent, agent_version) {
        var ptr0 = $796a66717a25f3ee$var$isLikeNone(agent) ? 0 : $796a66717a25f3ee$var$passStringToWasm0(agent, $796a66717a25f3ee$var$wasm.__wbindgen_malloc, $796a66717a25f3ee$var$wasm.__wbindgen_realloc);
        var len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        var ptr1 = $796a66717a25f3ee$var$isLikeNone(agent_version) ? 0 : $796a66717a25f3ee$var$passStringToWasm0(agent_version, $796a66717a25f3ee$var$wasm.__wbindgen_malloc, $796a66717a25f3ee$var$wasm.__wbindgen_realloc);
        var len1 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.fromgboptions_new(thumbnail, $796a66717a25f3ee$var$isLikeNone(state_format) ? 0 : state_format, ptr0, len0, ptr1, len1);
        return $796a66717a25f3ee$export$bbbb570a7e306505.__wrap(ret);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$bbbb570a7e306505.prototype[Symbol.dispose] = $796a66717a25f3ee$export$bbbb570a7e306505.prototype.free;
class $796a66717a25f3ee$export$4da340665b18d90 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$GameBoyFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_gameboy_free(ptr, 0);
    }
    /**
     * @param {string} code
     * @returns {boolean}
     */ add_cheat_code_wa(code) {
        const ptr0 = $796a66717a25f3ee$var$passStringToWasm0(code, $796a66717a25f3ee$var$wasm.__wbindgen_malloc, $796a66717a25f3ee$var$wasm.__wbindgen_realloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.gameboy_add_cheat_code_wa(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return ret[0] !== 0;
    }
    /**
     * @param {number} cycles
     */ apu_clock(cycles) {
        $796a66717a25f3ee$var$wasm.gameboy_apu_clock(this.__wbg_ptr, cycles);
    }
    /**
     * @returns {boolean}
     */ apu_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_apu_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    attach_null_serial() {
        $796a66717a25f3ee$var$wasm.gameboy_attach_null_serial(this.__wbg_ptr);
    }
    attach_printer_serial() {
        $796a66717a25f3ee$var$wasm.gameboy_attach_printer_serial(this.__wbg_ptr);
    }
    attach_stdout_serial() {
        $796a66717a25f3ee$var$wasm.gameboy_attach_stdout_serial(this.__wbg_ptr);
    }
    /**
     * @returns {Uint16Array}
     */ audio_all_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_all_output(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU16FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * @param {boolean} clear
     * @returns {Int16Array}
     */ audio_buffer_eager(clear) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_buffer_eager(this.__wbg_ptr, clear);
        var v1 = $796a66717a25f3ee$var$getArrayI16FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 2, 2);
        return v1;
    }
    /**
     * @returns {boolean}
     */ audio_ch1_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch1_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ audio_ch1_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch1_output(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */ audio_ch2_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch2_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ audio_ch2_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch2_output(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */ audio_ch3_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch3_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ audio_ch3_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch3_output(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */ audio_ch4_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch4_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ audio_ch4_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_ch4_output(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ audio_channels() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_channels(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ audio_filter_mode_wa() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_filter_mode_wa(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ audio_output() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_output(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ audio_sampling_rate() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_audio_sampling_rate(this.__wbg_ptr);
        return ret;
    }
    /**
     * Direct boot method that immediately jumps the machine
     * to the post boot state, this will effectively skip the
     * boot sequence and jump to the cartridge execution.
     */ boot() {
        $796a66717a25f3ee$var$wasm.gameboy_boot(this.__wbg_ptr);
    }
    /**
     * @returns {BootRom}
     */ boot_rom() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_boot_rom(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {string}
     */ boot_rom_s() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.gameboy_boot_rom_s(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Cartridge}
     */ cartridge_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_cartridge_eager(this.__wbg_ptr);
        return $796a66717a25f3ee$export$dbc25efda8448299.__wrap(ret);
    }
    /**
     * Advance the clock of the system by one tick, this will
     * usually imply executing one CPU instruction and advancing
     * all the other components of the system by the required
     * amount of cycles.
     *
     * This method takes into account the current speed of the
     * system (single or double) and will execute the required
     * amount of cycles in the other components of the system
     * accordingly.
     *
     * The amount of cycles executed by the CPU is returned.
     * @returns {number}
     */ clock() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clock(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ clock_freq() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clock_freq(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {string}
     */ clock_freq_s() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.gameboy_clock_freq_s(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Risky function that will clock the CPU multiple times
     * allowing an undefined number of cycles to be executed
     * in the other Game Boy components.
     *
     * This can cause unwanted behaviour in components like
     * the PPU where only one mode switch operation is expected
     * per each clock call.
     *
     * At the end of this execution major synchronization issues
     * may arise, so use with caution.
     * @param {number} count
     * @returns {number}
     */ clock_many(count) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clock_many(this.__wbg_ptr, count);
        return ret;
    }
    /**
     * Function equivalent to [`clock()`][GameBoy::clock()] but that allows pre-emptive
     * breaking of the clock cycle loop if the PC (Program Counter)
     * reaches the provided address, making sure that in such a situation
     * the devices are not clocked.
     * @param {number} addr
     * @returns {number}
     */ clock_step(addr) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clock_step(this.__wbg_ptr, addr);
        return ret;
    }
    /**
     * Equivalent to [`clock()`][GameBoy::clock()] but allows the execution of multiple
     * clock operations in a single call.
     * @param {number} count
     * @returns {bigint}
     */ clocks(count) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clocks(this.__wbg_ptr, count);
        return BigInt.asUintN(64, ret);
    }
    /**
     * Clocks the emulator until the limit of cycles that has been
     * provided and returns the amount of cycles that have been
     * clocked.
     * @param {number} limit
     * @returns {bigint}
     */ clocks_cycles(limit) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clocks_cycles(this.__wbg_ptr, limit);
        return BigInt.asUintN(64, ret);
    }
    /**
     * Clocks the emulator until the limit of cycles that has been
     * provided and returns the amount of cycles that have been
     * clocked together with the frame buffer of the PPU.
     *
     * Allows a caller to clock the emulator and at the same time
     * retrieve the frame buffer of the PPU at the proper timing
     * (on V-Blank).
     *
     * This method allows for complex foreign call optimizations
     * by preventing the need to call the emulator clock multiple
     * times to obtain the right frame buffer retrieval timing.
     * @param {number} limit
     * @returns {ClockFrame}
     */ clocks_frame_buffer(limit) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_clocks_frame_buffer(this.__wbg_ptr, limit);
        return $796a66717a25f3ee$export$a564195ba20f9a9e.__wrap(ret);
    }
    /**
     * @returns {number}
     */ cpu_clock() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_cpu_clock(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} column_length
     * @returns {string}
     */ description(column_length) {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.gameboy_description(this.__wbg_ptr, column_length);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */ description_debug() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.gameboy_description_debug(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {number}
     */ display_height() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_display_height(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */ display_width() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_display_width(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} cycles
     */ dma_clock(cycles) {
        $796a66717a25f3ee$var$wasm.gameboy_dma_clock(this.__wbg_ptr, cycles);
    }
    /**
     * @returns {boolean}
     */ dma_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_dma_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {Uint8Array}
     */ frame_buffer_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_frame_buffer_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */ frame_buffer_raw_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_frame_buffer_raw_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Obtains the tile structure for the tile at the
     * given index, no conversion in the pixel buffer
     * is done so that the color reference is the GB one.
     * @param {number} index
     * @returns {Tile}
     */ get_tile(index) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_get_tile(this.__wbg_ptr, index);
        return $796a66717a25f3ee$export$235cb65c20ad2b7.__wrap(ret);
    }
    /**
     * Obtains the pixel buffer for the tile at the
     * provided index, converting the color buffer
     * using the currently loaded (background) palette.
     * @param {number} index
     * @returns {Uint8Array}
     */ get_tile_buffer(index) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_get_tile_buffer(this.__wbg_ptr, index);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {Uint8Array}
     */ hram_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_hram_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * Updates the emulation mode using the cartridge info
     * for the provided data to obtain the CGB flag value
     * and set the mode accordingly.
     *
     * This can be an expensive operation as it will require
     * cartridge data parsing to obtain the CGB flag.
     * It will also have to clone the data buffer.
     * @param {Uint8Array} data
     */ infer_mode_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.gameboy_infer_mode_wa(this.__wbg_ptr, ptr0, len0);
        if (ret[1]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @returns {boolean}
     */ is_cgb() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_is_cgb(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ is_dmg() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_is_dmg(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ is_sgb() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_is_sgb(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {PadKey} key
     */ key_lift(key) {
        $796a66717a25f3ee$var$wasm.gameboy_key_lift(this.__wbg_ptr, key);
    }
    /**
     * @param {PadKey} key
     */ key_press(key) {
        $796a66717a25f3ee$var$wasm.gameboy_key_press(this.__wbg_ptr, key);
    }
    /**
     * Loads the machine directly to after the boot execution state,
     * setting the state of the system accordingly and updating the
     * Program Counter (PC) to the post boot address (0x0100).
     *
     * Should allow the machine to jump to the cartridge (ROM) execution
     * directly, skipping the boot sequence.
     *
     * Currently supports only DMG machines.
     */ load_boot_state() {
        $796a66717a25f3ee$var$wasm.gameboy_load_boot_state(this.__wbg_ptr);
    }
    load_callbacks_wa() {
        $796a66717a25f3ee$var$wasm.gameboy_load_callbacks_wa(this.__wbg_ptr);
    }
    load_logger_wa() {
        $796a66717a25f3ee$var$wasm.gameboy_load_logger_wa(this.__wbg_ptr);
    }
    load_null_wa() {
        $796a66717a25f3ee$var$wasm.gameboy_load_null_wa(this.__wbg_ptr);
    }
    load_printer_wa() {
        $796a66717a25f3ee$var$wasm.gameboy_load_printer_wa(this.__wbg_ptr);
    }
    /**
     * @param {Uint8Array} data
     * @returns {Cartridge}
     */ load_rom_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.gameboy_load_rom_wa(this.__wbg_ptr, ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return $796a66717a25f3ee$export$dbc25efda8448299.__wrap(ret[0]);
    }
    /**
     * Unsafe load strategy that will panic the current system
     * in case there are boot ROM loading issues.
     * @param {boolean} boot
     */ load_unsafe(boot) {
        $796a66717a25f3ee$var$wasm.gameboy_load_unsafe(this.__wbg_ptr, boot);
    }
    /**
     * @returns {GameBoyMode}
     */ mode() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_mode(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ multiplier() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_multiplier(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {GameBoyMode | null} [mode]
     */ constructor(mode){
        const ret = $796a66717a25f3ee$var$wasm.gameboy_new($796a66717a25f3ee$var$isLikeNone(mode) ? 0 : mode);
        this.__wbg_ptr = ret;
        $796a66717a25f3ee$var$GameBoyFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Clocks the system until the next frame is reached and returns
     * the amount of cycles that have been clocked.
     *
     * This function is used to clock the system until the next frame
     * is reached and returns the amount of cycles that have been
     * clocked.
     * @returns {number}
     */ next_frame() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_next_frame(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} cycles
     */ ppu_clock(cycles) {
        $796a66717a25f3ee$var$wasm.gameboy_ppu_clock(this.__wbg_ptr, cycles);
    }
    /**
     * @returns {boolean}
     */ ppu_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ppu_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ ppu_frame() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ppu_frame(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ ppu_ly() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ppu_ly(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {PpuMode}
     */ ppu_mode() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ppu_mode(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Uint8Array}
     */ ram_data_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ram_data_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {RamSize}
     */ ram_size() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_ram_size(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {Registers}
     */ registers() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_registers(this.__wbg_ptr);
        return $796a66717a25f3ee$export$3a5bc9999b36d01d.__wrap(ret);
    }
    reload_wa() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_reload_wa(this.__wbg_ptr);
        if (ret[1]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * Resets the entire state of the Game Boy system,
     * including all its components and the CPU.
     *
     * This method ensures that the [`Ppu`], [`Apu`], [`Timer`],
     * [`Serial`], [`Mmu`], and [`Cpu`] are all reset to their initial states.
     */ reset() {
        $796a66717a25f3ee$var$wasm.gameboy_reset(this.__wbg_ptr);
    }
    /**
     * Resets all the cheats currently registered in the system.
     *
     * It clears both Game Genie and GameShark cheats from the
     * respective cheat managers.
     */ reset_cheats() {
        $796a66717a25f3ee$var$wasm.gameboy_reset_cheats(this.__wbg_ptr);
    }
    /**
     * @param {number} cycles
     */ serial_clock(cycles) {
        $796a66717a25f3ee$var$wasm.gameboy_serial_clock(this.__wbg_ptr, cycles);
    }
    /**
     * @returns {boolean}
     */ serial_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_serial_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {boolean} value
     */ set_all_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_all_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_apu_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_apu_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} enabled
     */ set_audio_ch1_enabled(enabled) {
        $796a66717a25f3ee$var$wasm.gameboy_set_audio_ch1_enabled(this.__wbg_ptr, enabled);
    }
    /**
     * @param {boolean} enabled
     */ set_audio_ch2_enabled(enabled) {
        $796a66717a25f3ee$var$wasm.gameboy_set_audio_ch2_enabled(this.__wbg_ptr, enabled);
    }
    /**
     * @param {boolean} enabled
     */ set_audio_ch3_enabled(enabled) {
        $796a66717a25f3ee$var$wasm.gameboy_set_audio_ch3_enabled(this.__wbg_ptr, enabled);
    }
    /**
     * @param {boolean} enabled
     */ set_audio_ch4_enabled(enabled) {
        $796a66717a25f3ee$var$wasm.gameboy_set_audio_ch4_enabled(this.__wbg_ptr, enabled);
    }
    /**
     * @param {number} mode
     */ set_audio_filter_mode_wa(mode) {
        $796a66717a25f3ee$var$wasm.gameboy_set_audio_filter_mode_wa(this.__wbg_ptr, mode);
    }
    /**
     * @param {BootRom} value
     */ set_boot_rom(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_boot_rom(this.__wbg_ptr, value);
    }
    /**
     * @param {number} value
     */ set_clock_freq(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_clock_freq(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_dma_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_dma_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {GameBoyMode} value
     */ set_mode(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_mode(this.__wbg_ptr, value);
    }
    /**
     * @param {any[]} value
     */ set_palette_colors_wa(value) {
        const ptr0 = $796a66717a25f3ee$var$passArrayJsValueToWasm0(value, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        $796a66717a25f3ee$var$wasm.gameboy_set_palette_colors_wa(this.__wbg_ptr, ptr0, len0);
    }
    static set_panic_hook_wa() {
        $796a66717a25f3ee$var$wasm.gameboy_set_panic_hook_wa();
    }
    /**
     * @param {boolean} value
     */ set_ppu_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_ppu_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {Uint8Array} ram_data
     */ set_ram_data(ram_data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(ram_data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        $796a66717a25f3ee$var$wasm.gameboy_set_ram_data(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @param {boolean} value
     */ set_serial_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_serial_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_timer_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboy_set_timer_enabled(this.__wbg_ptr, value);
    }
    /**
     * @returns {GameBoySpeed}
     */ speed() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_speed(this.__wbg_ptr);
        return ret;
    }
    /**
     * Clocks the system until the Program Counter (PC) reaches the
     * provided address and returns the amount of cycles that have been
     * clocked.
     *
     * This advances the emulation step by step, accumulating the number of
     * cycles spent until the CPU's PC matches `addr`. Useful for precise
     * debugging or driving the emulator to a known execution point.
     * @param {number} addr
     * @returns {number}
     */ step_to(addr) {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_step_to(this.__wbg_ptr, addr);
        return ret >>> 0;
    }
    /**
     * @param {number} cycles
     */ timer_clock(cycles) {
        $796a66717a25f3ee$var$wasm.gameboy_timer_clock(this.__wbg_ptr, cycles);
    }
    /**
     * @returns {boolean}
     */ timer_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_timer_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * Verifies if the provided data represents a valid Game Boy ROM.
     *
     * It is used to verify if the provided data is a valid ROM
     * before loading it into the Game Boy.
     * Preventing the loading of invalid ROMs into the Game Boy which
     * would cause the emulator to crash at runtime.
     *
     * This approach is not guaranteed to be 100% accurate, but it
     * is a good (enough) way to verify if the provided data is
     * a valid ROM.
     * @param {Uint8Array} data
     * @returns {boolean}
     */ static verify_rom(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.gameboy_verify_rom(ptr0, len0);
        return ret !== 0;
    }
    /**
     * @returns {Uint8Array}
     */ vram_eager() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_vram_eager(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @returns {RamSize}
     */ vram_size() {
        const ret = $796a66717a25f3ee$var$wasm.gameboy_vram_size(this.__wbg_ptr);
        return ret;
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$4da340665b18d90.prototype[Symbol.dispose] = $796a66717a25f3ee$export$4da340665b18d90.prototype.free;
class $796a66717a25f3ee$export$b7c8a48ed2af04d9 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$GameBoyConfigFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_gameboyconfig_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */ apu_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_apu_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {number}
     */ clock_freq() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_clock_freq(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {boolean}
     */ dma_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_dma_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ is_cgb() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_is_cgb(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ is_dmg() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_is_dmg(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ is_sgb() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_is_sgb(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {GameBoyMode}
     */ mode() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_mode(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {boolean}
     */ ppu_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_ppu_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */ serial_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_serial_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {boolean} value
     */ set_apu_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_apu_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {number} value
     */ set_clock_freq(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_clock_freq(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_dma_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_dma_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {GameBoyMode} value
     */ set_mode(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_mode(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_ppu_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_ppu_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_serial_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_serial_enabled(this.__wbg_ptr, value);
    }
    /**
     * @param {boolean} value
     */ set_timer_enabled(value) {
        $796a66717a25f3ee$var$wasm.gameboyconfig_set_timer_enabled(this.__wbg_ptr, value);
    }
    /**
     * @returns {boolean}
     */ timer_enabled() {
        const ret = $796a66717a25f3ee$var$wasm.gameboyconfig_timer_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$b7c8a48ed2af04d9.prototype[Symbol.dispose] = $796a66717a25f3ee$export$b7c8a48ed2af04d9.prototype.free;
const $796a66717a25f3ee$export$5edab71e65ab5626 = Object.freeze({
    Cpu: 0,
    "0": "Cpu",
    Mmu: 1,
    "1": "Mmu",
    Ppu: 3,
    "3": "Ppu",
    Apu: 4,
    "4": "Apu",
    Dma: 5,
    "5": "Dma",
    Pad: 6,
    "6": "Pad",
    Timer: 7,
    "7": "Timer",
    Serial: 8,
    "8": "Serial",
    Unknown: 100,
    "100": "Unknown"
});
const $796a66717a25f3ee$export$5694d6c89ba78dab = Object.freeze({
    Dmg: 1,
    "1": "Dmg",
    Cgb: 2,
    "2": "Cgb",
    Sgb: 3,
    "3": "Sgb"
});
const $796a66717a25f3ee$export$3cd536aab18fb47d = Object.freeze({
    Normal: 0,
    "0": "Normal",
    Double: 1,
    "1": "Double"
});
class $796a66717a25f3ee$export$bb4b220708807778 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$GameGenieFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_gamegenie_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$bb4b220708807778.prototype[Symbol.dispose] = $796a66717a25f3ee$export$bb4b220708807778.prototype.free;
class $796a66717a25f3ee$export$8bb44588d42d9a6e {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$GameSharkFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_gameshark_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$8bb44588d42d9a6e.prototype[Symbol.dispose] = $796a66717a25f3ee$export$8bb44588d42d9a6e.prototype.free;
class $796a66717a25f3ee$export$c4868e4a24d48fad {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$InfoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_info_free(ptr, 0);
    }
    /**
     * @returns {string}
     */ static compilation_date() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_compilation_date();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */ static compilation_time() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_compilation_time();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the name of the compiler that has been
     * used in the compilation of the base Boytacean
     * library. Can be used for diagnostics.
     * @returns {string}
     */ static compiler() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_compiler();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */ static compiler_version() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_compiler_version();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the name of the emulator.
     * @returns {string}
     */ static name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_name();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the name of the emulator in lowercase.
     * Useful for file paths and other cases where.
     * @returns {string}
     */ static name_lower() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_name_lower();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the system this emulator is emulating.
     * @returns {string}
     */ static system() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_system();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Obtains the version of the emulator.
     * @returns {string}
     */ static version() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $796a66717a25f3ee$var$wasm.info_version();
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string | undefined}
     */ static wasm_engine() {
        const ret = $796a66717a25f3ee$var$wasm.info_wasm_engine();
        let v1;
        if (ret[0] !== 0) {
            v1 = $796a66717a25f3ee$var$getStringFromWasm0(ret[0], ret[1]).slice();
            $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$c4868e4a24d48fad.prototype[Symbol.dispose] = $796a66717a25f3ee$export$c4868e4a24d48fad.prototype.free;
const $796a66717a25f3ee$export$e797150f37843f50 = Object.freeze({
    Unknown: 0,
    "0": "Unknown",
    None: 1,
    "1": "None",
    Nintendo: 2,
    "2": "Nintendo",
    Capcom: 3,
    "3": "Capcom",
    HOTB: 4,
    "4": "HOTB",
    Jaleco: 5,
    "5": "Jaleco",
    CoconutsJapan: 6,
    "6": "CoconutsJapan",
    EliteSystems: 7,
    "7": "EliteSystems",
    EAElectronicArts: 8,
    "8": "EAElectronicArts",
    HudsonSoft: 9,
    "9": "HudsonSoft",
    ITCEntertainment: 10,
    "10": "ITCEntertainment",
    Yanoman: 11,
    "11": "Yanoman",
    JapanClary: 12,
    "12": "JapanClary",
    VirginGamesLtd: 13,
    "13": "VirginGamesLtd",
    PCMComplete: 14,
    "14": "PCMComplete",
    SanX: 15,
    "15": "SanX",
    Kemco: 16,
    "16": "Kemco",
    SETACorporation: 17,
    "17": "SETACorporation",
    Infogrames: 18,
    "18": "Infogrames",
    Bandai: 19,
    "19": "Bandai",
    NewLicensee: 20,
    "20": "NewLicensee",
    Konami: 21,
    "21": "Konami",
    HectorSoft: 22,
    "22": "HectorSoft",
    Banpresto: 23,
    "23": "Banpresto",
    EntertainmentI: 24,
    "24": "EntertainmentI",
    Gremlin: 25,
    "25": "Gremlin",
    UbiSoft: 26,
    "26": "UbiSoft",
    Atlus: 27,
    "27": "Atlus",
    MalibuInteractive: 28,
    "28": "MalibuInteractive",
    Angel: 29,
    "29": "Angel",
    SpectrumHoloby: 30,
    "30": "SpectrumHoloby",
    Irem: 31,
    "31": "Irem",
    USGold: 32,
    "32": "USGold",
    Absolute: 33,
    "33": "Absolute",
    AcclaimEntertainment: 34,
    "34": "AcclaimEntertainment",
    Activision: 35,
    "35": "Activision",
    SammyUSACorporation: 36,
    "36": "SammyUSACorporation",
    GameTek: 37,
    "37": "GameTek",
    ParkPlace: 38,
    "38": "ParkPlace",
    LJN: 39,
    "39": "LJN",
    Matchbox: 40,
    "40": "Matchbox",
    MiltonBradleyCompany: 41,
    "41": "MiltonBradleyCompany",
    Mindscape: 42,
    "42": "Mindscape",
    Romstar: 43,
    "43": "Romstar",
    NaxatSoft: 44,
    "44": "NaxatSoft",
    Tradewest: 45,
    "45": "Tradewest",
    TitusInteractive: 46,
    "46": "TitusInteractive",
    OceanSoftware: 47,
    "47": "OceanSoftware",
    EliteSystems2: 48,
    "48": "EliteSystems2",
    ElectroBrain: 49,
    "49": "ElectroBrain",
    InterplayEntertainment: 50,
    "50": "InterplayEntertainment",
    Broderbund: 51,
    "51": "Broderbund",
    SculpturedSoftware: 52,
    "52": "SculpturedSoftware",
    TheSalesCurveLimited: 53,
    "53": "TheSalesCurveLimited",
    THQ: 54,
    "54": "THQ",
    Accolade: 55,
    "55": "Accolade",
    TriffixEntertainment: 56,
    "56": "TriffixEntertainment",
    Microprose: 57,
    "57": "Microprose",
    MisawaEntertainment: 58,
    "58": "MisawaEntertainment",
    Lozc: 59,
    "59": "Lozc",
    TokumaShoten: 60,
    "60": "TokumaShoten",
    BulletProofSoftware: 61,
    "61": "BulletProofSoftware",
    VicTokai: 62,
    "62": "VicTokai",
    Ape: 63,
    "63": "Ape",
    IMax: 64,
    "64": "IMax",
    Chunsoft: 65,
    "65": "Chunsoft",
    VideoSystem: 66,
    "66": "VideoSystem",
    TsubarayaProductions: 67,
    "67": "TsubarayaProductions",
    Varie: 68,
    "68": "Varie",
    YonezawaSpal: 69,
    "69": "YonezawaSpal",
    Arc: 70,
    "70": "Arc",
    NihonBussan: 71,
    "71": "NihonBussan",
    Tecmo: 72,
    "72": "Tecmo",
    Imagineer: 73,
    "73": "Imagineer",
    Nova: 74,
    "74": "Nova",
    HoriElectric: 75,
    "75": "HoriElectric",
    Kawada: 76,
    "76": "Kawada",
    Takara: 77,
    "77": "Takara",
    TechnosJapan: 78,
    "78": "TechnosJapan",
    ToeiAnimation: 79,
    "79": "ToeiAnimation",
    Toho: 80,
    "80": "Toho",
    Namco: 81,
    "81": "Namco",
    ASCIICorporationOrNexsoft: 82,
    "82": "ASCIICorporationOrNexsoft",
    SquareEnix: 83,
    "83": "SquareEnix",
    HALLaboratory: 84,
    "84": "HALLaboratory",
    SNK: 85,
    "85": "SNK",
    PonyCanyon: 86,
    "86": "PonyCanyon",
    CultureBrain: 87,
    "87": "CultureBrain",
    Sunsoft: 88,
    "88": "Sunsoft",
    SonyImagesoft: 89,
    "89": "SonyImagesoft",
    SammyCorporation: 90,
    "90": "SammyCorporation",
    Taito: 91,
    "91": "Taito",
    Square: 92,
    "92": "Square",
    DataEast: 93,
    "93": "DataEast",
    Tonkinhouse: 94,
    "94": "Tonkinhouse",
    Koei: 95,
    "95": "Koei",
    UFL: 96,
    "96": "UFL",
    Ultra: 97,
    "97": "Ultra",
    Vap: 98,
    "98": "Vap",
    UseCorporation: 99,
    "99": "UseCorporation",
    Meldac: 100,
    "100": "Meldac",
    PoneyCanyon: 101,
    "101": "PoneyCanyon",
    Sofel: 102,
    "102": "Sofel",
    Quest: 103,
    "103": "Quest",
    SigmaEnterprises: 104,
    "104": "SigmaEnterprises",
    ASKKodanshaCo: 105,
    "105": "ASKKodanshaCo",
    CopyaSystem: 106,
    "106": "CopyaSystem",
    Tomy: 107,
    "107": "Tomy",
    NCS: 108,
    "108": "NCS",
    Human: 109,
    "109": "Human",
    Altron: 110,
    "110": "Altron",
    TowaChiki: 111,
    "111": "TowaChiki",
    Yutaka: 112,
    "112": "Yutaka",
    Epcoh: 113,
    "113": "Epcoh",
    Athena: 114,
    "114": "Athena",
    AsmikAceEntertainment: 115,
    "115": "AsmikAceEntertainment",
    Natsume: 116,
    "116": "Natsume",
    KingRecords: 117,
    "117": "KingRecords",
    EpicSonyRecords: 118,
    "118": "EpicSonyRecords",
    IGS: 119,
    "119": "IGS",
    AWave: 120,
    "120": "AWave",
    ExtremeEntertainment: 121,
    "121": "ExtremeEntertainment",
    NintendoResearchDevelopment1: 122,
    "122": "NintendoResearchDevelopment1",
    BAI: 123,
    "123": "BAI",
    KSS: 124,
    "124": "KSS",
    PlanningOfficeWADA: 125,
    "125": "PlanningOfficeWADA",
    Viacom: 126,
    "126": "Viacom",
    HiTechExpressions: 127,
    "127": "HiTechExpressions",
    Mattel: 128,
    "128": "Mattel",
    LucasfilmGames: 129,
    "129": "LucasfilmGames",
    TsukudaOriginal: 130,
    "130": "TsukudaOriginal",
    ChunsoftCo: 131,
    "131": "ChunsoftCo",
    OceanSoftwareAcclaimEntertainment: 132,
    "132": "OceanSoftwareAcclaimEntertainment",
    Kaneko: 133,
    "133": "Kaneko",
    PackInVideo: 134,
    "134": "PackInVideo",
    BottomUp: 135,
    "135": "BottomUp",
    KonamiYuGiOh: 136,
    "136": "KonamiYuGiOh",
    MTO: 137,
    "137": "MTO",
    Kodansha: 138,
    "138": "Kodansha"
});
const $796a66717a25f3ee$export$5852b69c25bf0aca = Object.freeze({
    NoMbc: 0,
    "0": "NoMbc",
    Mbc1: 1,
    "1": "Mbc1",
    Mbc2: 2,
    "2": "Mbc2",
    Mbc3: 3,
    "3": "Mbc3",
    Mbc5: 4,
    "4": "Mbc5",
    Mbc6: 5,
    "5": "Mbc6",
    Mbc7: 6,
    "6": "Mbc7",
    Unknown: 7,
    "7": "Unknown"
});
class $796a66717a25f3ee$export$2984ca2c52e07410 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$ObjectDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_objectdata_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$2984ca2c52e07410.prototype[Symbol.dispose] = $796a66717a25f3ee$export$2984ca2c52e07410.prototype.free;
const $796a66717a25f3ee$export$9d3c08039c4aa2b1 = Object.freeze({
    Up: 0,
    "0": "Up",
    Down: 1,
    "1": "Down",
    Left: 2,
    "2": "Left",
    Right: 3,
    "3": "Right",
    Start: 4,
    "4": "Start",
    Select: 5,
    "5": "Select",
    A: 6,
    "6": "A",
    B: 7,
    "7": "B"
});
class $796a66717a25f3ee$export$d580c76fe1354004 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$PaletteInfoFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_paletteinfo_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$d580c76fe1354004.prototype[Symbol.dispose] = $796a66717a25f3ee$export$d580c76fe1354004.prototype.free;
const $796a66717a25f3ee$export$733beca1b1011b27 = Object.freeze({
    HBlank: 0,
    "0": "HBlank",
    VBlank: 1,
    "1": "VBlank",
    OamRead: 2,
    "2": "OamRead",
    VramRead: 3,
    "3": "VramRead"
});
const $796a66717a25f3ee$export$61b7b771a48a19f1 = Object.freeze({
    NoRam: 0,
    "0": "NoRam",
    Unused: 1,
    "1": "Unused",
    Size8K: 2,
    "2": "Size8K",
    Size16K: 3,
    "3": "Size16K",
    Size32K: 4,
    "4": "Size32K",
    Size64K: 5,
    "5": "Size64K",
    Size128K: 6,
    "6": "Size128K",
    SizeUnknown: 7,
    "7": "SizeUnknown"
});
const $796a66717a25f3ee$export$b1f97c3099fc6872 = Object.freeze({
    World: 0,
    "0": "World",
    Japan: 1,
    "1": "Japan",
    USA: 2,
    "2": "USA",
    Europe: 3,
    "3": "Europe",
    Spain: 4,
    "4": "Spain",
    Italy: 5,
    "5": "Italy",
    France: 6,
    "6": "France",
    Germany: 7,
    "7": "Germany",
    Korean: 8,
    "8": "Korean",
    Australia: 9,
    "9": "Australia",
    Unknown: 10,
    "10": "Unknown"
});
class $796a66717a25f3ee$export$3a5bc9999b36d01d {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$3a5bc9999b36d01d.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$RegistersFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$RegistersFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_registers_free(ptr, 0);
    }
    /**
     * @returns {number}
     */ get a() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_a(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get b() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_b(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get c() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_c(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get d() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_d(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get e() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_e(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get h() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_h(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get l() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_l(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get ly() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_ly(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get lyc() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_lyc(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get pc() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_pc(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get scx() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_scx(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get scy() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_scy(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get sp() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_sp(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get wx() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_wx(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {number}
     */ get wy() {
        const ret = $796a66717a25f3ee$var$wasm.__wbg_get_registers_wy(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */ set a(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_a(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set b(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_b(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set c(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_c(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set d(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_d(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set e(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_e(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set h(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_h(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set l(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_l(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set ly(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_ly(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set lyc(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_lyc(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set pc(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_pc(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set scx(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_scx(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set scy(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_scy(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set sp(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_sp(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set wx(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_wx(this.__wbg_ptr, arg0);
    }
    /**
     * @param {number} arg0
     */ set wy(arg0) {
        $796a66717a25f3ee$var$wasm.__wbg_set_registers_wy(this.__wbg_ptr, arg0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$3a5bc9999b36d01d.prototype[Symbol.dispose] = $796a66717a25f3ee$export$3a5bc9999b36d01d.prototype.free;
const $796a66717a25f3ee$export$75e0c3fcb86c5578 = Object.freeze({
    Size32K: 0,
    "0": "Size32K",
    Size64K: 1,
    "1": "Size64K",
    Size128K: 2,
    "2": "Size128K",
    Size256K: 3,
    "3": "Size256K",
    Size512K: 4,
    "4": "Size512K",
    Size1M: 5,
    "5": "Size1M",
    Size2M: 6,
    "6": "Size2M",
    Size4M: 7,
    "7": "Size4M",
    Size8M: 8,
    "8": "Size8M",
    SizeUnknown: 9,
    "9": "SizeUnknown"
});
const $796a66717a25f3ee$export$1deeb67e57aee1b0 = Object.freeze({
    RomOnly: 0,
    "0": "RomOnly",
    Mbc1: 1,
    "1": "Mbc1",
    Mbc1Ram: 2,
    "2": "Mbc1Ram",
    Mbc1RamBattery: 3,
    "3": "Mbc1RamBattery",
    Mbc2: 5,
    "5": "Mbc2",
    Mbc2Battery: 6,
    "6": "Mbc2Battery",
    RomRam: 8,
    "8": "RomRam",
    RomRamBattery: 9,
    "9": "RomRamBattery",
    Mmm01: 11,
    "11": "Mmm01",
    Mmm01Ram: 12,
    "12": "Mmm01Ram",
    Mmm01RamBattery: 13,
    "13": "Mmm01RamBattery",
    Mbc3TimerBattery: 15,
    "15": "Mbc3TimerBattery",
    Mbc3TimerRamBattery: 16,
    "16": "Mbc3TimerRamBattery",
    Mbc3: 17,
    "17": "Mbc3",
    Mbc3Ram: 18,
    "18": "Mbc3Ram",
    Mbc3RamBattery: 19,
    "19": "Mbc3RamBattery",
    Mbc5: 25,
    "25": "Mbc5",
    Mbc5Ram: 26,
    "26": "Mbc5Ram",
    Mbc5RamBattery: 27,
    "27": "Mbc5RamBattery",
    Mbc5Rumble: 28,
    "28": "Mbc5Rumble",
    Mbc5RumbleRam: 29,
    "29": "Mbc5RumbleRam",
    Mbc5RumbleRamBattery: 30,
    "30": "Mbc5RumbleRamBattery",
    Mbc6: 32,
    "32": "Mbc6",
    Mbc7SensorRumbleRamBattery: 34,
    "34": "Mbc7SensorRumbleRamBattery",
    PocketCamera: 252,
    "252": "PocketCamera",
    BandaiTama5: 253,
    "253": "BandaiTama5",
    HuC3: 254,
    "254": "HuC3",
    HuC1RamBattery: 255,
    "255": "HuC1RamBattery",
    Unknown: 239,
    "239": "Unknown"
});
const $796a66717a25f3ee$export$32a80ba62f2420fa = Object.freeze({
    /**
     * Boytacean Save Compressed format (BOSC).
     *
     * This format uses the Zippy compression algorithm
     * to compress the underlying BOS contents.
     *
     * The BOSC format is the default format for the
     * save state.
     *
     * Using a compressed file format means that BESS out-of-the
     * box compatibility is not possible.
     */ Bosc: 1,
    "1": "Bosc",
    /**
     * Boytacean Save format (uncompressed) (BOS).
     *
     * This format is the uncompressed version of the
     * BOSC format.
     *
     * Using an uncompressed file format means that BESS
     * out-of-the box compatibility is possible.
     */ Bos: 2,
    "2": "Bos",
    /**
     * Best Effort Save State format (BESS).
     *
     * This is an abstract payload opaque format created
     * by the same people of Sameboy.
     */ Bess: 3,
    "3": "Bess"
});
const $796a66717a25f3ee$export$5e231d7d49dad7f8 = Object.freeze({
    NoSgb: 0,
    "0": "NoSgb",
    SgbFunctions: 3,
    "3": "SgbFunctions"
});
const $796a66717a25f3ee$export$8a162aefb823ffcc = Object.freeze({
    /**
     * Minimal state format, meaning that only the most basic
     * elements of the component will be stored and retrieved.
     */ Minimal: 1,
    "1": "Minimal",
    /**
     * Partial state format, meaning that only the essential
     * elements of the component will be stored and retrieved.
     * All the remaining data, should inferred or computed.
     */ Partial: 2,
    "2": "Partial",
    /**
     * Full state format, meaning that every single element
     * of the component will be stored and retrieved. This
     * should included redundant and calculated data.
     */ Full: 3,
    "3": "Full"
});
class $796a66717a25f3ee$export$4d5c8163a511d38a {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$StateManagerFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_statemanager_free(ptr, 0);
    }
    /**
     * @param {Uint8Array} data
     * @returns {string}
     */ static format_str_wa(data) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
            const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
            const ret = $796a66717a25f3ee$var$wasm.statemanager_format_str_wa(ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0;
                len2 = 0;
                throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return $796a66717a25f3ee$var$getStringFromWasm0(ptr2, len2);
        } finally{
            $796a66717a25f3ee$var$wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * @param {Uint8Array} data
     * @returns {SaveStateFormat}
     */ static format_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_format_wa(ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return ret[0];
    }
    /**
     * @param {Uint8Array} data
     * @param {GameBoy} gb
     * @param {SaveStateFormat | null} [format]
     * @param {ToGbOptions | null} [options]
     */ static load_wa(data, gb, format, options) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        $796a66717a25f3ee$var$_assertClass(gb, $796a66717a25f3ee$export$4da340665b18d90);
        let ptr1 = 0;
        if (!$796a66717a25f3ee$var$isLikeNone(options)) {
            $796a66717a25f3ee$var$_assertClass(options, $796a66717a25f3ee$export$69d12c518f92aec6);
            ptr1 = options.__destroy_into_raw();
        }
        const ret = $796a66717a25f3ee$var$wasm.statemanager_load_wa(ptr0, len0, gb.__wbg_ptr, $796a66717a25f3ee$var$isLikeNone(format) ? 0 : format, ptr1);
        if (ret[1]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[0]);
    }
    /**
     * @param {Uint8Array} data
     * @returns {BessState}
     */ static read_bess_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_read_bess_wa(ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return $796a66717a25f3ee$export$103f9e68d146c6c.__wrap(ret[0]);
    }
    /**
     * @param {Uint8Array} data
     * @returns {BosState}
     */ static read_bos_auto_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_read_bos_auto_wa(ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return $796a66717a25f3ee$export$b7ac99645321b5f9.__wrap(ret[0]);
    }
    /**
     * @param {Uint8Array} data
     * @returns {BosState}
     */ static read_bos_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_read_bos_wa(ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return $796a66717a25f3ee$export$b7ac99645321b5f9.__wrap(ret[0]);
    }
    /**
     * @param {Uint8Array} data
     * @returns {BoscState}
     */ static read_bosc_wa(data) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_read_bosc_wa(ptr0, len0);
        if (ret[2]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[1]);
        return $796a66717a25f3ee$export$af807f7dbba0e4c5.__wrap(ret[0]);
    }
    /**
     * @param {GameBoy} gb
     * @param {SaveStateFormat | null} [format]
     * @param {FromGbOptions | null} [options]
     * @returns {Uint8Array}
     */ static save_wa(gb, format, options) {
        $796a66717a25f3ee$var$_assertClass(gb, $796a66717a25f3ee$export$4da340665b18d90);
        let ptr0 = 0;
        if (!$796a66717a25f3ee$var$isLikeNone(options)) {
            $796a66717a25f3ee$var$_assertClass(options, $796a66717a25f3ee$export$bbbb570a7e306505);
            ptr0 = options.__destroy_into_raw();
        }
        const ret = $796a66717a25f3ee$var$wasm.statemanager_save_wa(gb.__wbg_ptr, $796a66717a25f3ee$var$isLikeNone(format) ? 0 : format, ptr0);
        if (ret[3]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
        var v2 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v2;
    }
    /**
     * @param {Uint8Array} data
     * @param {SaveStateFormat | null} [format]
     * @returns {Uint8Array}
     */ static thumbnail_wa(data, format) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_thumbnail_wa(ptr0, len0, $796a66717a25f3ee$var$isLikeNone(format) ? 0 : format);
        if (ret[3]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[2]);
        var v2 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v2;
    }
    /**
     * @param {Uint8Array} data
     * @param {string | null} [title]
     */ static validate_wa(data, title) {
        const ptr0 = $796a66717a25f3ee$var$passArray8ToWasm0(data, $796a66717a25f3ee$var$wasm.__wbindgen_malloc);
        const len0 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        var ptr1 = $796a66717a25f3ee$var$isLikeNone(title) ? 0 : $796a66717a25f3ee$var$passStringToWasm0(title, $796a66717a25f3ee$var$wasm.__wbindgen_malloc, $796a66717a25f3ee$var$wasm.__wbindgen_realloc);
        var len1 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
        const ret = $796a66717a25f3ee$var$wasm.statemanager_validate_wa(ptr0, len0, ptr1, len1);
        if (ret[1]) throw $796a66717a25f3ee$var$takeFromExternrefTable0(ret[0]);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$4d5c8163a511d38a.prototype[Symbol.dispose] = $796a66717a25f3ee$export$4d5c8163a511d38a.prototype.free;
class $796a66717a25f3ee$export$235cb65c20ad2b7 {
    static __wrap(ptr) {
        const obj = Object.create($796a66717a25f3ee$export$235cb65c20ad2b7.prototype);
        obj.__wbg_ptr = ptr;
        $796a66717a25f3ee$var$TileFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$TileFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_tile_free(ptr, 0);
    }
    /**
     * @returns {Uint8Array}
     */ buffer() {
        const ret = $796a66717a25f3ee$var$wasm.tile_buffer(this.__wbg_ptr);
        var v1 = $796a66717a25f3ee$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $796a66717a25f3ee$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v1;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @returns {number}
     */ get(x, y) {
        const ret = $796a66717a25f3ee$var$wasm.tile_get(this.__wbg_ptr, x, y);
        return ret;
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {boolean} xflip
     * @param {boolean} yflip
     * @returns {number}
     */ get_flipped(x, y, xflip, yflip) {
        const ret = $796a66717a25f3ee$var$wasm.tile_get_flipped(this.__wbg_ptr, x, y, xflip, yflip);
        return ret;
    }
    /**
     * @returns {Tile}
     */ static new() {
        const ret = $796a66717a25f3ee$var$wasm.tile_new();
        return $796a66717a25f3ee$export$235cb65c20ad2b7.__wrap(ret);
    }
    /**
     * @param {number} x
     * @param {number} y
     * @param {number} value
     */ set(x, y, value) {
        $796a66717a25f3ee$var$wasm.tile_set(this.__wbg_ptr, x, y, value);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$235cb65c20ad2b7.prototype[Symbol.dispose] = $796a66717a25f3ee$export$235cb65c20ad2b7.prototype.free;
class $796a66717a25f3ee$export$bdf2cc4152119afa {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$TileDataFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_tiledata_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$bdf2cc4152119afa.prototype[Symbol.dispose] = $796a66717a25f3ee$export$bdf2cc4152119afa.prototype.free;
class $796a66717a25f3ee$export$69d12c518f92aec6 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $796a66717a25f3ee$var$ToGbOptionsFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $796a66717a25f3ee$var$wasm.__wbg_togboptions_free(ptr, 0);
    }
}
if (Symbol.dispose) $796a66717a25f3ee$export$69d12c518f92aec6.prototype[Symbol.dispose] = $796a66717a25f3ee$export$69d12c518f92aec6.prototype.free;
function $796a66717a25f3ee$export$fc00ee57782020aa() {
    const ret = $796a66717a25f3ee$var$wasm.timestamp();
    return BigInt.asUintN(64, ret);
}
function $796a66717a25f3ee$var$__wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_string_get_b0ca35b86a603356: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'string' ? obj : undefined;
            var ptr1 = $796a66717a25f3ee$var$isLikeNone(ret) ? 0 : $796a66717a25f3ee$var$passStringToWasm0(ret, $796a66717a25f3ee$var$wasm.__wbindgen_malloc, $796a66717a25f3ee$var$wasm.__wbindgen_realloc);
            var len1 = $796a66717a25f3ee$var$WASM_VECTOR_LEN;
            $796a66717a25f3ee$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $796a66717a25f3ee$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_throw_344f42d3211c4765: function(arg0, arg1) {
            throw new Error($796a66717a25f3ee$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg_loggerCallback_38bf5613a6679d69: function(arg0, arg1) {
            var v0 = $796a66717a25f3ee$var$getArrayU8FromWasm0(arg0, arg1).slice();
            $796a66717a25f3ee$var$wasm.__wbindgen_free(arg0, arg1 * 1, 1);
            window.loggerCallback(v0);
        },
        __wbg_now_86c0d4ba3fa605b8: function() {
            const ret = Date.now();
            return ret;
        },
        __wbg_panic_1e209e0d163f1a45: function(arg0, arg1) {
            window.panic($796a66717a25f3ee$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg_printerCallback_8507a423ee98ee22: function(arg0, arg1) {
            var v0 = $796a66717a25f3ee$var$getArrayU8FromWasm0(arg0, arg1).slice();
            $796a66717a25f3ee$var$wasm.__wbindgen_free(arg0, arg1 * 1, 1);
            window.printerCallback(v0);
        },
        __wbg_rumbleCallback_02bd409cabb0e2ad: function(arg0) {
            window.rumbleCallback(arg0 !== 0);
        },
        __wbg_speedCallback_3110c9e1ae69aca7: function(arg0) {
            window.speedCallback(arg0);
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = $796a66717a25f3ee$var$getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = $796a66717a25f3ee$var$wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        }
    };
    return {
        __proto__: null,
        "./boytacean_bg.js": import0
    };
}
const $796a66717a25f3ee$var$BessStateFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_bessstate_free(ptr, 1));
const $796a66717a25f3ee$var$BosStateFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_bosstate_free(ptr, 1));
const $796a66717a25f3ee$var$BoscStateFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_boscstate_free(ptr, 1));
const $796a66717a25f3ee$var$CartridgeFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_cartridge_free(ptr, 1));
const $796a66717a25f3ee$var$ClockFrameFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_clockframe_free(ptr, 1));
const $796a66717a25f3ee$var$FromGbOptionsFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_fromgboptions_free(ptr, 1));
const $796a66717a25f3ee$var$GameBoyFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_gameboy_free(ptr, 1));
const $796a66717a25f3ee$var$GameBoyConfigFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_gameboyconfig_free(ptr, 1));
const $796a66717a25f3ee$var$GameGenieFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_gamegenie_free(ptr, 1));
const $796a66717a25f3ee$var$GameSharkFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_gameshark_free(ptr, 1));
const $796a66717a25f3ee$var$InfoFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_info_free(ptr, 1));
const $796a66717a25f3ee$var$ObjectDataFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_objectdata_free(ptr, 1));
const $796a66717a25f3ee$var$PaletteInfoFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_paletteinfo_free(ptr, 1));
const $796a66717a25f3ee$var$RegistersFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_registers_free(ptr, 1));
const $796a66717a25f3ee$var$StateManagerFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_statemanager_free(ptr, 1));
const $796a66717a25f3ee$var$TileFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_tile_free(ptr, 1));
const $796a66717a25f3ee$var$TileDataFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_tiledata_free(ptr, 1));
const $796a66717a25f3ee$var$ToGbOptionsFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$796a66717a25f3ee$var$wasm.__wbg_togboptions_free(ptr, 1));
function $796a66717a25f3ee$var$addToExternrefTable0(obj) {
    const idx = $796a66717a25f3ee$var$wasm.__externref_table_alloc();
    $796a66717a25f3ee$var$wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}
function $796a66717a25f3ee$var$_assertClass(instance, klass) {
    if (!(instance instanceof klass)) throw new Error(`expected instance of ${klass.name}`);
}
function $796a66717a25f3ee$var$getArrayI16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $796a66717a25f3ee$var$getInt16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}
function $796a66717a25f3ee$var$getArrayU16FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $796a66717a25f3ee$var$getUint16ArrayMemory0().subarray(ptr / 2, ptr / 2 + len);
}
function $796a66717a25f3ee$var$getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $796a66717a25f3ee$var$getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}
let $796a66717a25f3ee$var$cachedDataViewMemory0 = null;
function $796a66717a25f3ee$var$getDataViewMemory0() {
    if ($796a66717a25f3ee$var$cachedDataViewMemory0 === null || $796a66717a25f3ee$var$cachedDataViewMemory0.buffer.detached === true || $796a66717a25f3ee$var$cachedDataViewMemory0.buffer.detached === undefined && $796a66717a25f3ee$var$cachedDataViewMemory0.buffer !== $796a66717a25f3ee$var$wasm.memory.buffer) $796a66717a25f3ee$var$cachedDataViewMemory0 = new DataView($796a66717a25f3ee$var$wasm.memory.buffer);
    return $796a66717a25f3ee$var$cachedDataViewMemory0;
}
let $796a66717a25f3ee$var$cachedInt16ArrayMemory0 = null;
function $796a66717a25f3ee$var$getInt16ArrayMemory0() {
    if ($796a66717a25f3ee$var$cachedInt16ArrayMemory0 === null || $796a66717a25f3ee$var$cachedInt16ArrayMemory0.byteLength === 0) $796a66717a25f3ee$var$cachedInt16ArrayMemory0 = new Int16Array($796a66717a25f3ee$var$wasm.memory.buffer);
    return $796a66717a25f3ee$var$cachedInt16ArrayMemory0;
}
function $796a66717a25f3ee$var$getStringFromWasm0(ptr, len) {
    return $796a66717a25f3ee$var$decodeText(ptr >>> 0, len);
}
let $796a66717a25f3ee$var$cachedUint16ArrayMemory0 = null;
function $796a66717a25f3ee$var$getUint16ArrayMemory0() {
    if ($796a66717a25f3ee$var$cachedUint16ArrayMemory0 === null || $796a66717a25f3ee$var$cachedUint16ArrayMemory0.byteLength === 0) $796a66717a25f3ee$var$cachedUint16ArrayMemory0 = new Uint16Array($796a66717a25f3ee$var$wasm.memory.buffer);
    return $796a66717a25f3ee$var$cachedUint16ArrayMemory0;
}
let $796a66717a25f3ee$var$cachedUint8ArrayMemory0 = null;
function $796a66717a25f3ee$var$getUint8ArrayMemory0() {
    if ($796a66717a25f3ee$var$cachedUint8ArrayMemory0 === null || $796a66717a25f3ee$var$cachedUint8ArrayMemory0.byteLength === 0) $796a66717a25f3ee$var$cachedUint8ArrayMemory0 = new Uint8Array($796a66717a25f3ee$var$wasm.memory.buffer);
    return $796a66717a25f3ee$var$cachedUint8ArrayMemory0;
}
function $796a66717a25f3ee$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $796a66717a25f3ee$var$passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    $796a66717a25f3ee$var$getUint8ArrayMemory0().set(arg, ptr / 1);
    $796a66717a25f3ee$var$WASM_VECTOR_LEN = arg.length;
    return ptr;
}
function $796a66717a25f3ee$var$passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for(let i = 0; i < array.length; i++){
        const add = $796a66717a25f3ee$var$addToExternrefTable0(array[i]);
        $796a66717a25f3ee$var$getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    $796a66717a25f3ee$var$WASM_VECTOR_LEN = array.length;
    return ptr;
}
function $796a66717a25f3ee$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $796a66717a25f3ee$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $796a66717a25f3ee$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $796a66717a25f3ee$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $796a66717a25f3ee$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $796a66717a25f3ee$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $796a66717a25f3ee$var$cachedTextEncoder.encodeInto(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $796a66717a25f3ee$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
function $796a66717a25f3ee$var$takeFromExternrefTable0(idx) {
    const value = $796a66717a25f3ee$var$wasm.__wbindgen_externrefs.get(idx);
    $796a66717a25f3ee$var$wasm.__externref_table_dealloc(idx);
    return value;
}
let $796a66717a25f3ee$var$cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
});
$796a66717a25f3ee$var$cachedTextDecoder.decode();
const $796a66717a25f3ee$var$MAX_SAFARI_DECODE_BYTES = 2146435072;
let $796a66717a25f3ee$var$numBytesDecoded = 0;
function $796a66717a25f3ee$var$decodeText(ptr, len) {
    $796a66717a25f3ee$var$numBytesDecoded += len;
    if ($796a66717a25f3ee$var$numBytesDecoded >= $796a66717a25f3ee$var$MAX_SAFARI_DECODE_BYTES) {
        $796a66717a25f3ee$var$cachedTextDecoder = new TextDecoder('utf-8', {
            ignoreBOM: true,
            fatal: true
        });
        $796a66717a25f3ee$var$cachedTextDecoder.decode();
        $796a66717a25f3ee$var$numBytesDecoded = len;
    }
    return $796a66717a25f3ee$var$cachedTextDecoder.decode($796a66717a25f3ee$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
const $796a66717a25f3ee$var$cachedTextEncoder = new TextEncoder();
if (!('encodeInto' in $796a66717a25f3ee$var$cachedTextEncoder)) $796a66717a25f3ee$var$cachedTextEncoder.encodeInto = function(arg, view) {
    const buf = $796a66717a25f3ee$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
let $796a66717a25f3ee$var$WASM_VECTOR_LEN = 0;
let $796a66717a25f3ee$var$wasmModule, $796a66717a25f3ee$var$wasmInstance, $796a66717a25f3ee$var$wasm;
function $796a66717a25f3ee$var$__wbg_finalize_init(instance, module) {
    $796a66717a25f3ee$var$wasmInstance = instance;
    $796a66717a25f3ee$var$wasm = instance.exports;
    $796a66717a25f3ee$var$wasmModule = module;
    $796a66717a25f3ee$var$cachedDataViewMemory0 = null;
    $796a66717a25f3ee$var$cachedInt16ArrayMemory0 = null;
    $796a66717a25f3ee$var$cachedUint16ArrayMemory0 = null;
    $796a66717a25f3ee$var$cachedUint8ArrayMemory0 = null;
    $796a66717a25f3ee$var$wasm.__wbindgen_start();
    return $796a66717a25f3ee$var$wasm;
}
async function $796a66717a25f3ee$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            const validResponse = module.ok && expectedResponseType(module.type);
            if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
    function expectedResponseType(type) {
        switch(type){
            case 'basic':
            case 'cors':
            case 'default':
                return true;
        }
        return false;
    }
}
function $796a66717a25f3ee$export$2ec80ee76a9348bf(module) {
    if ($796a66717a25f3ee$var$wasm !== undefined) return $796a66717a25f3ee$var$wasm;
    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $796a66717a25f3ee$var$__wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $796a66717a25f3ee$var$__wbg_finalize_init(instance, module);
}

async function $796a66717a25f3ee$export$2e2bcd8739ae039(module_or_path) {
    if ($796a66717a25f3ee$var$wasm !== undefined) return $796a66717a25f3ee$var$wasm;
    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (module_or_path === undefined) module_or_path = new URL((parcelRequire("9L3aU")));
    const imports = $796a66717a25f3ee$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    const { instance: instance, module: module } = await $796a66717a25f3ee$var$__wbg_load(await module_or_path, imports);
    return $796a66717a25f3ee$var$__wbg_finalize_init(instance, module);
}





const $8c1c76caa224125f$export$d9e1028cbc2a33d = [
    {
        name: "basic",
        colors: [
            "ffffff",
            "c0c0c0",
            "606060",
            "000000"
        ]
    },
    {
        name: "hogwards",
        colors: [
            "b6a571",
            "8b7e56",
            "554d35",
            "201d13"
        ]
    },
    {
        name: "christmas",
        colors: [
            "e8e7df",
            "8bab95",
            "9e5c5e",
            "534d57"
        ]
    },
    {
        name: "goldsilver",
        colors: [
            "c5c66d",
            "97a1b0",
            "585e67",
            "232529"
        ]
    },
    {
        name: "pacman",
        colors: [
            "ffff00",
            "ffb897",
            "3732ff",
            "000000"
        ]
    },
    {
        name: "mariobros",
        colors: [
            "f7cec3",
            "cc9e22",
            "923404",
            "000000"
        ]
    },
    {
        name: "pokemon",
        colors: [
            "f87800",
            "b86000",
            "783800",
            "000000"
        ]
    }
];
const $8c1c76caa224125f$export$d4ea00769622a07f = Object.fromEntries($8c1c76caa224125f$export$d9e1028cbc2a33d.map((v)=>[
        v.name,
        v
    ]));


/**
 * Storage adapter backed by the Web Storage API, using the
 * `localStorage` of the current window as the persistence layer.
 *
 * This is the default adapter used whenever the core runs in a
 * browser environment that exposes the `localStorage` object.
 */ class $83e762893e55c27a$export$ca74261544d29115 {
    getItem(key) {
        return localStorage.getItem(key);
    }
    setItem(key, value) {
        localStorage.setItem(key, value);
    }
}
class $83e762893e55c27a$export$a14722703201ea8 {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getItem(key) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setItem(key, value) {}
}
const $83e762893e55c27a$export$586b30dcaeecb901 = ()=>typeof localStorage === "undefined" ? new $83e762893e55c27a$export$a14722703201ea8() : new $83e762893e55c27a$export$ca74261544d29115();


var $6ac8ff7fc530a3fb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6ac8ff7fc530a3fb$export$7fabdfe3e47f752a = 4194304;
const $6ac8ff7fc530a3fb$export$3b97a0bdfca476e2 = 59.7275;
const $6ac8ff7fc530a3fb$export$aaad43aac3497d8d = 160;
const $6ac8ff7fc530a3fb$export$b2eb37da27702138 = 144;
const $6ac8ff7fc530a3fb$export$abe0151f658f27ae = 2;
/**
 * The rate at which the storage RAM state flush operation
 * is going to be performed, this value is the number of
 * seconds in between flush operations (eg: 5 seconds).
 */ const $6ac8ff7fc530a3fb$var$STORE_RATE = 5;
const $6ac8ff7fc530a3fb$var$KEYS_NAME = {
    ArrowUp: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Up,
    ArrowDown: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Down,
    ArrowLeft: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Left,
    ArrowRight: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Right,
    Start: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Start,
    Select: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).Select,
    A: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).A,
    B: (0, $796a66717a25f3ee$export$9d3c08039c4aa2b1).B
};
var $6ac8ff7fc530a3fb$export$61b0d7921fd6a089;
(function(SerialDevice) {
    SerialDevice["Null"] = "null";
    SerialDevice["Logger"] = "logger";
    SerialDevice["Printer"] = "printer";
})($6ac8ff7fc530a3fb$export$61b0d7921fd6a089 || ($6ac8ff7fc530a3fb$export$61b0d7921fd6a089 = {}));
/**
 * The core instance that is currently receiving the callbacks
 * triggered from the WASM side.
 *
 * The WASM module binds its callbacks to the `window` namespace,
 * which means that only a single core instance can be active at
 * any given time.
 */ let $6ac8ff7fc530a3fb$var$activeCore = null;
/**
 * Registers the provided core as the one that is going to receive
 * the callbacks triggered from the WASM side.
 *
 * The callbacks exposed by the WASM module are bound to the `window`
 * namespace, meaning that a single core instance can be active at
 * any given time.
 *
 * @param core The core instance to be set as the active one.
 */ const $6ac8ff7fc530a3fb$var$setActiveCore = (core)=>{
    // warns about the takeover of the callbacks, as the previously
    // active core stops receiving the speed switch, serial, printer
    // and rumble events from that moment on, only a core that has
    // already loaded a ROM is considered, so that the sequential
    // creation of cores is not reported as a conflict
    if ($6ac8ff7fc530a3fb$var$activeCore && $6ac8ff7fc530a3fb$var$activeCore !== core && $6ac8ff7fc530a3fb$var$activeCore.loaded) core.logger.warn("Multiple Game Boy cores detected, only the last one created receives the WASM callbacks");
    $6ac8ff7fc530a3fb$var$activeCore = core;
};
const $6ac8ff7fc530a3fb$export$349edede6a43f4ba = (core)=>{
    if ($6ac8ff7fc530a3fb$var$activeCore !== core) return;
    $6ac8ff7fc530a3fb$var$activeCore = null;
};

class $6ac8ff7fc530a3fb$export$e0a61f4eccc5d4d5 extends (0, $21488f2abed026ea$export$9965e7f257856636) {
    constructor({ wasmPath: wasmPath, storage: storage, extraSettings: extraSettings = {} } = {}){
        super();
        /**
         * The Game Boy engine (probably coming from WASM) that
         * is going to be used for the emulation.
         */ this.gameBoy = null;
        /**
         * The descriptive name of the engine that is currently
         * in use to emulate the system.
         */ this._engine = null;
        /**
         * If the GB running mode should be automatically inferred
         * from the GBC flag in the cartridge. Meaning that if the
         * cartridge is a GBC compatible or GBC only the GBC emulation
         * mode is going to be used, otherwise the DMG mode is used
         * instead. This should provide an optimal usage experience.
         */ this.autoMode = false;
        this.logicFrequency = $6ac8ff7fc530a3fb$export$7fabdfe3e47f752a;
        this.visualFrequency = $6ac8ff7fc530a3fb$export$3b97a0bdfca476e2;
        this.paletteIndex = 0;
        /**
         * Number of pending CPU cycles from the previous tick.
         * This is used to keep track of the overflow cycles.
         */ this.pending = 0;
        /**
         * The frequency at which the battery backed RAM is going
         * to be flushed to the storage adapter.
         */ this.flushCycles = $6ac8ff7fc530a3fb$export$7fabdfe3e47f752a * $6ac8ff7fc530a3fb$var$STORE_RATE;
        this.romName = null;
        this.romData = null;
        this.romSize = 0;
        this.cartridge = null;
        this._serialDevice = $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Null;
        /**
         * The path from which the WASM binary is going to be loaded,
         * kept around so that hard resets can reload the module.
         */ this.wasmPath = null;
        /**
         * Associative map for extra settings to be used in
         * opaque storage operations, associated setting
         * name with its value as a string.
         */ this.extraSettings = {};
        /**
         * Current frame structure used in the clocking operations
         * of the emulator, allowing deferred frame buffer retrieval.
         */ this.clockFrame = null;
        this.wasmPath = wasmPath !== null && wasmPath !== void 0 ? wasmPath : null;
        this.storage = storage !== null && storage !== void 0 ? storage : (0, $83e762893e55c27a$export$586b30dcaeecb901)();
        this.extraSettings = extraSettings;
        $6ac8ff7fc530a3fb$var$setActiveCore(this);
    }
    /**
     * Initializes the global module structures.
     */ init() {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            // initializes the WASM module, this is required
            // so that the global symbols become available
            yield this.wasm();
        });
    }
    /**
     * Runs a tick operation in the current emulator, this operation should
     * be triggered at a regular interval to ensure that the emulator is
     * properly updated.
     *
     * Not necessarily executed once per frame, but rather once per logic
     * emulator unit.
     *
     * The tick operation is responsible for the following operations:
     * - Clocks the system by the target number of cycles.
     * - Triggers the frame event in case there's a frame to be processed.
     * - Triggers the audio event, allowing the deferred retrieval of the audio buffer.
     * - Flushes the RAM to the storage in case the cartridge is battery backed.
     *
     * @params params The parameters to be used in the tick operation.
     */ tick(params) {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            // in case the reference to the system is not set then
            // returns the control flow immediately (not possible to tick)
            if (!this.gameBoy) return;
            // uses the Game Boy multiplier to re-calculate the number
            // of cycles to be used for the tick
            const tickCycles = params.cycles * ((_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.multiplier()) !== null && _b !== void 0 ? _b : 1);
            // calculates the target cycles for clocking in the current
            // tick operation, this is the ideal value and the concrete
            // execution should not match this value
            const targetCycles = tickCycles - this.pending;
            // clocks the system by the target number of cycles (deducted
            // by the carryover cycles) and then in case there's at least
            // a frame to be processed triggers the frame event, allowing
            // the deferred retrieval of the frame buffer
            this.clockFrame = this.gameBoy.clocks_frame_buffer(Math.max(targetCycles, 0));
            const executedCycles = Number(this.clockFrame.cycles);
            if (this.clockFrame.frames > 0) this.trigger("frame", {
                count: this.clockFrame.frames
            });
            // triggers the audio event, meaning that the audio should be
            // processed for the current emulator, effectively emptying
            // the audio buffer that is pending processing
            this.trigger("audio");
            // in case the current cartridge is battery backed
            // then we need to check if a RAM flush to the storage
            // operation is required
            if (this.cartridge && this.cartridge.has_battery()) {
                this.flushCycles -= executedCycles;
                if (this.flushCycles <= 0) {
                    this.saveRam();
                    this.flushCycles = this.logicFrequency * $6ac8ff7fc530a3fb$var$STORE_RATE;
                }
            }
            // triggers the tick event, indicating that a new tick
            // operation has been performed and providing some information
            // about the number of cycles that have been executed
            this.trigger("tick", {
                cycles: executedCycles
            });
            // calculates the new number of pending (overflow) cycles
            // that are going to be added to the next iteration
            this.pending = executedCycles - targetCycles;
        });
    }
    hardReset() {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            // releases the references to the structures of the previous
            // WASM instance, as they would otherwise be used against the
            // fresh linear memory that the reload creates
            this.gameBoy = null;
            this.cartridge = null;
            this.clockFrame = null;
            yield this.wasm(false);
            yield this.boot({
                engine: this._engine || "auto",
                restore: false,
                reuse: false
            });
        });
    }
    /**
     * Starts the current machine, setting the internal structure in
     * a proper state to start drawing and receiving input.
     *
     * This method can also be used to load a new ROM into the machine.
     *
     * @param options The options that are going to be used in the
     * starting of the machine, includes information on the ROM and
     * the emulator engine to use.
     */ boot() {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, arguments, void 0, function*({ engine: engine = "auto", restore: restore = true, reuse: reuse = true, loadRom: loadRom = false, romPath: romPath, romName: romName = null, romData: romData = null } = {}) {
            // in case a remote ROM loading operation has been
            // requested then loads it from the remote origin
            if (loadRom && romPath !== undefined) ({ name: romName, data: romData } = yield $6ac8ff7fc530a3fb$export$e0a61f4eccc5d4d5.fetchRom(romPath));
            else if (romName === null || romData === null) [romName, romData] = [
                this.romName,
                this.romData
            ];
            // in case either the ROM's name or data is not available
            // throws an error as the boot process is not possible
            if (!romName || !romData) throw new Error("Unable to load initial ROM");
            // checks if the current operation is a create operation
            // meaning that a new emulator instance is being created
            const isCreate = !(this.gameBoy && reuse);
            // selects the proper engine for execution
            // and builds a new instance of it
            switch(engine){
                case "auto":
                    this.gameBoy = isCreate ? new (0, $796a66717a25f3ee$export$4da340665b18d90)((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Dmg) : this.gameBoy;
                    this.gameBoy.set_mode((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Dmg);
                    this.autoMode = true;
                    break;
                case "cgb":
                    this.gameBoy = isCreate ? new (0, $796a66717a25f3ee$export$4da340665b18d90)((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Cgb) : this.gameBoy;
                    this.gameBoy.set_mode((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Cgb);
                    this.autoMode = false;
                    break;
                case "dmg":
                    this.gameBoy = isCreate ? new (0, $796a66717a25f3ee$export$4da340665b18d90)((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Dmg) : this.gameBoy;
                    this.gameBoy.set_mode((0, $796a66717a25f3ee$export$5694d6c89ba78dab).Dmg);
                    this.autoMode = false;
                    break;
                default:
                    if (!this.gameBoy) throw new Error("No engine requested");
                    break;
            }
            // runs the initial palette update operation, restoring
            // the palette of the emulator according to the currently
            // selected one
            this.updatePalette();
            // in case the auto emulation mode is enabled runs the
            // inference logic to try to infer the best mode from the
            // GBC header in the cartridge data
            if (this.autoMode) this.gameBoy.infer_mode_wa(romData);
            // prints some debug information about the emulator that
            // has just been booted, this should provide some insights
            if (isCreate) {
                this.logger.info(`Creating Boytacean emulator (${engine !== null && engine !== void 0 ? engine : "current"})...`);
                this.logger.info(`${this.gameBoy.description(9)}`);
            } else this.logger.info(`Resetting Boytacean emulator (${engine !== null && engine !== void 0 ? engine : "current"})...`);
            // resets the Game Boy engine to restore it into
            // a valid state ready to be used
            this.gameBoy.reset();
            this.gameBoy.load_unsafe(true);
            // loads the ROM file into the system and retrieves
            // the cartridge instance associated with it
            const cartridge = this.gameBoy.load_rom_wa(romData);
            // prints some debug information about the cartridge that
            // has just been loaded, this should provide some insights
            this.logger.info(`${cartridge.description(9)}`);
            // loads the callbacks so that the Typescript code
            // gets notified about the various events triggered
            // in the WASM side
            this.gameBoy.load_callbacks_wa();
            // in case there's a serial device involved tries to load
            // it and initialize for the current Game Boy machine
            this.loadSerialDevice();
            // updates the name of the currently selected engine
            // to the one that has been provided (logic change)
            if (engine) this._engine = engine;
            // updates the ROM name in case there's extra information
            // coming from the cartridge
            romName = cartridge.title() ? cartridge.title() : romName;
            // updates the complete set of global information that
            // is going to be displayed
            this.setRom(romName, romData, cartridge);
            // in case there's a battery involved tries to load the
            // current RAM from the storage
            if (cartridge.has_battery()) this.loadRam();
            // in case the restore (state) flag is set
            // then resumes the machine execution
            if (restore) yield this.resume();
            // triggers the booted event indicating that the
            // emulator has finished the loading process
            this.trigger("booted");
        });
    }
    setRom(name, data, cartridge) {
        this.romName = name;
        this.romData = data;
        this.romSize = data.length;
        this.cartridge = cartridge;
    }
    get instance() {
        return this.gameBoy;
    }
    get engines() {
        return [
            "auto",
            "cgb",
            "dmg"
        ];
    }
    get engine() {
        return this._engine || "auto";
    }
    get pixelFormat() {
        return (0, $21488f2abed026ea$export$abee86c20a5429d).RGB;
    }
    get dimensions() {
        return {
            width: $6ac8ff7fc530a3fb$export$aaad43aac3497d8d,
            height: $6ac8ff7fc530a3fb$export$b2eb37da27702138,
            scale: $6ac8ff7fc530a3fb$export$abe0151f658f27ae
        };
    }
    /**
     * Returns the array buffer that contains the complete set of
     * pixel data that is going to be drawn.
     *
     * @returns The current pixel data for the emulator display.
     */ get imageBuffer() {
        var _a, _b, _c, _d;
        return (_d = (_b = (_a = this.clockFrame) === null || _a === void 0 ? void 0 : _a.frame_buffer_eager()) !== null && _b !== void 0 ? _b : (_c = this.gameBoy) === null || _c === void 0 ? void 0 : _c.frame_buffer_eager()) !== null && _d !== void 0 ? _d : new Uint8Array();
    }
    get audioSpecs() {
        var _a, _b, _c, _d;
        return {
            samplingRate: (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.audio_sampling_rate()) !== null && _b !== void 0 ? _b : 44100,
            channels: (_d = (_c = this.gameBoy) === null || _c === void 0 ? void 0 : _c.audio_channels()) !== null && _d !== void 0 ? _d : 2
        };
    }
    get audioBuffer() {
        var _a, _b;
        const internalBuffer = (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.audio_buffer_eager(true)) !== null && _b !== void 0 ? _b : [];
        const leftStream = new Float32Array(internalBuffer.length / 2);
        const rightStream = new Float32Array(internalBuffer.length / 2);
        for(let index = 0; index < internalBuffer.length; index += 2){
            leftStream[index / 2] = internalBuffer[index] / 100.0;
            rightStream[index / 2] = internalBuffer[index + 1] / 100.0;
        }
        return [
            leftStream,
            rightStream
        ];
    }
    get frequency() {
        return this.logicFrequency;
    }
    set frequency(value) {
        var _a;
        value = Math.max(value, 0);
        this.logicFrequency = value;
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_clock_freq(value);
        this.trigger("frequency", value);
    }
    get displayFrequency() {
        return this.visualFrequency;
    }
    set displayFrequency(value) {
        value = Math.max(value, 0);
        this.visualFrequency = value;
        this.trigger("display-frequency", value);
    }
    get registers() {
        var _a;
        const registers = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.registers();
        if (!registers) return {};
        return {
            pc: registers.pc,
            sp: registers.sp,
            a: registers.a,
            b: registers.b,
            c: registers.c,
            d: registers.d,
            e: registers.e,
            h: registers.h,
            l: registers.l,
            scy: registers.scy,
            scx: registers.scx,
            wy: registers.wy,
            wx: registers.wx,
            ly: registers.ly,
            lyc: registers.lyc
        };
    }
    get speed() {
        var _a, _b;
        return (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.speed()) !== null && _b !== void 0 ? _b : (0, $796a66717a25f3ee$export$3cd536aab18fb47d).Normal;
    }
    get audioOutput() {
        var _a;
        const output = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.audio_all_output();
        if (!output) return {};
        return {
            master: output[0],
            ch1: output[1],
            ch2: output[2],
            ch3: output[3],
            ch4: output[4]
        };
    }
    get palette() {
        const paletteObj = (0, $8c1c76caa224125f$export$d9e1028cbc2a33d)[this.paletteIndex];
        return paletteObj.name;
    }
    set palette(value) {
        if (value === undefined) return;
        const paletteObj = (0, $8c1c76caa224125f$export$d4ea00769622a07f)[value];
        this.paletteIndex = Math.max((0, $8c1c76caa224125f$export$d9e1028cbc2a33d).indexOf(paletteObj), 0);
        this.updatePalette();
    }
    get serialDevice() {
        return this._serialDevice;
    }
    set serialDevice(value) {
        this._serialDevice = value;
    }
    /**
     * The name of the ROM that is currently loaded in the machine,
     * null in case no ROM has been loaded yet.
     */ get loadedRomName() {
        return this.romName;
    }
    /**
     * The size in bytes of the ROM that is currently loaded in the
     * machine, zero in case no ROM has been loaded yet.
     */ get loadedRomSize() {
        return this.romSize;
    }
    /**
     * If a ROM has already been loaded into the machine, meaning
     * that the emulation is able to run.
     */ get loaded() {
        return this.romData !== null;
    }
    keyPress(key) {
        var _a;
        const keyCode = $6ac8ff7fc530a3fb$var$KEYS_NAME[key];
        if (keyCode === undefined) return;
        (_a = this.gameBoy) === null || _a === void 0 || _a.key_press(keyCode);
    }
    keyLift(key) {
        var _a;
        const keyCode = $6ac8ff7fc530a3fb$var$KEYS_NAME[key];
        if (keyCode === undefined) return;
        (_a = this.gameBoy) === null || _a === void 0 || _a.key_lift(keyCode);
    }
    serializeState() {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.gameBoy) throw new Error("Unable to serialize state");
            return (0, $796a66717a25f3ee$export$4d5c8163a511d38a).save_wa(this.gameBoy);
        });
    }
    unserializeState(data) {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.gameBoy) throw new Error("Unable to unserialize state");
            (0, $796a66717a25f3ee$export$4d5c8163a511d38a).load_wa(data, this.gameBoy);
        });
    }
    buildState(index, data) {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let state = null;
                const format = (0, $796a66717a25f3ee$export$4d5c8163a511d38a).format_wa(data);
                switch(format){
                    case (0, $796a66717a25f3ee$export$32a80ba62f2420fa).Bos:
                    case (0, $796a66717a25f3ee$export$32a80ba62f2420fa).Bosc:
                        state = (0, $796a66717a25f3ee$export$4d5c8163a511d38a).read_bos_auto_wa(data);
                        break;
                    case (0, $796a66717a25f3ee$export$32a80ba62f2420fa).Bess:
                        state = (0, $796a66717a25f3ee$export$4d5c8163a511d38a).read_bess_wa(data);
                        break;
                    default:
                        throw new Error(`Invalid state format ${format}`);
                }
                const timestamp = Number(state.timestamp_wa());
                return {
                    index: index,
                    timestamp: timestamp > 0 ? timestamp : undefined,
                    agent: state.agent_wa(),
                    model: state.model_wa(),
                    title: state.title_wa(),
                    format: (0, $796a66717a25f3ee$export$4d5c8163a511d38a).format_str_wa(data),
                    size: data.length,
                    thumbnail: state.has_image_wa() ? state.image_eager_wa() : undefined
                };
            } catch (err) {
                return {
                    index: index,
                    error: err instanceof Error ? err : new Error(String(err))
                };
            }
        });
    }
    validateState(data, validation) {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            (0, $796a66717a25f3ee$export$4d5c8163a511d38a).validate_wa(data, validation.title);
        });
    }
    pauseVideo() {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_ppu_enabled(false);
    }
    resumeVideo() {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_ppu_enabled(true);
    }
    getVideoState() {
        var _a, _b;
        return (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.ppu_enabled()) !== null && _b !== void 0 ? _b : false;
    }
    pauseAudio() {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_apu_enabled(false);
        this.trigger("audio-state", {
            state: "paused",
            stateBool: false
        });
    }
    resumeAudio() {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_apu_enabled(true);
        this.trigger("audio-state", {
            state: "resumed",
            stateBool: true
        });
    }
    getAudioState() {
        var _a, _b;
        return (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.apu_enabled()) !== null && _b !== void 0 ? _b : false;
    }
    getTile(index) {
        var _a, _b;
        return (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.get_tile_buffer(index)) !== null && _b !== void 0 ? _b : new Uint8Array();
    }
    changePalette() {
        this.paletteIndex += 1;
        this.paletteIndex %= (0, $8c1c76caa224125f$export$d9e1028cbc2a33d).length;
        this.updatePalette();
        return (0, $8c1c76caa224125f$export$d9e1028cbc2a33d)[this.paletteIndex].name;
    }
    benchmark(count = 50000000) {
        var _a, _b;
        let cycles = 0;
        this.pause();
        try {
            const initial = (0, $21488f2abed026ea$export$9965e7f257856636).now();
            for(let i = 0; i < count; i++)cycles += (_b = (_a = this.gameBoy) === null || _a === void 0 ? void 0 : _a.clock()) !== null && _b !== void 0 ? _b : 0;
            const delta = ((0, $21488f2abed026ea$export$9965e7f257856636).now() - initial) / 1000;
            const frequency_mhz = cycles / delta / 1000 / 1000;
            return {
                delta: delta,
                count: count,
                cycles: cycles,
                frequency_mhz: frequency_mhz
            };
        } finally{
            this.resume();
        }
    }
    onBackground(background) {
        this.extraSettings.background = background;
        this.storeSettings();
    }
    loadSerialDevice(device) {
        device = device !== null && device !== void 0 ? device : this.serialDevice;
        switch(device){
            case $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Null:
                this.loadNullDevice();
                break;
            case $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Logger:
                this.loadLoggerDevice();
                break;
            case $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Printer:
                this.loadPrinterDevice();
                break;
        }
    }
    loadNullDevice(set = true) {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.load_null_wa();
        if (set) this.serialDevice = $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Null;
    }
    loadLoggerDevice(set = true) {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.load_logger_wa();
        if (set) this.serialDevice = $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Logger;
    }
    loadPrinterDevice(set = true) {
        var _a;
        (_a = this.gameBoy) === null || _a === void 0 || _a.load_printer_wa();
        if (set) this.serialDevice = $6ac8ff7fc530a3fb$export$61b0d7921fd6a089.Printer;
    }
    onSpeedSwitch(speed) {
        this.trigger("speed", {
            data: speed
        });
    }
    onLoggerDevice(data) {
        this.trigger("logger", {
            data: data
        });
    }
    onPrinterDevice(imageBuffer) {
        this.trigger("printer", {
            imageBuffer: imageBuffer
        });
    }
    /**
     * Tries for save/flush the current machine RAM into the
     * storage adapter, so that it can be latter restored.
     */ saveRam() {
        if (!this.gameBoy || !this.cartridge) return;
        if (!this.cartridge.has_battery()) return;
        const title = this.cartridge.title();
        const ramData = this.gameBoy.ram_data_eager();
        const ramDataB64 = (0, $a07119bee7a8f987$export$8ffe10d2aad3f2)(ramData);
        // the storage operation is guarded as it runs from the tick
        // operation, meaning that a failing adapter (eg: exhausted
        // quota) would otherwise break the emulation loop
        try {
            this.storage.setItem(title, ramDataB64);
        } catch (err) {
            this.logger.warn(`Failed to save RAM data (${err})`);
        }
    }
    /**
     * Tries to load game RAM from the storage adapter using the
     * current cartridge title as the name of the item and
     * decoding it using Base64.
     */ loadRam() {
        if (!this.gameBoy || !this.cartridge) return;
        const ramDataB64 = this.storage.getItem(this.cartridge.title());
        if (!ramDataB64) return;
        const ramData = (0, $a07119bee7a8f987$export$243468195665a877)(ramDataB64);
        this.gameBoy.set_ram_data(ramData);
    }
    storeSettings() {
        const settings = Object.assign({
            palette: (0, $8c1c76caa224125f$export$d9e1028cbc2a33d)[this.paletteIndex].name
        }, this.extraSettings);
        // guards the storage operation as this method is called as
        // part of the boot sequence, which should not be interrupted
        // by a failing storage adapter
        try {
            this.storage.setItem("settings", JSON.stringify(settings));
        } catch (err) {
            this.logger.warn(`Failed to store settings (${err})`);
        }
    }
    updatePalette() {
        var _a;
        const palette = (0, $8c1c76caa224125f$export$d9e1028cbc2a33d)[this.paletteIndex];
        (_a = this.gameBoy) === null || _a === void 0 || _a.set_palette_colors_wa(palette.colors);
        this.storeSettings();
    }
    /**
     * Loads the WASM module of the emulator, using the path that has
     * been provided at construction time and falling back to the
     * default wasm-bindgen resolution strategy.
     *
     * @param setHook If the panic hook should be set as part of the
     * WASM module loading operation.
     */ wasm() {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, arguments, void 0, function*(setHook = true) {
            var _a;
            // resolves the path of the WASM binary, falling back to the
            // one that sits next to the `boytacean` package, this is
            // required as some bundlers strip the `import.meta.url` based
            // resolution that wasm-bindgen relies on by default
            const wasmPath = (_a = this.wasmPath) !== null && _a !== void 0 ? _a : $6ac8ff7fc530a3fb$export$e0a61f4eccc5d4d5.defaultWasmPath();
            // waits for the WASM module to be (hard) re-loaded
            // this should be an expensive operation, uses fallback
            // logic to determine if the new set of arguments for
            // wasm-bindgen should be used
            try {
                yield wasmPath ? (0, $796a66717a25f3ee$export$2e2bcd8739ae039)({
                    module_or_path: wasmPath
                }) : (0, $796a66717a25f3ee$export$2e2bcd8739ae039)();
            } catch (err) {
                if (err instanceof TypeError) yield (0, $796a66717a25f3ee$export$2e2bcd8739ae039)();
                else throw err;
            }
            // in case the set hook flag is set, then tries to
            // set the panic hook for the WASM module, this call
            // may fail in some versions of wasm-bindgen as the
            // thread is still marked as "panicking", so we need to
            // wrap the call around try/catch
            if (setHook) try {
                (0, $796a66717a25f3ee$export$4da340665b18d90).set_panic_hook_wa();
            } catch (err) {
                console.error(err);
            }
        });
    }
    /**
     * Resolves the default location of the WASM binary, which is the
     * one distributed next to the `boytacean` package.
     *
     * @returns The URL of the WASM binary or null in case it cannot
     * be resolved in the current environment.
     */ static defaultWasmPath() {
        try {
            return new URL((parcelRequire("9L3aU"))).href;
        } catch (err) {
            return null;
        }
    }
    static fetchRom(romPath) {
        return $6ac8ff7fc530a3fb$var$__awaiter(this, void 0, void 0, function*() {
            // extracts the name of the ROM from the provided
            // path by splitting its structure
            const romPathS = romPath.split(/\//g);
            let romName = romPathS[romPathS.length - 1].split("?")[0];
            const romNameS = romName.split(/\./g);
            romName = `${romNameS[0]}.${romNameS[romNameS.length - 1]}`;
            // loads the ROM data and converts it into the
            // target byte array buffer (to be used by WASM)
            const response = yield fetch(romPath);
            if (!response.ok) throw new Error(`Unable to load ROM from ${romPath} (${response.status})`);
            const blob = yield response.blob();
            const arrayBuffer = yield blob.arrayBuffer();
            const romData = new Uint8Array(arrayBuffer);
            // returns both the name of the ROM and the data
            // contents as a byte array
            return {
                name: romName,
                data: romData
            };
        });
    }
}
if (typeof window !== "undefined") {
    window.panic = (message)=>{
        console.error(message);
    };
    window.speedCallback = (speed)=>{
        $6ac8ff7fc530a3fb$var$activeCore === null || $6ac8ff7fc530a3fb$var$activeCore === void 0 || $6ac8ff7fc530a3fb$var$activeCore.onSpeedSwitch(speed);
    };
    window.loggerCallback = (data)=>{
        $6ac8ff7fc530a3fb$var$activeCore === null || $6ac8ff7fc530a3fb$var$activeCore === void 0 || $6ac8ff7fc530a3fb$var$activeCore.onLoggerDevice(data);
    };
    window.printerCallback = (imageBuffer)=>{
        $6ac8ff7fc530a3fb$var$activeCore === null || $6ac8ff7fc530a3fb$var$activeCore === void 0 || $6ac8ff7fc530a3fb$var$activeCore.onPrinterDevice(imageBuffer);
    };
    window.rumbleCallback = (active)=>{
        var _a, _b, _c, _d;
        if (!active) return;
        // runs the vibration actuator on the current window
        // this will probably affect only mobile devices
        (_b = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.vibrate) === null || _b === void 0 || _b.call(_a, 250);
        // iterates over all the available gamepads to run
        // the vibration actuator on each of them
        let gamepadIndex = 0;
        while(true){
            const gamepad = navigator.getGamepads()[gamepadIndex];
            if (!gamepad) break;
            (_d = (_c = gamepad === null || gamepad === void 0 ? void 0 : gamepad.vibrationActuator) === null || _c === void 0 ? void 0 : _c.playEffect) === null || _d === void 0 || _d.call(_c, "dual-rumble", {
                startDelay: 0,
                duration: 150,
                weakMagnitude: 0.8,
                strongMagnitude: 0.0
            });
            gamepadIndex++;
        }
    };
}









var $ff323866fb43afa6$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $ff323866fb43afa6$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;

!function(e) {
    $ff323866fb43afa6$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $587b054e52e3ab52$exports.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});




var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"boytacean-web\",\"version\":\"0.13.2\",\"description\":\"The web version of Boytacean\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/joamag/boytacean.git\"},\"license\":\"Apache-2.0\",\"scripts\":{\"build\":\"parcel build index.html\",\"dev\":\"parcel index.html\",\"lint\":\"eslint .\",\"nodemon\":\"nodemon --exec \\\"parcel --no-cache index.html\\\"\",\"pretty\":\"prettier --config .prettierrc \\\"./**/*.{js,ts,tsx,json}\\\" --write\",\"start\":\"npm run build\",\"watch\":\"parcel watch index.html\"},\"source\":\"index.ts\",\"devDependencies\":{\"@parcel/transformer-typescript-tsc\":\"^2.14.0\",\"@types/mocha\":\"^10.0.10\",\"@types/node\":\"^26.1.2\",\"@types/react\":\"^18.3.18\",\"@types/react-dom\":\"^18.3.5\",\"@typescript-eslint/eslint-plugin\":\"^7.18.0\",\"@typescript-eslint/parser\":\"^7.18.0\",\"buffer\":\"^6.0.3\",\"emukit\":\"^0.10.25\",\"eslint\":\"^8.57.1\",\"eslint-plugin-import\":\"^2.31.0\",\"eslint-plugin-react-hooks\":\"^5.2.0\",\"jszip\":\"^3.10.1\",\"nodemon\":\"^3.1.9\",\"parcel\":\"^2.14.0\",\"prettier\":\"^3.5.3\",\"prettier-plugin-organize-imports\":\"^4.1.0\",\"process\":\"^0.11.10\",\"react\":\"^18.3.1\",\"react-dom\":\"^18.3.1\",\"recoil\":\"^0.7.7\",\"svgo\":\"^3.3.2\",\"typescript\":\"^5.8.2\",\"webgl-plot\":\"^0.7.2\"},\"alias\":{\"boytacean\":\"./lib/boytacean.js\",\"boytacean-core\":\"./core/index.ts\",\"emukit/logic\":\"./node_modules/emukit/logic.ts\",\"process\":{\"global\":\"process\"}}}");




var $acw62 = parcelRequire("acw62");
class $b561b35af75249bf$export$e1fa5eb04d8533ba {
    r;
    g;
    b;
    a;
    constructor(r, g, b, a){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
}
/**
 * Baseline class
 */ class $b561b35af75249bf$var$WebglBase {
    //private static program: WebGLProgram;
    intensity;
    visible;
    /**
     * The number of data point pairs in the line
     */ numPoints;
    /**
     * The data ponits for webgl array
     * @internal
     */ xy;
    /**
     * The Color of the line
     */ color;
    /**
     * The horizontal scale of the line
     * @default = 1
     */ scaleX;
    /**
     * The vertical scale of the line
     * @default = 1
     */ scaleY;
    /**
     * The horizontal offset of the line
     * @default = 0
     */ offsetX;
    /**
     * the vertical offset of the line
     * @default = 0
     */ offsetY;
    /**
     * if this is a close loop line or not
     * @default = false
     */ loop;
    /**
     * total webgl number of points
     * @internal
     */ webglNumPoints;
    /**
     * @private
     * @internal
     */ _vbuffer;
    /**
     * @private
     * @internal
     */ //public _prog: WebGLProgram;
    /**
     * @private
     * @internal
     */ _coord;
    /**
     * @internal
     */ constructor(){
        this.scaleX = 1;
        this.scaleY = 1;
        this.offsetX = 0;
        this.offsetY = 0;
        this.loop = false;
        this._vbuffer = 0;
        this._coord = 0;
        this.visible = true;
        this.intensity = 1;
        this.xy = new Float32Array([]);
        this.numPoints = 0;
        this.color = new $b561b35af75249bf$export$e1fa5eb04d8533ba(0, 0, 0, 1);
        this.webglNumPoints = 0;
    }
}
/**
 * The standard Line class
 */ class $b561b35af75249bf$export$c11cfec07e42e9b4 extends $b561b35af75249bf$var$WebglBase {
    currentIndex = 0;
    /**
     * Create a new line
     * @param c - the color of the line
     * @param numPoints - number of data pints
     * @example
     * ```typescript
     * x= [0,1]
     * y= [1,2]
     * line = new WebglLine( new ColorRGBA(0.1,0.1,0.1,1), 2);
     * ```
     */ constructor(c, numPoints){
        super();
        this.webglNumPoints = numPoints;
        this.numPoints = numPoints;
        this.color = c;
        this.xy = new Float32Array(2 * this.webglNumPoints);
    }
    /**
     * Set the X value at a specific index
     * @param index - the index of the data point
     * @param x - the horizontal value of the data point
     */ setX(index, x) {
        this.xy[index * 2] = x;
    }
    /**
     * Set the Y value at a specific index
     * @param index : the index of the data point
     * @param y : the vertical value of the data point
     */ setY(index, y) {
        this.xy[index * 2 + 1] = y;
    }
    /**
     * Get an X value at a specific index
     * @param index - the index of X
     */ getX(index) {
        return this.xy[index * 2];
    }
    /**
     * Get an Y value at a specific index
     * @param index - the index of Y
     */ getY(index) {
        return this.xy[index * 2 + 1];
    }
    /**
     * Make an equally spaced array of X points
     * @param start  - the start of the series
     * @param stepSize - step size between each data point
     *
     * @example
     * ```typescript
     * //x = [-1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8]
     * const numX = 10;
     * line.lineSpaceX(-1, 2 / numX);
     * ```
     */ lineSpaceX(start, stepSize) {
        for(let i = 0; i < this.numPoints; i++)// set x to -num/2:1:+num/2
        this.setX(i, start + stepSize * i);
    }
    /**
     * Automatically generate X between -1 and 1
     * equal to lineSpaceX(-1, 2/ number of points)
     */ arrangeX() {
        this.lineSpaceX(-1, 2 / this.numPoints);
    }
    /**
     * Set a constant value for all Y values in the line
     * @param c - constant value
     */ constY(c) {
        for(let i = 0; i < this.numPoints; i++)// set x to -num/2:1:+num/2
        this.setY(i, c);
    }
    /**
     * Add a new Y values to the end of current array and shift it, so that the total number of the pair remains the same
     * @param data - the Y array
     *
     * @example
     * ```typescript
     * yArray = new Float32Array([3, 4, 5]);
     * line.shiftAdd(yArray);
     * ```
     */ shiftAdd(data) {
        const shiftSize = data.length;
        for(let i = 0; i < this.numPoints - shiftSize; i++)this.setY(i, this.getY(i + shiftSize));
        for(let i = 0; i < shiftSize; i++)this.setY(i + this.numPoints - shiftSize, data[i]);
    }
    /**
     * Add new Y values to the line and maintain the position of the last data point
     */ addArrayY(yArray) {
        if (this.currentIndex + yArray.length <= this.numPoints) for(let i = 0; i < yArray.length; i++){
            this.setY(this.currentIndex, yArray[i]);
            this.currentIndex++;
        }
    }
    /**
     * Replace the all Y values of the line
     */ replaceArrayY(yArray) {
        if (yArray.length == this.numPoints) for(let i = 0; i < this.numPoints; i++)this.setY(i, yArray[i]);
    }
}
/**
 * The step based line plot
 */ class $b561b35af75249bf$export$8af5179b37e0e3d0 extends $b561b35af75249bf$var$WebglBase {
    /**
     * Create a new step line
     * @param c - the color of the line
     * @param numPoints - number of data pints
     * @example
     * ```typescript
     * x= [0,1]
     * y= [1,2]
     * line = new WebglStep( new ColorRGBA(0.1,0.1,0.1,1), 2);
     * ```
     */ constructor(c, num){
        super();
        this.webglNumPoints = num * 2;
        this.numPoints = num;
        this.color = c;
        this.xy = new Float32Array(2 * this.webglNumPoints);
    }
    /**
     * Set the Y value at a specific index
     * @param index - the index of the data point
     * @param y - the vertical value of the data point
     */ setY(index, y) {
        this.xy[index * 4 + 1] = y;
        this.xy[index * 4 + 3] = y;
    }
    getX(index) {
        return this.xy[index * 4];
    }
    /**
     * Get an X value at a specific index
     * @param index - the index of X
     */ getY(index) {
        return this.xy[index * 4 + 1];
    }
    /**
     * Make an equally spaced array of X points
     * @param start  - the start of the series
     * @param stepSize - step size between each data point
     *
     * @example
     * ```typescript
     * //x = [-1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8]
     * const numX = 10;
     * line.lineSpaceX(-1, 2 / numX);
     * ```
     */ lineSpaceX(start, stepsize) {
        for(let i = 0; i < this.numPoints; i++){
            // set x to -num/2:1:+num/2
            this.xy[i * 4] = start + i * stepsize;
            this.xy[i * 4 + 2] = start + (i * stepsize + stepsize);
        }
    }
    /**
     * Set a constant value for all Y values in the line
     * @param c - constant value
     */ constY(c) {
        for(let i = 0; i < this.numPoints; i++)// set x to -num/2:1:+num/2
        this.setY(i, c);
    }
    /**
     * Add a new Y values to the end of current array and shift it, so that the total number of the pair remains the same
     * @param data - the Y array
     *
     * @example
     * ```typescript
     * yArray = new Float32Array([3, 4, 5]);
     * line.shiftAdd(yArray);
     * ```
     */ shiftAdd(data) {
        const shiftSize = data.length;
        for(let i = 0; i < this.numPoints - shiftSize; i++)this.setY(i, this.getY(i + shiftSize));
        for(let i = 0; i < shiftSize; i++)this.setY(i + this.numPoints - shiftSize, data[i]);
    }
}
class $b561b35af75249bf$export$73b032bd11002da3 extends $b561b35af75249bf$var$WebglBase {
    numPoints;
    xy;
    color;
    intenisty;
    visible;
    offsetTheta;
    constructor(c, numPoints){
        super();
        this.webglNumPoints = numPoints;
        this.numPoints = numPoints;
        this.color = c;
        this.intenisty = 1;
        this.xy = new Float32Array(2 * this.webglNumPoints);
        this._vbuffer = 0;
        this._coord = 0;
        this.visible = true;
        this.offsetTheta = 0;
    }
    /**
     * @param index: index of the line
     * @param theta : angle in deg
     * @param r : radius
     */ setRtheta(index, theta, r) {
        //const rA = Math.abs(r);
        //const thetaA = theta % 360;
        const x = r * Math.cos(2 * Math.PI * (theta + this.offsetTheta) / 360);
        const y = r * Math.sin(2 * Math.PI * (theta + this.offsetTheta) / 360);
        //const index = Math.round( ((theta % 360)/360) * this.numPoints );
        this.setX(index, x);
        this.setY(index, y);
    }
    getTheta(index) {
        //return Math.tan
        return 0;
    }
    getR(index) {
        //return Math.tan
        return Math.sqrt(Math.pow(this.getX(index), 2) + Math.pow(this.getY(index), 2));
    }
    setX(index, x) {
        this.xy[index * 2] = x;
    }
    setY(index, y) {
        this.xy[index * 2 + 1] = y;
    }
    getX(index) {
        return this.xy[index * 2];
    }
    getY(index) {
        return this.xy[index * 2 + 1];
    }
}
/**
 * The Square class
 */ class $b561b35af75249bf$export$3489eb3dc4c4c299 extends $b561b35af75249bf$var$WebglBase {
    /**
     * Create a new line
     * @param c - the color of the line
     * @example
     * ```typescript
     * line = new WebglSquare( new ColorRGBA(0.1,0.1,0.1,0.5) );
     * ```
     */ constructor(c){
        super();
        this.webglNumPoints = 4;
        this.numPoints = 4;
        this.color = c;
        this.xy = new Float32Array(2 * this.webglNumPoints);
    }
    /**
     * draw a square
     * @param x1 start x
     * @param y1 start y
     * @param x2 end x
     * @param y2 end y
     */ setSquare(x1, y1, x2, y2) {
        this.xy = new Float32Array([
            x1,
            y1,
            x1,
            y2,
            x2,
            y1,
            x2,
            y2
        ]);
    }
}
/**
 * modified functions from:
 * https://github.com/stackgl/gl-vec2
 * See License2.md for more info
 */ const $b561b35af75249bf$var$scaleAndAdd = (a, b, scale)=>{
    const out = {
        x: 0,
        y: 0
    };
    out.x = a.x + b.x * scale;
    out.y = a.y + b.y * scale;
    return out;
};
const $b561b35af75249bf$var$normal = (dir)=>{
    //get perpendicular
    const out = $b561b35af75249bf$var$set(-dir.y, dir.x);
    return out;
};
const $b561b35af75249bf$var$direction = (a, b)=>{
    //get unit dir of two lines
    let out = $b561b35af75249bf$var$subtract(a, b);
    out = $b561b35af75249bf$var$normalize(out);
    return out;
};
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ const $b561b35af75249bf$var$add = (a, b)=>{
    const out = {
        x: 0,
        y: 0
    };
    out.x = a.x + b.x;
    out.y = a.y + b.y;
    return out;
};
/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */ const $b561b35af75249bf$var$dot = (a, b)=>{
    return a.x * b.x + a.y * b.y;
};
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */ const $b561b35af75249bf$var$normalize = (a)=>{
    const out = {
        x: 0,
        y: 0
    };
    let len = a.x * a.x + a.y * a.y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out.x = a.x * len;
        out.y = a.y * len;
    }
    return out;
};
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */ const $b561b35af75249bf$var$set = (x, y)=>{
    const out = {
        x: 0,
        y: 0
    };
    out.x = x;
    out.y = y;
    return out;
};
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ const $b561b35af75249bf$var$subtract = (a, b)=>{
    const out = {
        x: 0,
        y: 0
    };
    out.x = a.x - b.x;
    out.y = a.y - b.y;
    return out;
};
/**
 * inspired and modified from:
 * https://github.com/mattdesl/polyline-normals
 * See License1.md for more info
 */ const $b561b35af75249bf$var$PolyLine = (lineXY)=>{
    let curNormal;
    let lineA = {
        x: 0,
        y: 0
    };
    let lineB = {
        x: 0,
        y: 0
    };
    const out = [];
    const addNext = (normal, length)=>{
        out.push({
            vec2: normal,
            miterLength: length
        });
    };
    const getXY = (index)=>{
        return {
            x: lineXY[index * 2],
            y: lineXY[index * 2 + 1]
        };
    };
    // add initial normals
    lineA = $b561b35af75249bf$var$direction(getXY(1), getXY(0));
    curNormal = $b561b35af75249bf$var$normal(lineA);
    addNext(curNormal, 1);
    const numPoints = lineXY.length / 2;
    for(let i = 1; i < numPoints - 1; i++){
        const last = getXY(i - 1);
        const cur = getXY(i);
        const next = getXY(i + 1);
        lineA = $b561b35af75249bf$var$direction(cur, last);
        curNormal = $b561b35af75249bf$var$normal(lineA);
        lineB = $b561b35af75249bf$var$direction(next, cur);
        //stores tangent & miter
        const miter = $b561b35af75249bf$var$computeMiter(lineA, lineB);
        const miterLen = $b561b35af75249bf$var$computeMiterLen(lineA, miter, 1);
        addNext(miter, miterLen);
    }
    // add last normal
    // no miter, simple segment
    lineA = $b561b35af75249bf$var$direction(getXY(numPoints - 1), getXY(numPoints - 2));
    curNormal = $b561b35af75249bf$var$normal(lineA); //reset normal
    addNext(curNormal, 1);
    return out;
};
const $b561b35af75249bf$var$computeMiter = (lineA, lineB)=>{
    //get tangent line
    let tangent = $b561b35af75249bf$var$add(lineA, lineB);
    tangent = $b561b35af75249bf$var$normalize(tangent);
    //get miter as a unit vector
    const miter = $b561b35af75249bf$var$set(-tangent.y, tangent.x);
    return miter;
};
const $b561b35af75249bf$var$computeMiterLen = (lineA, miter, halfThick)=>{
    const tmp = $b561b35af75249bf$var$set(-lineA.y, lineA.x);
    //get the necessary length of our miter
    return halfThick / $b561b35af75249bf$var$dot(miter, tmp);
};
/**
 * The standard Line class
 */ class $b561b35af75249bf$export$b99e5a4c37dcf0aa extends $b561b35af75249bf$var$WebglBase {
    currentIndex = 0;
    //protected triPoints: Float32Array;
    _linePoints;
    _thicknessRequested = 0;
    _actualThickness = 0;
    /**
     * Create a new line
     * @param c - the color of the line
     * @param numPoints - number of data pints
     * @example
     * ```typescript
     * x= [0,1]
     * y= [1,2]
     * line = new WebglLine( new ColorRGBA(0.1,0.1,0.1,1), 2);
     * ```
     */ constructor(c, numPoints, thickness){
        super();
        this.webglNumPoints = numPoints * 2;
        this.numPoints = numPoints;
        this.color = c;
        this._thicknessRequested = thickness;
        this._linePoints = new Float32Array(numPoints * 2);
        //this.triPoints = new Float32Array(this.numPoints * 4);
        this.xy = new Float32Array(2 * this.webglNumPoints);
    }
    convertToTriPoints() {
        //const thick = 0.01;
        const halfThick = this._actualThickness / 2;
        const normals = $b561b35af75249bf$var$PolyLine(this._linePoints);
        //console.log(this.linePoints);
        //console.log(normals);
        for(let i = 0; i < this.numPoints; i++){
            const x = this._linePoints[2 * i];
            const y = this._linePoints[2 * i + 1];
            const point = {
                x: x,
                y: y
            };
            const top = $b561b35af75249bf$var$scaleAndAdd(point, normals[i].vec2, normals[i].miterLength * halfThick);
            const bot = $b561b35af75249bf$var$scaleAndAdd(point, normals[i].vec2, -normals[i].miterLength * halfThick);
            this.xy[i * 4] = top.x;
            this.xy[i * 4 + 1] = top.y;
            this.xy[i * 4 + 2] = bot.x;
            this.xy[i * 4 + 3] = bot.y;
        }
    }
    /**
     * Set the X value at a specific index
     * @param index - the index of the data point
     * @param x - the horizontal value of the data point
     */ setX(index, x) {
        this._linePoints[index * 2] = x;
    }
    /**
     * Set the Y value at a specific index
     * @param index : the index of the data point
     * @param y : the vertical value of the data point
     */ setY(index, y) {
        this._linePoints[index * 2 + 1] = y;
    }
    /**
     * Make an equally spaced array of X points
     * @param start  - the start of the series
     * @param stepSize - step size between each data point
     *
     * @example
     * ```typescript
     * //x = [-1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8]
     * const numX = 10;
     * line.lineSpaceX(-1, 2 / numX);
     * ```
     */ lineSpaceX(start, stepSize) {
        for(let i = 0; i < this.numPoints; i++)// set x to -num/2:1:+num/2
        this.setX(i, start + stepSize * i);
    }
    setThickness(thickness) {
        this._thicknessRequested = thickness;
    }
    getThickness() {
        return this._thicknessRequested;
    }
    setActualThickness(thickness) {
        this._actualThickness = thickness;
    }
}
/**
 * Author Danial Chitnis 2019-20
 *
 * inspired by:
 * https://codepen.io/AzazelN28
 * https://www.tutorialspoint.com/webgl/webgl_modes_of_drawing.htm
 */ /**
 * The main class for the webgl-plot library
 */ class $b561b35af75249bf$export$d9af3c4cac7f4a4 {
    /**
     * @protected
     */ webgl;
    /**
     * Global horizontal scale factor
     * @default = 1.0
     */ gScaleX;
    /**
     * Global vertical scale factor
     * @default = 1.0
     */ gScaleY;
    /**
     * Global X/Y scale ratio
     * @default = 1
     */ gXYratio;
    /**
     * Global horizontal offset
     * @default = 0
     */ gOffsetX;
    /**
     * Global vertical offset
     * @default = 0
     */ gOffsetY;
    /**
     * Global log10 of x-axis
     * @default = false
     */ gLog10X;
    /**
     * Global log10 of y-axis
     * @default = false
     */ gLog10Y;
    /**
     * collection of data lines in the plot
     */ _linesData;
    /**
     * collection of auxiliary lines (grids, markers, etc) in the plot
     */ _linesAux;
    _thickLines;
    _surfaces;
    get linesData() {
        return this._linesData;
    }
    get linesAux() {
        return this._linesAux;
    }
    get thickLines() {
        return this._thickLines;
    }
    get surfaces() {
        return this._surfaces;
    }
    _progLine;
    /**
     * log debug output
     */ debug = false;
    /**
     * Create a webgl-plot instance
     * @param canvas - the canvas in which the plot appears
     * @param debug - (Optional) log debug messages to console
     *
     * @example
     *
     * For HTMLCanvas
     * ```typescript
     * const canvas = document.getElementbyId("canvas");
     *
     * const devicePixelRatio = window.devicePixelRatio || 1;
     * canvas.width = canvas.clientWidth * devicePixelRatio;
     * canvas.height = canvas.clientHeight * devicePixelRatio;
     *
     * const webglp = new WebGLplot(canvas);
     * ...
     * ```
     * @example
     *
     * For OffScreenCanvas
     * ```typescript
     * const offscreen = htmlCanvas.transferControlToOffscreen();
     *
     * offscreen.width = htmlCanvas.clientWidth * window.devicePixelRatio;
     * offscreen.height = htmlCanvas.clientHeight * window.devicePixelRatio;
     *
     * const worker = new Worker("offScreenCanvas.js", { type: "module" });
     * worker.postMessage({ canvas: offscreen }, [offscreen]);
     * ```
     * Then in offScreenCanvas.js
     * ```typescript
     * onmessage = function (evt) {
     * const wglp = new WebGLplot(evt.data.canvas);
     * ...
     * }
     * ```
     */ constructor(canvas, options){
        if (options == undefined) this.webgl = canvas.getContext("webgl", {
            antialias: true,
            transparent: false
        });
        else {
            this.webgl = canvas.getContext("webgl", {
                antialias: options.antialias,
                transparent: options.transparent,
                desynchronized: options.deSync,
                powerPerformance: options.powerPerformance,
                preserveDrawing: options.preserveDrawing
            });
            this.debug = options.debug == undefined ? false : options.debug;
        }
        this.log("canvas type is: " + canvas.constructor.name);
        this.log(`[webgl-plot]:width=${canvas.width}, height=${canvas.height}`);
        this._linesData = [];
        this._linesAux = [];
        this._thickLines = [];
        this._surfaces = [];
        //this.webgl = webgl;
        this.gScaleX = 1;
        this.gScaleY = 1;
        this.gXYratio = 1;
        this.gOffsetX = 0;
        this.gOffsetY = 0;
        this.gLog10X = false;
        this.gLog10Y = false;
        // Clear the color
        this.webgl.clear(this.webgl.COLOR_BUFFER_BIT);
        // Set the view port
        this.webgl.viewport(0, 0, canvas.width, canvas.height);
        this._progLine = this.webgl.createProgram();
        this.initThinLineProgram();
        //https://learnopengl.com/Advanced-OpenGL/Blending
        this.webgl.enable(this.webgl.BLEND);
        this.webgl.blendFunc(this.webgl.SRC_ALPHA, this.webgl.ONE_MINUS_SRC_ALPHA);
    }
    /**
     * updates and redraws the content of the plot
     */ _drawLines(lines) {
        const webgl = this.webgl;
        lines.forEach((line)=>{
            if (line.visible) {
                webgl.useProgram(this._progLine);
                const uscale = webgl.getUniformLocation(this._progLine, "uscale");
                webgl.uniformMatrix2fv(uscale, false, new Float32Array([
                    line.scaleX * this.gScaleX * (this.gLog10X ? 1 / Math.log(10) : 1),
                    0,
                    0,
                    line.scaleY * this.gScaleY * this.gXYratio * (this.gLog10Y ? 1 / Math.log(10) : 1)
                ]));
                const uoffset = webgl.getUniformLocation(this._progLine, "uoffset");
                webgl.uniform2fv(uoffset, new Float32Array([
                    line.offsetX + this.gOffsetX,
                    line.offsetY + this.gOffsetY
                ]));
                const isLog = webgl.getUniformLocation(this._progLine, "is_log");
                webgl.uniform2iv(isLog, new Int32Array([
                    this.gLog10X ? 1 : 0,
                    this.gLog10Y ? 1 : 0
                ]));
                const uColor = webgl.getUniformLocation(this._progLine, "uColor");
                webgl.uniform4fv(uColor, [
                    line.color.r,
                    line.color.g,
                    line.color.b,
                    line.color.a
                ]);
                webgl.bufferData(webgl.ARRAY_BUFFER, line.xy, webgl.STREAM_DRAW);
                webgl.drawArrays(line.loop ? webgl.LINE_LOOP : webgl.LINE_STRIP, 0, line.webglNumPoints);
            }
        });
    }
    _drawSurfaces(squares) {
        const webgl = this.webgl;
        squares.forEach((square)=>{
            if (square.visible) {
                webgl.useProgram(this._progLine);
                const uscale = webgl.getUniformLocation(this._progLine, "uscale");
                webgl.uniformMatrix2fv(uscale, false, new Float32Array([
                    square.scaleX * this.gScaleX * (this.gLog10X ? 1 / Math.log(10) : 1),
                    0,
                    0,
                    square.scaleY * this.gScaleY * this.gXYratio * (this.gLog10Y ? 1 / Math.log(10) : 1)
                ]));
                const uoffset = webgl.getUniformLocation(this._progLine, "uoffset");
                webgl.uniform2fv(uoffset, new Float32Array([
                    square.offsetX + this.gOffsetX,
                    square.offsetY + this.gOffsetY
                ]));
                const isLog = webgl.getUniformLocation(this._progLine, "is_log");
                webgl.uniform2iv(isLog, new Int32Array([
                    this.gLog10X ? 1 : 0,
                    this.gLog10Y ? 1 : 0
                ]));
                const uColor = webgl.getUniformLocation(this._progLine, "uColor");
                webgl.uniform4fv(uColor, [
                    square.color.r,
                    square.color.g,
                    square.color.b,
                    square.color.a
                ]);
                webgl.bufferData(webgl.ARRAY_BUFFER, square.xy, webgl.STREAM_DRAW);
                webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, square.webglNumPoints);
            }
        });
    }
    _drawTriangles(thickLine) {
        const webgl = this.webgl;
        webgl.bufferData(webgl.ARRAY_BUFFER, thickLine.xy, webgl.STREAM_DRAW);
        webgl.useProgram(this._progLine);
        const uscale = webgl.getUniformLocation(this._progLine, "uscale");
        webgl.uniformMatrix2fv(uscale, false, new Float32Array([
            thickLine.scaleX * this.gScaleX * (this.gLog10X ? 1 / Math.log(10) : 1),
            0,
            0,
            thickLine.scaleY * this.gScaleY * this.gXYratio * (this.gLog10Y ? 1 / Math.log(10) : 1)
        ]));
        const uoffset = webgl.getUniformLocation(this._progLine, "uoffset");
        webgl.uniform2fv(uoffset, new Float32Array([
            thickLine.offsetX + this.gOffsetX,
            thickLine.offsetY + this.gOffsetY
        ]));
        const isLog = webgl.getUniformLocation(this._progLine, "is_log");
        webgl.uniform2iv(isLog, new Int32Array([
            0,
            0
        ]));
        const uColor = webgl.getUniformLocation(this._progLine, "uColor");
        webgl.uniform4fv(uColor, [
            thickLine.color.r,
            thickLine.color.g,
            thickLine.color.b,
            thickLine.color.a
        ]);
        webgl.drawArrays(webgl.TRIANGLE_STRIP, 0, thickLine.xy.length / 2);
    }
    _drawThickLines() {
        this._thickLines.forEach((thickLine)=>{
            if (thickLine.visible) {
                const calibFactor = Math.min(this.gScaleX, this.gScaleY);
                //const calibFactor = 10;
                //console.log(thickLine.getThickness());
                thickLine.setActualThickness(thickLine.getThickness() / calibFactor);
                thickLine.convertToTriPoints();
                this._drawTriangles(thickLine);
            }
        });
    }
    /**
     * Draw and clear the canvas
     */ update() {
        this.clear();
        this.draw();
    }
    /**
     * Draw without clearing the canvas
     */ draw() {
        this._drawLines(this.linesData);
        this._drawLines(this.linesAux);
        this._drawThickLines();
        this._drawSurfaces(this.surfaces);
    }
    /**
     * Clear the canvas
     */ clear() {
        //this.webgl.clearColor(0.1, 0.1, 0.1, 1.0);
        this.webgl.clear(this.webgl.COLOR_BUFFER_BIT);
    }
    /**
     * adds a line to the plot
     * @param line - this could be any of line, linestep, histogram, or polar
     *
     * @example
     * ```typescript
     * const line = new line(color, numPoints);
     * wglp.addLine(line);
     * ```
     */ _addLine(line) {
        //line.initProgram(this.webgl);
        line._vbuffer = this.webgl.createBuffer();
        this.webgl.bindBuffer(this.webgl.ARRAY_BUFFER, line._vbuffer);
        this.webgl.bufferData(this.webgl.ARRAY_BUFFER, line.xy, this.webgl.STREAM_DRAW);
        //this.webgl.bindBuffer(this.webgl.ARRAY_BUFFER, line._vbuffer);
        line._coord = this.webgl.getAttribLocation(this._progLine, "coordinates");
        this.webgl.vertexAttribPointer(line._coord, 2, this.webgl.FLOAT, false, 0, 0);
        this.webgl.enableVertexAttribArray(line._coord);
    }
    addDataLine(line) {
        this._addLine(line);
        this.linesData.push(line);
    }
    addLine = this.addDataLine;
    addAuxLine(line) {
        this._addLine(line);
        this.linesAux.push(line);
    }
    addThickLine(thickLine) {
        this._addLine(thickLine);
        this._thickLines.push(thickLine);
    }
    addSurface(surface) {
        this._addLine(surface);
        this.surfaces.push(surface);
    }
    initThinLineProgram() {
        const vertCode = `
      attribute vec2 coordinates;
      uniform mat2 uscale;
      uniform vec2 uoffset;
      uniform ivec2 is_log;

      void main(void) {
         float x = (is_log[0]==1) ? log(coordinates.x) : coordinates.x;
         float y = (is_log[1]==1) ? log(coordinates.y) : coordinates.y;
         vec2 line = vec2(x, y);
         gl_Position = vec4(uscale*line + uoffset, 0.0, 1.0);
      }`;
        // Create a vertex shader object
        const vertShader = this.webgl.createShader(this.webgl.VERTEX_SHADER);
        // Attach vertex shader source code
        this.webgl.shaderSource(vertShader, vertCode);
        // Compile the vertex shader
        this.webgl.compileShader(vertShader);
        // Fragment shader source code
        const fragCode = `
         precision mediump float;
         uniform highp vec4 uColor;
         void main(void) {
            gl_FragColor =  uColor;
         }`;
        const fragShader = this.webgl.createShader(this.webgl.FRAGMENT_SHADER);
        this.webgl.shaderSource(fragShader, fragCode);
        this.webgl.compileShader(fragShader);
        this._progLine = this.webgl.createProgram();
        this.webgl.attachShader(this._progLine, vertShader);
        this.webgl.attachShader(this._progLine, fragShader);
        this.webgl.linkProgram(this._progLine);
    }
    /**
     * remove the last data line
     */ popDataLine() {
        this.linesData.pop();
    }
    /**
     * remove all the lines
     */ removeAllLines() {
        this._linesData = [];
        this._linesAux = [];
        this._thickLines = [];
        this._surfaces = [];
    }
    /**
     * remove all data lines
     */ removeDataLines() {
        this._linesData = [];
    }
    /**
     * remove all auxiliary lines
     */ removeAuxLines() {
        this._linesAux = [];
    }
    /**
     * Change the WbGL viewport
     * @param a
     * @param b
     * @param c
     * @param d
     */ viewport(a, b, c, d) {
        this.webgl.viewport(a, b, c, d);
    }
    log(str) {
        if (this.debug) console.log("[webgl-plot]:" + str);
    }
}



const $7ca5bdb66efd0e4c$export$77c311101ec4312 = ({ emulator: emulator, getAudioOutput: getAudioOutput, interval: interval = 1, drawInterval: drawInterval = 1000 / 60, color: color = 0x58b09cff, range: range = 128, rangeVolume: rangeVolume = 32, engine: engine = "webgl", style: style = [], renderWave: renderWave })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const classes = (0, $acw62.useMemo)(()=>[
            "audio-gb",
            ...style
        ].join(" "), [
        style
    ]);
    const [audioOutput, setAudioOutput] = (0, $acw62.useState)({});
    const [ch1Enabled, setCh1Enabled] = (0, $acw62.useState)((_b = (_a = emulator.instance) === null || _a === void 0 ? void 0 : _a.audio_ch1_enabled()) !== null && _b !== void 0 ? _b : true);
    const [ch2Enabled, setCh2Enabled] = (0, $acw62.useState)((_d = (_c = emulator.instance) === null || _c === void 0 ? void 0 : _c.audio_ch2_enabled()) !== null && _d !== void 0 ? _d : true);
    const [ch3Enabled, setCh3Enabled] = (0, $acw62.useState)((_f = (_e = emulator.instance) === null || _e === void 0 ? void 0 : _e.audio_ch3_enabled()) !== null && _f !== void 0 ? _f : true);
    const [ch4Enabled, setCh4Enabled] = (0, $acw62.useState)((_h = (_g = emulator.instance) === null || _g === void 0 ? void 0 : _g.audio_ch4_enabled()) !== null && _h !== void 0 ? _h : true);
    (0, $acw62.useEffect)(()=>{
        const updateAudioOutput = ()=>{
            var _a;
            const _audioOutput = getAudioOutput();
            for (const [key, value] of Object.entries(_audioOutput)){
                const values = (_a = audioOutput[key]) !== null && _a !== void 0 ? _a : new Array(range).fill(0);
                values.push(value);
                if (values.length > range) values.shift();
                audioOutput[key] = values;
            }
            setAudioOutput(audioOutput);
        };
        updateAudioOutput();
        const audioInterval = setInterval(()=>updateAudioOutput(), interval);
        return ()=>{
            clearInterval(audioInterval);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        audioOutput,
        interval,
        range
    ]);
    const renderAudioWave = (name, key, styles, onClick)=>{
        if (renderWave) return renderWave(name, key, styles, onClick);
        if (engine === "canvas") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ca5bdb66efd0e4c$var$AudioWave, {
            key: key,
            name: name,
            index: key,
            audioOutput: audioOutput,
            drawInterval: drawInterval,
            color: color,
            range: range,
            rangeVolume: rangeVolume,
            styles: styles,
            onClick: onClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7ca5bdb66efd0e4c$var$AudioWaveWebGL, {
            key: key,
            name: name,
            index: key,
            audioOutput: audioOutput,
            drawInterval: drawInterval,
            color: color,
            range: range,
            rangeVolume: rangeVolume,
            styles: styles,
            onClick: onClick
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "section"
    }, renderAudioWave("Master", "master", [
        "master"
    ]), renderAudioWave("CH1", "ch1", [
        "ch1",
        "selector",
        ch1Enabled ? "" : "disabled"
    ], ()=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_audio_ch1_enabled(!ch1Enabled);
        setCh1Enabled(!ch1Enabled);
    }), renderAudioWave("CH2", "ch2", [
        "ch2",
        "selector",
        ch2Enabled ? "" : "disabled"
    ], ()=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_audio_ch2_enabled(!ch2Enabled);
        setCh2Enabled(!ch2Enabled);
    }), renderAudioWave("CH3", "ch3", [
        "ch3",
        "selector",
        ch3Enabled ? "" : "disabled"
    ], ()=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_audio_ch3_enabled(!ch3Enabled);
        setCh3Enabled(!ch3Enabled);
    }), renderAudioWave("CH4", "ch4", [
        "ch4",
        "selector",
        ch4Enabled ? "" : "disabled"
    ], ()=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_audio_ch4_enabled(!ch4Enabled);
        setCh4Enabled(!ch4Enabled);
    })));
};
const $7ca5bdb66efd0e4c$var$AudioWave = ({ name: name, index: index, audioOutput: audioOutput, drawInterval: drawInterval = 1000 / 60, color: color = 0x58b09cff, range: range = 128, rangeVolume: rangeVolume = 32, styles: styles = [], onClick: onClick })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "audio-wave",
            ...styles
        ].join(" "), [
        styles
    ]);
    const canvasRef = (0, $acw62.useRef)(null);
    const onCanvas = (0, $acw62.useCallback)((structure)=>{
        const drawWave = ()=>{
            const values = audioOutput[index];
            if (!values) return;
            structure.canvasImage.data.fill(0);
            values.forEach((value, index)=>{
                const valueN = Math.min(value, rangeVolume - 1);
                const line = rangeVolume - 1 - valueN;
                const offset = (line * range + index) * (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA;
                structure.canvasBuffer.setUint32(offset, color);
            });
            structure.canvasOffScreenContext.putImageData(structure.canvasImage, 0, 0);
            structure.canvasContext.clearRect(0, 0, range, rangeVolume);
            structure.canvasContext.drawImage(structure.canvasOffScreen, 0, 0);
        };
        drawWave();
        const interval = setInterval(()=>drawWave(), drawInterval);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        index,
        audioOutput,
        drawInterval,
        color,
        range,
        rangeVolume
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        onClick: ()=>onClick && onClick(index)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a762831310e01428$export$8d01c972ee8b14a9), {
        width: range,
        height: rangeVolume,
        canvasRef: canvasRef,
        onCanvas: onCanvas
    }));
};
const $7ca5bdb66efd0e4c$var$AudioWaveWebGL = ({ name: name, index: index, audioOutput: audioOutput, drawInterval: drawInterval = 1000 / 60, color: color = 0x58b09cff, range: range = 128, rangeVolume: rangeVolume = 32, styles: styles = [], onClick: onClick })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "audio-wave",
            ...styles
        ].join(" "), [
        styles
    ]);
    const canvasRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!canvasRef.current) return;
        // converts the canvas to the expected size according
        // to the device pixel ratio value
        const devicePixelRatio = window.devicePixelRatio || 1;
        canvasRef.current.width = range * devicePixelRatio;
        canvasRef.current.height = rangeVolume * devicePixelRatio;
        // creates the WGL Plot object with the canvas element
        // that is associated with the current audio wave
        const wglPlot = new (0, $b561b35af75249bf$export$d9af3c4cac7f4a4)(canvasRef.current);
        const colorRgba = new (0, $b561b35af75249bf$export$e1fa5eb04d8533ba)(...$7ca5bdb66efd0e4c$var$intToColor2(color));
        const line = new (0, $b561b35af75249bf$export$c11cfec07e42e9b4)(colorRgba, range);
        line.arrangeX();
        wglPlot.addLine(line);
        const drawWave = ()=>{
            const values = audioOutput[index];
            if (!values) return;
            values.forEach((value, index)=>{
                const valueN = Math.min(value, rangeVolume - 1);
                line.setY(index, valueN / rangeVolume - 1);
            });
            wglPlot.update();
        };
        drawWave();
        const interval = setInterval(()=>drawWave(), drawInterval);
        return ()=>{
            clearInterval(interval);
        };
    }, [
        audioOutput,
        index,
        drawInterval,
        color,
        range,
        rangeVolume
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        onClick: ()=>onClick && onClick(index)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a762831310e01428$export$8d01c972ee8b14a9), {
        width: range,
        height: rangeVolume,
        canvasRef: canvasRef,
        init: false
    }));
};
const $7ca5bdb66efd0e4c$var$intToColor = (int)=>{
    const r = int >> 24 & 0xff;
    const g = int >> 16 & 0xff;
    const b = int >> 8 & 0xff;
    const a = int & 0xff;
    return [
        r,
        g,
        b,
        a
    ];
};
const $7ca5bdb66efd0e4c$var$intToColor2 = (int)=>{
    const color = $7ca5bdb66efd0e4c$var$intToColor(int);
    return color.map((v)=>v / 255);
};
var $7ca5bdb66efd0e4c$export$2e2bcd8739ae039 = $7ca5bdb66efd0e4c$export$77c311101ec4312;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $b05a1f4b28c172de$export$71e4abfdb7540558 = ({ getRegisters: getRegisters, getSpeed: getSpeed = ()=>(0, $796a66717a25f3ee$export$3cd536aab18fb47d).Normal, interval: interval = 50, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "registers-gb",
            ...style
        ].join(" "), [
        style
    ]);
    const [registers, setRegisters] = (0, $acw62.useState)({});
    const [speed, setSpeed] = (0, $acw62.useState)((0, $796a66717a25f3ee$export$3cd536aab18fb47d).Normal);
    (0, $acw62.useEffect)(()=>{
        const updateValues = ()=>{
            const registers = getRegisters();
            const speed = getSpeed();
            setRegisters(registers);
            setSpeed(speed);
        };
        updateValues();
        const updateInterval = setInterval(()=>updateValues(), interval);
        return ()=>{
            clearInterval(updateInterval);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        interval
    ]);
    const renderRegister = (key, value, size = 2, styles = [])=>{
        var _a;
        const classes = ()=>[
                "register",
                ...styles
            ].join(" ");
        const valueS = (_a = value === null || value === void 0 ? void 0 : value.toString(16).toUpperCase().padStart(size, "0")) !== null && _a !== void 0 ? _a : value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: classes()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "register-key"
        }, key), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "register-value"
        }, valueS ? `0x${valueS}` : "-"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", null, "CPU ", speed == (0, $796a66717a25f3ee$export$3cd536aab18fb47d).Double ? "2x" : ""), renderRegister("PC", registers.pc, 4), renderRegister("SP", registers.sp, 4), renderRegister("A", registers.a), renderRegister("B", registers.b), renderRegister("C", registers.c), renderRegister("D", registers.d), renderRegister("E", registers.e), renderRegister("H", registers.h), renderRegister("L", registers.l)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", null, "PPU"), renderRegister("SCY", registers.scy), renderRegister("SCX", registers.scx), renderRegister("WY", registers.wy), renderRegister("WX", registers.wx), renderRegister("LY", registers.ly), renderRegister("LYC", registers.lyc)));
};
var $b05a1f4b28c172de$export$2e2bcd8739ae039 = $b05a1f4b28c172de$export$71e4abfdb7540558;




var $acw62 = parcelRequire("acw62");

const $ec1f656545d80342$export$d3c3e5fda54544a4 = ({ getTile: getTile, tileCount: tileCount, width: width, contentBox: contentBox = true, interval: interval = 1000, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "tiles-gb",
            contentBox ? "content-box" : "",
            ...style
        ].join(" "), [
        contentBox,
        style
    ]);
    const intervalsRef = (0, $acw62.useRef)();
    const canvasRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (intervalsRef.current) clearInterval(intervalsRef.current);
        };
    }, []);
    const onCanvas = (0, $acw62.useCallback)((structure)=>{
        const drawTiles = ()=>{
            for(let index = 0; index < tileCount; index++){
                const pixels = getTile(index);
                $ec1f656545d80342$var$drawTile(index, pixels, structure);
            }
        };
        drawTiles();
        intervalsRef.current = setInterval(()=>drawTiles(), interval);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tileCount,
        interval
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a762831310e01428$export$8d01c972ee8b14a9), {
        width: 128,
        height: 192,
        canvasRef: canvasRef,
        scale: 2,
        scaledWidth: width,
        onCanvas: onCanvas
    }));
};
/**
 * Draws the tile at the given index to the proper vertical
 * offset in the given context and buffer.
 *
 * @param index The index of the sprite to be drawn.
 * @param pixels Buffer of pixels that contains the RGB data
 * that is going to be drawn.
 * @param structure The canvas context to which the tile is
 * growing to be drawn.
 * @param format The pixel format of the sprite.
 */ const $ec1f656545d80342$var$drawTile = (index, pixels, structure, format = (0, $21488f2abed026ea$export$abee86c20a5429d).RGB)=>{
    const line = Math.floor(index / 16);
    const column = index % 16;
    let offset = (line * structure.canvasOffScreen.width * 8 + column * 8) * (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA;
    let counter = 0;
    for(let i = 0; i < pixels.length; i += format){
        const color = pixels[i] << 24 | pixels[i + 1] << 16 | pixels[i + 2] << 8 | (format === (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA ? pixels[i + 3] : 0xff);
        structure.canvasBuffer.setUint32(offset, color);
        counter++;
        if (counter === 8) {
            counter = 0;
            offset += (structure.canvasOffScreen.width - 7) * (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA;
        } else offset += (0, $21488f2abed026ea$export$abee86c20a5429d).RGBA;
    }
    structure.canvasOffScreenContext.putImageData(structure.canvasImage, 0, 0);
    structure.canvasContext.drawImage(structure.canvasOffScreen, 0, 0);
};
var $ec1f656545d80342$export$2e2bcd8739ae039 = $ec1f656545d80342$export$d3c3e5fda54544a4;



const $87bc3a70ec183eb3$export$4378ef85714e3d1b = ({ emulator: emulator })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, emulator.getTile && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "inline-block",
            verticalAlign: "top",
            marginRight: 32,
            width: 256
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "VRAM Tiles"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec1f656545d80342$export$d3c3e5fda54544a4), {
        getTile: (index)=>emulator.getTile ? emulator.getTile(index) : new Uint8Array(),
        tileCount: 384,
        width: "100%",
        contentBox: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "inline-block",
            verticalAlign: "top"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Registers"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b05a1f4b28c172de$export$71e4abfdb7540558), {
        getRegisters: ()=>emulator.registers,
        getSpeed: ()=>emulator.speed
    })));
};
const $87bc3a70ec183eb3$export$62553d8dcdf3797f = ({ emulator: emulator })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: "inline-block",
            verticalAlign: "top"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Audio Waveform"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ca5bdb66efd0e4c$export$77c311101ec4312), {
        emulator: emulator,
        getAudioOutput: ()=>emulator.audioOutput
    })));
};
const $87bc3a70ec183eb3$export$4c6991a6d39114b9 = ({ emulator: emulator })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($87bc3a70ec183eb3$var$DebugSettingsContent, {
        emulator: emulator
    }));
};
const $87bc3a70ec183eb3$var$DebugSettingsContent = ({ emulator: emulator })=>{
    var _a, _b, _c, _d, _e;
    const [updated, setUpdated] = (0, $acw62.useState)(Date.now());
    (0, $acw62.useEffect)(()=>{
        const onAudioState = ()=>{
            setUpdated(Date.now());
        };
        emulator.bind("audio-state", onAudioState);
        return ()=>{
            emulator.unbind("audio-state", onAudioState);
        };
    }, [
        emulator
    ]);
    const onPpuChange = (0, $acw62.useCallback)((option)=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_ppu_enabled(option === "on");
    }, [
        emulator
    ]);
    const onApuChange = (0, $acw62.useCallback)((option)=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_apu_enabled(option === "on");
    }, [
        emulator
    ]);
    const onDmaChange = (0, $acw62.useCallback)((option)=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_dma_enabled(option === "on");
    }, [
        emulator
    ]);
    const onTimerChange = (0, $acw62.useCallback)((option)=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_timer_enabled(option === "on");
    }, [
        emulator
    ]);
    const onSerialChange = (0, $acw62.useCallback)((option)=>{
        var _a;
        (_a = emulator.instance) === null || _a === void 0 || _a.set_serial_enabled(option === "on");
    }, [
        emulator
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), {
        key: updated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        name: "PPU",
        valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
            options: [
                "on",
                "off"
            ],
            value: ((_a = emulator.instance) === null || _a === void 0 ? void 0 : _a.ppu_enabled()) ? "on" : "off",
            uppercase: true,
            size: "large",
            style: [
                "simple"
            ],
            onChange: onPpuChange
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        name: "APU",
        valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
            options: [
                "on",
                "off"
            ],
            value: ((_b = emulator.instance) === null || _b === void 0 ? void 0 : _b.apu_enabled()) ? "on" : "off",
            uppercase: true,
            size: "large",
            style: [
                "simple"
            ],
            onChange: onApuChange
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        name: "DMA",
        valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
            options: [
                "on",
                "off"
            ],
            value: ((_c = emulator.instance) === null || _c === void 0 ? void 0 : _c.dma_enabled()) ? "on" : "off",
            uppercase: true,
            size: "large",
            style: [
                "simple"
            ],
            onChange: onDmaChange
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        name: "Timer",
        valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
            options: [
                "on",
                "off"
            ],
            value: ((_d = emulator.instance) === null || _d === void 0 ? void 0 : _d.timer_enabled()) ? "on" : "off",
            uppercase: true,
            size: "large",
            style: [
                "simple"
            ],
            onChange: onTimerChange
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        name: "Serial",
        valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
            options: [
                "on",
                "off"
            ],
            value: ((_e = emulator.instance) === null || _e === void 0 ? void 0 : _e.serial_enabled()) ? "on" : "off",
            uppercase: true,
            size: "large",
            style: [
                "simple"
            ],
            onChange: onSerialChange
        })
    }));
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

const $f9a1ed433afbc62c$export$5c1afd69948782b1 = ({ playlist: playlist, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "playlist-info",
            ...style
        ].join(" "), [
        style
    ]);
    const tabs = [
        $f9a1ed433afbc62c$export$24c9bd4c06a374cb({
            playlist: playlist
        })
    ];
    const tabNames = [
        "Main"
    ];
    if (playlist.description) {
        tabs.push($f9a1ed433afbc62c$export$70212a950eed7ce1({
            playlist: playlist
        }));
        tabNames.push("Description");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$445d62b2c6943727), {
        tabs: tabs,
        tabNames: tabNames,
        flex: true
    }));
};
const $f9a1ed433afbc62c$export$24c9bd4c06a374cb = ({ playlist: playlist })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "playlist-info-main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), null, playlist.name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "name",
        name: "Name",
        value: playlist.name
    }), playlist.version && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "version",
        name: "Version",
        value: playlist.version
    }), playlist.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "author",
        name: "Author",
        value: playlist.author
    }), playlist.authorEmail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "author-email",
        name: "Email",
        value: playlist.authorEmail
    }), playlist.releaseDate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "release-date",
        name: "Release Date",
        value: playlist.releaseDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
        key: "entries",
        name: "Entries",
        value: String(playlist.entries.length)
    })));
const $f9a1ed433afbc62c$export$70212a950eed7ce1 = ({ playlist: playlist })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df815c6cfea7e2d2$export$358a232cca1ab2ac), null, playlist.description);
var $f9a1ed433afbc62c$export$2e2bcd8739ae039 = $f9a1ed433afbc62c$export$5c1afd69948782b1;



var $4dd7072f45dc8f5c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $4dd7072f45dc8f5c$export$db2f51785b169a9f = ({ entries: entries, playlist: playlist, emulator: emulator, onSelect: onSelect, style: style = [] })=>{
    var _a;
    const classes = (0, $acw62.useMemo)(()=>[
            "game-playlist",
            ...style
        ].join(" "), [
        style
    ]);
    const [filter, setFilter] = (0, $acw62.useState)("");
    const [loading, setLoading] = (0, $acw62.useState)(null);
    const [activeUrl, setActiveUrl] = (0, $acw62.useState)(null);
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(-1);
    const listRef = (0, $acw62.useRef)(null);
    const filteredEntries = (0, $acw62.useMemo)(()=>{
        if (!filter) return entries;
        const query = filter.toLowerCase();
        return entries.filter((entry)=>{
            var _a;
            return entry.name.toLowerCase().includes(query) || ((_a = entry.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query));
        });
    }, [
        entries,
        filter
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (selectedIndex < 0) return;
        const node = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.children[selectedIndex];
        node === null || node === void 0 || node.scrollIntoView({
            block: "nearest"
        });
    }, [
        selectedIndex
    ]);
    const onFilterChange = (0, $acw62.useCallback)((value)=>{
        setFilter(value);
        setSelectedIndex(-1);
    }, []);
    const onInfoClick = (0, $acw62.useCallback)(()=>$4dd7072f45dc8f5c$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a, _b, _c;
            if (!playlist) return;
            yield (_b = (_a = emulator.handlers).showModal) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = playlist.name) !== null && _c !== void 0 ? _c : "Playlist Info", undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9a1ed433afbc62c$export$5c1afd69948782b1), {
                playlist: playlist
            }));
        }), [
        playlist,
        emulator
    ]);
    const onEntryClick = (0, $acw62.useCallback)((entry)=>$4dd7072f45dc8f5c$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            setLoading(entry.url);
            try {
                const response = yield fetch(entry.url);
                if (!response.ok) throw new Error(`Problem retrieving ROM (${response.status})`);
                const blob = yield response.blob();
                const arrayBuffer = yield blob.arrayBuffer();
                const romData = new Uint8Array(arrayBuffer);
                // extracts the file name from the URL to be
                // used as the ROM name for the emulator
                const urlParts = entry.url.split(/\//g);
                let romName = urlParts[urlParts.length - 1].split("?")[0];
                const romNameParts = romName.split(/\./g);
                romName = `${romNameParts[0]}.${romNameParts[romNameParts.length - 1]}`;
                yield emulator.boot({
                    engine: null,
                    romName: romName,
                    romData: romData
                });
                setActiveUrl(entry.url);
                (_b = (_a = emulator.handlers).showToast) === null || _b === void 0 || _b.call(_a, `Loaded ${entry.name} successfully!`);
                onSelect === null || onSelect === void 0 || onSelect(entry);
            } catch (err) {
                (_d = (_c = emulator.handlers).showToast) === null || _d === void 0 || _d.call(_c, `Failed to load ${entry.name}!`, true);
                emulator.logger.error(`Failed to load ${entry.name} (${err})`);
            } finally{
                setLoading(null);
            }
        }), [
        emulator,
        onSelect
    ]);
    const onKeyDown = (0, $acw62.useCallback)((event)=>{
        if (filteredEntries.length === 0) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setSelectedIndex((prev)=>Math.min(prev + 1, filteredEntries.length - 1));
                break;
            case "ArrowUp":
                event.preventDefault();
                setSelectedIndex((prev)=>Math.max(prev - 1, 0));
                break;
            case "Enter":
                if (selectedIndex >= 0) {
                    event.preventDefault();
                    onEntryClick(filteredEntries[selectedIndex]);
                }
                break;
        }
    }, [
        filteredEntries,
        selectedIndex,
        onEntryClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes,
        onKeyDown: onKeyDown
    }, playlist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "game-playlist-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "game-playlist-header-left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "game-playlist-header-title"
    }, (_a = playlist.name) !== null && _a !== void 0 ? _a : "Playlist"), playlist.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "game-playlist-header-subtitle"
    }, "by ", playlist.author)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        text: "Info",
        onClick: onInfoClick
    })), (playlist === null || playlist === void 0 ? void 0 : playlist.description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "game-playlist-header-description"
    }, playlist.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9838918c3372d19$export$c86715117507e8e5), {
        size: "medium",
        placeholder: "Search games...",
        value: filter,
        onChange: onFilterChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "game-playlist-list",
        ref: listRef
    }, filteredEntries.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "game-playlist-empty"
    }, "No games found."), filteredEntries.map((entry, index)=>{
        var _a, _b, _c;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: entry.url,
            className: [
                "game-playlist-entry",
                loading === entry.url ? "loading" : "",
                activeUrl === entry.url ? "active" : "",
                selectedIndex === index ? "selected" : ""
            ].join(" "),
            onClick: ()=>onEntryClick(entry)
        }, ((_a = entry.thumbnail) !== null && _a !== void 0 ? _a : entry.thumbnailSmall) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            className: "game-playlist-thumbnail",
            src: (playlist === null || playlist === void 0 ? void 0 : playlist.useThumbnail) ? (_b = entry.thumbnail) !== null && _b !== void 0 ? _b : entry.thumbnailSmall : (_c = entry.thumbnailSmall) !== null && _c !== void 0 ? _c : entry.thumbnail,
            alt: entry.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "game-playlist-info"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "game-playlist-title"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "game-playlist-name"
        }, entry.name), loading === entry.url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "game-playlist-loading"
        }, "Loading...")), entry.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "game-playlist-description"
        }, entry.description)));
    })));
};
var $4dd7072f45dc8f5c$export$2e2bcd8739ae039 = $4dd7072f45dc8f5c$export$db2f51785b169a9f;




var $acw62 = parcelRequire("acw62");

const $a5f4ce175bdcbad3$export$a3d6720cb964fc2d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "keyboard-help"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Enter")), "Start button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Space")), "Select button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "A")), "A button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "S")), "B button"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "\u2190"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "\u2192")), "Horizontal control"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "\u2191"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "\u2193")), "Vertical control"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Escape")), "Exit fullscreen"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Ctrl + D")), "Turbo speed"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Ctrl + F")), "Toggle fullscreen"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Ctrl + K")), "Toggle on-screen keyboard"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "key"
    }, "Ctrl + P")), "Change screen palette"));
const $a5f4ce175bdcbad3$export$56c5018fa70ea939 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "faqs-help"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Does it play all Game Boy games?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Not really, but it plays the coolest ones. Now seriously it should play around 90% of the Game Boy games."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Why there's no sound?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "You need to click or touch the screen to start the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        href: "https://developer.mozilla.org/docs/Web/API/Web_Audio_API",
        target: "_blank"
    }, "Web Audio API"), " ", "support. That's just the way browsers work these days, security first \uD83D\uDE04."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Can I use my Xbox One/PS4/PS5 Gamepad?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Yes, just plug it in, press a button, and you're ready to go.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("br", null), "BTW: This uses the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        href: "https://developer.mozilla.org/docs/Web/API/Gamepad_API/Using_the_Gamepad_API",
        target: "_blank"
    }, "Web Gamepad API"), " ", "\uD83D\uDD79\uFE0F."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Will it ever play Game Boy Color games?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "It already does!"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "I've found a bug, where can I report it?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Use the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        href: "https://github.com/joamag/boytacean/issues",
        target: "_blank"
    }, "GitHub issue tracker"), "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "What's WebAssembly?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "The coolest thing that happened to the Web in the latest years, check the", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a1e6017981edfa31$export$a6c7ac8248d6e38a), {
        href: "https://en.wikipedia.org/wiki/WebAssembly",
        target: "_blank"
    }, "Wikipedia page"), " ", "for more info."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", null, "Why another Game Boy emulator?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Because it's cool, and a challenging problem to solve."));






var $acw62 = parcelRequire("acw62");


const $33a6dd9088378252$var$DEVICE_ICON = {
    null: "\uD83D\uDED1",
    logger: "\uD83D\uDCDC",
    printer: "\uD83D\uDDA8\uFE0F"
};
const $33a6dd9088378252$export$4255756ffbbcf41c = ({ emulator: emulator, style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "serial-section",
            ...style
        ].join(" "), [
        style
    ]);
    const [loggerData, setLoggerData] = (0, $acw62.useState)();
    const [printerImageUrls, setPrinterImageUrls] = (0, $acw62.useState)();
    const loggerDataRef = (0, $acw62.useRef)([]);
    const printerDataRef = (0, $acw62.useRef)([]);
    const loggerRef = (0, $acw62.useRef)(null);
    const imagesRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const onLoggerData = (data)=>{
            const byte = data[0];
            const charByte = String.fromCharCode(byte);
            loggerDataRef.current.push(charByte);
            setLoggerData(loggerDataRef.current.join(""));
        };
        const onPrinterData = (imageBuffer)=>{
            const imageUrl = (0, $8995200ce6b7afb4$export$a7cfebf844ed78f9)(imageBuffer, 160);
            printerDataRef.current.unshift(imageUrl);
            setPrinterImageUrls([
                ...printerDataRef.current
            ]);
        };
        const onLogger = (emulator, _params = {})=>{
            const params = _params;
            onLoggerData(params.data);
        };
        const onPrinter = (emulator, _params = {})=>{
            const params = _params;
            onPrinterData(params.imageBuffer);
        };
        emulator.bind("logger", onLogger);
        emulator.bind("printer", onPrinter);
        return ()=>{
            emulator.unbind("logger", onLogger);
            emulator.unbind("printer", onPrinter);
        };
    }, [
        emulator
    ]);
    const onDeviceChange = (option)=>{
        var _a, _b, _c;
        emulator.loadSerialDevice(option);
        const optionIcon = (_a = $33a6dd9088378252$var$DEVICE_ICON[option]) !== null && _a !== void 0 ? _a : "";
        (_c = (_b = emulator.handlers).showToast) === null || _c === void 0 || _c.call(_b, `${optionIcon} ${option} attached to the serial port & active`);
    };
    const getTabs = ()=>{
        return [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6731544d163a7061$export$c4868e4a24d48fad), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
                key: "button-device",
                name: "Device",
                valueNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f38955a851b5395c$export$822ecae9b15b07a4), {
                    options: [
                        "null",
                        "logger",
                        "printer"
                    ],
                    value: emulator.serialDevice,
                    uppercase: true,
                    size: "large",
                    style: [
                        "simple"
                    ],
                    onChange: onDeviceChange
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abb712638f5210c7$export$d63d7cff08fe4dc9), {
                key: "baud-rate",
                name: "Baud Rate",
                value: "1 KB/s"
            })),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "logger",
                ref: loggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "logger-data"
            }, loggerData || "Logger contents are empty.")),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "printer",
                ref: imagesRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "printer-lines"
            }, printerImageUrls ? printerImageUrls.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
                    key: index,
                    className: "printer-line",
                    src: url
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "placeholder"
            }, "Printer contents are empty.")))
        ];
    };
    const getTabNames = ()=>{
        return [
            "Settings",
            "Logger",
            "Printer"
        ];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8c0c095862b1bbd$export$445d62b2c6943727), {
        tabs: getTabs(),
        tabNames: getTabNames(),
        selectors: true
    }));
};
var $33a6dd9088378252$export$2e2bcd8739ae039 = $33a6dd9088378252$export$4255756ffbbcf41c;




var $acw62 = parcelRequire("acw62");

const $80612ec9583c1bf3$export$3cc7409e7dd7cedc = ({ style: style = [] })=>{
    const classes = (0, $acw62.useMemo)(()=>[
            "test-section",
            ...style
        ].join(" "), [
        style
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9838918c3372d19$export$c86715117507e8e5), {
        size: "small",
        placeholder: "XXX-XXX-XXX"
    }));
};
var $80612ec9583c1bf3$export$2e2bcd8739ae039 = $80612ec9583c1bf3$export$3cc7409e7dd7cedc;







var $a575cb24eea273f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a575cb24eea273f3$export$61d4212795f516b4 = (url)=>$a575cb24eea273f3$var$__awaiter(void 0, void 0, void 0, function*() {
        const response = yield fetch(url);
        if (!response.ok) throw new Error(`Problem retrieving playlist (${response.status})`);
        const data = yield response.json();
        // supports both a raw array of entries and a
        // structured playlist object with metadata
        if (Array.isArray(data)) return {
            entries: data
        };
        return data;
    });


var $e37bedb8d850049a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e37bedb8d850049a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e53ead4e95acb266$exports = {};
$e53ead4e95acb266$exports = import.meta.resolve("8CgYU");






class $e37bedb8d850049a$export$931178187aeca9b7 extends (0, $6ac8ff7fc530a3fb$export$e0a61f4eccc5d4d5) {
    constructor(extraSettings = {}){
        super({
            wasmPath: (parcelRequire("9L3aU")),
            extraSettings: extraSettings
        });
        /**
         * The URL of the JSON playlist file to be loaded
         * remotely, if not set the playlist feature is disabled.
         */ this._playlistUrl = null;
        /**
         * The cached playlist structure that has been loaded
         * from the remote URL, avoiding redundant fetches.
         */ this._playlist = null;
    }
    get playlistUrl() {
        return this._playlistUrl;
    }
    set playlistUrl(value) {
        this._playlistUrl = value;
        this._playlist = null;
    }
    /**
     * The default ROM URL from the loaded playlist, if
     * available. Used to boot the initial ROM when a
     * playlist is provided.
     */ get defaultRomUrl() {
        var _a, _b;
        return (_b = (_a = this._playlist) === null || _a === void 0 ? void 0 : _a.defaultUrl) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Loads the playlist from the remote URL and caches
     * it for subsequent usage in the playlist section.
     */ loadPlaylist() {
        return $e37bedb8d850049a$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._playlistUrl) return;
            try {
                this._playlist = yield (0, $a575cb24eea273f3$export$61d4212795f516b4)(this._playlistUrl);
            } catch (err) {
                this.logger.error(`Failed to load playlist (${err})`);
            }
        });
    }
    boot() {
        const _super = Object.create(null, {
            boot: {
                get: ()=>super.boot
            }
        });
        return $e37bedb8d850049a$var$__awaiter(this, arguments, void 0, function*(_a = {}) {
            var { romPath: romPath = $e53ead4e95acb266$exports } = _a, options = $e37bedb8d850049a$var$__rest(_a, [
                "romPath"
            ]);
            yield _super.boot.call(this, Object.assign({
                romPath: romPath
            }, options));
        });
    }
    get name() {
        var _a;
        return (_a = (0, $796a66717a25f3ee$export$c4868e4a24d48fad).name()) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($8f13b60c0ee5b277$exports))).name;
    }
    get device() {
        return {
            text: (0, $796a66717a25f3ee$export$c4868e4a24d48fad).system(),
            url: "https://en.wikipedia.org/wiki/Game_Boy"
        };
    }
    get icon() {
        return (parcelRequire("16DSZ"));
    }
    get version() {
        var _a;
        return {
            text: (_a = (0, $796a66717a25f3ee$export$c4868e4a24d48fad).version()) !== null && _a !== void 0 ? _a : (0, (/*@__PURE__*/$parcel$interopDefault($8f13b60c0ee5b277$exports))).version,
            url: "https://github.com/joamag/boytacean/blob/master/CHANGELOG.md"
        };
    }
    get repository() {
        return {
            text: "GitHub",
            url: "https://github.com/joamag/boytacean"
        };
    }
    get features() {
        var _a, _b;
        return [
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Help,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Debug,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Themes,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Palettes,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Benchmark,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Keyboard,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).KeyboardGB,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).Framerate,
            (0, $21488f2abed026ea$export$6e91cf7616333d5).SaveState,
            ...((_b = (_a = this.extraSettings) === null || _a === void 0 ? void 0 : _a.debug) !== null && _b !== void 0 ? _b : false) ? [
                (0, $21488f2abed026ea$export$6e91cf7616333d5).LoopMode,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).DisplayFrequency,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).BootRomInfo,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).RomTypeInfo,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).Cyclerate,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).Animationrate,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).SkippedTicks,
                (0, $21488f2abed026ea$export$6e91cf7616333d5).EmulationSpeed
            ] : []
        ];
    }
    get sections() {
        var _a, _b, _c;
        const _sections = [
            {
                name: "Serial",
                icon: (parcelRequire("jdh2q")),
                node: (0, $33a6dd9088378252$export$4255756ffbbcf41c)({
                    emulator: this
                })
            }
        ];
        if (this._playlistUrl) _sections.push({
            name: "Playlist",
            icon: (parcelRequire("iZEw8")),
            node: (0, $4dd7072f45dc8f5c$export$db2f51785b169a9f)({
                entries: (_b = (_a = this._playlist) === null || _a === void 0 ? void 0 : _a.entries) !== null && _b !== void 0 ? _b : [],
                playlist: (_c = this._playlist) !== null && _c !== void 0 ? _c : undefined,
                emulator: this
            })
        });
        return _sections;
    }
    get help() {
        return [
            {
                name: "Keyboard",
                node: (0, $a5f4ce175bdcbad3$export$a3d6720cb964fc2d)({})
            },
            {
                name: "FAQs",
                node: (0, $a5f4ce175bdcbad3$export$56c5018fa70ea939)({})
            }
        ];
    }
    get debug() {
        return [
            {
                name: "General",
                node: (0, $87bc3a70ec183eb3$export$4378ef85714e3d1b)({
                    emulator: this
                })
            },
            {
                name: "Audio",
                node: (0, $87bc3a70ec183eb3$export$62553d8dcdf3797f)({
                    emulator: this
                })
            },
            {
                name: "Settings",
                node: (0, $87bc3a70ec183eb3$export$4c6991a6d39114b9)({
                    emulator: this
                })
            }
        ];
    }
    get romExts() {
        return [
            "gb",
            "gbc",
            "zip"
        ];
    }
    get stateExts() {
        return [
            "sav",
            ...Array.from({
                length: 10
            }, (_, i)=>`s${i + 1}`)
        ];
    }
    get romInfo() {
        var _a, _b, _c, _d, _e, _f;
        return {
            name: (_a = this.romName) !== null && _a !== void 0 ? _a : undefined,
            data: (_b = this.romData) !== null && _b !== void 0 ? _b : undefined,
            size: this.romSize,
            extra: {
                bootRom: (_c = this.gameBoy) === null || _c === void 0 ? void 0 : _c.boot_rom_s(),
                romType: (_d = this.cartridge) === null || _d === void 0 ? void 0 : _d.rom_type_s(),
                romSize: (_e = this.cartridge) === null || _e === void 0 ? void 0 : _e.rom_size_s(),
                ramSize: (_f = this.cartridge) === null || _f === void 0 ? void 0 : _f.ram_size_s()
            }
        };
    }
    get frequencySpecs() {
        return {
            unit: (0, $21488f2abed026ea$export$44c95d3770756ed2).MHz,
            delta: 400000,
            places: 2
        };
    }
    get compiler() {
        if (!this.gameBoy) return null;
        return {
            name: (0, $796a66717a25f3ee$export$c4868e4a24d48fad).compiler(),
            version: (0, $796a66717a25f3ee$export$c4868e4a24d48fad).compiler_version()
        };
    }
    get compilation() {
        if (!this.gameBoy) return null;
        return {
            date: (0, $796a66717a25f3ee$export$c4868e4a24d48fad).compilation_date(),
            time: (0, $796a66717a25f3ee$export$c4868e4a24d48fad).compilation_time()
        };
    }
    get wasmEngine() {
        var _a;
        if (!this.gameBoy) return null;
        return (_a = (0, $796a66717a25f3ee$export$c4868e4a24d48fad).wasm_engine()) !== null && _a !== void 0 ? _a : null;
    }
    buildRomData(file) {
        return $e37bedb8d850049a$var$__awaiter(this, void 0, void 0, function*() {
            const arrayBuffer = yield file.arrayBuffer();
            let romData = new Uint8Array(arrayBuffer);
            if (file.name.endsWith(".zip")) {
                const zip = yield (0, $ff323866fb43afa6$exports.loadAsync)(romData);
                const firstFile = Object.values(zip.files)[0];
                romData = yield firstFile.async("uint8array");
            }
            return romData;
        });
    }
    /**
     * Shows the game playlist modal overlay allowing the
     * user to search and select a ROM from the playlist.
     */ showPlaylist() {
        return $e37bedb8d850049a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e;
            if (!this._playlistUrl) return;
            // fetches the playlist from the remote URL in case
            // it has not been cached yet, avoiding redundant requests
            if (!this._playlist) try {
                this._playlist = yield (0, $a575cb24eea273f3$export$61d4212795f516b4)(this._playlistUrl);
            } catch (err) {
                (_b = (_a = this.handlers).showToast) === null || _b === void 0 || _b.call(_a, "Failed to load the playlist!", true);
                this.logger.error(`Failed to load playlist (${err})`);
                return;
            }
            // shows the playlist modal with the game entries
            // allowing the user to search and select a ROM
            yield (_d = (_c = this.handlers).showModal) === null || _d === void 0 ? void 0 : _d.call(_c, (_e = this._playlist.name) !== null && _e !== void 0 ? _e : "Game Playlist", undefined, (0, $4dd7072f45dc8f5c$export$db2f51785b169a9f)({
                entries: this._playlist.entries,
                playlist: this._playlist,
                emulator: this
            }));
        });
    }
}
console.image = (url, size = 80)=>{
    const style = `font-size: ${size}px; background-image: url("${url}"); background-size: contain; background-repeat: no-repeat;`;
    console.log("%c     ", style);
};



/**
 * Converts an array of bytes into an image data object
 * ready to be used with a canvas context.
 *
 * @param buffer The array of bytes to convert.
 * @param width The width of the image in the buffer.
 * @returns The resulting image data object.
 */ const $8995200ce6b7afb4$export$6f7c9021898da29f = (buffer, width)=>{
    const clampedBuffer = new Uint8ClampedArray(buffer.length);
    for(let index = 0; index < clampedBuffer.length; index += 4){
        clampedBuffer[index + 0] = buffer[index];
        clampedBuffer[index + 1] = buffer[index + 1];
        clampedBuffer[index + 2] = buffer[index + 2];
        clampedBuffer[index + 3] = buffer[index + 3];
    }
    return new ImageData(clampedBuffer, width);
};
const $8995200ce6b7afb4$export$a7cfebf844ed78f9 = (buffer, width, format = "image/png")=>{
    const imageData = $8995200ce6b7afb4$export$6f7c9021898da29f(buffer, width);
    const canvas = document.createElement("canvas");
    [canvas.width, canvas.height] = [
        imageData.width,
        imageData.height
    ];
    const context = canvas.getContext("2d");
    context === null || context === void 0 || context.putImageData(imageData, 0, 0);
    const dataUrl = canvas.toDataURL(format);
    return dataUrl;
};




var $5619a25c82b92f8e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * List of available background theme colors that can be used
 * to style the main emulator area.
 */ const $5619a25c82b92f8e$var$BACKGROUNDS = [
    "264653",
    "1b1a17",
    "023047",
    "bc6c25",
    "283618",
    "2a9d8f",
    "3a5a40"
];
(()=>$5619a25c82b92f8e$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        // tries to load the settings from the local storage
        // to be used as fallback process for GET parameters
        let settings = {};
        if (window.localStorage) settings = JSON.parse((_a = localStorage.getItem("settings")) !== null && _a !== void 0 ? _a : "{}");
        // parses the current location URL as retrieves
        // some of the "relevant" GET parameters for logic
        const params = new URLSearchParams(window.location.search);
        const romUrl = (_c = (_b = params.get("rom_url")) !== null && _b !== void 0 ? _b : params.get("url")) !== null && _c !== void 0 ? _c : undefined;
        const fullscreen = [
            "1",
            "true",
            "True"
        ].includes((_e = (_d = params.get("fullscreen")) !== null && _d !== void 0 ? _d : params.get("fs")) !== null && _e !== void 0 ? _e : "");
        const debug = [
            "1",
            "true",
            "True"
        ].includes((_f = params.get("debug")) !== null && _f !== void 0 ? _f : "");
        const verbose = [
            "1",
            "true",
            "True"
        ].includes((_g = params.get("verbose")) !== null && _g !== void 0 ? _g : "");
        const keyboard = [
            "1",
            "true",
            "True"
        ].includes((_h = params.get("keyboard")) !== null && _h !== void 0 ? _h : "");
        const palette = (_k = (_j = params.get("palette")) !== null && _j !== void 0 ? _j : settings["palette"]) !== null && _k !== void 0 ? _k : undefined;
        const background = (_p = (_o = (_m = (_l = params.get("background")) !== null && _l !== void 0 ? _l : params.get("theme")) !== null && _m !== void 0 ? _m : settings["background"]) !== null && _o !== void 0 ? _o : settings["theme"]) !== null && _p !== void 0 ? _p : undefined;
        const playlistUrl = (_r = (_q = params.get("playlist_url")) !== null && _q !== void 0 ? _q : params.get("playlist")) !== null && _r !== void 0 ? _r : undefined;
        // creates the emulator structure and initializes the
        // React app with both the parameters and the emulator
        const emulator = new (0, $e37bedb8d850049a$export$931178187aeca9b7)({
            background: background,
            debug: debug || verbose
        });
        if (playlistUrl) {
            emulator.playlistUrl = playlistUrl;
            yield emulator.loadPlaylist();
        }
        // computes both the info and sections based on the initial
        // state of the emulator configuration
        const info = !playlistUrl;
        const sections = playlistUrl ? [
            "Playlist"
        ] : [];
        yield emulator.init();
        (0, $a64f72727446b946$export$e820db9e9e2fc09b)("app", {
            emulator: emulator,
            fullscreen: fullscreen,
            info: info,
            debug: debug,
            keyboard: keyboard,
            sections: sections,
            palette: palette,
            background: background,
            backgrounds: $5619a25c82b92f8e$var$BACKGROUNDS
        });
        // sets the emulator in the global scope this is useful
        // to be able to access the emulator from global functions
        window.emulator = emulator;
        // starts the emulator with the provided ROM URL, using
        // the playlist default URL as fallback if available
        const defaultRomUrl = (_s = romUrl !== null && romUrl !== void 0 ? romUrl : emulator.defaultRomUrl) !== null && _s !== void 0 ? _s : undefined;
        yield emulator.start({
            romUrl: defaultRomUrl
        });
    }))();


//# sourceMappingURL=web.19415b1b.js.map
